Raven
.config('https://f04f7d6fb2e24c389b8d43f7002bb3d2@meploy.me/log/3', {release:clientVersion})
.addPlugin(Raven.Plugins.Angular)
.install();

if (window.DEBUG){
    Raven.config(false)
}

angular.module('meploy', [
    'ngRaven',
    // new modules below
    'ngRoute',
    'satellizer',
    'tmh.dynamicLocale',
    'pascalprecht.translate',
    'uiGmapgoogle-maps',
    'ui.bootstrap',
    'ui.bootstrap.showErrors',
    'ngTouch',
    'ngAnimate',
    'ngMessages',
    'ngSanitize',
    'chart.js',
    'core',
    'modals',
    'apply-application',
    'timecards',
    'profile',
    'timer',
    'postEditPloy',
    'searchMeployees',
    'signUpMeployee',
    'signUpMeployer',
    'signUpMeployeeAddress',
    'salaryRules',
    'signUpMeployeeTaxes',
    'signUpNewMeployee',
    'ployTemplate',
    'angular-loading-bar',
    'ui-kit',
    'edit-profile',
    'cv',
    'profile-settings',
    'user',
    'about',
    'help',
    'ipip',
    'report',
    'angular-alert-banner',
    'myPloys',
    'myCompany',
    'myStaff',
    'salaryFactor',
    'collectiveAgreement',
    'ploys',
    'conversation',
    'myPayments',
    '404',
    'engagementShift',
    'workerSalary',
    'confirm-email',
    'angular-clipboard',
    '720kb.socialshare',
    'terms',
    'contact-us',
    'searchPloys',
    'download',
    'ngGeolocation',
    'logIn',
    'signUp',
    'leaveReview',
    'myActivity',
    'cookies-law-bar',
    'notifications-dropdown',
    'user-menu',
    'header',
    'referral',
    'cms',
    'ios-spinner',
    'ngFileUpload',
    'angularMoment',
    'ng.group',
    'ngCookies',
    'ngTagsInput',
    'LocalStorageModule',
    'angulartics',
    'angulartics.google.analytics',
    'angulartics.facebook.pixel', // todo: do we need this?
    'infinite-scroll',
    'ui.mask',
    'duScroll',
    'truncate',
    'sayHi',
    'angulartics.scroll',
    'angucomplete-alt',
    'meployScout',
    'rzModule',
    'ngIntlTelInput',
    'stat',
    'smsVerificationBar',
    'ui.calendar',
    'myCalendar',
    'checkInOut',
    'kyc',
    'wt.responsive',
    'pasvaz.bindonce',
    'angular-cvr-validator',
    'multipleDatePicker',
    'supplement',
    'workRequirement',
    'ngjsColorPicker',
    'alexjoffroy.angular-loaders',
    'slickCarousel',
    'dndLists',
    'crumble',
    'hl.sticky',
    'ployByWorker',
    '720kb.tooltips',
    'uiCropper',
    'onboarding-bar',
  ])
    .config(function (ngIntlTelInputProvider) {
    ngIntlTelInputProvider.set({
    allowExtensions: false,
    autoFormat: true,
    autoHideDialCode: true,
    autoPlaceholder: true,
    customPlaceholder: null,
    initialCountry: "dk",
    geoIpLookup: null,
    nationalMode: false,
    separateDialCode: true,
    numberType: "MOBILE",
    skipUtilScriptDownload: false,
    formatOnDisplay: true,
    utilsScript: "bower_components/intl-tel-input/build/js/utils.js"
  });
  })

.config(['$routeProvider', 'redirectToHomeBasedOnUser', function($routeProvider, redirectToHomeBasedOnUser) {
     $routeProvider

      .when('/', {
        resolve: redirectToHomeBasedOnUser,
        label: 'Home',
      })
         
      .otherwise({
        templateUrl : '/src/404/html/404.html'
      });
}])

.config(['$httpProvider', function($httpProvider) {
    $httpProvider.defaults.headers.common['Pragma'] = 'no-cache';
}])

.run(['$rootScope', '$http',function($rootScope, $http){
        $http.defaults.headers.common['Client'] = 'web ' + clientVersion;

}])
;



moment.locale('en', {
    relativeTime : {
        future: "in %s",
        past:   "%s",
        s:  "%ds",
        m:  "1m",
        mm: "%dm",
        h:  "1h",
        hh: "%dh",
        d:  "1d",
        dd: "%dd",
        M:  "1mo",
        MM: "%dmo",
        y:  "1y",
        yy: "%dy"
    }
});


angular.module('404', ['ngRoute'])

.config(['$routeProvider',
    function ($routeProvider) {
      

      $routeProvider
      .when('/page-not-found', {
        templateUrl : '/src/404/html/404.html',
      })

    }]);

angular.module('about', ['ngRoute'])

.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {
      
      var path = htmlPath('about');
      $routeProvider
      .when('/about_meploy', {
        templateUrl : path('about_meploy.html'),
        label: 'ABOUT_US'
      })

      .when('/about_press', {
        templateUrl : path('press.html'),
        label: 'ABOUT_US'
      })

    }]);

angular.module('apply-application', ['ngRoute'])
.config(['$routeProvider',
    function ($routeProvider) {
      $routeProvider
      .when('/apply-application/:ployId', {
          templateUrl : '/src/apply-application/html/apply-application.html',
          resolve: {
              access: ["Access", Access => {
                  Access.requireLogin().then(() => {
                      Access.engNotAlreadyExists();
                  });
              }],
          },
          parent: '/ploy-detail/{{ploy.id}}/',
          label: 'APPLICATION'
      })
    }]);

angular.module('checkInOut', ['ngRoute'])

.config(['$routeProvider', 'htmlPath',
    function($routeProvider, htmlPath) {

    let path = htmlPath('check-in-out');
    $routeProvider
        .when('/check-in-out/:engId', {
            templateUrl: path('check-in-out-page.html'),
            resolve: {
            access: ["Access", Access => {
                Access.requireLogin();
                // Access.requireLogin().then(() => {
                //     Access.requireMeployeeEmailVerification();
                // });
              }],
            },
            parent: '/',
            label: 'CONVERSATION__DETAILS__CHECKIN_LABEL',
        })

}]);

angular.module('cms', ['ngSanitize']);

angular.module('collectiveAgreement', [])

.config(['$routeProvider', 'htmlPath', function($routeProvider, htmlPath) {

    var path = htmlPath('collective-agreement');

    $routeProvider
    .when('/collective-agreements', {
       templateUrl : path('collective-agreements.html'),
       resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus().then(() => {
                    Access.requireCollectiveAgreement();
                })
            });
          }],
       },
       parent: '/my-company',
       label: 'COLLECTIVE_AGREEMENT__BREADCRUMB'
     })
     .when('/collective-agreements/add', {
       templateUrl : path('add-collective-agreement.html'),
       resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus().then(() => {
                    Access.requireCollectiveAgreement();
                })
            });
          }],
       },
       parent: '/collective-agreements',
       label: 'ADD_COLLECTIVE_AGREEMENT__BREADCRUMB'
     })

     .when('/collective-agreements/edit/:collective_agreement_id', {
       templateUrl : path('add-collective-agreement.html'),
       resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus().then(() => {
                    Access.requireCollectiveAgreement();
                })
            });
          }],
       },
       parent: '/collective-agreements',
       label: 'EDIT_COLLECTIVE_AGREEMENT__BREADCRUMB'
     })

}]);

angular.module('confirm-email', ['ngRoute'])

    .config(['$routeProvider', '$locationProvider', 'htmlPath',
        function ($routeProvider, $locationProvider, htmlPath) {

            let path = htmlPath('confirm-email');
            $routeProvider
                .when('/confirm-email', {
                    templateUrl: path('confirm-email-info.html'),
                    resolve: {
                      access: ["Access", Access => {
                        Access.requireLogin()
                      }],
                    },
                    label: 'PROFILE_COMPLETION__MISSING__EMAIL_VERIFY'
                })
                .when('/confirm_email/:token', {
                    templateUrl: path('confirm-email.html'),
                })

        }]);

angular.module('contact-us', ['ngRoute'])

.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {
      
      var path = htmlPath('contact-us');
      $routeProvider
      .when('/contact_us', {
        templateUrl : path('contact-us.html'),
        label: 'CONTACT'
      })

    }]);

angular.module('conversation', ['ngRoute'])


.config(['$routeProvider', '$locationProvider', 'htmlPath',
        function ($routeProvider, $locationProvider, htmlPath) {

        let path = htmlPath('conversation');

        $routeProvider
            .when('/my-ploys/:id/conversation', {
                templateUrl: path('conversation.html'),
                resolve: {
                  access: ["Access", Access => {
                    Access.requireLogin()
                  }],
                },
                parent: '/my-ploys/{{ploy.id}}/',
                label: '{{engagement.employee.first_name}} {{engagement.employee.last_name}}',
                hideFooter: true
            })
            .when('/my-ploys/:id/conversation/modify-workhours', {
                templateUrl: path('modify-workhours.html'),
                resolve: {
                  access: ["Access", Access => {
                    Access.requireLogin()
                  }],
                },
                parent: '/my-ploys/{{ploy.id}}/',
                label: 'Modify workhours',
            })

}]);

angular.module('cookies-law-bar', [])
angular.module('core', ['satellizer','ngResource', 'ngRoute', 'pascalprecht.translate','tmh.dynamicLocale'])
angular.module('cv', [])

.config(['$routeProvider', 'htmlPath', function($routeProvider, htmlPath) {

    var path = htmlPath('cv');

    $routeProvider
        .when('/cv', {
            label: 'CV_LABEL'
        })
        .when('/cv/edit', {
            templateUrl: path('edit-cv.html'),
            resolve: {
                access: ['Access', Access => {
                    Access.requireLogin()
                }],
            },
            label: 'CV_EDIT_LABEL'
        })
        .when('/cv/edit/professional-experience/:work_id?', {
            templateUrl: path('edit-cv-works.html'),
            resolve: {
                access: ['Access', Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/cv/edit',
            label: 'CV_EDIT_WORKS_LABEL'
        })
        .when('/cv/edit/education/:school_id?', {
            templateUrl: path('edit-cv-school.html'),
            resolve: {
                access: ['Access', Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/cv/edit',
            label: 'CV_EDIT_SCHOOLS_LABEL'
        })
        .when('/cv/edit/skills', {
            templateUrl: path('edit-cv-skills.html'),
            resolve: {
                access: ['Access', Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/cv/edit',
            label: 'CV_EDIT_SKILLS_LABEL'
        })
        .when('/cv/edit/languages', {
            templateUrl: path('edit-cv-languages.html'),
            resolve: {
                access: ['Access', Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/cv/edit',
            label: 'CV_EDIT_LANGUAGES_LABEL'
        })
        .when('/cv/edit/certificates/:certificate_id?', {
            templateUrl: path('edit-cv-certificates.html'),
            resolve: {
                access: ['Access', Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/cv/edit',
            label: 'CV_EDIT_CERTIFICATES_LABEL'
        })
        .when('/cv/edit/hobbies', {
            templateUrl: path('edit-cv-hobbies.html'),
            resolve: {
                access: ['Access', Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/cv/edit',
            label: 'CV_EDIT_HOBBIES_LABEL'
        })

}])

angular.module('download', [])


    .config(['$routeProvider', 'htmlPath', function ($routeProvider, htmlPath) {

        var path = htmlPath('download');

        $routeProvider

            .when('/download', {
                templateUrl: path('download.html'),
            })
            .when('/download-app', {
                templateUrl: path('download-app.html'),
            })

    }]);

angular.module('edit-profile', [])

.config(['$routeProvider', 'htmlPath', function($routeProvider, htmlPath) {

    var path = htmlPath('edit-profile');

    $routeProvider
        .when('/edit-profile', {
            templateUrl: path('edit-profile.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/profile-settings',
            label: 'EDIT_PROFILE'
        })
        .when('/edit-profile/name', {
            templateUrl: path('edit-profile/name.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__NAME'
        })
        .when('/edit-profile/age', {
            templateUrl: path('edit-profile/age.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__AGE'
        })
        .when('/edit-profile/phone', {
            templateUrl: path('edit-profile/phone.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__PHONE'
        })
        .when('/edit-profile/email', {
            templateUrl: path('edit-profile/email.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__EMAIL'
        })
        .when('/edit-profile/category', {
            templateUrl: path('edit-profile/category.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__CATEGORY'
        })
        .when('/edit-profile/occupation', {
            templateUrl: path('edit-profile/occupation.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__OCCUPATION'
        })
        .when('/edit-profile/bio', {
            templateUrl: path('edit-profile/bio.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__BIO'
        })
        .when('/edit-profile/photo', {
            templateUrl: path('edit-profile/photo.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__PHOTO'
        })
        .when('/edit-profile/nationality', {
            templateUrl: path('edit-profile/nationality.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__NATIONALITY'
        })
        .when('/edit-profile/criminal-record', {
            templateUrl: path('edit-profile/criminal-record.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__CRIMINAL_RECORD'
        })
        .when('/edit-profile/cpr', {
            templateUrl: path('edit-profile/cpr.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__CPR'
        })
        .when('/edit-profile/address', {
            templateUrl: path('edit-profile/address.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__ADDRESS'
        })
        .when('/edit-profile/id', {
            templateUrl: path('edit-profile/id.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__ID'
        })
        .when('/edit-profile/bank', {
            templateUrl: path('edit-profile/bank.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__BANK'
        })
        .when('/edit-profile/pension', {
            templateUrl: path('edit-profile/pension.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__PENSION'
        })

        // employer view:
        .when('/edit-profile/professional-title', {
            templateUrl: path('edit-profile/professional-title.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/edit-profile',
            label: 'EDIT_PROFILE__PROFESSIONAL_TITLE'
        })

}])

angular.module('engagementShift', ['ngRoute'])

.config(['$routeProvider', 'htmlPath',
    function ($routeProvider, htmlPath) {

        var path = htmlPath('engagement-shift');
        $routeProvider
            .when('/engagement-shift', {
                templateUrl : path('engagement-shift.html'),
                resolve: {
                  access: ["Access", Access => {
                    Access.requireLogin()
                  }],
                },
                label: 'ENGAGEMENT_SHIFT__MENU'
            })

}]);

angular.module('header', []);
var module = angular.module('help', ['ngRoute']);

module.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

      var path = htmlPath('help');

      $routeProvider
      .when('/help', {
        templateUrl : path('help.html'),
      })

      .when('/help_getting_started', {
        templateUrl : path('getting_started.html'),
      })

      .when('/help_account_profile', {
        templateUrl : path('account_profile.html'),
      })

      .when('/help_upload_ploy', {
        templateUrl : path('upload_ploy.html'),
      })

      .when('/help_apply_ploy', {
        templateUrl : path('apply_ploy.html'),
      })

      .when('/help_trust_safety', {
        templateUrl : path('trust_safety.html'),
      })

      .when('/help_reviews', {
        templateUrl : path('reviews.html'),
      })

      .when('/help_secure_payments', {
        templateUrl : path('secure_payments.html'),
      })

      .when('/help_taxes', {
        templateUrl : path('taxes.html'),
      })

      .when('/help_insurance', {
        templateUrl : path('insurance.html'),
      })

      .when('/help_contact_meploy', {
        templateUrl : path('contact_meploy.html'),
      })

     .when('/help_meploy_scout', {
        templateUrl : path('meploy_scout.html'),
      })


    }]);

angular.module('ios-spinner', []);
var module = angular.module('ipip', ['ngRoute']);

module.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

        var path = htmlPath('ipip');

        $routeProvider
            .when('/ipip', {
                templateUrl: path('ipip-introduction.html'),
                label: 'SETTINGS__IPIP',
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireWorkerStatus().then(() => {
                                Access.ipipTestNotCompleted();
                            });
                        });
                    }],
                },
            })
            .when('/ipip/demo', {
                templateUrl: path('ipip-demo.html'),
                label: 'Demo',
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireWorkerStatus().then(() => {
                                Access.ipipTestNotCompleted();
                            });
                        });
                    }],
                },
            })
            .when('/ipip/test', {
                templateUrl: path('ipip.html'),
                label: 'Test',
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireWorkerStatus().then(() => {
                                Access.ipipTestNotCompleted();
                            });
                        });
                    }],
                },
            })
            .when('/ipip/result', {
                templateUrl: path('ipip-result.html'),
                label: 'IPIP_RESULT__HEADING',
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireWorkerStatus();
                        });
                    }],
                },
            })


    }]);

angular.module('kyc', ['ngRoute'])

    .config(['$routeProvider', 'htmlPath',
        function ($routeProvider, htmlPath) {

            var path = htmlPath('kyc');
            $routeProvider
                .when('/documents-permissions', {
                    templateUrl: path('document-permission.html'),
                    resolve: {
                      access: ["Access", Access => {
                        Access.requireLogin()
                      }],
                    },
                    parent: '/profile-settings',
                    label: 'DOCUMENT-PERMISSIONS__MAIN-TITLE',
                })

        }]);

angular.module('leaveReview', ['ngRoute'])

.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

      var path = htmlPath('leave-review');
      $routeProvider
     .when('/leave-review/:id', {
        templateUrl : path('leave-review.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireLogin()
          }],
        },
        parent:  '/engagement-shift',
        label: 'LEAVE_REVIEW'
      })

    }]);

var module = angular.module('logIn', ['ngRoute']);

module.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

      var path = htmlPath('log-in');

      $routeProvider
      .when('/log-in', {
        templateUrl : path('log-in.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireAnonymous()
          }],
        },
        label: 'LOG_IN'
      })
      .when('/reset_password', {
        templateUrl : path('new-password.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireAnonymous()
          }],
        },
        label: 'RESET_PASSWORD'
      })
      .when('/reset_password/:token', {
        templateUrl : path('new-password.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireAnonymous()
          }],
        },
        label: 'RESET_PASSWORD'
      })

    }]);

angular.module('meployScout', ['ngRoute'])

  .config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

        var path = htmlPath('meploy-scout');

        $routeProvider
            .when('/meploy-scout', {
                templateUrl: path('meploy-scout.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin()
                    }],
                },
            })
            .when('/meploy-scout/start', {
                templateUrl: path('meploy-scout-cards.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin()
                    }],
                },
            })
            .when('/meploy-scout/declined-users', {
                templateUrl: path('meploy-scout-declined-users.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin()
                    }],
                },
            })
    }]);

angular.module('modals', [])
var module = angular.module('myActivity', ['ngRoute']);

module.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

      var path = htmlPath('my-activity');

      $routeProvider
      .when('/my-activity', {
        templateUrl : path('my-activity.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireLogin();
            // Access.requireLogin().then(() => {
            //     Access.requireMeployeeEmailVerification();
            // });
          }],
        },
        label: 'MY_ACTIVITY'
      })

    }]);

angular.module('myCalendar', ['ngRoute'])

    .config(['$routeProvider', 'htmlPath', 'authorizeUserFromToken',
        function ($routeProvider, htmlPath, authorizeUserFromToken) {

            let path = htmlPath('my-calendar');
            $routeProvider
                .when('/my-calendar', {
                    templateUrl: path('my-calendar.html'),
                    resolve: {
                        access: ["Access", Access => {
                            Access.requireLogin().then(() => {
                                Access.requireWorkerStatus();  //.then(() => {
                                    // Access.requireMeployeeEmailVerification();
                                // });
                            });
                        }],
                    },
                    label: 'MY_CALENDAR'
                })
                .when('/my-calendar/:token', { // todo: Path deprecated. Chceck usages and delete.
                    templateUrl: path('my-calendar.html'),
                    resolve: angular.extend({}, authorizeUserFromToken)
                })
        }]);

angular.module('myCompany', ['ngRoute'])

.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

      let path = htmlPath('my-company');
      $routeProvider
      .when('/my-company', {
        templateUrl : path('my-company.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus();
            });
          }],
        },
        label: 'MY_COMPANY'
      })
      .when('/my-company/edit', {
        templateUrl : path('edit-company.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus();
            });
          }],
        },
        label: 'MY_COMPANY__MENU__EDIT_COMPANY_LINK'
      })
      .when('/my-company/invoice-settings', {
        templateUrl : path('invoice-settings.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus();
            });
          }],
        },
        label: 'MY_COMPANY__MENU__INVOICE_SETTINGS_LINK'
      })
      .when('/my-company/documents', {
        templateUrl : path('edit-documents.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus();
            });
          }],
        },
        label: 'MY_COMPANY__MENU__DOCUMENTS_LINK'
      })
      .when('/my-company/members', {
        templateUrl : path('company-members.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus();
            });
          }],
        },
        label: 'COMPANY_MEMBERS__BREADCRUMB'
      })
      .when('/my-company/stats', {
        templateUrl : path('company-stats.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus();
            });
          }],
        },
        label: 'PLOY_STATISTICS__BREADCRUMB'
      })
      .when('/my-company/ploys-settings', {
        templateUrl : path('ploys-settings.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus();
            });
          }],
        },
        label: 'PLOYS_SETTINGS__BREADCRUMB'
      })
      .when('/my-company/documents/acceptance-logs', {
        templateUrl : path('company-document-acceptance-logs.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus();
            });
          }],
        },
        label: 'COMPANY_DOCUMENTS_ACCEPTANCES__BREADCRUMB'
      })

    }]);

angular.module('myPayments', ['ngRoute'])

.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

      var path = htmlPath('my-payments');
      $routeProvider
      .when('/my-payments', {
        templateUrl : path('my-payments.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus();
            });
          }],
        },
        parent: '/my-ploys',
        label: 'MY_PAYMENTS__HEADING'
      })
      .when('/my-payments/for/:ploy', {
        templateUrl : path('pay-for.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus();
            });
          }],
        },
        parent: '/my-payments',
        label: 'PAY_FOR__HEADING'
      })
      .when('/my-payments/payments-archive', {
        templateUrl : path('payments-archive.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus();
            });
          }],
        },
        label: 'PAYMENTS_ARCHIVE__TITLE'
      })
    }]);

angular.module('myPloys', ['ngRoute'])

    .config(['$routeProvider', '$locationProvider', 'htmlPath',
        function ($routeProvider, $locationProvider, htmlPath,) {

            let path = htmlPath('my-ploys');
            $routeProvider
                .when('/my-ploys', {
                    templateUrl: path('my-ploys.html'),
                    resolve: {
                        access: ["Access", Access => {
                            Access.requireLogin();
                            // Access.requireLogin().then(() => {
                            //     Access.requireMeployeeCPRNumber().then(() => {
                            //         Access.requireMeployeeEmailVerification();
                            //     });
                            // });
                        }],
                    },
                    label: 'MY_PLOYS'
                })

                .when('/my-ploys/archive', {
                    templateUrl: path('archive.html'),
                    resolve: {
                        access: ["Access", Access => {
                            Access.requireLogin();
                            // Access.requireLogin().then(() => {
                            //     Access.requireMeployeeCPRNumber().then(() => {
                            //         Access.requireMeployeeEmailVerification();
                            //     });
                            // });
                        }],
                    },
                    label: 'ARCHIVE'

                })

                .when('/my-ploys/:id', {
                    templateUrl: path('ploy-management.html'),
                    resolve: {
                        access: ["Access", Access => {
                            Access.requireLogin().then(() => {
                                Access.requireCompanyStatus();
                            });
                            // Access.requireLogin().then(() => {
                            //     Access.requireMeployeeCPRNumber().then(() => {
                            //         Access.requireMeployeeEmailVerification();
                            //     });
                            // });
                        }],
                    },
                    label: '{{ploy.category | categoryName }} {{ ploy | displayPloyDuration }}'
                })

                .when('/my-ploys/:id/details', {
                    templateUrl : path('../../ploys/html/ploy-public.html'),
                    label: '{{ploy.category | categoryName }} {{ ploy | displayPloyDuration }}',
                    parent: '/my-ploys',
                })

                .when('/my-ploys/:id/message-to-workers', {
                    templateUrl: path('message-to-workers.html'),
                    resolve: {
                        access: ["Access", Access => {
                            Access.requireLogin().then(() => {
                                Access.requireCompanyStatus();
                                // Access.requireMeployeeCPRNumber().then(() => {
                                //     Access.requireMeployeeEmailVerification();
                                // });
                            });
                        }],
                    },
                    label: 'MESSAGE_TO_WORKERS__TITLE'
                })

                .when('/today-shifts', {
                    templateUrl: path('today-shifts.html'),
                    resolve: {
                        access: ["Access", Access => {
                            Access.requireLogin().then(() => {
                                Access.requireCompanyStatus();
                            });
                        }],
                    },
                    label: 'Today shifts'
                })


                .when('/my-ploys/:id/find-replacement', {
                    templateUrl: path('find-replacement.html'),
                    resolve: {
                        access: ["Access", Access => {
                            Access.requireLogin().then(() => {
                                Access.requireCompanyStatus();
                            });
                        }],
                    },
                    label: '{{\'PLOY_MANAGEMENT__REPLACEMENT__LABEL\' | translate}} {{engagement.employee.first_name}}'
                })

        }]);

angular.module('myStaff', ['ngRoute'])

.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

        let path = htmlPath('my-staff');
        $routeProvider
            .when('/my-staff/groups/add/:first_members_id?', {
                templateUrl: path('staff-groups__add-edit.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireCompanyStatus();
                        });
                    }],
                },
                label: 'STAFF-GROUPS__HEADING-ADD-GROUP'
            })
            .when('/my-staff/groups/edit/:id', {
                templateUrl: path('staff-groups__add-edit.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireCompanyStatus();
                        });
                    }],
                },
                parent: '/my-staff/groups',
                label: 'STAFF-GROUPS__HEADING-EDIT-GROUP'
            })
            .when('/my-staff/groups', {
                templateUrl: path('staff-groups.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireCompanyStatus();
                        });
                    }],
                },
                label: 'STAFF-GROUPS__HEADING'
            })
            .when('/my-staff/add-users-to-group/:staff_users', {
                templateUrl: path('add-users-to-group.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireCompanyStatus().then(() => {
                                Access.requireAnyCreatedGroups();
                            })
                        });
                    }],
                },
            })
            .when('/my-staff', {
                templateUrl: path('my-staff.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireCompanyStatus();
                        });
                    }],
                },
                label: 'MY_STAFF__HEADING'
            })
            .when('/my-staff/export/:target_ids', {
                templateUrl: path('export-staff.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireCompanyStatus();
                        });
                    }],
                },
            })
            .when('/my-staff/deleted-staff', {
                templateUrl: path('deleted-staff.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireCompanyStatus();
                        });
                    }],
                },
                parent: '/my-staff',
                label: 'DELETED_STAFF__TITLE'
            })
            .when('/my-staff/:hire', {
                templateUrl: path('my-staff.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireCompanyStatus();
                        });
                    }],
                },
                label: 'HIRE'
            })
            .when('/my-staff/edit/:id', {
                templateUrl: path('edit-staff.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireCompanyStatus();
                        });
                    }],
                },
                parent: '/my-staff',
                label: '{{username}}'
            })
    }]);

angular.module('notifications-dropdown', ['ngResource']);

angular.module('onboarding-bar', [])

angular.module('ployByWorker', ['ngRoute'])

.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function($routeProvider, $locationProvider, htmlPath) {

    var path = htmlPath('ployByWorker');

    $routeProvider
        .when('/ploy-by-worker/:engagementId', {
            templateUrl: path('ploy-by-worker.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin().then(() => {
                        Access.requireMeployeeEmailVerification();
                    });
                }],
            },
            parent: '/my-ploys/{{engagement.id}}/conversation',
            label: 'PLOY_BY_WORKER__HEADER',
        })

}]);

angular.module('ployTemplate', ['ngRoute'])

.config(['$routeProvider', ($routeProvider) => {

    $routeProvider
        .when('/ploy-templates', {
            templateUrl: '/src/ploy-template/html/ploy-templates.html',
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin().then(() => {
                        Access.requireCompanyStatus();
                    });
                }],
            },
            parent: '/my-ploys',
            label: 'PLOY_TEMPLATES__MAIN_HEADER'
        })
        .when('/ploy-templates/create', {
            templateUrl: '/src/ploy-template/html/ploy-template-create-edit.html',
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin().then(() => {
                        Access.requireCompanyStatus();
                    });
                }],
            },
            parent: '/ploy-templates',
            label: 'PLOY_TEMPLATES__CREATE__TITLE'
        })
        .when('/ploy-templates/edit/:ploy_template_id', {
            templateUrl: '/src/ploy-template/html/ploy-template-create-edit.html',
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin().then(() => {
                        Access.requireCompanyStatus();
                    });
                }],
            },
            parent: '/ploy-templates',
            label: 'PLOY_TEMPLATES__EDIT__TITLE'
        })
        .when('/ploy-templates/from-ploy/:ploy_id', {
            templateUrl: '/src/ploy-template/html/ploy-template-create-edit.html',
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin().then(() => {
                        Access.requireCompanyStatus();
                    });
                }],
            },
            parent: '/ploy-templates',
            label: 'PLOY_TEMPLATES__CREATE__TITLE'
        })

}]);

angular.module('ploys', ['ngRoute'])

.config(['$routeProvider', '$locationProvider', 'htmlPath', 'authorizeUserFromToken',
    function ($routeProvider, $locationProvider, htmlPath, authorizeUserFromToken) {

      var path = htmlPath('ploys');

      $routeProvider
          .when('/ploy-detail/:id', {
              templateUrl : path('ploy-public.html'),
              parent: '/search',
              label: '{{ploy.category | categoryName }} {{ ploy | displayPloyDuration }}'
          })
          .when('/ploy-detail/:id/:token', { // deprecated. check usages in web/mobile app and delete.
              templateUrl : path('ploy-public.html'),
              resolve: angular.extend({}, authorizeUserFromToken)
          })
}]);

angular.module('postEditPloy', ['ngRoute'])

  .config(['$routeProvider',
    function ($routeProvider) {
      $routeProvider

          .when('/post-ploy', {
              templateUrl: '/src/post-edit-ploy/html/post-edit-ploy.html',
              parent: '/my-ploys',
              label: 'POST_PLOY',
              resolve: {
                  access: ["Access", Access => {
                      Access.requireLogin().then(() => {
                          Access.requireCompanyStatus();
                      });
                  }],
              },
          })
          .when('/post-ploy/public', { // todo: deprecated????
              templateUrl: '/src/post-edit-ploy/html/post-edit-ploy.html'
          })
          .when('/post-ploy/for/:target_meployees', {
              templateUrl: '/src/post-edit-ploy/html/post-edit-ploy.html',
              parent: '/my-ploys',
              resolve: {
                  access: ["Access", Access => {
                      Access.requireLogin().then(() => {
                          Access.requireCompanyStatus();
                      });
                  }],
              },
              label: 'POST_PLOY'
          })
          .when('/post-ploy/staff/:all_staff', {
              templateUrl: '/src/post-edit-ploy/html/post-edit-ploy.html',
              parent: '/my-ploys',
              resolve: {
                  access: ["Access", Access => {
                      Access.requireLogin().then(() => {
                          Access.requireCompanyStatus();
                      });
                  }],
              },
              label: 'POST_PLOY'
          })
          .when('/post-ploy/group/:allGroup', {
              templateUrl: '/src/post-edit-ploy/html/post-edit-ploy.html',
              parent: '/my-ploys',
              resolve: {
                  access: ["Access", Access => {
                      Access.requireLogin().then(() => {
                          Access.requireCompanyStatus();
                      });
                  }],
              },
              label: 'POST_PLOY'
          })
          .when('/edit-ploy/:ploy_id', {
              templateUrl: '/src/post-edit-ploy/html/post-edit-ploy.html',
              resolve: {
                  access: ["Access", Access => {
                      Access.requireLogin().then(() => {
                          Access.requireCompanyStatus();
                      });
                  }],
              },
              parent: '/my-ploys',
              label: 'EDIT_PLOY'
          })
          .when('/duplicate/:duplicate_ploy_id', { // todo: deprecated????
              templateUrl: '/src/post-edit-ploy/html/post-edit-ploy.html',
              resolve: {
                  access: ["Access", Access => {
                      Access.requireLogin().then(() => {
                          Access.requireCompanyStatus();
                      });
                  }],
              },
              parent: '/my-ploys',
              label: 'POST_PLOY'
          })
    }]);

angular.module('profile-settings', [])


.config(['$routeProvider', 'htmlPath',
  function($routeProvider, htmlPath) {

    var path = htmlPath('profile-settings');

    $routeProvider
        .when('/profile-settings', {
          templateUrl: path('settings-list.html'),
          resolve: {
            access: ["Access", Access => {
              Access.requireLogin()
            }],
          },
          label: 'SETTINGS'
        })

        .when('/account-settings', {
          templateUrl: path('account-settings.html'),
          resolve: {
            access: ["Access", Access => {
              Access.requireLogin()
            }],
          },
          parent: '/profile-settings',
          label: 'ACCOUNT'
        })

        .when('/verifications', {
          templateUrl: path('verifications.html'),
          resolve: {
            access: ["Access", Access => {
              Access.requireLogin()
            }],
          },
          parent: '/profile-settings',
          label: 'VERIFICATIONS'
        })

        .when('/notification-settings', {
          templateUrl: path('notification-settings.html'),
          resolve: {
            access: ["Access", Access => {
              Access.requireLogin()
            }],
          },
          parent: '/profile-settings',
          label: 'NOTIFICATION_SETTINGS'
        })

        .when('/privacy-settings', {
          templateUrl: path('privacy-settings.html'),
          resolve: {
            access: ["Access", Access => {
              Access.requireLogin()
            }],
          },
          parent: '/profile-settings',
          label: 'PRIVACY'
        })

}]);

angular.module('profile', [])

.config(['$routeProvider', '$locationProvider','htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

      var path = htmlPath('profile');

      $routeProvider
      .when('/profile/:userId',{
          templateUrl : path('user-profile.html'),
          label: '{{username}}',
          parent: '/'
      });

      $routeProvider
      .when('/company/:companyId',{
          templateUrl : path('company-profile.html'),
          label: '{{company}}',
          parent: '/'
      })

      .when('/profile/:userId/:slug?/:category?',{
          templateUrl : path('user-profile.html'),
          parent: '/',
          label: '{{username}}'
      })

}]);

var module = angular.module('referral', ['ngRoute']);

module.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

      var path = htmlPath('referral');

      $routeProvider
      .when('/referral', {
        templateUrl : path('referral.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireAnonymous()
          }],
        },
        // label: 'Invitation',
      })

    }]);

angular.module('report', ['ngRoute'])

.config(['$routeProvider',
    function ($routeProvider) {
        $routeProvider
            .when('/report/:ploy_id', {
                templateUrl: '/src/report/html/report.html',
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin()
                    }],
                },
                parent: '/',
                label: 'REPORT'
            })
    }]);

angular.module('salaryFactor', [])

.config(['$routeProvider', 'htmlPath', function($routeProvider, htmlPath) {

    var path = htmlPath('salary-factor');

    $routeProvider
    .when('/salary-factor', {
       templateUrl : path('salary-factor.html'),
       resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus();
            });
          }],
        },
       parent: '/my-company',
       label: 'SALARY_FACTOR__BREADCRUMB'
     })
     .when('/salary-factor/calculate', {
       templateUrl : path('add-salary-factor.html'),
       resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus();
            });
          }],
        },
       parent: '/salary-factor',
       label: 'CALCULATE_SALARY_FACTOR__BREADCRUMB'
     })

}]);

angular.module('salaryRules', [])

.config(['$routeProvider', 'htmlPath', function($routeProvider, htmlPath) {

    let path = htmlPath('salary-rules');

    $routeProvider
        .when('/salary-rules/base-salary', {
            templateUrl: path('base-salary.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin().then(() => {
                        Access.requireCompanyStatus();
                    });
                }],
            },
            parent: '/my-company',
            label: 'BASE_SALARY__HEADER'
        })
        .when('/salary-rules/overtime', {
            templateUrl: path('overtime.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin().then(() => {
                        Access.requireCompanyStatus();
                    });
                }],
            },
            parent: '/my-company',
            label: 'OVERTIME__HEADER'
        })
        .when('/salary-rules/pension', {
            templateUrl: path('pension.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin().then(() => {
                        Access.requireCompanyStatus();
                    });
                }],
            },
            parent: '/my-company',
            label: 'PENSION_SALARY__HEADER'
        })
        .when('/salary-rules/costs', {
            templateUrl: path('costs.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin().then(() => {
                        Access.requireCompanyStatus();
                    });
                }]
            },
            parent: '/my-company',
            label: 'SALARY_COSTS__HEADER'
        })

}]);

angular.module('sayHi', [])

.config(['$routeProvider', 'htmlPath', function($routeProvider, htmlPath) {

    var path = htmlPath('say-hi');

    $routeProvider
        .when('/say-hi', {
            templateUrl: path('say-hi.html'),
            resolve: {
                access: ["Access", Access => {
                    Access.requireLogin()
                }],
            },
            parent: '/application',
            label: 'SAY_HI__TITLE'
        })

}]);

angular.module('searchMeployees', [])

.config(['$routeProvider', 'htmlPath', function($routeProvider, htmlPath) {

    var path = htmlPath('search-meployees');

    $routeProvider
     .when('/search-meployees', {
       templateUrl : path('search-meployees.html'),
       resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
                Access.requireCompanyStatus();
            });
          }],
       },
       parent: '/my-staff',
       label: 'FIND_MEPLOYEE'
     })

}]);

angular.module('searchPloys', [])

module.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

      var path = htmlPath('search-ploys');

      $routeProvider
      .when('/search', {
        templateUrl : path('search-ploys.html'),
        label: 'SEARCH_PLOYS'
      })
    }]);

var module = angular.module('signUpMeployeeAddress', ['ngRoute']);

module.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

      var path = htmlPath('sign-up-meployee-address');

        $routeProvider
            .when('/sign-up/employee/address', {
                templateUrl: path('sign-up-meployee-address.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireWorkerStatus();
                        });
                    }],
                },
            })

    }]);

var module = angular.module('signUpMeployeeTaxes', ['ngRoute']);

module.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

      var path = htmlPath('sign-up-meployee-taxes');

        $routeProvider
            .when('/sign-up/employee/taxes', {
                templateUrl: path('sign-up-meployee-taxes.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireWorkerStatus();
                        });
                    }],
                },
            })

    }]);

var module = angular.module('signUpMeployee', ['ngRoute']);

module.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

        let path = htmlPath('sign-up-meployee');

        $routeProvider
            .when('/sign-up/employee', {
                templateUrl: path('sign-up-meployee.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireAnonymous()
                    }],
                    hideHeaderButtons: () => true
                },
                label: 'SIGN_UP__EMPLOYEE_ROLE__HEADING'
            })
            .when('/sign-up/employee/email', {
                templateUrl: path('sign-up-meployee-email.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireAnonymous()
                    }],
                    hideHeaderButtons: () => true
                },
                label: 'EMAIL'
            })
            .when('/sign-up/employee/details', {
                templateUrl: path('sign-up-meployee-details.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireWorkerStatus();
                        });
                    }],
                    hideHeaderButtons: () => true
                },
            })
            .when('/sign-up/employee/when-to-work', {
                templateUrl: path('sign-up-meployee-when-to-work.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireWorkerStatus();
                        });
                    }],
                    hideHeaderButtons: () => true
                },
                label: 'Worktime preferences'
            })
            .when('/sign-up/employee/choose-categories', {
                templateUrl: path('sign-up-meployee-choose-categories.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireWorkerStatus();
                        });
                    }],
                    hideHeaderButtons: () => true
                },
                label: 'CATEGORY'
            })
            .when('/sign-up/employee/calendar', {
                templateUrl: path('sign-up-meployee-calendar.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireWorkerStatus();
                        });
                    }],
                    hideHeaderButtons: () => true
                },
                label: 'CATEGORY'
            })
            .when('/sign-up/employee/postal-code', {
                templateUrl: path('sign-up-meployee-postal-code.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireWorkerStatus();
                        });
                    }],
                    hideHeaderButtons: () => true
                },
                label: 'POSTAL_CODE'
            })
            .when('/sign-up/employee/summary', {
                templateUrl: path('sign-up-meployee-summary.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireWorkerStatus();
                        });
                    }],
                    hideHeaderButtons: () => true
                },
                label: 'WELCOME_TO_MEPLOY'
            })

    }]);

var module = angular.module('signUpMeployer', ['ngRoute']);

module.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

      var path = htmlPath('sign-up-meployer');

      $routeProvider
      .when('/sign-up/employer', {
        templateUrl : path('sign-up-meployer.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireAnonymous()
          }],
          hideHeaderButtons: () => true
        },
        label: 'SIGN_UP__EMPLOYER_ROLE__HEADING'
      })

      .when('/sign-up/employer/collective-agreement', {
        templateUrl : path('sign-up-meployer-collective-agreement.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
              Access.requireCompanyStatus();
            });
          }],
          hideHeaderButtons: () => true
        },
        label: 'SIGN_UP_EMPLOYER__COLLECTIVE_AGREEMENT__BREADCRUMB'
      })

      .when('/sign-up/employer/company-address', {
        templateUrl : path('sign-up-meployer-address.html'),
        resolve: {
          access: ["Access", Access => {
            Access.requireLogin().then(() => {
              Access.requireCompanyStatus();
            });
          }],
          hideHeaderButtons: () => true
        },
        label: 'SIGN_UP_EMPLOYER__COMPANY_ADDRESS__BREADCRUMB'
      })

    }]);

var module = angular.module('signUpNewMeployee', ['ngRoute']);

module.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

        let path = htmlPath('sign-up-new-meployee');

        $routeProvider
            .when('/sign-up/new-employee', {
                templateUrl: path('sign-up-new-meployee.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireAnonymous()
                    }],
                    hideHeaderButtons: () => true
                },
                label: 'SIGN_UP__EMPLOYEE_ROLE__HEADING'
            })
            .when('/sign-up/new-employee/name', {
                templateUrl: path('sign-up-new-meployee-name.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireAnonymous()
                    }],
                    hideHeaderButtons: () => true
                },
                label: 'SIGN_UP__EMPLOYEE_ROLE__HEADING'
            })
            .when('/sign-up/new-employee/postal-code', {
                templateUrl: path('sign-up-new-meployee-postal-code.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireAnonymous()
                    }],
                    hideHeaderButtons: () => true
                },
                label: 'POSTAL_CODE'
            })
            .when('/sign-up/new-employee/birthday', {
                templateUrl: path('sign-up-new-meployee-birthday.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireAnonymous()
                    }],
                    hideHeaderButtons: () => true
                },
                label: 'BIRTHDAY'
            })
            .when('/sign-up/new-employee/email-phone', {
                templateUrl: path('sign-up-new-meployee-email-phone.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireAnonymous()
                    }],
                    hideHeaderButtons: () => true
                },
                label: 'BREADCRUMBS__EMAIL_PHONE'
            })
            .when('/sign-up/new-employee/password', {
                templateUrl: path('sign-up-new-meployee-password.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireAnonymous()
                    }],
                    hideHeaderButtons: () => true
                },
                label: 'BREADCRUMBS__PASSWORD'
            })
            .when('/sign-up/new-employee/phone-verify', {
                templateUrl: path('sign-up-new-meployee-phone-verify.html'),
                resolve: {
                    access: ['Access', Access => {
                        Access.requireLogin()
                    }],
                },
                label: 'VERIFY_PHONE_NUMBER'
            })

    }
]);

angular.module('signUp', ['ngRoute'])
    .config(['$routeProvider', 'htmlPath',
    function ($routeProvider, htmlPath) {

        let path = htmlPath('sign-up');

        $routeProvider
            .when('/sign-up', {
                templateUrl: path('sign-up.html'),
                resolve: {
                  access: ["Access", Access => {
                    Access.requireAnonymous()
                  }],
                },
                label: "SIGN_UP"
            })

    }]);

angular.module('smsVerificationBar', []);

angular.module('stat', []);

angular.module('supplement', ['ngRoute']);

var module = angular.module('terms', ['ngRoute']);

module.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

      var path = htmlPath('terms');

      $routeProvider
      .when('/terms', {
        templateUrl : path('terms.html'),
      })

      .when('/terms-of-service', {
        templateUrl : path('terms-of-service.html'),
      })

      .when('/terms-privacy-policy', {
        templateUrl : path('privacy-policy.html'),
      })

      .when('/terms-community-guidelines', {
        templateUrl : path('community-guidelines.html'),
      })

    }]);

angular.module('timecards', [])

.config(['$routeProvider', '$locationProvider', 'htmlPath',
    function ($routeProvider, $locationProvider, htmlPath) {

      var path = htmlPath('timecards');

      $routeProvider
      .when('/timecards', {
        templateUrl : path('timecards.html'),
      })

    }]);

angular.module('ui-kit', ['ngRoute'])


.config(['$routeProvider', function($routeProvider) {
    $routeProvider

        .when('/_ui-kit', {
            templateUrl: '/src/ui-kit/html/_ui-kit.html',
        })

        .when('/_ui-layouts', {
            templateUrl: '/src/ui-kit/html/_ui-layouts.html',
        })

        .when('/_ui-layout-1', {
            templateUrl: '/src/ui-kit/html/_layout-1.html',
        })

        .when('/_ui-layout-2', {
            templateUrl: '/src/ui-kit/html/_layout-2.html',
        })

        .when('/_ui-layout-3', {
            templateUrl: '/src/ui-kit/html/_layout-3.html',
        })

        .when('/_ui-layout-4', {
            templateUrl: '/src/ui-kit/html/_layout-4.html',
        })

        .when('/_ui-layout-5', {
            templateUrl: '/src/ui-kit/html/_layout-5.html',
        })

        .when('/_ui-layout-6', {
            templateUrl: '/src/ui-kit/html/_layout-6.html',
        })

         .when('/_ui-layout-7', {
            templateUrl: '/src/ui-kit/html/_layout-7.html',
        })

        .when('/_ui-layout-8', {
            templateUrl: '/src/ui-kit/html/_layout-8.html',
        })
        .when('/_ui-layout-10', {
            templateUrl: '/src/ui-kit/html/_layout-10.html',
        })


}]);

angular.module('user-menu', []);

angular.module('user', [])
angular.module('workRequirement', ['ngRoute']);

angular.module('workerSalary', ['ngRoute'])

.config(['$routeProvider', 'htmlPath',
    function ($routeProvider, htmlPath) {

        let path = htmlPath('worker-salary');
        $routeProvider
            .when('/salary', {
                templateUrl : path('worker-salary.html'),
                resolve: {
                    access: ["Access", Access => {
                        Access.requireLogin().then(() => {
                            Access.requireWorkerStatus();
                        });
                    }],
                },
                label: 'WORKER_SALARY__MENU'
            })

}]);

angular.module('apply-application')

    .controller('ApplyApplicationController', ['$scope', '$routeParams', 'User', 'Engagement', '$location', 'Ploy',
        '$translate', 'AlertBanner', 'crumble', '$filter', 'Stat', 'VerificationRequestResource', 'MyStaff',
        'KycConstants', 'DocumentResource', '$uibModal',
        ($scope, $routeParams, User, Engagement, $location, Ploy, $translate, AlertBanner, crumble, $filter,
         Stat, VerificationRequestResource, MyStaff, KycConstants, DocumentResource, $uibModal) => {

            $scope.isInCompanyStaff = false;
            $scope.form = {};
            $scope.minNumberOfDescription = 20;

            Engagement.engagementExists(User.get().id, $routeParams.ployId).$promise.then(response => {
                if (response.exists) $location.path('/my-ploys').replace();
            });

            Ploy.get({id:$routeParams.ployId}).$promise.then(data => {
                $scope.ploy = data;
                crumble.update({ploy: data});

                VerificationRequestResource.getCurrentForCompany({'companyId': $scope.ploy.company.id})
                    .$promise.then((verificationRequest) => {
                        if (verificationRequest && verificationRequest.documents) {
                            $scope.documents = verificationRequest.documents;
                        }
                    });
                MyStaff.isInStaff($scope.ploy.company.id).$promise.then(response => {
                    $scope.isInCompanyStaff = response.is_in_staff
                });

                if ( data.category.based_on_verification && !User.get().category.some((category) => category.id === data.category.id) ) {
                    $uibModal.open({
                        templateUrl: 'src/apply-application/html/modal-category-verification-required.html',
                        windowClass: 'modal-vertical-centered'
                    })
                }
            });

            let applyToPloyFn = (ploy, form) => {
                let comment = form.comment;
                if (!$scope.isInCompanyStaff) {
                    let line1 = $filter('translate')('APPLY_APPLICATION__FIRST_APPLY__INTRO_PLACEHOLDER') + ':\n' + form.bio;
                    let line2 = $filter('translate')('APPLY_APPLICATION__FIRST_APPLY__EXPERIENCE_PLACEHOLDER') + ':\n' + form.experience;
                    let line3 = $filter('translate')('APPLY_APPLICATION__FIRST_APPLY__COVER_LETTER_PLACEHOLDER') + ':\n' + form.cover_letter;
                    comment = line1 + '\n\n' + line2 + '\n\n' + line3
                }
                Stat.recordUserAction('apply to ploy before', {ploy, comment});
                Engagement.applyToPloy(ploy, comment).then(engId => {
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('APPLY_APPLICATION__SUCCESFULLY_APPLIED')+'!',
                        timeCollapse: 4000
                    });
                    Stat.recordUserAction('apply to ploy after', {ploy, comment});
                    DocumentResource.updateDocumentPermissions({'documents': $scope.documents,
                        'companyId': $scope.ploy.company.id}).$promise.then(() => {
                        $location.path('/my-ploys/' + engId + '/conversation');
                    });
                }, (error) => {
                    if (!error) return;  // if error is missing - case for new users. Check because empty reject may be returned by frontend
                    let errorMessage = (error.data[0]) ? error.data[0] : 'SOMETHING_WENT_WRONG_PLEASE_CONTACT_WITH_SUPPORT';
                    AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')(errorMessage),
                        timeCollapse: 4000
                    });
                });
            };

            $scope.applyToPloy = _.debounce(applyToPloyFn, 200);

            /**
             * Returns 'true' if validation is failing
             */
            $scope.applyValidationIsMissing = () => {
                return Engagement.applyValidationIsMissing($scope.ploy) || $scope.ApplicationForm.$invalid;
            };

            $scope.documents = [];
            $scope.checkedDocumentTypes = [KycConstants.criminalRecord, KycConstants.truckLicence, KycConstants.cv];
            $scope.documentTranslationKeys = KycConstants.documentTranslationKeys;

            $scope.hasDocumentsToShow = () => {
                return $scope.documents
                    .filter(d => $scope.checkedDocumentTypes.indexOf(d.type) > -1 && d.has_pictures === true).length > 0;
            };

        }]);

angular.module('apply-application')

.controller('ModalVerifyEmailController', ['$scope', 'User', 'Modal', '$uibModal', '$filter', function ($scope, User, Modal, $uibModal, $filter) {
    $scope.openVerifyEmailModal = function () {
        if (!User.get().id) {
            Modal.alert({
                title: 'Psst..',
                message: $filter('translate')('YOU_NEED_TO_LOGIN_FIRST')
            })
        } else {
            $uibModal.open({
                templateUrl: 'src/apply-application/html/modal-verify-email.html',
                controller: 'ModalVerifyEmailController',
                windowClass: 'modal-vertical-centered'
            })
        }
    };

    $scope.email = User.get().email;
    $scope.sendVerificationEmail = User.sendVerificationEmail;
}]);

angular.module('apply-application')

.controller('ModalVerifyPhoneController', ['$scope', 'User', '$uibModal', 'Modal', '$filter', '$analytics',
, function ($scope, User, $uibModal, Modal, $filter, $analytics) {
    $scope.openVerifyPhoneModal = function () {
        if (!User.get().id) {
            Modal.alert({
                title: 'Psst..',
                message: $filter('translate')('YOU_NEED_TO_LOGIN_FIRST')
            })
        } else {
            $uibModal.open({
                templateUrl: 'src/apply-application/html/modal-verify-phone.html',
                controller: 'ModalVerifyPhoneController',
                windowClass: 'modal-vertical-centered'
            })
        }
    };

    User.get().$promise.then(function(user) {         $scope.form = angular.copy(user);     });
    $scope.user_have_phone = User.get().phone;
    $scope.second_step = false;
    $scope.savePhone = function(user) {
        User.save(user).then(function() {
            $scope.second_step = true;
        });
    };
    $scope.resendCode = function () {
        $scope.second_step = false;
        $scope.user_have_phone = false;
    };
    $scope.confirmPhone = function(phoneVerifyCode) {
        User.verifyPhone(phoneVerifyCode).$promise.then(function(){
            $scope.correctCode = true;
            $scope.wrongCode = false;
            User.get().phone_verify = true;
            $analytics.eventTrack('Verify phone', {category: 'Registration'});
        }, function (error) {
            $scope.correctCode = false;
            $scope.wrongCode = true;
        });
    };

}]);

angular.module('checkInOut')
.controller('CheckInOutBarController', ['$scope', 'CheckInOutService', '$location',
    function ($scope, CheckInOutService, $location) {

    $scope.myTodayEngs = {};

    $scope.checkInOut = (engId) => {
        $location.path('/check-in-out/' + engId);
    };

    $scope.getTodayEngagements = CheckInOutService.getTodayEngagements;

    $scope.hideBar = () => $location.path().includes('check-in-out')

    $scope.isEngStartsFromYesterday = eng => {
        return moment(eng.checkin_time).add(1, 'days').format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")
    };

}]);

angular.module('checkInOut')
.controller('CheckInOutPageController', ['$scope', 'WorkLogResource', '$routeParams', '$location', '$uibModal', 'Stat',
    'Modal', '$translate', 'CheckInOutService', 'AlertBanner', '$filter', 'CompanyDocument', 'Constants', '$analytics',
    function ($scope, WorkLogResource, $routeParams, $location, $uibModal, Stat, Modal,
              $translate, CheckInOutService, AlertBanner, $filter, CompanyDocument, Constants, $analytics) {

        let initialCurrentEng = {};
        $scope.form = {};
        $scope.unacceptedDocuments = [];
        $scope.isHelpCollapsed = true;
        $scope.isCheckedInLate = false;
        $scope.lateCheckInTime = new Date();

        let loadTodayEngagements = () => {
            WorkLogResource.myTodayEngagements().$promise.then((todayEngs) => {
                let currentEng = todayEngs.filter(eng => eng.id == $routeParams.engId)[0];
                if (!currentEng) {
                    $location.path('/');
                    return;
                }
                const ployStartTime = moment(currentEng.checkin_time).set({
                        hour: currentEng.ploy.start_time.getHours(),
                        minute: currentEng.ploy.start_time.getMinutes(),
                        second: 0
                    });
                if (moment(currentEng.checkin_time).isAfter(ployStartTime)) {
                    $scope.isCheckedInLate = true;
                    $scope.lateCheckInTime = angular.copy(currentEng.checkin_time);
                }
                $scope.currentEng = currentEng;
                $scope.currentEng.comment = currentEng.last_comment;
                if (currentEng.last_pause_time) {
                    $scope.currentEng.pause_time = moment.duration(currentEng.last_pause_time * 1000);
                }
                $scope.currentEng.lunchBreak = CheckInOutService.prepareLunchBreak($scope.currentEng);

                $scope.ployFromPast = new Date(currentEng.checkout_time).getTime() < new Date().getTime();

                initialCurrentEng = angular.copy(currentEng);
                CompanyDocument.loadUnacceptedDocuments(currentEng.ploy.company.id).then(documents => {
                    documents.forEach(doc => {
                        doc.accepted = false;
                        $scope.unacceptedDocuments.push(doc)
                    })
                });

                $scope.differentCheckinTime = {};
                $scope.differentCheckinTime.checkin_time = $scope.currentEng.checkin_time;
                $scope.differentCheckinTime.requested_by = '';
                $scope.differentCheckinTime.showForm = false;
                CheckInOutService.isTrustedToModifyTime({'companyId': $scope.currentEng.ploy.company.id}).$promise.then(response => {
                    $scope.isTrustedToModifyTime = response.isTrusted;
                });

            });
        };
        loadTodayEngagements();

        $scope.messageEmployer = () => {
            $location.path('/my-ploys/' + $routeParams.engId + '/conversation');
        };

        $scope.goToContactUs = () => {
            $location.path('/contact_us');
        };


        let lateReasons = [
            {
                value: 'oversleep',
                translationKey: 'CHECK_IN_BAR__OVERSLEEP',
            },
            {
                value: 'cant_find_location',
                translationKey: 'CHECK_IN_BAR__CANT_FIND_LOCATION',
            },
            {
                value: 'public_transport',
                translationKey: 'CHECK_IN_BAR__PUBLIC_TRANSPORT',
            }
        ];

        let lateMinutes = [5, 10, 15, 20, 30, 45, 60];

        $scope.runningLate = () => {
            let runningLateInstance = $uibModal.open({
                templateUrl: 'src/check-in-out/html/modals/running-late.html',
                windowClass: 'modal-vertical-centered',
                controller: function($scope) {
                    $scope.lateReasons = lateReasons;
                    $scope.reason = lateReasons[0];
                    $scope.setReason = (reason) => {
                        $scope.reason = reason;
                    }
                },
            });
            runningLateInstance.result.then((chosenReason) => {
                if (chosenReason) {
                    let lateMinutesInstance = $uibModal.open({
                        templateUrl: 'src/check-in-out/html/modals/running-late-minutes.html',
                        windowClass: 'modal-vertical-centered',
                        controller: function($scope) {
                            $scope.lateMinutes = lateMinutes;
                            $scope.minutes = lateMinutes[0];
                            $scope.setMinutes = (minutes) => {
                                $scope.minutes = minutes;
                            }
                        }
                    });
                    lateMinutesInstance.result.then((minutes) => {
                        if (minutes) {
                            let data = {
                                will_be_late: chosenReason.value,
                                engagement: $routeParams.engId,
                                will_be_late_minutes: minutes,
                                log_type: Constants.workLogTypes.WORK_LOG_TYPE_WILL_BE_LATE,
                            };
                            WorkLogResource.iWillBeLate(data).$promise.then(() => {
                                Modal.alert({
                                    title: $filter('translate')('CHECK_IN_BAR__LATE_REPORTED'),
                                });
                            });
                        }
                    });
                }
            });
        };

        $scope.checkIn = (date, requestedBy) => {
            let data = {
                checkin_time: (date) ? date : new Date(),
                engagement: $routeParams.engId,
                log_type: (date) ? Constants.workLogTypes.WORK_LOG_TYPE_CHECK_IN_MODIFIED : Constants.workLogTypes.WORK_LOG_TYPE_CHECK_IN,
            };
            if (requestedBy) {
                data['requested_by'] = requestedBy;
            }
            Stat.recordUserAction('check-in before', data);
            WorkLogResource.checkIn(data).$promise.then(() => {
                CheckInOutService.refreshTodayEngagements();
                loadTodayEngagements();
                AlertBanner.publish({
                    type: 'success',
                    message: $filter('translate')('CHECK_IN_BAR__SUCCESS_CHECK_IN'),
                    timeCollapse: 6000
                });
                Stat.recordUserAction('check-in after', data);
                $analytics.eventTrack('CheckIn', {category: 'Ploy'});
            }, error => {
                let errorMessage = (error.data[0]) ? error.data[0] : 'SOMETHING_WENT_WRONG_PLEASE_CONTACT_WITH_SUPPORT';
                AlertBanner.publish({
                    type: 'error',
                    message: $filter('translate')(errorMessage),
                    timeCollapse: 4000
                });
            });
        };


        $scope.changeCheckInTimeAndCheckIn = (newCheckInTime, requestedBy) => {
            $scope.checkIn(newCheckInTime, requestedBy);
        };


        $scope.saveForLater = () => {
            let data = {
                checkin_time: $scope.currentEng.checkin_time,
                checkout_time: $scope.currentEng.checkout_time,
                engagement: $routeParams.engId,
                pause_time: $scope.currentEng.pauseTime,
                comment: $scope.currentEng.comment,
                requested_by: $scope.currentEng.requested_by,
                log_type: Constants.workLogTypes.WORK_LOG_TYPE_SAVE_FOR_LATER,
            };

            WorkLogResource.saveForLater(data).$promise.then(() => {
                $location.path('/');
            });
        };

        $scope.submitForm = (record) => {
            let data = CheckInOutService.prepareWorkLogToSave(record, initialCurrentEng);
            Stat.recordUserAction('check-out before', data);
            WorkLogResource.checkOut(data).$promise.then(() => {
                CheckInOutService.refreshTodayEngagements();
                Stat.recordUserAction('check-out after', data);
                AlertBanner.publish({
                    type: 'success',
                    message: $filter('translate')('CHECK_IN_OUT_PAGE__CHECKOUT_SUCCESS_MESSAGE'),
                    timeCollapse: 3000
                });
                $location.path('/');
            }, error => {
                AlertBanner.publish({
                    type: 'error',
                    message: $filter('translate')('CHECK_IN_OUT_PAGE__MODAL_ERROR__' + error.data[0]),
                    timeCollapse: 5000
                });
            });
        };

        let isInitialTimeChanged = (currentEngLastComment, checkinTime, checkoutTime) => {
            if (currentEngLastComment) return true;
            if (checkinTime.format() !== moment(initialCurrentEng.checkin_time).format()) {
                return true;
            }
            return checkoutTime.format() > moment(initialCurrentEng.checkout_time).format();
        };

        $scope.$watchGroup([ 'currentEng.checkout_time', 'currentEng.checkin_time','currentEng.lunchBreak'], (newVal, oldVal) => {
            if ($scope.currentEng) {
                $scope.currentEng = CheckInOutService.calcCheckInOutPause($scope.currentEng, newVal);

                let checkout_time = moment(newVal[0]).seconds(0).milliseconds(0);
                let checkin_time = moment(newVal[1]).seconds(0).milliseconds(0);
                $scope.touched = isInitialTimeChanged($scope.currentEng.last_comment, checkin_time, checkout_time);
            }
        });

        $scope.isOvertime = CheckInOutService.isOvertime;

        $scope.touched = false;

        $scope.anyDocumentsAreUnaccepted = () => {
            return $scope.unacceptedDocuments.some(document => {
                return !document.accepted;
            })
        };

        $scope.differentNameRequestedByRequired = () => {
            return !Boolean($scope.differentCheckinTime.requested_by);
        };

        $scope.toggleDifferentCheckinTime = () => {
            $scope.differentCheckinTime.showForm = !$scope.differentCheckinTime.showForm;
        };



    }
]);

angular.module('checkInOut')

.factory('WorkLogResource', ['$resource', function($resource) {
    return $resource('/api/work-log/:id/', {id: '@id'}, {
        'myTodayEngagements': {
            url: '/api/work-log/my_today_engagements/',
            method: 'GET',
            isArray: true,
        },
        'iWillBeLate': {
            url: '/api/work-log/',
            method: 'POST',
        },
        'checkIn': {
            url: '/api/work-log/',
            method: 'POST',
        },
        'checkOut': {
            url: '/api/work-log/',
            method: 'POST',
        },
        'saveForLater': {
            url: '/api/work-log/',
            method: 'POST',
        }
    });
}]);

angular.module('checkInOut')

.service('CheckInOutService', ['WorkLogResource', 'MyStaffResource', 'Constants',
    function(WorkLogResource, MyStaffResource, Constants) {

        let CheckInOutService = {};

        let myTodayEngagements = {};

        let loadTodayEngagements = () => {
            WorkLogResource.myTodayEngagements().$promise.then((engs) => {
                myTodayEngagements = engs;
            });
        };
        loadTodayEngagements();

        CheckInOutService.getTodayEngagements = () => {
            return myTodayEngagements;
        };

        CheckInOutService.refreshTodayEngagements = () => {
            loadTodayEngagements();
        };

        /**
         * Common method to calc values for calculations while checkout in checkout page and modify check-in-out page
         * @param eng
         * @param newVal
         * @returns {*} engagement
         */
        CheckInOutService.calcCheckInOutPause = (eng, newVal) => {
            let lunch_break = moment(newVal[2]).seconds(0).milliseconds(0);
            let startOfDay = moment(newVal[2]).startOf('day').seconds(0).milliseconds(0);
            let tempLunchBreak = moment.duration(lunch_break.diff(startOfDay));
            let checkout_time = moment(newVal[0]).seconds(0).milliseconds(0);
            let checkin_time = moment(newVal[1]).seconds(0).milliseconds(0);

            eng.checkOutTimeDiff = 0;
            eng.workTime = moment.duration(checkout_time.diff(checkin_time));
            eng.workTime = eng.workTime - tempLunchBreak;
            eng.workTimeToDisplay = eng.workTime;
            if (eng.workTimeToDisplay >= 86400000) {  // fix - when work time is above 24h
                eng.workTimeToDisplay = eng.workTimeToDisplay - 86400000;
                eng.checkOutTimeDiff = -86400000;  // needed to decrease day
            }
            if (eng.workTimeToDisplay < 0) {  // fix - when work time is below 0h
                eng.workTimeToDisplay = eng.workTimeToDisplay + 86400000;
                eng.checkOutTimeDiff = 86400000;  // needed to increase day
            }
            eng.pauseTime = tempLunchBreak.asSeconds();

            return eng;
        };

        /**
         * Used to prepare engagement to create WorkLog. User in checkInOutPage and in modify check-in-out page
         * @param engagement
         * @param initialEng
         * @returns {{checkin_time: *, engagement: *, requested_by: undefined, pause_time, checkout_time: *, comment: (*|undefined)}}
         */
        CheckInOutService.prepareWorkLogToSave = (engagement, initialEng) => {
            let checkin_time = angular.copy(engagement.checkin_time);
            let checkout_time = moment(engagement.checkout_time).add(engagement.checkOutTimeDiff);  // add to fix day if end earlier/later day than should
            // case = checkin time changed - to be in the next day, e.g. from 23:00 to 01:00
            if (engagement.checkin_time < moment(initialEng.checkin_time).add(-12, 'hours')) {
                checkin_time = moment(checkin_time).add(1, 'days');
                checkout_time = moment(checkout_time).add(1, 'days');
            }

            return {
                'checkin_time': checkin_time,
                'checkout_time': checkout_time,
                'pause_time': engagement.pauseTime,
                'engagement': engagement.id,
                'comment' : engagement.comment || undefined,
                'requested_by' : engagement.requested_by || undefined,
                'log_type': Constants.workLogTypes.WORK_LOG_TYPE_CHECK_OUT,
            };
        };

        /**
         * Used to prepare lunch break in check-in-out report. User in checkInOutPage and in modify check-in-out page
         * @param engagement
         * @returns {Date}
         */
        CheckInOutService.prepareLunchBreak = (engagement) => {
            let lunchBreak = new Date();
            if (engagement.pause_time) {
                let lb = moment.duration(engagement.pause_time);
                lunchBreak.setHours(lb.hours());
                lunchBreak.setMinutes(lb.minutes());
            } else {
                lunchBreak.setHours(0);
                lunchBreak.setMinutes(30);
            }
            lunchBreak.setSeconds(0);
            return lunchBreak;
        };

        CheckInOutService.isOvertime = (engagement) => {
            if (engagement) {
                return (engagement.workTimeToDisplay / 1000) > engagement.ploy.should_work_time;
            }
            return true;
        };

        CheckInOutService.isTrustedToModifyTime = MyStaffResource.isTrustedToModifyTime;

        return CheckInOutService;

}]);

angular.module('cms')
.directive('getCmsText', ['Cms', 'LanguageService',
    function(Cms, LanguageService) {
        return {
            restrict: 'E',
            scope: {
                slug: '=slug'
            },
            template : '<div ng-bind-html="text"></div>',
            link: function(scope, iElm, iAttrs, controller) {

                function doRefresh(lang) {
                    Cms.get({'slug': iAttrs.slug}).$promise.then(function(data) {
                      scope.text = data['text_'+lang];
                      if(!scope.text){
                          scope.text = data.text;
                        }
                    });
                }
                doRefresh(LanguageService.getCurrentLanguage());

                scope.$on('refreshLanguage', function(event, lang) {
                    doRefresh(lang);
                });
            }
        };
    }
])
;

angular.module('cms')
.factory('CmsResource', [
    '$resource',
    function($resource) {
        return $resource('/api/mcms/:slug/', {slug:'@slug'}, {
            update: { method:'PATCH' },
            startingWith : {
                url: '/api/mcms/:slug/starting_with/',
                isArray : true
            }
        });
}]);


angular.module('cms')
.service('Cms', ['CmsResource', function(CmsResource) {
        this.get = CmsResource.get;
        this.search = CmsResource.startingWith ;
    }
]);
angular.module('collectiveAgreement')

  .controller('AddEditCollectiveAgreementController', ['$scope', 'CollectiveAgreement', 'Modal', '$location', '$filter', 'AlertBanner', 'MeployerOnboardingBar', '$routeParams', 'CollectiveAgreementSupplementResource',
    function ($scope, CollectiveAgreement, Modal, $location, $filter, AlertBanner, MeployerOnboardingBar, $routeParams, CollectiveAgreementSupplementResource) {

        $scope.collectiveAgreementFile = {};
        $scope.collectiveAgreement = {
            free_choice_payroll: 4,
            public_holidays: 4,
            extra_holiday_entitlements: 2.5,
            extra_supplement_type: 'percentage'
        };

        $scope.isCalculatorFormValid = false;
        $scope.costs = [];
        $scope.supplements = [];
        $scope.calculatedCosts = {
            supplements: {}
        };

        CollectiveAgreement.getTradeUnions().$promise.then(unions => {
            $scope.autocompleteData = unions;
        });

        CollectiveAgreement.getCollectiveAgreementCosts().$promise.then(data => {
            $scope.costs = data;
        });

        if ($routeParams.collective_agreement_id) {
            CollectiveAgreement.getCollectiveAgreement({'id': $routeParams.collective_agreement_id}).$promise.then(agreement => {
                let tempCosts = {};
                $scope.costs.filter(fullCost => {
                   tempCosts[fullCost.slug] = agreement.costs.some(costID => costID === fullCost.id);
                });
                agreement.costs = tempCosts;
                $scope.collectiveAgreement = agreement;
                CollectiveAgreement.calculateTotalSalary($scope.collectiveAgreement).$promise.then(data => {
                    $scope.calculatedCosts = data;
                });
            });
            CollectiveAgreementSupplementResource.getSupplementsForCA({'caId': $routeParams.collective_agreement_id}).$promise.then(supplements => {
                $scope.supplements = supplements;
            })
        }

        let calculateFn = () => {
            if (!$scope.isCalculatorFormValid) return;
            Object.keys($scope.collectiveAgreement).map(val => {
                if ($scope.collectiveAgreement[val] === null) {
                    $scope.collectiveAgreement[val] = 0
                }
            });
            $scope.collectiveAgreement.supplements = $scope.supplements;
            CollectiveAgreement.calculateTotalSalary($scope.collectiveAgreement).$promise.then(data => {
                $scope.calculatedCosts = data;
            });
        };

        $scope.openFileUploadedModal = () => {
            Modal.alert({
                title: $filter('translate')('ADD_COLLECTIVE_AGREEMENT__UPLOADER__MODAL_TITLE'),
                message: $filter('translate')('ADD_COLLECTIVE_AGREEMENT__UPLOADER__MODAL_CONTENT'),
                buttonColor: 'green',
            });
            $location.path('/collective-agreements')
        };

        $scope.calculateTotalSalary = _.debounce(calculateFn, 350, {leading: true, trailing: true});

        $scope.saveCollectiveAgreement = () => {
            return Modal.confirm({
                title: $filter('translate')('ADD_COLLECTIVE_AGREEMENT__FACTOR_MODAL__TITLE'),
                message: '<b>' + $filter('translate')('ADD_COLLECTIVE_AGREEMENT__FACTOR_MODAL__FACTOR_LABEL') + ' ' + $scope.calculatedCosts.factor + '</b><br/><br/>' + $filter('translate')('ADD_COLLECTIVE_AGREEMENT__FACTOR_MODAL__AGREEMENT_PARAGRAPH'),
                firstButtonLabel: $filter('translate')('ADD_COLLECTIVE_AGREEMENT__FACTOR_MODAL__FIRST_BUTTON_LABEL'),
                secondButtonLabel: $filter('translate')('ADD_COLLECTIVE_AGREEMENT__FACTOR_MODAL__SECOND_BUTTON_LABEL'),
                secondButtonColor: 'green',
                staticBackdrop: true,
                secondButtonFunction: () => {
                    let actionsAfterSave = (collectiveAgreementId) => {
                        AlertBanner.publish({
                            type: 'success',
                            message: $filter('translate')('SAVED') + '!',
                            timeCollapse: 4000
                        });
                        MeployerOnboardingBar.loadCollectiveAgreements();

                        $location.path('/collective-agreements');
                    };
                    if ($scope.collectiveAgreement.id) {
                        delete $scope.collectiveAgreement.agreement_file;
                        return CollectiveAgreement.updateCollectiveAgreement($scope.collectiveAgreement).$promise.then((collectiveAgreement) => {
                            actionsAfterSave(collectiveAgreement.id);
                        })
                    }
                    CollectiveAgreement.saveCollectiveAgreement($scope.collectiveAgreement).$promise.then(collectiveAgreement => {
                        actionsAfterSave(collectiveAgreement.id);
                    })
                },
            });
        }

    }]);

angular.module('collectiveAgreement')
.controller('AddSupplementModalController', ['$scope',
    function($scope, ) {

   $scope.supplement = {};
   $scope.addSupplement = supplement => {
    $scope.$close(supplement)
  };

}]);

angular.module('collectiveAgreement')

  .controller('CollectiveAgreementController', ['$scope', 'CollectiveAgreement', 'SalaryGroupService', '$uibModal', 'AlertBanner', '$filter', 'Modal', '$location',
    function ($scope, CollectiveAgreement, SalaryGroupService, $uibModal, AlertBanner, $filter, Modal, $location) {
        $scope.establishedCollectiveAgreements = [];
        CollectiveAgreement.loadEstablishedCollectiveAgreements().$promise.then(agreements => {
            $scope.establishedCollectiveAgreements = agreements;
        });

        CollectiveAgreement.loadCompanyFilesWithoutAgreement().$promise.then(files => {
            $scope.agreementFilesWithoutAgreement = files;
        });

        $scope.deactivateEstablishedAgreement = establishedAgreement => {
            Modal.confirm({
                title: $filter('translate')('COLLECTIVE_AGREEMENT__TABLE__DEACTIVATE_MODAL_TITLE'),
                message: $filter('translate')('ARE_YOU_SURE'),
                firstButtonLabel: $filter('translate')('CANCEL'),
                secondButtonLabel: $filter('translate')('YES'),
                secondButtonColor: 'red',
                secondButtonFunction: () => {
                    return CollectiveAgreement.deactivateEstablishedCollectiveAgreements(establishedAgreement).$promise.then(() => {
                        AlertBanner.publish({
                            type: 'success',
                            message: $filter('translate')('SAVED') + '!',
                            timeCollapse: 4000
                        });
                        CollectiveAgreement.loadEstablishedCollectiveAgreements().$promise.then(agreements => {
                            $scope.establishedCollectiveAgreements = agreements;
                        });
                    })
                }
            });
        };

        $scope.goToEditCollectiveAgreement = collectiveAgreementId => {
          $location.path('/collective-agreements/edit/' + collectiveAgreementId)
        };

        $scope.updateSalaryGroup = establishedAgreement => {
            return $uibModal.open({
                templateUrl: '/src/collective-agreement/html/modals/update-established-agreement-salary-group-modal.html',
                windowClass: 'modal-vertical-centered',
                controller: 'UpdateEstablishedAgreementSalaryGroupModalController',
                size: 'sm',
                resolve: {
                    establishedAgreement: () => {
                        return establishedAgreement
                    }
                }
            }).result.then(() => {
                CollectiveAgreement.loadEstablishedCollectiveAgreements().$promise.then(agreements => {
                    $scope.establishedCollectiveAgreements = agreements;
                });
            });
        };

    }]);

angular.module('collectiveAgreement')
.controller('UpdateEstablishedAgreementSalaryGroupModalController', ['$scope', 'establishedAgreement', 'CollectiveAgreement', 'SalaryGroupService',
    function($scope, establishedAgreement, CollectiveAgreement, SalaryGroupService) {
    $scope.establishedAgreement = establishedAgreement;
    SalaryGroupService.getList().$promise.then(groups => {
       $scope.salaryGroups = groups;
    });
    $scope.form = {
        id: establishedAgreement.id,
    };
    $scope.updateSalaryGroup = form => {
        CollectiveAgreement.updateEstablishedAgreement(form).$promise.then(() => {
            $scope.$close();
        })
    }

}]);

angular.module('collectiveAgreement')
.directive('collectiveAgreementCalculator', ['CollectiveAgreement', '$uibModal', 'Modal', '$filter',
    function(CollectiveAgreement, $uibModal, Modal, $filter) {
  return {
    restrict: 'AE',
    templateUrl: '/src/collective-agreement/html/directives/collective-agreement-calculator.html',
    scope: {
      ngModel : '=',
      calculatedCosts: '=',
      costs: '=',
      supplements: '=',
      onValuesChange: '&',
      isValid: "="
    },
    require: 'ngModel',
    link: function (scope, element, attrs, ngModelCtrl) {

      scope.displayAddSupplementForm = false;
      scope.totalSalary = 0;
      scope.enabledFields = {
        'free_choice_payroll': true,
        'public_holidays': true,
        'extra_holiday_entitlements': true,
        'extra_supplement': true,
      };

      scope.$watch('ngModel', () => {
        scope.isValid = scope.CollectiveAgreementCalculatorForm.$valid;
        if (scope.ngModel.id) {
          scope.enabledFields.free_choice_payroll = scope.ngModel.free_choice_payroll > 0;
          scope.enabledFields.public_holidays = scope.ngModel.public_holidays > 0;
          scope.enabledFields.extra_holiday_entitlements = scope.ngModel.extra_holiday_entitlements > 0;
          scope.enabledFields.extra_supplement = scope.ngModel.extra_supplement > 0;
        }
      }, true);

      scope.$watch('supplements', () => scope.onValuesChange(), true);

      scope.addSupplementModal = () => {
          return $uibModal.open({
              templateUrl: '/src/collective-agreement/html/modals/add-supplement-modal.html',
              windowClass: 'modal-vertical-centered',
              controller: 'AddSupplementModalController',
              size: 'sm',
              backdrop: 'static'
          }).result.then((supplement) => {
            scope.supplements.push(supplement);
          });
      };

      scope.removeSupplement = (supplement) => {
        return Modal.confirm({
          title: $filter('translate')('REMOVE'),
          message: $filter('translate')('ARE_YOU_SURE'),
          firstButtonLabel: $filter('translate')('CANCEL'),
          secondButtonLabel: $filter('translate')('REMOVE'),
          secondButtonColor: 'red',
          staticBackdrop: true,
          secondButtonFunction: () => {
            if (supplement.id) {
              supplement.remove = true;
            } else {
              scope.supplements = scope.supplements.filter(s => s !== supplement);
            }
          }
        });
      };

      scope.displayCalculatedSupplementValue = supplement => {
          return scope.calculatedCosts.supplements[supplement.name]
      }
    }
  }
}]);

angular.module('collectiveAgreement')
.directive('collectiveAgreementUploader', ['CollectiveAgreement', 'Upload', function(CollectiveAgreement, Upload) {
  return {
    restrict: 'AE',
    templateUrl: '/src/collective-agreement/html/directives/collective-agreement-uploader.html',
    scope: {
         ngModel : '=',
         onFileUploaded: '&'
    },
    require: 'ngModel',
    link: function (scope, element, attrs, ngModelCtrl) {
        scope.uploadCollectiveAgreementFile = files => {
           if (files && files.length) {
                const file = files[0];
                Upload.upload({
                    url: '/api/collective-agreement-file/',
                    data: {
                        file: file,
                    },
                }).then(response => {
                    response.data.filename = response.data.file.replace(/^.*[\\\/]/, '');
                    scope.uploadedFile = response.data;
                    scope.ngModel = response.data.id;
                    scope.onFileUploaded();
                }, err => {
                });
            }
        };
        scope.resetUpload = () => {
            scope.uploadedFile = {}
        }
    }
}}]);


angular.module('collectiveAgreement')

.filter('SupplementValue', ['$translate', function($translate) {
    return function(supplement) {
        if (!supplement) {return}
        let mapType = (type) => {
          return type === 'percentage' ? '%' : ' ' + $translate.instant('FACTOR_CALCULATOR__UNIT')
        };

        return supplement.hourly_value + mapType(supplement.supplement_type)
    };
}]);

angular.module('collectiveAgreement')

.factory('CollectiveAgreementCostResource', ['$resource', function($resource) {
  return  $resource('/api/collective-agreement-cost/:id/', {id:'@id'},{
          update: { method:'PATCH'},
      });
  }]);

angular.module('collectiveAgreement')

.factory('CollectiveAgreementEstablishedAgreementResource', ['$resource', function($resource) {
  return  $resource('/api/collective-agreement-established-agreement/:id/', {id:'@id'},{
          update: { method:'PATCH'},
          deactivate: {
            method: 'POST',
            url: '/api/collective-agreement-established-agreement/deactivate_established_agreement/',
          },
      });
  }]);

angular.module('collectiveAgreement')

.factory('CollectiveAgreementFileResource', ['$resource', function($resource) {
  return  $resource('/api/collective-agreement-file/:id/', {id:'@id'},{
          update: { method:'PATCH'},
          companyFilesWithoutAgreement: {
            method: 'GET',
            url: '/api/collective-agreement-file/company_files_without_agreement/',
              isArray: true
          },
      });
  }]);

angular.module('collectiveAgreement')

.factory('CollectiveAgreementSupplementResource', ['$resource', function($resource) {
  return  $resource('/api/collective-agreement-supplement/:id/', {id:'@id'}, {
    'getSupplementsForCA': {
      method: 'GET',
      url: '/api/collective-agreement-supplement/get_supplements_for_ca/',
      isArray: true,
    },
  });
}]);

angular.module('collectiveAgreement')

.factory('CollectiveAgreementTradeUnionResource', ['$resource', function($resource) {
  return  $resource('/api/collective-agreement-trade-union/:id/', {id:'@id'}, {});
}]);

angular.module('collectiveAgreement')

.factory('CollectiveAgreementResource', ['$resource', function($resource) {
  return  $resource('/api/collective-agreement/:id/', {id:'@id'},{
          update: { method:'PATCH'},
          calculateTotalSalary: {
            method: 'POST',
            url: '/api/collective-agreement/calculate_total/',
          },
          hasCollectiveAgreement: {
            method: 'GET',
            url: '/api/collective-agreement/has_established_agreements/',
          },
      });
  }]);

angular.module('collectiveAgreement')

.factory('CollectiveAgreement', ['CollectiveAgreementResource', 'CollectiveAgreementCostResource',
    'CollectiveAgreementTradeUnionResource', 'CollectiveAgreementEstablishedAgreementResource', 'CollectiveAgreementFileResource',
    function (CollectiveAgreementResource, CollectiveAgreementCostResource,
              CollectiveAgreementTradeUnionResource, CollectiveAgreementEstablishedAgreementResource, CollectiveAgreementFileResource) {

    let CollectiveAgreementService = {};

    CollectiveAgreementService.getCollectiveAgreementCosts = CollectiveAgreementCostResource.query;
    CollectiveAgreementService.getTradeUnions = CollectiveAgreementTradeUnionResource.query;
    CollectiveAgreementService.loadEstablishedCollectiveAgreements = CollectiveAgreementEstablishedAgreementResource.query;
    CollectiveAgreementService.saveCollectiveAgreement = CollectiveAgreementResource.save;
    CollectiveAgreementService.updateCollectiveAgreement = CollectiveAgreementResource.update;
    CollectiveAgreementService.calculateTotalSalary = CollectiveAgreementResource.calculateTotalSalary;
    CollectiveAgreementService.updateEstablishedAgreement = CollectiveAgreementEstablishedAgreementResource.update;
    CollectiveAgreementService.hasCollectiveAgreements =  CollectiveAgreementResource.hasCollectiveAgreement;
    CollectiveAgreementService.deactivateEstablishedCollectiveAgreements = CollectiveAgreementEstablishedAgreementResource.deactivate;
    CollectiveAgreementService.loadCompanyFilesWithoutAgreement = CollectiveAgreementFileResource.companyFilesWithoutAgreement;
    CollectiveAgreementService.getCollectiveAgreement = CollectiveAgreementResource.get;

    return CollectiveAgreementService

}]);

angular.module('confirm-email')
.controller('ConfirmEmailInfoController', ['$scope', 'User', '$location',
    function($scope, User, $location) {

        User.get().$promise.then( (user) => {
            if (user.email_verify) {
                $location.path('/')
            }
        });

    }
]);


angular.module('confirm-email')

.controller('ConfirmEmailController', ['$scope', 'User', '$routeParams', '$location', 'Constants', 'LanguageService', '$auth', '$analytics',
    function($scope, User, $routeParams, $location, Constants, LanguageService,$auth, $analytics) {
    $scope.lang = LanguageService.getCurrentLanguage;
    $scope.user=User.currentUser;
    $scope.success = -1;
    $analytics.eventTrack('Complete Registration', {category: 'Registration'});

    User.confirmEmail($routeParams.token).$promise.then(function(data){
        if(data.token) {
            $auth.setToken(data.token);
        }
        $scope.user=User.get();
        $scope.success = 1;
    }, function(error) {
        $scope.success = 0;
    });

    $scope.redirect = () => {
        User.refresh().then(() => {  // needs to refresh user, because /my-calendar resolver will redirect back to confirm-email page if user not refreshed (email_verified must be updated)
            User.get().$promise.then(user => {
                $location.path(`/profile/${user.id}`);
            });
        });
    };
}]);

angular.module('contact-us')

.controller('ContactUsController', ['$scope', 'Constants', 'ContactForm', 'AlertBanner', '$filter', '$location', '$auth', '$routeParams', 'User',
        function($scope, Constants, ContactForm, AlertBanner, $filter, $location, $auth, $routeParams, User) {

    $scope.form = {};
    $scope.problem = false;

    if (_.get($routeParams,'problem',false)) {
        $scope.problem = true;
        $scope.form.subject = 'Engagement id '+_.get($routeParams,'e',false);
    }
    if (_.get($routeParams,'demo',false)) {
        $scope.form.subject = 'Demo Request';
    }
    if ($location.search().subject) {
        $scope.form.subject = $filter('translate')($location.search().subject)
    }

    if ($auth.isAuthenticated()) {
        User.get().$promise.then(user => {
            $scope.form.name = user.first_name + ' ' + user.last_name;
            $scope.form.email = user.email;
        });
    }

    $scope.patterns = Constants.patterns;
    $scope.sendContactForm = function(form) {
        ContactForm.save(form).$promise.then(function() {
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('YOUR_MESSAGE_HAS_BEEN_SENT'),
                timeCollapse: 4000
            });
            $scope.form = {}
        });
    };

}]);

angular.module('contact-us')

.factory('ContactFormResource', ['$resource', function($resource) {
    return  $resource('/api/contact-form/', {},{
        update: { method:'PATCH'}
    });
}]);
angular.module('contact-us')

.factory('ContactForm', ['ContactFormResource', function (ContactFormResource) {
    var contactFormFactory = {};

    contactFormFactory.get = ContactFormResource.get;
    contactFormFactory.save = ContactFormResource.save;

    return contactFormFactory;
}]);
angular.module('conversation')
.controller('ConversationController', ['$scope', '$rootScope', '$location', '$routeParams', 'Event', 'Engagement',
    'EngagementConstants', 'AlertBanner', '$filter', '$anchorScroll','$timeout', '$uibModal', 'Constants', 'crumble', 'CompanyDocument',
     function($scope, $rootScope, $location, $routeParams, Event, Engagement,
              EngagementConstants, AlertBanner, $filter, $anchorScroll, $timeout, $uibModal, Constants, crumble, CompanyDocument) {

    $scope.engagement = {};
    $scope.sending = false;
    $scope.hasCompanyDocuments = false;

    Engagement.get($routeParams.id).$promise.then(function (eng) {
        $scope.engagement = eng;
        crumble.update({engagement: eng, ploy: eng.ploy});
        CompanyDocument.loadActiveDocuments(eng.ploy.company).then(documents => {
            $scope.hasCompanyDocuments = Boolean(documents.length);
        });
    }, err => {
        return $location.path('/my-ploys');
    });

    $scope.$on('update-engagement', function (event, args) {
        Engagement.get($routeParams.id).$promise.then(function (eng) {
            $scope.engagement = eng;
        })
    });

    $scope.allowEditMessage = function (message, eng) {
        let allowEditMessageForThisEngState = (engagement) => {
            return Constants.engagementStatesNotClosed.includes(engagement.state)
        };
        if ((Math.abs($scope.currentDate - message.created) / 36e5 ) < 0.25 && allowEditMessageForThisEngState(eng)) {
            return true
        }
    };

    $scope.editMessage = function (message) {
        return $uibModal.open({
            templateUrl: 'src/modals/html/modal-edit-message.html',
            windowClass: 'modal-vertical-centered',
            controller: 'ModalEditMessageController',
            backdrop: 'static',
            resolve: {
                message: function () {
                    return  message || ''
                }
            }
        })
    };

    $scope.isEmployee = Engagement.isEmployee;
    $scope.isEmployer = Engagement.isEmployer;

    let createCommentEvent = (comment, event) => {
        event.preventDefault();
        if (!comment.data) return;
        $scope.sending = true;
        Engagement.createComment(comment).then(function(resp) {
            comment.data = "";
            $scope.sending = false;
        }, (error) => {
            $scope.sending = false;
            let errorMessage = (error.data[0]) ? error.data[0] : 'SOMETHING_WENT_WRONG_PLEASE_CONTACT_WITH_SUPPORT';
            AlertBanner.publish({
               type: 'error',
               message: $filter('translate')(errorMessage),
               timeCollapse: 4000
            });
        });
    };

    $scope.createComment = _.debounce(createCommentEvent, 1000, {leading: true});

    $scope.disableMessages = function (eng) {
        if (eng.state) {
             return eng.ploy.dont_bother;
        }
    };

    $scope.goToPloyDetails = (eng) => {
        $location.path('/ploy-detail/' + eng.ploy.id)
    };

    $scope.showCompanyDocumentsModal = (eng) => {
        return $scope.hasCompanyDocuments && (
            eng.state === Constants.engagementStates.EMPLOYER_CHOSE_EMPLOYEE
            || eng.state === Constants.engagementStates.ENGAGEMENT_COMPLETED
            || eng.state === Constants.engagementStates.ENGAGEMENT_PAID
        )
    }

    $scope.openCompanyDocumentsModal = (eng) => {
        return $uibModal.open({
            templateUrl: 'src/modals/html/modal-company-documents.html',
            windowClass: 'modal-vertical-centered',
            controller: 'ModalCompanyDocumentsController',
            backdrop: 'static',
            resolve: {
                companyId: function () {
                    return eng.ploy.company || ''
                }
            }
        })
    };

    $scope.goToModifyWorkhours = (eng) => {
        $location.path('/my-ploys/' + eng.id + '/conversation/modify-workhours')
    };

    $scope.goToPloyManagement = (eng) => {
        $location.path('/my-ploys/' + eng.ploy.id)
    };

    $scope.isEngMarkedAsCompleted = eng => {
        return eng.state == Constants.engagementStates.ENGAGEMENT_COMPLETED
    };

    $scope.goToEngBeingReplaced = eng => {
        return '/my-ploys/' + eng.ploy.replacement_for.id + '/conversation';
    }

}]);

angular.module('conversation')
    .controller('ModifyWorkhoursController', ['$scope', 'WorkLogResource', '$routeParams', 'Engagement', 'crumble', 'CheckInOutService',
        '$location', 'EngagementShiftService', 'AlertBanner', '$filter', 'Constants',
        function ($scope, WorkLogResource, $routeParams, Engagement, crumble, CheckInOutService,
                  $location, EngagementShiftService, AlertBanner, $filter, Constants) {

            $scope.isCheckedInLate = false;
            $scope.lateCheckInTime = new Date();

            let initialCurrentEng = {};
            Engagement.get($routeParams.id).$promise.then(function (eng) {
                crumble.update({engagement: eng, ploy: eng.ploy});
                let currentEng = eng;
                const ployStartTime = moment(currentEng.checkin_time).set({
                        hour: currentEng.ploy.start_time.getHours(),
                        minute: currentEng.ploy.start_time.getMinutes(),
                        second: 0
                    });
                if (moment(currentEng.checkin_time).isAfter(ployStartTime)) {
                    $scope.isCheckedInLate = true;
                    $scope.lateCheckInTime = angular.copy(currentEng.checkin_time);
                }
                if (currentEng.state != Constants.engagementStates.ENGAGEMENT_COMPLETED) {
                    AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')('MODIFY_WORKHOURS__PLOY_NOT_COMPLETED_ERROR'),
                        timeCollapse: 5000
                    });
                    return $location.path('/my-ploys');
                }
                if (currentEng.approved) {
                    AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')('MODIFY_WORKHOURS__APPROVED_SHIFT_ERROR'),
                        timeCollapse: 5000
                    });
                    return $location.path('/my-ploys');
                }
                $scope.currentEng = currentEng;
                $scope.currentEng.comment = currentEng.last_comment;
                currentEng.lunchBreak = CheckInOutService.prepareLunchBreak(currentEng);
                initialCurrentEng = currentEng;
            }, err => {
                return $location.path('/my-ploys');
            });

            $scope.$watchGroup(['currentEng.checkout_time', 'currentEng.checkin_time', 'currentEng.lunchBreak'], (newVal, oldVal) => {
                if ($scope.currentEng) {
                    $scope.currentEng = CheckInOutService.calcCheckInOutPause($scope.currentEng, newVal);
                }
            });

            $scope.isOvertime = CheckInOutService.isOvertime;

            $scope.saveWorkLog = engagement => {
                let workLog = CheckInOutService.prepareWorkLogToSave(engagement, initialCurrentEng);

                WorkLogResource.save(workLog).$promise.then(() => {
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('SAVED') + '!',
                        timeCollapse: 4000
                    });
                    $location.path('/my-ploys/' + engagement.id + '/conversation');
                }, error => {
                    let errorMessage = (error.data[0]) ? error.data[0] : 'SOMETHING_WENT_WRONG_PLEASE_CONTACT_WITH_SUPPORT';
                    AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')(errorMessage),
                        timeCollapse: 4000
                    });
                })
            };
        }
    ]);

angular
    .module('conversation')
    .directive('showConversationDocuments', ['CompanyDocument', function (CompanyDocument) {
        return {
            scope: {
                'unacceptedDocuments': '<',
                'onAccept': '&',
            },
            restrict: 'E',
            templateUrl: '/src/conversation/html/includes/conversation-documents.html',
            transclude: true,
            link: function ($scope, element, attrs, ctrls) {
                $scope.anyDocumentsAreUnaccepted = () => {
                    return $scope.unacceptedDocuments.some(document => {
                        return !document.accepted;
                    })
                };
            }
        };
    }]);


angular
    .module('conversation')
    .directive('showConversationEvents', [ 'User', '$interpolate', 'Engagement', '$translate', 'LanguageService', '$filter',
        function(User, $interpolate, Engagement, $translate, LanguageService, $filter) {
            return {
                // name: '',
                // priority: 1,
                // terminal: true,
                 scope: {
                   event : '=',
                   engagement : '='  
                 }, // {} = isolate, true = child, false/undefined = no change
                 controller: function($scope, EngagementConstants, $element, $attrs, $transclude) {
                     $scope.getEventMessage = function () {
                             return _.find(EngagementConstants.status, {name: $scope.event.event_type}).event_message;
                     };
                     
                     $scope.getEventColor = function () {
                             return _.find(EngagementConstants.status, {name: $scope.event.event_type}).color;
                     };

                     $scope.hideState = function () {
                             return _.find(EngagementConstants.status, {name: $scope.event.event_type}).hide;
                     };

                     // engWithEventInfo - needed to append to translation key some info from event
                     $scope.engWithEventInfo = angular.copy($scope.engagement);
                     $scope.engWithEventInfo.event_created_by_first_name = $scope.event.created_by.first_name;
                 },
                // require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
                // restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
                 template:
                     '<div class="conversation-state-change-{{ getEventColor() }}" ng-if="!hideState()">{{ getEventMessage() | translate:engWithEventInfo }} </div>'
                // templateUrl: '',
                // replace: true,
                // transclude: true,
                // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
                
            };
        }
    ]);

angular
    .module('conversation')
    .directive('showConversationStatus', ['Constants', 'CompanyDocument', 'User', 'AlertBanner', '$filter',
        function (Constants, CompanyDocument, User, AlertBanner, $filter) {
        return {
            scope: {
                'engagement': '<',
            },
            restrict: 'E',
            templateUrl: '/src/conversation/html/includes/conversation-status.html',
            transclude: true,
            link: function ($scope, element, attrs, ctrls) {
                $scope.unacceptedDocuments = [];

                if (User.get().user_type == Constants.userTypes.MEPLOYEE) {
                    CompanyDocument.loadUnacceptedDocuments($scope.engagement.ploy.company).then(documents => {
                        documents.forEach(document => $scope.unacceptedDocuments.push(document))
                    });
                }

                $scope.showDocumentsAcceptance = () => {
                    return $scope.engagement.state == Constants.engagementStates.EMPLOYER_CHOSE_EMPLOYEE &&
                        !!$scope.unacceptedDocuments.length && User.get().user_type == Constants.userTypes.MEPLOYEE
                };

                $scope.acceptAllDocuments = () => {
                    CompanyDocument.createAcceptationsForMissingDocuments($scope.engagement.ploy.company).$promise.then(() => {
                        AlertBanner.publish({
                            type: 'success',
                            message: $filter('translate')('SAVED') + '!',
                            timeCollapse: 4000
                        });
                        $scope.unacceptedDocuments = [];
                    });
                };

            }
        };
    }]);


angular
    .module('conversation')
    .directive('showEngagementAction', [ 'User', 'Engagement',
        function(User, Engagement) {
            return {
                 scope: {
                   engagement : '='
                 },
                 controller: function($scope, EngagementConstants) {
                     $scope.isEmployee = Engagement.isEmployee;
                     $scope.isEmployer = Engagement.isEmployer;

                     $scope.getActionButtonsFunctionForMeployee = function () {
                         if ($scope.engagement.$resolved) {
                             return _.find(EngagementConstants.status, {name: $scope.engagement.state}).actions_meployee
                         }
                     };

                     $scope.getActionButtonsFunctionForMeployer = function () {
                         if ($scope.engagement.$resolved) {
                             return _.find(EngagementConstants.status, {name: $scope.engagement.state}).actions_meployeer
                         }
                     }
                 },
                 template:
                     '<div ng-if="isEmployee()" class="engagement-actions">' +
                        '<span class="engagement-actions__element" ng-repeat="button in getActionButtonsFunctionForMeployee()" ng-hide="button.isHidden(engagement)">' +
                            '<button ng-click="button.button_function(engagement)" uib-tooltip="{{ button.button_tooltip | translate }}"' +
                                    'class="{{ button.button_class }}" ng-disabled="button.button_disabled(engagement)" tooltip-placement="left"> ' +
                                '{{ button.button_text | translate }}' +
                            '</button>'+
                        '</span>' +
                     '</div>' +

                     '<div ng-if="isEmployer()" class="engagement-actions">' +
                        '<span class="engagement-actions__element" ng-repeat="button in getActionButtonsFunctionForMeployer()" ng-hide="button.isHidden(engagement)">' +
                            '<button ng-click="button.button_function(engagement)" uib-tooltip="{{ button.button_tooltip | translate }}" class="{{ button.button_class }}" ' +
                                'ng-disabled="button.button_disabled(engagement)" tooltip-placement="left">' +
                                '{{ button.button_text | translate }}' +
                            '</button>'+
                        '</span>' +
                     '</div>'
            };
        }
    ]);


angular
    .module('conversation')
    .directive('showEngagementDescription', [ 'User', '$interpolate', 'Engagement', '$translate', 'LanguageService', '$filter',
        function(User, $interpolate, Engagement, $translate, LanguageService, $filter) {
            return {
                // name: '',
                // priority: 1,
                // terminal: true,
                 scope: {
                   engagement : '='
                 }, // {} = isolate, true = child, false/undefined = no change
                 controller: function($scope, EngagementConstants, $element, $attrs, $transclude) {
                     $scope.isEmployee = Engagement.isEmployee;
                     $scope.isEmployer = Engagement.isEmployer;

                     $scope.getEngagementDescriptionForMeployee = function () {
                         if ($scope.engagement.$resolved) {
                             return _.find(EngagementConstants.status, {name: $scope.engagement.state}).description_meployee;
                         }
                     };

                     $scope.getEngagementDescriptionForMeployer = function () {
                         if ($scope.engagement.$resolved) {
                             return _.find(EngagementConstants.status, {name: $scope.engagement.state}).description_meployer;
                         }
                     }
                 },
                // require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
                // restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
                 template:
                     '<div ng-if="isEmployee()" class="engagement-description">{{ getEngagementDescriptionForMeployee() | translate:engagement }} </div>' +
                     '<div ng-if="isEmployer()" class="engagement-description">{{ getEngagementDescriptionForMeployer()  | translate:engagement }} </div>' ,
                // templateUrl: '',
                // replace: true,
                // transclude: true,
                // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
                link: function($scope, iElm, iAttrs, controller) {

                }
            };
        }
    ]);

angular.module('cookies-law-bar')

.controller('CookieLawBarController',  ['$scope', 'Constants', '$cookies', 'localStorageService',
        function($scope, Constants, $cookies, localStorageService) {
    // LOCAL STORAGE USED TO COOKIE LAW INFO
    $scope.markAsRead = function () {
        localStorageService.set('cookiesAccepted', 'true');
        $scope.cookiesStatus = true;
    };

    $scope.cookiesStatus = localStorageService.get('cookiesAccepted');
}]);

angular.module('core')
.config(['$authProvider', function($authProvider) {
    $authProvider.loginUrl = '/api/api-token-auth/';
    $authProvider.signupUrl = '/api/user/';
    $authProvider.authToken = 'JWT';
    $authProvider.tokenPrefix = 'meploy';
    $authProvider.storageType = 'localStorage';

    $authProvider.facebook({
        clientId: '1575294709400938',
        url: '/api/oauth/facebook/',
        redirectUri: window.location.origin + '/log-in',
        authorizationEndpoint: 'https://www.facebook.com/v7.0/dialog/oauth',
        scope: ['email'],
        //responseType:'token',
    });
}])

.config(['uiGmapGoogleMapApiProvider', function(uiGmapGoogleMapApiProvider) {
    uiGmapGoogleMapApiProvider.configure({
        key: 'AIzaSyBcCbXGS5GhBpZw85O8HP81JunW7eEY98s',
        v: '3.22',
        libraries: 'places' // Required for SearchBox.
    });
}])

.config(['$resourceProvider', function($resourceProvider) {
  $resourceProvider.defaults.stripTrailingSlashes = false;
}])

.config(['$locationProvider', function($locationProvider) {
    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix('!');
}])

.config(['$translateProvider', '$translateSanitizationProvider', function($translateProvider, $translateSanitizationProvider) {
  $translateProvider.preferredLanguage('da');
  $translateProvider.useSanitizeValueStrategy('escape');
  $translateProvider.useStaticFilesLoader({
      prefix:  'https://cloud.meploy.me/api/translation/web/',
      suffix: '/'
  });
}])

.factory('authHttpResponseInterceptor',['$q','$window', '$injector', function($q, $window, $injector){
    return {
        response: function(response){
            if (response.status === 403 || response.status === 401) {
                var authService = $injector.get('$auth');
                authService.logout();
                $window.location.replace('/log-in')
            }
            return response || $q.when(response);
        },
        responseError: function(rejection) {
            if (rejection.status === 403 || rejection.status === 401) {
                var authService = $injector.get('$auth');
                authService.logout();
                $window.location.replace('/log-in')
            }
            return $q.reject(rejection);
        }
    }
}])


.config(['tmhDynamicLocaleProvider', function(tmhDynamicLocaleProvider) {
  tmhDynamicLocaleProvider.localeLocationPattern('../../static/lib/angular-locale_{{locale}}.js');
}])

.config(['$routeProvider', '$locationProvider', 'becomeUser',
  function($routeProvider, $locationProvider, becomeUser) {
    $routeProvider
      .when('/become/:token/:page?/:getParams?', {
        resolve: becomeUser
      })
}])

.config(["$httpProvider", function ($httpProvider) {
    $httpProvider.interceptors.push('authHttpResponseInterceptor');
    $httpProvider.interceptors.push(function() {
        function getVersionedUrl(url) {
            // only do for html templates of this app
            // NOTE: the path to test for is app dependent!
            if (!url || url.indexOf('.html') < 0 ||  url.indexOf('src/') < 0 || url.indexOf('/html/') < 0 || !clientVersion) {
                return url
            }

            var param = 'v=' + clientVersion;

            if (url.indexOf('?') > 0) {
                return url + '&' + param;
            }
            return url + '?' + param;
        }
        return {
            'request': function(config) {
                config.url = getVersionedUrl(config.url);
                return config;
            }
        };
    });

    $httpProvider.defaults.transformResponse.push(function(responseData){
        var regexIso8601 = /^(\d{4}|\+\d{6})-((\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})(\.(\d{1,}))?(Z|([\-+])(\d{2}):(\d{2}))?)?)?)?$/;

        function convertDateStringsToDates(input) {
            // Ignore things that aren't objects.
            if (typeof input !== "object") return input;

            for (var key in input) {
                if (!input.hasOwnProperty(key)) continue;

                var value = input[key];
                var match;
                // Check for string properties which look like dates.
                if (typeof value === "string" && (match = value.match(regexIso8601))) {
                    var milliseconds = Date.parse(match[0]);
                    if (!isNaN(milliseconds)) {
                        input[key] = new Date(milliseconds);
                    }
                } else if (typeof value === "object") {
                    // Recurse into object
                    convertDateStringsToDates(value);
                }
            }
        }

        convertDateStringsToDates(responseData);
        return responseData;
    });
}])


.constant('ratingConfig', {
  max: 5,
  stateOn: null,
  stateOff: null,
  titles : ['one', 'two', 'three', 'four', 'five']
});

angular.module('core')

.constant('redirectToHomeBasedOnUser', { // todo: divide it to smaller parts and move to Access Service
    redirectToHomeBasedOnUser : function ($q, $rootScope, $timeout, $auth, $location, User, Constants) {
        var deffered = $q.defer();

        let redirectToUrl = (user) => {
            if (user.user_type == Constants.userTypes.MEPLOYEE) {
                if (!user.phone_verify) {
                    return '/sign-up/new-employee/phone-verify'
                }
                if (user.phone_verify) {
                    return '/search';
                }
                return '/';
            }
            if (user.user_type == Constants.userTypes.MEPLOYER && !user.company.onboarding_completed) {
                if (user.company.collective_agreement === null) {
                   return '/sign-up/employer/collective-agreement'
                }
            }
            return '/my-ploys';
        };

        if ($auth.isAuthenticated()) {
            User.get().$promise.then( function(user) {
                $location.path(redirectToUrl(user)).replace().search({user_type: user.user_type + '-' + user.language});
            });

            // If the promise never resolves properly, reject it
            $timeout(function () {
                deffered.reject('LOGIN');
            }, 10000);
        }
        else {
            deffered.resolve();
            $location.path('/log-in');
        }


        return deffered.promise;
    }
});

angular.module('core')

.controller('BaseController', ['$scope', '$rootScope', '$auth','$location', '$window' , 'User', 'LanguageService',
                'Constants', 'Auth', 'Category', 'SearchMeployees', '$interval', 'Stat','$uibModal', '$anchorScroll',
                '$analytics', 'crumble', '$translate', '$interpolate', '$document', '$timeout', '$cookies',
        function($scope, $rootScope, $auth, $location, $window, User, LanguageService,
                 Constants, Auth, Category, SearchMeployees, $interval, Stat, $uibModal, $anchorScroll,
                 $analytics, crumble, $translate, $interpolate, $document, $timeout, $cookies) {

    $anchorScroll.yOffset = 200;

    $scope.crumble = crumble;

    // Breadcrumbs custom functions
    let getDefaultParent = crumble.getParent;
    crumble.getParent = (path) => {
        let route = crumble.getRoute(path);
        return route && angular.isDefined(route.parent)
            ? route.parent
            : getDefaultParent(path);
    };

    crumble.getCrumb = path => {
        // breadcrumbs translation
        let route = crumble.getRoute(path);
        if (!route) {
            console.info('Breadcrumbs failed due to invalid route');
            return route = {label: null}
        }
        if (!angular.isString(route.label)) {
            console.info('Missing breadcrumb label for current route.');
            return route.label = null
        }
        let pathLabel = $translate.instant(route.label, crumble.context).replace(/&amp;/g, '&');
        return {
            path: $interpolate(path)(crumble.context),
            label: $interpolate(pathLabel)(crumble.context),
        };
    };


    $rootScope.$on('$routeChangeSuccess', (e, current) => {
        crumble.update();
        if (!current.$$route) return $scope.hideBreadcrumbs = true;
        $scope.hideBreadcrumbs = _.isNull(current.$$route.label) || current.$$route.hideBreadcrumbs;
        $scope.hideFooter = current.$$route.hideFooter;
        chatUrlChangedPing();

        $timeout(() => {
            let el = $document[0].getElementsByTagName('textarea');
            if (el) {
                resizeHandlerPolyfill(el);
            }
        }, 2000);

        if ($location.search() && $location.search().invby) {
            if (!$cookies.get('invited_by') || !$cookies.get('invited_by_date')) {
                $cookies.put('invited_by', $location.search().invby);
                $cookies.put('invited_by_date', moment().add(31, 'days').toISOString());
            }
            $location.search('');
            $location.path('/referral');
        }

    });

    $rootScope.$on('$translateChangeSuccess', () => {
      crumble.update();
    });

    $scope.mobileBreakpoint = function () {
        return window.innerWidth <= 1000;
    };

    $scope.cdn = cdn || '';

    $scope.currentDate = new Date();

    $scope.pagesHistory = [];
    $scope.status = {};

    $scope.user = function(){
        return User.get();
    };

    $scope.isEmployer = () => {
        return $scope.user().user_type === Constants.userTypes.MEPLOYER;
    };

    $scope.userAuthenticated = User.isAuthenticated;

    $scope.languages = Constants.languages;
    $scope.setLanguage = LanguageService.setLanguage;
    $scope.language = LanguageService.getCurrentLanguage;

    $scope.console=window.console;
    $scope.search_ploy = false;

    $scope.swipeLeft = function() {
        if($location.path()!='/search-map' && $location.path()!='/search') {
            $scope.status.navOpen=true;
        }
    };

    $scope.allCategories = Category.getAll();

    $scope.searchMeployee = function (searchStr) {
        if (searchStr) {
        SearchMeployees.newSearching();
        SearchMeployees.clearFilters();
        SearchMeployees.addFilter(searchStr.originalObject['name_'+LanguageService.getCurrentLanguage()]);
        $location.path('search-meployees')
        }
    };

    $scope.isAuthenticated = function() {
        return $auth.isAuthenticated();
    };


    $scope.$on('$routeChangeSuccess', function (new_route) {
        $scope.currentLocation = $location.path();
        $scope.pagesHistory.push($location.$$path);
    });


    $scope.goBack = function() {
        $window.history.back();
    };

    $scope.$on('user-verified-phone', () => {
        $scope.phone_verify = true;
        $scope.user().phone_verify = true;
    });

    $scope.logout = Auth.logout;

    $interval(function () {
        Stat.record();
    }, 60000);

    let chatUrlChangedPing = () => {
        var _hsq = window._hsq = window._hsq || [];
        var pathName = window.location.pathname + window.location.search;
        _hsq.push(['setPath', pathName]);
        _hsq.push(['trackPageView']);
    };

    if ($auth.isAuthenticated()) {
        User.get().$promise.then((user) => {
            if (user.user_type === Constants.userTypes.MEPLOYER && user.client_version !== 1) {
                redirectToDashboard();
            }
        });
    }

    const redirectToDashboard = () => {
        const currentPath = $location.path();
        const dashboardUrl = DEBUG ? Constants.dashboardEnvUrls.DEV : Constants.dashboardEnvUrls.PROD;
        let profileMatch = currentPath.match('\\/profile\\/([0-9]*)');
        if (profileMatch) {
            let profileId = profileMatch[1];
            window.location = dashboardUrl + '/staff/find-staff/profile/' + profileId;
            return
        }
        window.location = dashboardUrl;
    }

    if (User.get().$promise) {
        User.checkUserAndInitializeChat();
    }

    $scope.setVerticalOffset = (offset, callback) => {
        let body = $("html, body");
        body.stop().animate({scrollTop: offset});
        callback();
    };

    MobileDragDrop.polyfill({
        // use this to make use of the scroll behaviour
        dragImageTranslateOverride: MobileDragDrop.scrollBehaviourDragImageTranslateOverride
    });
}]);

angular.module('core')

.controller('LanguageController', ['$scope', 'Constants', 'LanguageService', '$cookies', '$rootScope',
        function($scope, Constants, LanguageService, $cookies, $rootScope) {
    $scope.languages = Constants.languages;
    $scope.setLanguage = LanguageService.setLanguage;
    $scope.language = LanguageService.getCurrentLanguage;
}])
;
angular.module('core')

.controller('RatingController', ['$scope', '$attrs', 'ratingConfig', function($scope, $attrs, ratingConfig) {
  var ngModelCtrl  = { $setViewValue: angular.noop };

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.push(function(value) {
      if (angular.isNumber(value) && value << 0 !== value) {
        value = Math.round(value);
      }
      return value;
    });

    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
    var tmpTitles = angular.isDefined($attrs.titles)  ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles ;
    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
      tmpTitles : ratingConfig.titles;

    var ratingStates = angular.isDefined($attrs.ratingStates) ?
      $scope.$parent.$eval($attrs.ratingStates) :
      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
    $scope.range = this.buildTemplateObjects(ratingStates);
  };

  this.buildTemplateObjects = function(states) {
    for (var i = 0, n = states.length; i < n; i++) {
      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
    }
    return states;
  };

  this.getTitle = function(index) {
    if (index >= this.titles.length) {
      return index + 1;
    } else {
      return this.titles[index];
    }
  };

  $scope.rate = function(value) {
    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
      ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue === value ? 0 : value);
      ngModelCtrl.$render();
    }
  };

  $scope.enter = function(value) {
    if (!$scope.readonly) {
      $scope.value = value;
    }
    $scope.onHover({value: value});
  };

  $scope.reset = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.onLeave();
  };

  $scope.onKeydown = function(evt) {
    if (/(37|38|39|40)/.test(evt.which)) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
    }
  };

  this.render = function() {
    $scope.value = ngModelCtrl.$viewValue;
  };
}])

angular.module('core')

    .controller('UserCalendarController', [
        '$scope', '$translate', '$uibModal', 'AlertBanner', 'MyCalendar', '$location', 'PloyResource', '$filter', 'MyCalendarConstants',
        function ($scope, $translate, $uibModal, AlertBanner, MyCalendar, $location, PloyResource, $filter, MyCalendarConstants) {
            $scope.currentMonth = moment();
            $scope.currentMonth_plus_1 = moment().add(1, 'MONTH');
            $scope.currentMonth_plus_2 = moment().add(2, 'MONTH');
            $scope.calendarMonth = $scope.currentMonth;
            $scope.daysAllowed = [];
            $scope.selectedDates = [];
            $scope.maxSelectedDates = 7;
            $scope.ploysTogether = [];

            $scope.getMonthName = function (month) {
                return _.capitalize(month.format('MMMM'));
            };

            $scope.compareFunction = function (check_day) {
                return function (excluded_day) {
                    return moment(excluded_day.date).format('DD/MM/YYYY') == moment(check_day).format('DD/MM/YYYY');
                };
            };

            $scope.generateAllowedDays = function () {
                MyCalendar.getMeployeeAvailableDays($scope.meployee.id).$promise.then((days) => {
                    $scope.daysAllowed = days
                        .filter(day => day.type_for_employer === MyCalendarConstants.types.AVAILABLE)
                        .map(day => day.day);
                    $scope.ploysTogether = days.filter(day => day.type_for_employer === MyCalendarConstants.types.PLOY)
                });
            };

            $scope.generateAllowedDays();
            $scope.checkSelection = function (event, date) {
                if (($scope.maxSelectedDates <= _.size($scope.selectedDates)) && (!date.mdp.selected)) {
                    event.preventDefault();
                    AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')('MODAL_CALENDAR__TOO_MUCH_SELECTED_DAYS'),
                        timeCollapse: 4000
                    });
                }
            };

            $scope.post_ploys = function () {
                var dates = btoa(JSON.stringify($scope.selectedDates));
                $location.path('/post-ploy/for/' + $scope.meployee.id).search({dates: dates});
            };

        }]);

angular.module('core')
.directive('avatar', ['$parse', 'Constants',function($parse, Constants) {
  return {
    restrict: 'AE',
    templateUrl: '/src/core/html/avatar.html',
    scope: {
         user : '<',
         onlyVerified: '<',
         showTooltip: '<'
    },
    link: function(scope, element, attrs, ngModelCtrl) {
      scope.userTypes = Constants.userTypes;
      scope.isNotDefaultImage = url => {
        if (url) {
          return url.replace(/^.*[\\\/]/, '') != 'default_profile_pic-46_150x150.png';
        }
      };
      scope.getTooltip = (user) => {
        if (scope.showTooltip) {
          if (user.user_type !== Constants.userTypes.MEPLOYER && user.profile.verified) {
              return 'MEPLOY_VERIFIED_BADGE__CAPTION'
          }
        }
      }
    }

}}]);

angular.module('core')
    .directive('changeTimeOfDate', ['$parse',function($parse) {
  return {
    restrict: 'AE',
    templateUrl: '/src/core/html/change_time_of_date.html',
    scope: {
         ngModel : '<',
         editMode : '<',
    },
    require: 'ngModel',
    link: function(scope, element, attrs, ngModelCtrl) {

        scope.tempDate = scope.ngModel;

        let pressed;
        let step = 0;

        let changeTimeUp = (step) => {
            let d = new moment(scope.tempDate);
            d.add(step, 'minutes');
            scope.tempDate = d.toDate();
        };

        let changeTimeDown = (step) => {
            let d = new moment(scope.tempDate);
            d.subtract(step, 'minutes');
            scope.tempDate = d.toDate();
        };


        scope.increaseTime = () => {
            if (pressed) {
                setTimeout(() => {
                        // step += 5;
                        step = 5;
                        changeTimeUp(step);
                        scope.$apply();
                        scope.increaseTime()
                    }, 300
                )
            }
        };

        scope.decreaseTime = () => {
            if (pressed) {
                setTimeout(() => {
                        // step += 5;
                        step = 5;
                        changeTimeDown(step);
                        scope.$apply();
                        scope.decreaseTime()
                    }, 300
                )
            }
        };

        scope.$on('updateTimeValues', () => {
           scope.ngModel = scope.tempDate;
           return $parse(attrs.ngModel).assign(scope.$parent, scope.ngModel);
        });

        scope.$on('resetTimeValues', () => {
           scope.tempDate = scope.ngModel
        });

        scope.disableChangingValue = () => {
            pressed = false;
            step = 0;
        };

        scope.enableChangingValue = () => {
            pressed = true;
        };

    }
  }
}]);

angular.module('core')
//copy of ng-click
.directive('clickIfFormValid', ['$parse', '$rootScope', 'AlertBanner' ,'$filter', function($parse, $rootScope, AlertBanner, $filter) {
      return {
        restrict: 'A',
        compile: function($element, attr) {
          var fn = $parse(attr['clickIfFormValid'], /* interceptorFn */ null, /* expensiveChecks */ true);
          var formName = $parse(attr['formName']);
          return function ngEventHandler(scope, element, attr) {
            element.on('click', function(event) {
              var callback = function() {
                if (!formName || !scope[formName()]){return}
                if (scope[formName()].$invalid){
                    $('form[name='+formName()+']').addClass('after-submit');
                    $("body").animate({ scrollTop: 0 }, 650);
                    AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')('IT_SEEMS_THAT_SOME_DATA_IS_MISSING_PLEASE_CHECK_ALL_FIELDS'),
                        timeCollapse: 5000
                    });
                }
                else{
                  fn(scope, {$event:event});
                }

              };
              scope.$apply(callback);

            });
          };
        }
      };
    }]);


angular.module('core')
.directive('clock', ['$parse', 'Constants', '$interval',function($parse, Constants, $interval) {
  return {
    restrict: 'AE',
    templateUrl: '/src/core/html/clock.html',
    scope: {
         user : '=',
    },
    link: function(scope, element, attrs, ngModelCtrl) {

      scope.counter = $interval(()=>{
            scope.datetimeNow = new Date();
      },1000);
      scope.datetimeNow = new Date();
      scope.$on('$destroy', function() {
        $interval.cancel(scope.counter);
      });
    }
}}]);

angular.module('core')

.directive('compareTo', function(){
    return {
      require: "ngModel",
      scope: {
        otherModelValue: "=compareTo"
      },
      link: function(scope, element, attributes, ngModel) {
        ngModel.$validators.compareTo = function(modelValue) {
          return modelValue == scope.otherModelValue;
        };

        scope.$watch("otherModelValue", function() {
          ngModel.$validate();
        });
      }
    };
});
angular.module('core')
    .directive('daterangeFilters', ['MyStaff', function(MyStaff) {
        return {
            scope: {
                'optionToday' : '<', // True if button "Today" should be visible
                'optionThisWeek' : '<', // True if button "This week" should be visible
                'onFilter': '&', // Function which should be fired after click on "Filter"
                'initialFilters': '<', // Object with initial filters which should be active
                'autocompleteData': '<', // Object with data for autocomplete input
                'verticalAlignment': '<' // Object with data for autocomplete input
            },
            restrict: 'E',
            templateUrl: '/src/core/html/daterange-filters.html',
            link: function ($scope, element, attrs, ctrls) {
                $scope.filters = $scope.initialFilters || {} ;

                let getWeekDates = () => {
                    let now = new Date();
                    let dayOfWeek = now.getDay();
                    let numDay = now.getDate();

                    let start = new Date(now);
                    start.setDate(numDay - dayOfWeek);
                    start.setHours(0, 0, 0, 0);

                    let end = new Date(now);
                    end.setDate(numDay + (7 - dayOfWeek));
                    end.setHours(0, 0, 0, 0);

                    return [start, end];
                };

                $scope.filterToday = () => {
                    let restartedData = new Date();
                    restartedData.setHours(0, 0, 0, 0);
                    $scope.filters.from = restartedData;
                    $scope.filters.to = restartedData;
                    $scope.onFilter({filters: $scope.filters})
                };

                $scope.filterThisWeek = () => {
                    let [start, end] = getWeekDates();
                    $scope.filters.from = start;
                    $scope.filters.to = end;
                    $scope.onFilter({filters: $scope.filters})
                };

                $scope.resetFilters = () => {
                    $scope.filters = {};
                    $scope.$broadcast('angucomplete-alt:clearInput'); // built-in broadcast
                    $scope.onFilter({filters: $scope.filters});
                };

                $scope.runFilter = () => {
                    $scope.onFilter({filters: $scope.filters})
                };

                $scope.autocompleteSelected = (obj) => {
                    if (obj) {
                        $scope.filters.person = obj.originalObject.id;
                        $scope.onFilter({filters: $scope.filters});
                    }
                };
            }
        };
    }]);

angular.module('core')
.directive('disableAnimate', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs, ngModelCtrl) {
      element.css({'transition': '0s'}) // https://docs.angularjs.org/api/ng/directive/ngShow#flickering-when-using-ngshow-to-toggle-between-elements
    }
}});

angular.module('core')

.directive('input', ['$location', function ($location) {
    return {
        restrict: 'E',
        link: function (scope, element) {
            if ($location.$$hash && $location.$$hash == element.context.id) {
                    element.focus()
            }
        }
    }
}])

.directive('textarea', ['$location', function ($location) {
    return {
        restrict: 'E',
        link: function (scope, element) {
            if ($location.$$hash && $location.$$hash == element.context.id) {
                element.focus()
            }
        }
    }
}]);
angular.module('core')

.directive("googlePlacesAutocomplete", ['uiGmapGoogleMapApi', function (uiGmapGoogleMapApi) {
    return {
        restrict: "A",
        require: 'ngModel',
        scope: {
            callback: "&onPlaceChanged"
        },
        link: function (scope, element, attrs, ngModelCtrl) {
            var autocomplete;

            uiGmapGoogleMapApi.then(function (maps) {
                var options = {
                    autocomplete: true,
                    types: ['address'],
                    componentRestrictions: {country: "dk"}
                };

                autocomplete = new maps.places.Autocomplete(element[0], options);

                if (scope.callback) {
                    autocomplete.addListener('place_changed', function () {
                        var place = autocomplete.getPlace();
                        ngModelCtrl.$setViewValue( place.formatted_address);
                        ngModelCtrl.$render();
                        scope.callback()(place);
                    });
                }
            });

        }
    }
}]);

angular.module('core')

.directive('hamburgerMenu', function() {
  return {
    template: '<div>' +
    '<i class="fa fa-bars" aria-hidden="true"></i>' +
    '</div>',
    restrict: 'E',
    transclude: true,
  };

});
angular.module('core')
    .directive('inputLengthGuard', function() {
        return {
            scope: {
                'ngModel' : '<',
                'minLength': '<',
            },
            restrict: 'E',
            templateUrl: '/src/core/html/input-length-guard.html',
            link: function (scope, element, attrs, ctrl) {
                scope.textLength = text => {
                    return (text) ? text.length : 0;
                };

                scope.hasRequiredAmountOfChars = text => {
                    if (!text) return false;
                    return text.length > scope.minLength-1;
                };

            }
        };
    });

angular.module('core')
    .directive('notifyIfDayChanged', ['$compile',function($compile) {
  return {
    restrict: 'AE',
    scope: {
         ngModel : '<',
    },
    require: 'ngModel',
    template: '<span class="day">{{ ngModel | date : "dd" }}</span>/<span>{{ ngModel | date : "MM/yy" }}</span>',
    link: function(scope, element, attrs, ngModelCtrl) {

    let startDateDay = moment(scope.ngModel);

    scope.$watch('ngModel', (newDate, oldDate) => {
         if (moment(newDate).format("DD") != moment(startDateDay).format("DD")) {
             element.addClass('engagement-shift__table__body__item-row__day-warning');
         } else {
             element.removeClass('engagement-shift__table__body__item-row__day-warning');
         }
    });


    }
  }
}]);

angular.module('core')

.directive('ratingNormal', function () {
    return {
      restrict: 'EA',
      require: ['ratingNormal', 'ngModel'],
      scope: {
        readonly: '=?',
        onHover: '&',
        onLeave: '&'
      },
      controller: 'RatingController',
      templateUrl: 'template/rating/rating_normal',
      replace: true,
      link: function (scope, element, attrs, ctrls) {
        var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
        ratingCtrl.init(ngModelCtrl);
      }
    };
})



.run(["$templateCache", function ($templateCache) {
    $templateCache.put("template/rating/rating_normal",
      "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\">" +
      "    <i ng-repeat=\"r in range track by $index\" ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"fa\" ng-class=\"$index < value && (r.stateOn || 'fa-star active') || (r.stateOff || 'fa-star')\">" +
      "    <span class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>" +
      "    </i>" +
      "</span>");
    $templateCache.put("template/rating/rating_slide",
      "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\">\n" +
      "    <i ng-repeat=\"r in range track by $index\" ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"slide\" ng-class=\"$index == value - 1 && ('blue choosen') || ($index < value && (r.stateOn || 'blue') || (r.stateOff || 'white'))\">\n" +
      "    {{ $index + 1 }} \n" +
      "    </i>\n" +
      "</span>");
}]);
angular.module('core')

.directive('scrollToBottom', [ '$timeout', function($timeout) {
    return{
    restrict: 'A',
    link: function (scope, element, attr) {
        $timeout(function () {$('body').scrollTop($('body').height());})
    }
  }
}]);


angular.module('core')
    .directive('scrollToBreadcrumbsOnClick', ['$parse', '$rootScope', 'AlertBanner', '$filter', function ($parse, $rootScope, AlertBanner, $filter) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                element.on('click', function (event) {
                    let body = $("html, body");
                    body.stop().animate({scrollTop: $(".onboarding-bar__collapser").offset().top}, 500, 'swing');
                });
            }
        };
    }]);

angular.module('core')
.directive('showWorkdays', ['$parse', 'LanguageService', 'Constants',function($parse, LanguageService, Constants) {
  return {
    restrict: 'AE',
    templateUrl: '/src/core/html/show-workdays.html',
    scope: {
         weekdays : '<',
         startDay : '<',
         endDay : '<',
         datePeriodInDays: '<' // optional
    },
    transclude: true,
    link: function(scope, element, attrs) {
        scope.displayAsText = attrs.hasOwnProperty('displayAsText');
        scope.datePeriodInDays = moment(scope.endDay).diff(moment(scope.startDay), 'days');
        scope.enabledDays = [0, 0, 0, 0, 0, 0, 0];

        scope.setWeekdays = (lang) => {
            if (lang === "da") {
                scope.weekdaysList = Constants.danishWeekdaysList;
            }
            if (lang === "en") {
                scope.weekdaysList = Constants.englishWeekdaysList;
            }
        };
        scope.active = (value) => {
            return value & scope.weekdays;
        };
        if ((scope.datePeriodInDays > 1) && (scope.datePeriodInDays < 7)) {
            let start_day = moment(Math.min(scope.endDay, scope.startDay));
            let end_day = moment(Math.max(scope.endDay, scope.startDay));
            scope.enabledDays = [0, 0, 0, 0, 0, 0, 0];
            for (let i = start_day; i <= end_day; i.add(1, 'day')) {
                scope.enabledDays[i.weekday()] = 1;
            }
        }
        else {
            scope.enabledDays = [1, 1, 1, 1, 1, 1, 1];
        }
        scope.setWeekdays('en');
        scope.setWeekdays(LanguageService.getCurrentLanguage());
  }
}}]);

angular.module('core')

.directive('stackCardsAnimations', [ '$timeout', function($timeout) {
    return{
    restrict: 'A',
    scope: {
        id: '='
    },
    link: function (scope, element, attr) {
        scope.$on('stack-cards-anim', function (event, args) {
            if (args.id == scope.id) {
                if (args.throwOut) {
                    element.addClass('throw-out')
                }
                if (args.zoomIn) {
                    element.addClass('zoom-in')
                }
            }
        });
    }
  }
}]);


angular.module('core')
    .directive('staffSelector', ['StaffGroupsService', 'MyStaff', '$routeParams',function(StaffGroupsService, MyStaff, $routeParams) {
        return {
            scope: {
                'staff' : '<',
                'ngModel': '=',
                'editMode': '<',
                'onLoadMore': '&',
                'activeSelecting': '<',
                'disableLoading': '<'
            },
            restrict: 'E',
            templateUrl: '/src/core/html/staff-selector.html',
            link: function (scope, element, attrs, ctrls) {

                let addMembersToGroup = (groupId, members) => {
                    StaffGroupsService.addMembers({id: groupId, members: members});
                };

                let removeMembersFromGroup = (groupId, members) => {
                    StaffGroupsService.removeMembers({id: groupId, members: members});
                };

                scope.isChecked = meployeeId => {
                    return scope.ngModel.some(memberId => memberId === meployeeId);
                };

                scope.toggleMemberSelection = (staffObj) => {
                    let idx = scope.ngModel.indexOf(staffObj.meployee.id);
                    if (idx > -1) {
                        scope.ngModel.splice(idx, 1);
                        if (scope.activeSelecting) { removeMembersFromGroup($routeParams.id, [staffObj.id]); }
                    } else {
                        scope.ngModel.push(staffObj.meployee.id);
                        if (scope.activeSelecting) { addMembersToGroup($routeParams.id, [staffObj.id]); }
                    }
                };
            }
        };
    }]);
angular.module('core')
.directive('stepsIndicator', ['Constants', function(Constants) {
  return {
    restrict: 'AE',
    templateUrl: '/src/core/html/steps-indicator.html',
    scope: {
         steps : '<',
         activeStep : '<',
    },
    link: function(scope, element, attrs, ngModelCtrl) {
        scope.isStepActive = index => {
            return scope.activeStep === index+1;
        }
  }
}}]);

angular.module('core')
.directive('supplementWorkdays', ['LanguageService', 'Constants',function(LanguageService, Constants) {
  return {
    restrict: 'AE',
    templateUrl: '/src/core/html/supplement-workdays.html',
    scope: {
         ngModel : '=',
    },
    require: 'ngModel',
    link: function(scope, element, attrs, ngModelCtrl) {
        scope.daysWithoutWeekdaysChoose = Constants.daysWithoutWeekdaysChoose;

        scope.setWeekdays = (lang) => {
            if (lang === "da") {
                scope.weekdays = Constants.danishWeekdaysList;
            }
            if (lang === "en") {
                scope.weekdays = Constants.englishWeekdaysList;
            }
        };

        scope.switchWeekday = (name) => {
            let index = _.findIndex(scope.weekdays, {'name': name});
            scope.ngModel ^= scope.weekdays[index].value; //xor
        };

        scope.active = (value) => {
            return value & scope.ngModel;
        };

        scope.setWeekdays('en');
        scope.setWeekdays(LanguageService.getCurrentLanguage());
  }
}}]);

angular.module('core')
    .directive('supplementsSelector', function() {
        return {
            scope: {
                'ngModel' : '=',
                'onSupplementAdded': '&',
                'onSupplementRemoved': '&',
            },
            restrict: 'E',
            templateUrl: '/src/core/html/supplements-selector.html',
            transclude: true,
            link: function (scope, element, attrs, ctrls) {

                scope.addSupplement = (supplement) => {
                    supplement.weekdays = (supplement.weekdays) ? supplement.weekdays : 127;
                    scope.ngModel.push(supplement);
                    scope.hideAddSupplementForm();
                    scope.onSupplementAdded({'supplement': supplement})
                };

                scope.removeSupplement = (supplement) => {
                    _.remove(scope.ngModel, (elem) => {
                        return elem == supplement;
                    });
                    scope.onSupplementRemoved({'supplement': supplement})
                };

                scope.showAddSupplementForm = () => {
                    scope.displayAddSupplementForm = true;
                    scope.supplement = {weekdays: 127};
                };

                scope.hideAddSupplementForm = () => {
                    scope.displayAddSupplementForm = false;
                };

            }
        };
    });

angular.module('core')
    .directive('templateSelector', ['PloyTemplateService', function(PloyTemplateService) {
        return {
            scope: {
                'template' : '<',
                'isPloy' : '<',
                'actionButton' : '<',
                'onButtonPressed' : '&',
                'onTemplateSelect': '&', // returns selected template
            },
            restrict: 'E',
            templateUrl: '/src/core/html/template-selector.html',
            transclude: true,
            link: function (scope, element, attrs, ctrls) {

            }
        };
    }]);

angular.module('core')
    .directive('timeDuration', ['$parse',function($parse) {
  return {
    restrict: 'AE',
    templateUrl: '/src/core/html/time_duration.html',
    scope: {
         ngModel : '=',
         editMode : '=',
    },
    require: 'ngModel',
    link: function(scope, element, attrs, ngModelCtrl) {

        scope.ngModel = new moment(scope.ngModel, 'HH:mm:ss').format('HH:mm:ss');

        scope.tempDate = scope.ngModel;
        
        scope.increaseTime = function () {
            let d = new moment(scope.tempDate, 'HH:mm:ss');
            d.add(5,'minutes');
            scope.tempDate = d.format('HH:mm:ss');
        };

        scope.decreaseTime = function () {
            let d = new moment(scope.tempDate, 'HH:mm:ss');
            if (d._i == '00:00:00') return;
            d.add(-5,'minutes');
            scope.tempDate = d.format('HH:mm:ss');
        };

        scope.$on('updateTimeValues', () => {
            scope.ngModel = scope.tempDate;
            return $parse(attrs.ngModel).assign(scope.$parent, scope.ngModel);
        });

        scope.$on('resetTimeValues', () => {
            scope.tempDate = scope.ngModel
        });


    }
  }
}]);

angular.module('core')
    .directive('userCalendar', function() {
        return {
            require: ['userCalendar'],
            scope: {
                'meployee' : '='
            },
            restrict: 'AE',
            controller: 'UserCalendarController',
            templateUrl: '/src/core/html/user-calendar.html',
            link: function (scope, element, attrs, ctrls) {}
        };
    });

angular.module('core')
.directive('workDays', ['$parse', 'LanguageService', 'Constants',function($parse, LanguageService, Constants) {
  return {
    restrict: 'AE',
    templateUrl: '/src/core/html/work-days.html',
    scope: {
         ngModel : '=',
         startDay : '=',
         endDay : '=',
    },
    require: 'ngModel',
    link: function(scope, element, attrs, ngModelCtrl) {
        scope.daysWithoutWeekdaysChoose = Constants.daysWithoutWeekdaysChoose;
        scope.datePeriodInDays = moment(scope.endDay).diff(moment(scope.startDay), 'days');
        scope.enabledDays = [0, 0, 0, 0, 0, 0, 0];

        scope.setWeekdays = (lang) => {
            if (lang === "da") {
                scope.weekdays = Constants.danishWeekdaysList;
            }
            if (lang === "en") {
                scope.weekdays = Constants.englishWeekdaysList;
            }
        };

        scope.calculatePeriodInDays = (dateObj) => {
            if (dateObj.startDay) {
                scope.startDay = dateObj.startDay;
                scope.datePeriodInDays = moment(scope.endDay).diff(moment(dateObj.startDay), 'days');
            } else {
                scope.endDay = dateObj.endDay;
                scope.datePeriodInDays = moment(dateObj.endDay).diff(moment(scope.startDay), 'days');
            }
        };

        scope.calculateWorkdays = () => {
            if (scope.datePeriodInDays > 7) {
                scope.ngModel = 31;  // bitnumber for days Mon-Fri
            }
            if (scope.datePeriodInDays <= scope.daysWithoutWeekdaysChoose) {
                scope.ngModel = Math.pow(2, (scope.startDay.getDay() + 6) % 7);
                if (scope.startDay.getDay() !== scope.endDay.getDay() && scope.endDay > scope.startDay) {
                    scope.ngModel += Math.pow(2, (scope.endDay.getDay() + 6) % 7);
                }
            }
            let days = scope.datePeriodInDays; // Enable only available days
            if ((days > 1) && (days < 7)) {
                scope.ngModel = 0;
                let start_day = moment(Math.min(scope.endDay, scope.startDay));
                let end_day = moment(Math.max(scope.endDay, scope.startDay));
                scope.enabledDays = [0, 0, 0, 0, 0, 0, 0];
                for (let i = start_day; i <= end_day; i.add(1, 'day')) {
                    scope.enabledDays[i.weekday()] = 1;
                }
            }
            else {
                scope.enabledDays = [1, 1, 1, 1, 1, 1, 1];
            }
        };
        scope.calculateWorkdays();

        scope.$on('ployDateChanged', (event, dateObj) => { // Event fired by post ploy controller when ploy date changes
            scope.calculatePeriodInDays(dateObj); // Calculate ploy duration in days
            scope.calculateWorkdays();
        });

        scope.switchWeekday = (name) => {
            let index = _.findIndex(scope.weekdays, {'name': name});
            scope.ngModel ^= scope.weekdays[index].value; //xor
        };

        scope.active = (value) => {
            return value & scope.ngModel;
        };

        scope.setWeekdays('en');
        scope.setWeekdays(LanguageService.getCurrentLanguage());
  }
}}]);

angular.module('core')
    .directive('workRequirementList', () => {
        return {
            scope: {
                'ngModel': '=',  // should receive ploy
            },
            restrict: 'E',
            templateUrl: '/src/core/html/work-requirement-list.html',
            transclude: true,
            link: function(scope, element, attrs, ctrls) {}
        }
    });

angular.module('core')
    .directive('workRequirementSelector', () => {
        return {
            scope: {
                'ngModel' : '=',
            },
            restrict: 'E',
            templateUrl: '/src/core/html/work-requirement-selector.html',
            transclude: true,
            link: function(scope, element, attrs, ctrls) {

                scope.addWorkRequirement = (name) => {
                    if (!name) return;  // do not let add empty field
                    scope.ngModel.push({'name': name});
                    scope.workRequirementName = '';
                };

                scope.removeWorkRequirement = (requirement) => {
                    scope.ngModel = scope.ngModel.filter(item => item !== requirement);
                };

            }
        };
    });

angular.module('core')
    .directive('workerCard', ['MyStaff', 'MyCalendarResource', '$uibModal', '$location', '$window', 'Constants', 'MyCalendarConstants', '$filter',
        function (MyStaff, MyCalendarResource, $uibModal, $location, $window, Constants, MyCalendarConstants, $filter) {
            return {
                restrict: 'E',
                templateUrl: '/src/core/html/worker-card.html',
                link: function (scope, element, attrs, ctrls) {
                    scope.hideCalendar = false;
                    scope.cachedMiniCalendar = {};
                    scope.noop = angular.noop;

                    scope.loadUserCalendar = (userId) => {
                        MyCalendarResource.getSmallUserCalendar(
                            {user: userId}
                        ).$promise.then(days => {
                            scope.cachedMiniCalendar = days.slice(0, 7);

                        });
                    };

                    scope.snoozeMeployee = (value, id) => {
                        let temp = {id: id, snooze: value};
                        MyStaff.updateStaffObject(temp);
                    };

                    scope.trustedChange = (value, id) => {
                        let temp = {id: id, trusted: value};
                        MyStaff.updateStaffObject(temp);
                    };

                    scope.getDayOfWeek = function (day) {
                        return _.capitalize(moment(day).format('ddd'));
                    };

                    scope.getShortDate = function (day) {
                        return moment(day).format('DD-MM');
                    };

                    scope.toggleCalendar = function () {
                        scope.hideCalendar = !scope.hideCalendar;
                    };

                    scope.postPloy = function (day, user_id) {
                        if (day.type_for_employer === MyCalendarConstants.types.AVAILABLE) {
                            let date = btoa(JSON.stringify([day.day]));
                            $location.path('post-ploy/for/' + user_id).search({dates: date});
                        }
                    };

                    scope.getStaffAvailability = (availabilityLevel) => {
                        return Constants.staffAvailabilityLevels.find(level => level.value === availabilityLevel).name;
                    };

                    scope.saveOffset = () => {
                        MyStaff.initialVerticalOffset = $window.pageYOffset;
                    };

                    scope.getDayClass = type => {
                        switch (type) {
                            case MyCalendarConstants.types.AVAILABLE:
                                return 'mini-calendar__item--available-for-work';
                            case MyCalendarConstants.types.NOT_AVAILABLE:
                                return 'mini-calendar__item--cant-work';
                            case MyCalendarConstants.types.PLOY:
                                return 'mini-calendar__item--ploy-together';
                            case MyCalendarConstants.types.VACATION:
                                return 'mini-calendar__item--vacation';
                            case MyCalendarConstants.types.SICK:
                                return 'mini-calendar__item--sick';
                        }
                    };

                    scope.getDayTooltip = type_for_employer => {
                        switch (type_for_employer) {
                            case MyCalendarConstants.types.AVAILABLE:
                                return $filter('translate')('MY_CALENDAR__EVENT__AVAILABLE__TITLE');
                            case MyCalendarConstants.types.NOT_AVAILABLE:
                                return $filter('translate')('MY_CALENDAR__EVENT__NOT_AVAILABLE__TITLE');
                            case MyCalendarConstants.types.SICK:
                                return $filter('translate')('MY_CALENDAR__EVENT__SICK_DAY__TITLE');
                            case MyCalendarConstants.types.VACATION:
                                return $filter('translate')('MY_CALENDAR__EVENT__VACATION__TITLE');
                            case MyCalendarConstants.types.PLOY:
                                return $filter('translate')('MY_CALENDAR__EVENT__PLOY__TITLE');
                            default:
                                return ''
                        }
                    }

                }
            };
        }]);

angular.module('core')
    .directive('workerDocuments', ['User', 'LightBox', '$filter', (User, LightBox, $filter) => {
        return {
            restrict: 'E',
            scope: {
                user : '=',
            },
            templateUrl: '/src/core/html/worker-documents.html',
            link: function (scope, element, attrs, ctrls) {
                scope.documents = {};
                scope.openLightBox = LightBox.open;
                User.getDocumentsForEmployers({id: scope.user.id}).$promise.then(documents => {
                    scope.documents = documents;
                });
                scope.isPdf = (documentImageUrl) => {
                    return $filter('lowercase')(documentImageUrl).includes('.pdf')
                };
                scope.isDoc = (documentImageUrl) => {
                    return $filter('lowercase')(documentImageUrl).includes('.doc')
                };
            }
        }
    }]);

angular.module('core').filter('ampersand', function(){
    return function(input){
        return input ? input.replace(/&amp;/, '&') : '';
    }
});
angular.module('core').filter('capitalize', function () {
    return function (input, all) {
      return (!!input) ? input.replace(/([^\W_]+[^\s-]*) */g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }) : '';
    }
  })
angular.module('core')

.filter('categoryNameWithGroup', ['$filter', function($filter) {
    return function(category) {
        if (!category) {return}
        if (category.category_group) {
            return $filter('categoryName')(category.category_group) + ' - ' + $filter('categoryName')(category);
        }
        return $filter('categoryName')(category);
    };
}]);

angular.module('core')

.filter('categoryName', ['LanguageService', function(LanguageService) {
    return function(category) {
        if (!category) {return}
        var language = LanguageService.getCurrentLanguage();
        var category_name = category['name_'+language];
        return category_name || category.name
    };
}]);
angular.module('core')
.filter('filterByDate', function() {
    return function(items, startDate, endDate) {


        let startFilter = item => moment(item.ploy.start_day).isSameOrAfter(startDate, 'day') && moment(item.ploy.start_day).isBefore(endDate, 'day');
        let endFilter = item => moment(item.ploy.end_day).isSameOrBefore(endDate, 'day') || moment(item.ploy.start_day).isBefore(endDate, 'day');

        if (!startDate && !endDate) {
            return items;
        }

        if (startDate && !endDate) {
            return items.filter(item => {
                return startFilter(item)
            });
        }

        if (!startDate && endDate) {
            return items.filter(item => {
                return endFilter(item)
            });

        }

        if (startDate && endDate) {
            return items.filter(item => {
                return  startFilter(item) && endFilter(item)
            });
        }

    };
});


angular.module('core')
.filter('getOccupationName', ['Constants', function(Constants) {
    return function(val) {
        if (!val) {return}
        occup = _.find(Constants.occupations, {'value': val});
        if (occup) {
            return occup.name;
        }
    };
}])
angular.module('core').filter('humanizeBool', ['$translate',  function($translate) {

  function asyncTranslate(input) {
    return input?$translate.instant('YES') : $translate.instant('NO');
  }

  asyncTranslate.$stateful = true;
  return asyncTranslate;
}]);
angular.module('core').filter('humanizeTimeDuration', ['LanguageService', function(LanguageService) {
  return function(input) {
    var language = LanguageService.getCurrentLanguage();
    let minus = input >= 0 ? "" : "-";
    return minus + humanizeDuration(input, {language: language, units: ['h','m'],round: true });
  };
}]);

angular.module('core').filter('humanizeTime', function(moment) {
  return function(input) {
    return moment.duration(input, "seconds").humanize();
  };
});

angular.module('core')
    .filter('isActiveDay', function () {
        return function (items, weekdays, enabledDays) {
            let filterActive = (day) => {
                return day.value & weekdays && enabledDays[day.number];
            };
            return items.filter(filterActive);
        };
    });

angular.module('core')
.filter('roundStars', ['$filter', function($filter) {
    return function(input) {
        if (! input) { return 0; }
        return Math.round(input*2)/2;
    }
}])
angular.module('core').filter('round', [function() {
  return function(value) {
    return parseFloat(value).toFixed(2);
  }
}]);
angular.module('core')
.filter('salaryRound', ['$filter', function($filter) {
    return function(input) {
        if(input === '')
            return '-';
        return $filter('number')(input, 2);
    }
}]);
angular.module('core').filter('trustAsResourceUrl', ['$sce', function ($sce) {
    return function(url) {
        return $sce.trustAsResourceUrl(url);
    };
}]);

angular.module('core').filter('trust', ['$sce',function($sce) {
  return function(value, type) {
    return $sce.trustAs(type || 'html', value);
  }
}]);
angular.module('core')

.factory('RegionResource', ['$resource', function($resource) {

    return $resource('/api/region/:id/', {id: '@id'}, {
        'getNameOfPostalCode': {
            url: '/api/region/get_name_for_postal_code/',
            method: 'GET',
        },
    })

}]);


angular.module('core')
    .factory("Access", ["Auth", "$route", '$auth', '$location', 'User', 'Constants', 'Engagement', 'IpipService',
        function (Auth, $route, $auth, $location, User, Constants, Engagement, IpipService) {

            let status = {
                OK: 200,
                UNAUTHORIZED: 401,
                FORBIDDEN: 403,
                DEFAULT_REDIRECT: 301,
            };

            let redirect = path => $location.path(path);

            let catchError = errorCode => {
                switch (errorCode) {
                    case status.OK:
                        break;

                    case status.UNAUTHORIZED:
                        Auth.setRedirect($location.path());
                        $location.path("/log-in");
                        console.info('Not authorized, redirecting to login...');
                        break;

                    case status.FORBIDDEN:
                        console.info('Resource forbidden');
                        $location.path("/my-ploys");
                        break;

                    case status.DEFAULT_REDIRECT:
                        console.info('User already logged in. Redirecting...');
                        $location.path("/");
                        break;

                    default:
                        break;
                }
            };

            let access = {

                requireLogin: () => {
                    return new Promise((resolve, reject) => {
                        if (Auth.isAuthenticated()) return resolve(status.OK);
                        return $route.current.params.meptok ?
                            resolve($auth.setToken($route.current.params.meptok)) : reject(status.UNAUTHORIZED)
                    }).catch(errorCode => catchError(errorCode));
                },

                requireAnonymous: () => {
                    return new Promise((resolve, reject) => {
                        return Auth.isAuthenticated() ? reject(status.DEFAULT_REDIRECT) : resolve(status.OK);
                    }).catch(errorCode => catchError(errorCode));
                },

                requireCompanyStatus: () => { // todo: to consider - change name to i.e. requireCompanyAccount?
                    return new Promise((resolve, reject) => {
                        return User.get().$promise.then(user => {
                            return user.legal_form === Constants.legalForms.COMPANY ?
                                resolve(status.OK) : reject(status.FORBIDDEN)
                        });
                    }).catch(errorCode => catchError(errorCode));
                },

                requireWorkerStatus: () => { // todo: to consider - change name to i.e. requireMeployeeAccount?
                    return new Promise((resolve, reject) => {
                        return User.get().$promise.then(user => {
                            return user.user_type === Constants.userTypes.MEPLOYEE ?
                                resolve(status.OK) : reject(status.FORBIDDEN)
                        });
                    }).catch(errorCode => catchError(errorCode));
                },

                requireMeployeeEmailVerification: () => {
                    let isEmailVerified = user => {
                        return user.user_type === Constants.userTypes.MEPLOYER ? true : user.email_verify;
                    };
                    return new Promise((resolve, reject) => {
                        return User.get().$promise.then(user => {
                            return isEmailVerified(user) ? resolve(status.OK) : reject(redirect('/confirm-email'))
                        });
                    }).catch(errorCode => catchError(errorCode));
                },

                requireMeployeeCPRNumber: () => {
                    let hasCPRNumber = user => {
                        return user.user_type === Constants.userTypes.MEPLOYER ? true : !!user.cpr_number;
                    };
                    return new Promise((resolve, reject) => {
                        return User.get().$promise.then(user => {
                            return hasCPRNumber(user) ? resolve(status.OK) : reject(redirect('/edit-profile/cpr'))
                        });
                    }).catch(errorCode => catchError(errorCode));
                },

                requireLightAccount: () => {
                    return new Promise((resolve, reject) => {
                        return User.get().$promise.then(user => {
                            return user.profile.verified ? reject(status.FORBIDDEN) : resolve(status.OK)
                        });
                    }).catch(errorCode => catchError(errorCode));
                },

                ipipTestNotCompleted: () => {
                    return new Promise((resolve, reject) => {
                        const checkChoices = () => {
                            return IpipService.hasChoices().then(has => {
                                return has ? reject(redirect('/ipip/test')) : resolve(null)
                            });
                        }
                        return IpipService.hasResult().then(has => {
                            return has ? reject(redirect('/ipip/result')) : checkChoices()
                        });
                    }).catch(errorCode => catchError(errorCode));
                },

                requireCollectiveAgreement: () => {
                    let isCollectiveAgreement = company => {
                        return company && company.collective_agreement
                    };
                    return new Promise((resolve, reject) => {
                        return User.get().$promise.then(user => {
                            isCollectiveAgreement(user.company) ? resolve(status.OK) : reject(status.FORBIDDEN)
                        });
                    }).catch(errorCode => catchError(errorCode));
                },

                requireAnyCreatedGroups: () => {
                    return new Promise((resolve, reject) => {
                        return User.hasAnyStaffGroups().$promise.then(response => {
                            response.has_staff_groups ? resolve(status.OK) : reject(
                                $location.url('/my-staff/groups/add/' + $route.current.params.staff_users).replace()
                            )
                        });
                    }).catch(errorCode => catchError(errorCode));
                },

                engNotAlreadyExists: () => {
                    return new Promise((resolve, reject) => {
                        return User.get().$promise.then(user => {
                            Engagement.engagementExists(user.id, $route.current.params.ployId).$promise.then(response => {
                                response.exists ? reject(status.FORBIDDEN) : resolve(status.OK)
                            });
                        });
                    }).catch(errorCode => catchError(errorCode));
                }
            };

            return access;

        }]);

angular.module('core')
    .factory('Constants', ['$location', function ($location) {

        let Constants = {};

        Constants.staffAvailabilityLevels = [
            {value: 0, name: 'EDIT_STAFF__AVAILABILITY__UNDEFINED'},
            {value: 1, name: 'EDIT_STAFF__AVAILABILITY__EASY'},
            {value: 2, name: 'EDIT_STAFF__AVAILABILITY__MEDIUM'},
            {value: 3, name: 'EDIT_STAFF__AVAILABILITY__HARD'},
        ];


        Constants.ployeesNeededMaxValue = 150;
        Constants.facebook = {appId: '1575294709400938', version: 'v7.0'};
        Constants.fee = 0;


        Constants.stripeKey = {
            TEST: 'pk_test_YfUx8k3rx6ypXgYJGTb7btGv',
            LIVE: 'pk_live_MyUG5JcdRsjFIKOBceQrTw2r',
        };

        Constants.envUrls = {
            DEV: 'http://localhost:8000',
            PROD: 'https://cloud.meploy.me',
        };


        Constants.dashboardEnvUrls = {
            DEV: 'http://localhost:4200',
            PROD: 'https://2cloud.meploy.me',
        };

        Constants.defaultAvatarUrl = 'https://s3-eu-west-1.amazonaws.com/meploystatic/default_profile_pic-46_150x150.png';

        // Constants.intercom_APP_ID = "wr5978u6";

        if (DEBUG) {
            Constants.stripe_key = Constants.stripeKey.TEST;
            Constants.siteUrl = Constants.envUrls.DEV;
        } else {
            Constants.stripe_key = Constants.stripeKey.LIVE;
            Constants.siteUrl = Constants.envUrls.PROD;
        }

        Constants.daysWithoutWeekdaysChoose = 1; // Defines when show weekdays selector in post ploy page

        // on develop.meploy.me and test.meploy.me - DEBUG is set on false for frontend, but need stripe_key set as test
        if ($location.host() == 'develop.meploy.me' || $location.host() == 'test.meploy.me') {
            Constants.stripe_key = Constants.stripeKey.TEST;
        }

        Constants.userTypes = {
            MEPLOYER: 'meployer',
            MEPLOYEE: 'meployee'
        };

        Constants.legalForms = {
            COMPANY: 'company',
            PRIVATE: 'private',
        };

        Constants.paymentTypes = {
            PAY_TYPE_INVOICE: 'invoice',
            PAY_TYPE_INVOICE_FEE: 'invoice-fee',
        };

        Constants.paymentTypesDetails = [
            {
                name: 'PAY_TYPE_INVOICE',
                value: Constants.paymentTypes.PAY_TYPE_INVOICE,
                legalForm: [
                    Constants.legalForms.COMPANY
                ],
            }
        ];

        Constants.languages = [
            {
                'name': 'Danish',
                'value': 'da'
            },
            {
                'name': 'English',
                'value': 'en'
            }
        ];

        Constants.locales = {'en': 'en-us'};

        Constants.countries = [
            {
                'name': 'Denmark',
                'value': 'DK'
            }
        ];

        Constants.cities = {
            'Copenhagen':
                {
                    'lat': 55.6750199,
                    'lon': 12.5747661
                }
        };

        Constants.englishWeekdaysList = [
            {name: 'monday', value: 1, number: 1},
            {name: 'tuesday', value: 2, number: 2},
            {name: 'wednesday', value: 4, number: 3},
            {name: 'thursday', value: 8, number: 4},
            {name: 'friday', value: 16, number: 5},
            {name: 'saturday', value: 32, number: 6},
            {name: 'sunday', value: 64, number: 0},
        ];

        Constants.danishWeekdaysList = [ // In denmark week starts from monday, not sunday
            {name: 'monday', value: 1, number: 0},
            {name: 'tuesday', value: 2, number: 1},
            {name: 'wednesday', value: 4, number: 2},
            {name: 'thursday', value: 8, number: 3},
            {name: 'friday', value: 16, number: 4},
            {name: 'saturday', value: 32, number: 5},
            {name: 'sunday', value: 64, number: 6},
        ];

        Constants.occupations = [
            {
                // 0
                'name': "IM_STUDENT_ON_SU",
                'value': 'student-su',
                'income': 7350,
                'incomePeriod': 'month',
                'outcome': 50000
            },
            {
                // 1
                'name': "IM_STUDENT",
                'value': 'student',
                'income': 18450,
                'incomePeriod': 'month',
                'outcome': 50000
            },
            {
                // 2
                'name': "IM_LOOKING_FOR_WORK",
                'value': 'looking',
                'income': 50000,
                'incomePeriod': 'year',
                'outcome': 50000
            },
            {
                // 3
                'name': "I_HAVE_A_FULL_TIME_JOB",
                'value': 'full-time',
                'income': 50000,
                'incomePeriod': 'year',
                'outcome': 50000
            },
            {
                // 4
                'name': "IM_A_PART_TIME_WORKER",
                'value': 'part-time',
                'income': 50000,
                'incomePeriod': 'year',
                'outcome': 50000
            },
            {
                // 5
                'name': "IM_AN_UNEMPLOYED_ON_SUPPORT",
                'value': 'unemployed',
                'income': 50000,
                'incomePeriod': 'year',
                'outcome': 50000
            },
            {
                // 6
                'name': "IM_RETIRED",
                'value': 'retired',
                'income': 60000,
                'incomePeriod': 'year',
                'outcome': 50000
            },
            {
                // 7
                'name': 'IM_SELF_EMPLOYED',
                'value': 'self-employed',
                'income': 50000,
                'incomePeriod': 'year',
                'outcome': 50000,
            },
            {
                // 8
                'name': 'IM_ENTREPRENEUR',
                'value': 'entrepreneur',
                'income': 50000,
                'incomePeriod': 'year',
                'outcome': 50000,
            },
            {
                // 9
                'name': 'IM_TEMP_WORKER',
                'value': 'temp-worker',
                'income': 50000,
                'incomePeriod': 'year',
                'outcome': 50000,
            },
            {
                // 10
                'name': 'IM_EXCHANGE_STUDENT',
                'value': 'exchange-student',
                'income': 18450,
                'incomePeriod': 'month',
                'outcome': 50000,
            },
            {
                // 11
                'name': 'IM_FREELANCER',
                'value': 'freelancer',
                'income': 50000,
                'incomePeriod': 'year',
                'outcome': 50000,
            }
        ];


        Constants.patterns = {
            'email': /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        };

        Constants.engagementStates = {
            EMPLOYER_CHOSE_EMPLOYEE: 'EMPLOYER_CHOSE_EMPLOYEE',
            EMPLOYER_PRE_APPROVE: 'EMPLOYER_PRE_APPROVE',
            ENGAGEMENT_EMPLOYEE_APPLIED: 'ENGAGEMENT_EMPLOYEE_APPLIED',
            ENGAGEMENT_DECLINED: 'ENGAGEMENT_DECLINED',
            ENGAGEMENT_COMPLETED: 'ENGAGEMENT_COMPLETED',
            ENGAGEMENT_PAID: 'ENGAGEMENT_PAID',
            ENGAGEMENT_CANCELLED: 'ENGAGEMENT_CANCELLED',
            ENGAGEMENT_CREATED: 'ENGAGEMENT_CREATED',
            ENGAGEMENT_INQUIRY_SENT: 'ENGAGEMENT_INQUIRY_SENT',
            ENGAGEMENT_SICK: 'ENGAGEMENT_SICK',
            ENGAGEMENT_ABSENT: 'ENGAGEMENT_ABSENT',
            ENGAGEMENT_SICK_WITH_PAYMENT: 'ENGAGEMENT_SICK_WITH_PAYMENT',
        };

        Constants.engagementStatesEmployeeChosen = [
            'ENGAGEMENT_PAID',
            'EMPLOYER_CHOSE_EMPLOYEE',
            'ENGAGEMENT_COMPLETED'
        ];

        Constants.engagementStatesAbsentOrSick = [
            Constants.engagementStates.ENGAGEMENT_SICK,
            Constants.engagementStates.ENGAGEMENT_SICK_WITH_PAYMENT,
            Constants.engagementStates.ENGAGEMENT_CANCELLED,
            Constants.engagementStates.ENGAGEMENT_ABSENT,
        ];

        Constants.engagementStatesNotApproved = [
            'ENGAGEMENT_CREATED',
            'ENGAGEMENT_INQUIRY_SENT',
            'ENGAGEMENT_EMPLOYEE_APPLIED',
            'EMPLOYER_PRE_APPROVE',
        ];

        Constants.engagementStatesNotClosed = [
            'ENGAGEMENT_CREATED',
            'ENGAGEMENT_INQUIRY_SENT',
            'ENGAGEMENT_EMPLOYEE_APPLIED',
            'EMPLOYER_PRE_APPROVE',
            'EMPLOYER_CHOSE_EMPLOYEE',
            'ENGAGEMENT_COMPLETED',
        ];

        Constants.notification_messages = [
            {
                'name': 'COMMENT',
                'value': "NM_STAGED_A_COMMENT"
            },
            {
                'name': 'EMPLOYER_CHOSE_EMPLOYEE',
                'value': "NM_CHOSEN_EMPLOYEE"
            },
            {
                'name': 'EMPLOYER_PRE_APPROVE',
                'value': "NM_PRE_APPROVED_PLOY"
            },
            {
                'name': 'ENGAGEMENT_CREATED',
                'value': "NM_CRATED_THE_PLOY"
            },
            {
                'name': 'ENGAGEMENT_INQUIRY_SENT',
                'value': "NM_SENT_INQUIRED"
            },
            {
                'name': 'ENGAGEMENT_EMPLOYEE_APPLIED',
                'value': "NM_APPLIED_THE_PLOY"
            },
            {
                'name': 'ENGAGEMENT_DECLINED',
                'value': "NM_MARKED_PLOY_AS_DECLINED"
            },
            {
                'name': 'ENGAGEMENT_COMPLETED',
                'value': "NM_MARKED_PLOY_AS_COMPLETED"
            },
            {
                'name': 'ENGAGEMENT_PAID',
                'value': "NM_PAID"
            },
            {
                'name': 'ENGAGEMENT_CANCELLED',
                'value': "NM_CANCELLED_THE_PLOY"
            },
            {
                'name': 'ENGAGEMENT_CLOSED',
                'value': "NM_CLOSED_PLOY"
            },
        ];

        Constants.PloyStatuses = {
            PLOY_STATUS_ASSIGNED: 'ASSIGNED',
            PLOY_STATUS_ENDED: 'ENDED',
            PLOY_STATUS_CANCELLED: 'CANCELLED',
            PLOY_STATUS_PRIVATE: 'PRIVATE',
            PLOY_STATUS_PUBLISHED: 'PUBLISHED',
            PLOY_STATUS_UNPUBLISHED: 'UNPUBLISHED',
            PLOY_STATUS_ONGOING: 'ONGOING',
            PLOY_STATUS_COMPLETED: 'COMPLETED',
        };

        Constants.hours = [
            {value: 3, name: '3_HOURS'},
            {value: 4, name: '4_HOURS'},
            {value: 5, name: '5_HOURS'},
            {value: 6, name: '6_HOURS'},
            {value: 7, name: '7_HOURS'},
            {value: 8, name: '8_HOURS'},
            {value: 9, name: '9_HOURS'},
            {value: 10, name: '10_HOURS'},
            {value: 11, name: '11_HOURS'},
            {value: 12, name: '12_HOURS'},
        ];

        Constants.minutes = [];
        let minutesCommon = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
        minutesCommon.forEach(option => {
            Constants.minutes.push({value: option, name: String(option) + '_MINUTES', type: 'MINUTES_COMMON'},);
        });
        for (let option = 1; option < 60; option++) {
            if (!minutesCommon.includes(option)) {
                Constants.minutes.push(
                    {value: option, name: String(option) + '_MINUTE', type: 'MINUTES_PRECISE'},
                )
            }
        }

        Constants.alvaLogs = {
            LOG_MATCH_ME_ACTIVATED: 'MATCH_ME_ACTIVATED',
            LOG_MATCH_ME_APPROVE: "MATCH_ME_APPROVE",
            LOG_MATCH_ME_DECLINED: "MATCH_ME_DECLINED",
            LOG_MATCH_ME_SEE_FULL_PROFILE: "MATCH_ME_SEE_FULL_PROFILE",
            LOG_SCOUT_SEARCH: "LOG_SCOUT_SEARCH",
            LOG_SCOUT_HOW_IT_WORKS_CLICK: "LOG_SCOUT_HOW_IT_WORKS_CLICK",
            LOG_SCOUT_APPROVE: "LOG_SCOUT_APPROVE",
            LOG_SCOUT_DECLINED: "LOG_SCOUT_DECLINED",
            LOG_SCOUT_SEE_FULL_PROFILE: "LOG_SCOUT_SEE_FULL_PROFILE",
            LOG_SCOUT_SEE_REJECTED_PROFILES: "LOG_SCOUT_SEE_REJECTED_PROFILES",
            LOG_SCOUT_REMOVE_FROM_REJECTED: "LOG_SCOUT_REMOVE_FROM_REJECTED",
        };

        Constants.view = {
            MINE: 'mine',
            COMPANY: 'company',
        };

        Constants.workLogTypes = {
            WORK_LOG_TYPE_CHECK_IN: 'check-in',
            WORK_LOG_TYPE_CHECK_OUT: 'check-out',
            WORK_LOG_TYPE_CHECK_IN_MODIFIED: 'check-in-modified',
            WORK_LOG_TYPE_WILL_BE_LATE: 'will-be-late',
            WORK_LOG_TYPE_SAVE_FOR_LATER: 'save-for-later',
            WORK_LOG_TYPE_EMPLOYER_MODIFICATION: 'shift-modified',
        };

        Constants.nationalityOptions = [
            {
                value: 1,
                name: 'SIGN_UP_EMPLOYEE__NATIONALITY__DANISH',
            },
            {
                value: 2,
                name: 'SIGN_UP_EMPLOYEE__NATIONALITY__NORDIC',
            },
            {
                value: 3,
                name: 'SIGN_UP_EMPLOYEE__NATIONALITY__EU_EAA_SWITZERLAND',
            },
            {
                value: 4,
                name: 'SIGN_UP_EMPLOYEE__NATIONALITY__OUTSIDE_EUROPE',
            }
        ];

        Constants.ipipChoiceScale = [
            {
                name: 'IPIP__CHOICE_1__LABEL',
                value: 1
            },
            {
                name: 'IPIP__CHOICE_2__LABEL',
                value: 2
            },
            {
                name: 'IPIP__CHOICE_3__LABEL',
                value: 3
            },
            {
                name: 'IPIP__CHOICE_4__LABEL',
                value: 4
            },
            {
                name: 'IPIP__CHOICE_5__LABEL',
                value: 5
            },
        ]

        Constants.months = {
            1: 'MONTH_1_NAME',
            2: 'MONTH_2_NAME',
            3: 'MONTH_3_NAME',
            4: 'MONTH_4_NAME',
            5: 'MONTH_5_NAME',
            6: 'MONTH_6_NAME',
            7: 'MONTH_7_NAME',
            8: 'MONTH_8_NAME',
            9: 'MONTH_9_NAME',
            10: 'MONTH_10_NAME',
            11: 'MONTH_11_NAME',
            12: 'MONTH_12_NAME',
        }

        Constants.yearsRange = () => {
            let yearsRange = [];
            const start = 1950;
            let year = new Date().getFullYear();
            for(; year > start; ) {
                yearsRange.push(year);
                year -= 1;
            }
            return yearsRange;
        };

        return Constants;

    }])

    .constant('becomeUser', {
        check: ['$q', '$auth', '$route', function ($q, $auth, $route) {
            $auth.setToken($route.current.params.token);
            let url = '/';
            if ($route.current.params.page) {
                let pagePartsArray = $route.current.params.page.split(',');
                pagePartsArray.forEach(part => {
                    url = url + part + '/';
                })
            }
            if ($route.current.params.getParams) {
                let getParamsArray = $route.current.params.getParams.split(',');
                url = url + '?';
                getParamsArray.forEach(part => {
                    url = url + part + '&';
                })
            }
            window.location = url;
        }]
    })

    .constant('authorizeUserFromToken', { // todo: Guard deprecated. Now it works with ?meptok=urltoken for every route. Delete when mobile app will be adjusted.
        check: ['$q', '$auth', '$route', function ($q, $auth, $route) {
            $auth.setToken($route.current.params.token);
        }]
    })

    .constant('htmlPath', function (name) {
        return filename => {
            return '/src/' + _.kebabCase(name) + '/html/' + filename
        }
    })

;

angular.module('core')

    .service('Device', function () {

        /**
         * Determine the mobile operating system.
         * Returns one of 'iOS', 'Android' or 'unknown'.
         */

        function getMobileOperatingSystem() {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;

            if (/android/i.test(userAgent)) {
                return "Android";
            }

            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }

            return "unknown";
        }
        return {getMobileOperatingSystem};
    });

angular.module('core')

.factory('Geolocation', [ '$geolocation', 'RegionResource',
    function($geolocation, RegionResource) {
    var Geolocation = {};

        Geolocation.getCurrentPosition = function () {
            return $geolocation.getCurrentPosition({
                timeout: 1000
            }).then(function (position) {
                return position;
            });
        };

        Geolocation.getAddressFromLatLon = function (lat, lon, callback) {
            var geocoder = new google.maps.Geocoder();
            var latlng = new google.maps.LatLng(lat, lon);
            geocoder.geocode({ 'latLng': latlng }, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    if (results[1]) {
                        console.log(results[1]);
                        callback({ 'success': true, 'formatted_address': results[1].formatted_address });
                        return results[1].formatted_address
                    } else {
                        console.log('Location not found');
                        return { 'success': false }
                    }
                } else {
                    console.log('Geocoder failed due to: ' + status);
                    return { 'success': false }
                }
            });
        };

        Geolocation.getNameOfPostalCode = RegionResource.getNameOfPostalCode;


    return Geolocation;
}]);

angular.module('core')

  .service('HandleServerErrors', ['AlertBanner', '$filter', function (AlertBanner, $filter) {
    this.handleFormError = function (response) {
      var fieldError = _.flatten(_.values(response.data))[0];
      var message = '';
      if (fieldError) {
        try {
          message = JSON.parse(fieldError);
          message = $filter('translate')(message.message, message.values)
        }
        catch(e) {
          message = $filter('translate')(fieldError)
        }
        AlertBanner.publish({
          type: 'error',
          message: message,
          timeCollapse: 5000
        });
      }
      return Promise.reject(message)
    }

  }]);

angular.module('core')

.service('LanguageService', ['$translate', '$cookies', 'tmhDynamicLocale', '$rootScope', 'Constants', function ($translate, $cookies, tmhDynamicLocale, $rootScope, Constants) {
      var currentLanguage;
      var lngService = {};

      var localization_map = {'en': 'en-us'};

      lngService.getFromCookies = function () {
          var language = $cookies.get('language') || 'da';
          if (language) {
              lngService.setLanguage(language)
          }
          return language
      };

      lngService.getCurrentLanguage = function () {
          return currentLanguage || lngService.getFromCookies()
      };

      lngService.setLanguage = function (language) {
          currentLanguage = language;
          $translate.use(language);
          $cookies.put('language', language);
          setLocalization(language);
          moment.locale(language);
          $rootScope.$broadcast('refreshLanguage', language);
      };

      var setLocalization = function (language) {
          var locale = Constants.locales[language] || language;
          tmhDynamicLocale.set(locale);
      };

      return lngService;
}]);

angular.module('core')

.service('PloyFormStorage', ['$location', 'PloyFilter', function ($location, PloyFilter) {
    var ployForm;
    var searchForm;

    var PloyFormStorageService = {};

    PloyFormStorageService.savePloyForm = function(form){
        ployForm = form;
        //if (ployForm.description) { ployForm.description = "I need a " + ployForm.description }
        //else ployForm.description = "";
        console.log('saved form', ployForm)
    };
    PloyFormStorageService.getPloyForm = function(form){
        form = angular.copy(ployForm);
        ployForm = undefined;
        return form
    };
    PloyFormStorageService.hasPloyForm = function(){
       return !!ployForm;
    };
    PloyFormStorageService.saveSearchForm = function(form){
        searchForm = form
    };
    PloyFormStorageService.getSearchForm = function(){
        form = angular.copy(searchForm);
        ployForm = undefined;
        return form
    };
    PloyFormStorageService.hasSearchForm = function(){
       return !!searchForm;
    };

    PloyFormStorageService.handleFormsAfterLogin = function(){
      if (PloyFormStorageService.hasSearchForm()){
          console.log('search form', searchForm);
          PloyFilter.set(PloyFormStorageService.getSearchForm(), []);
          $location.path('/search')
      }
      if (PloyFormStorageService.hasPloyForm()){
          console.log('ploy form', ployForm);
          $location.path('/post-ploy')
      } else {
          if($location.path() == '/log-in') {
              $location.path('/');
          }
      }

    };

    return PloyFormStorageService;

}]);
angular.module('core')

.service('RequestTransform', [ function () {

    this.getPaginatedCount = (data, headers) => {
        data = angular.fromJson(data);
        headers()['count'] = (data) ? data.count : 0;
        return data.results || 0;
    };

    this.getPaginatedCountWithCount = (data, headers) => {
        data = angular.fromJson(data);
        headers()['count'] = (data) ? data.count : 0;
        return {'results': data.results, 'count': data.count};
    };
}]);

angular.module('cv')

.controller('EditCvCertificatesController', ['$scope', 'User', '$location', 'Certificate', 'CertificatePicture', 'Modal', '$routeParams', '$filter', 'Upload', '$rootScope', 'Constants', '$route',
    function($scope, User, $location, Certificate, CertificatePicture, Modal, $routeParams, $filter, Upload, $rootScope, Constants, $route) {

    let loadPages = () => {
        $scope.pageNumbers = [...Array(7).keys()].slice(1).map(number => {
            return {'value': number, 'name': number + ' ' + $filter('translate')('PAGE')}
        });
    };
    loadPages();

    $scope.isDocumentBeingUploaded = false;

    $scope.form = {};
    let loadCertificate = () => {
        Certificate.get({id: $routeParams.certificate_id}).$promise.then((certificate) => {
            if (certificate.date_month) {
                certificate.date_month = String(certificate.date_month);
            }
            $scope.form = certificate;
        })
    }
    if ($routeParams.certificate_id) {
        loadCertificate();
    }
    
    $scope.addCertificate = (form) => {
        Certificate.save(form).$promise.then((certificate) => {
            $routeParams.certificate_id = certificate.id;
            loadCertificate();
        });
    }

    $scope.editCertificate = (form) => {
        Certificate.update(form).$promise.then(() => {
            goBackAfterAction();
        });
    }

    $scope.remove = (certificateId) => {
        return Modal.confirm({
            title: $filter('translate')('ARE_YOU_SURE'),
            firstButtonLabel: $filter('translate')('NO'),
            secondButtonLabel: $filter('translate')('YES'),
            secondButtonColor: 'green',
            secondButtonFunction: function () {
                return Certificate.remove({id: certificateId}).$promise.then(() => {
                    goBackAfterAction();
                });
            }
        });
    }

    let goBackAfterAction = () => {
        $rootScope.$broadcast('cv-updated');
        User.refresh().then(() => {
            User.get().$promise.then(() => {
                $location.path('/cv/edit');
            });
        });
    }

    $scope.uploadCertificatePicture = (files) => {
        const file = files[0];
        $scope.isDocumentBeingUploaded = true;
        Upload.upload({
            url: '/api/certificate-picture/upload_certificate_picture/',
            data: {
                certificate_id: $routeParams.certificate_id,
                certificate_image: file,
            },
        }).then(response => {
            if (!$routeParams.certificate_id && response.data && response.data.certificate) {
                $route.updateParams({'certificate_id': response.data.certificate});
                return;
            }
            loadCertificate();
            $scope.isDocumentBeingUploaded = false;
        }, err => {
            Modal.alert({
                title: $filter('translate')('KYC_SERVICE__DOCUMENT_UPLOAD_FAILED'),
                message: $filter('translate')('KYC_SERVICE__DOCUMENT_UPLOAD_FAILED__DESCRIPTION'),
                buttonColor: 'red'
            });
            $scope.isDocumentBeingUploaded = false;
        });
    };

    $scope.isImage = (path) => {
        return path.includes('.png') || path.includes('.jpg') || path.includes('.jpeg') ||
               path.includes('.PNG') || path.includes('.JPG') || path.includes('.JPEG');
    };
    $scope.getFileIcon = (path) => {
        if (path.includes('.pdf') || path.includes('.PDF')) return 'fa fa-file-pdf-o';
        if (path.includes('.doc') || path.includes('.DOC')) return 'fa fa-file-word-o';
        return 'fa fa-file-o';
    };
    $scope.setFieldCompleted = picture => {
        return $scope.fieldCompleted = picture.document_pictures.length > 0;
    };
    $scope.toFilename = url => {
        if (url) {
             return url.replace(/^.*[\\\/]/, ''); // get filename from url
        }
        return url
    };

    $scope.savePageNumber = (certificatePictureId, page) => {
        CertificatePicture.update({id: certificatePictureId, page: page}).$promise.then(() => {
            loadCertificate();
        });
    };

    $scope.deleteImg = (certificatePictureId) => {
        CertificatePicture.remove({id: certificatePictureId}).$promise.then(() => {
            loadCertificate();
        });
    };
    
    $scope.months = Constants.months;
    $scope.yearsRange = Constants.yearsRange;

}]);

angular.module('cv')

.controller('EditCvHobbiesController', ['$scope', 'Hobby', 'User', '$location', '$rootScope',
    function($scope, Hobby, User, $location, $rootScope) {

    $scope.form = {};
    User.get().$promise.then((user) => {
        $scope.form = user;
    });

    $scope.saveHobby = function (tag) {
        Hobby.save(tag).$promise.then(function (instance) {
            let idx = _.findIndex($scope.form.hobbies, tag);
            $scope.form.hobbies[idx] = instance;
            $rootScope.$broadcast('cv-updated');
        });
    };
    $scope.removeHobby = Hobby.remove;

    $scope.addEditHobbies = () => {
        goBackAfterAction();
    };

    let goBackAfterAction = () => {
        $rootScope.$broadcast('cv-updated');
        User.refresh().then(() => {
            User.get().$promise.then(() => {
                $location.path('/cv/edit');
            });
        });
    }

}]);

angular.module('cv')

.controller('EditCvLanguagesController', ['$scope', 'Language', 'User', '$location', '$rootScope',
    function($scope, Language, User, $location, $rootScope) {

    $scope.form = {};
    User.get().$promise.then((user) => {
        $scope.form = user;
    });

    $scope.saveLanguage = function (tag) {
        Language.save(tag).$promise.then(function (instance) {
            let idx = _.findIndex($scope.form.languages, tag);
            $scope.form.languages[idx] = instance;
            $rootScope.$broadcast('cv-updated');
        });
    };
    $scope.removeLanguage = Language.remove;

    $scope.addEditLanguages = () => {
        goBackAfterAction();
    };

    let goBackAfterAction = () => {
        $rootScope.$broadcast('cv-updated');
        User.refresh().then(() => {
            User.get().$promise.then(() => {
                $location.path('/cv/edit');
            });
        });
    }

}]);

angular.module('cv')

.controller('EditCvSchoolsController', ['$scope', '$location', 'User', 'School', '$routeParams', 'GeoResource', 'Modal', '$filter', '$rootScope', 'Constants',
    function($scope, $location, User, School, $routeParams, GeoResource, Modal, $filter, $rootScope, Constants) {

    $scope.form = {};
    GeoResource.getCountriesList().$promise.then(countries => {
        $scope.countries = countries;
    });

    if ($routeParams.school_id) {
        School.get({id: $routeParams.school_id}).$promise.then((school) => {
            if (school.since_month) {
                school.since_month = String(school.since_month);
            }
            if (school.to_month) {
                school.to_month = String(school.to_month);
            }
            $scope.form = school;
        })
    }

    $scope.addEditSchool = (form) => {
        const method = (form.id) ? School.update : School.save;
        method(form).$promise.then(() => {
            goBackAfterAction();

        });
    }

    $scope.remove = (schoolId) => {
        return Modal.confirm({
            title: $filter('translate')('ARE_YOU_SURE'),
            firstButtonLabel: $filter('translate')('NO'),
            secondButtonLabel: $filter('translate')('YES'),
            secondButtonColor: 'green',
            secondButtonFunction: function () {
                return School.remove({id: schoolId}).$promise.then(() => {
                    goBackAfterAction();
                });
            }
        });
    }

    let goBackAfterAction = () => {
        $rootScope.$broadcast('cv-updated');
        User.refresh().then(() => {
            User.get().$promise.then(() => {
                $location.path('/cv/edit');
            });
        });
    }

    $scope.months = Constants.months;
    $scope.yearsRange = Constants.yearsRange;

}])

angular.module('cv')

.controller('EditCvSkillsController', ['$scope', 'Skill', 'User', '$location', '$rootScope',
    function($scope, Skill, User, $location, $rootScope) {

    $scope.form = {};
    User.get().$promise.then((user) => {
        $scope.form = user;
    });

    $scope.saveSkill = function (tag) {
        Skill.save(tag).$promise.then(function (instance) {
            let idx = _.findIndex($scope.form.skills, tag);
            $scope.form.skills[idx] = instance;
            $rootScope.$broadcast('cv-updated');
        });
    };
    $scope.removeSkill = Skill.remove;

    $scope.addEditSkills = () => {
        goBackAfterAction();
    };

    let goBackAfterAction = () => {
        $rootScope.$broadcast('cv-updated');
        User.refresh().then(() => {
            User.get().$promise.then(() => {
                $location.path('/cv/edit');
            });
        });
    }

}]);

angular.module('cv')

.controller('EditCvWorksController', ['$scope', '$location', 'User', 'Work', '$routeParams', 'GeoResource', 'Modal', '$filter', '$rootScope', 'Constants',
    function($scope, $location, User, Work, $routeParams, GeoResource, Modal, $filter, $rootScope, Constants) {

    $scope.form = {};
    GeoResource.getCountriesList().$promise.then(countries => {
        $scope.countries = countries;
    });

    if ($routeParams.work_id) {
        Work.get({id: $routeParams.work_id}).$promise.then((work) => {
            if (work.since_month) {
                work.since_month = String(work.since_month);
            }
            if (work.to_month) {
                work.to_month = String(work.to_month);
            }
            $scope.form = work;
        })
    }

    $scope.addEditWork = (form) => {
        const method = (form.id) ? Work.update : Work.save;
        method(form).$promise.then(() => {
            goBackAfterAction();
        });
    }

    $scope.remove = (workId) => {
        return Modal.confirm({
            title: $filter('translate')('ARE_YOU_SURE'),
            firstButtonLabel: $filter('translate')('NO'),
            secondButtonLabel: $filter('translate')('YES'),
            secondButtonColor: 'green',
            secondButtonFunction: function () {
                return Work.remove({id: workId}).$promise.then(() => {
                    goBackAfterAction();
                });
            }
        });
    }

    let goBackAfterAction = () => {
        $rootScope.$broadcast('cv-updated');
        User.refresh().then(() => {
            User.get().$promise.then(() => {
                $location.path('/cv/edit');
            });
        });
    }

    $scope.months = Constants.months;
    $scope.yearsRange = Constants.yearsRange;

}]);

angular.module('cv')

.controller('EditCvController', ['$scope', '$location', 'User', 'Work', 'GeoResource', 'Constants',
    function($scope, $location, User, Work, GeoResource, Constants) {

    let signature = '';

    User.get().$promise.then(user => {
        User.getSignature({'id': user.id}).$promise.then((response) => {
            signature = response.signature;
        });
    });

    $scope.saveProfile = () => {
        User.save(user).then(function () {});
    };

    $scope.saveWork = function (tag) {
        Work.save(tag).$promise.then(function (instance) {
            let idx = _.findIndex($scope.form.works, tag);
            $scope.form.works[idx] = instance;
        });
    };
    $scope.removeWork = Work.remove;

    $scope.addCvDetail = (section) => {
        $location.path('/cv/edit/' + section);
    }

    $scope.editCvDetail = (section, detailId) => {
        $location.path('/cv/edit/' + section + '/' + detailId);
    }

    GeoResource.getCountriesList().$promise.then(countries => {
        $scope.countries = countries;
    });

    $scope.getCountryName = (countryCode) => {
        return ($scope.countries) ? $scope.countries[countryCode] : '';
    }

    $scope.months = Constants.months;

    $scope.getCvPdf = () => {
        return User.getCvPdf(signature);
    }

}]);

angular.module('download')


    .controller('DownloadAppController', ['$scope', 'Device', '$location',
        function ($scope, Device, $location) {

           $scope.isAndroid = Device.getMobileOperatingSystem() === 'Android';
           $scope.goToHome = () => {
               $location.path('/')
           }
           $scope.goToAppStore = () => {
               window.open('https://apps.apple.com/pl/app/meploy/id1090851429#?platform=iphone', '_blank');
           }

           $scope.goToGooglePlay = () => {
               window.open('https://play.google.com/store/apps/details?id=me.meploy.app&hl=pl&gl=US', '_blank');
           }

        }]);

angular.module('edit-profile')

.controller('EditProfileController', ['$scope', 'User', '$location', 'Constants', '$filter',
    function ($scope, User, $location, Constants, $filter) {

    $scope.userTypes = Constants.userTypes;

    $scope.goToEditProfilePage = (section) => {
        $location.path('/edit-profile/' + section);
    }

    let loadUser = () => {
        User.getCurrentProProfile().$promise.then(function (user) {
            $scope.currentProProfile = angular.copy(user);
            $scope.hasDefaultAvatar = user.avatar_url === Constants.defaultAvatarUrl;
        });
    };
    loadUser();

    User.getProfileProgress().$promise.then(data => {
        $scope.profileComplete = data.progress;
    });

    let isNationalityPendingVerification = () => $scope.currentProProfile && $scope.currentProProfile.nationality == 4
        && $scope.currentProProfile.work_permit_uploaded && $scope.currentProProfile.work_permit_verified == undefined;

    $scope.getNationalityTitle = () => {
        if (isNationalityPendingVerification()) {
            return $filter('translate')('EDIT_PRO_PROFILE__PENDING_VERIFICATION_INFO');
        }
        return '';
    }

    let isCriminalRecordPendingVerification = () => $scope.currentProProfile &&
        $scope.currentProProfile.criminal_record_uploaded && $scope.currentProProfile.criminal_record_verified == undefined;

    $scope.getCriminalRecordTitle = () => {
        if (isCriminalRecordPendingVerification()) {
            return $filter('translate')('EDIT_PRO_PROFILE__PENDING_VERIFICATION_INFO');
        }
        return '';
    }

}]);

angular.module('engagementShift')
.controller('EngagementShiftController', ['$scope', '$filter', 'Modal', 'EngagementShiftService', 'AlertBanner',
    function($scope, $filter, Modal, EngagementShiftService, AlertBanner) {

    $scope.collapsedListItems = {};
    $scope.currentlyLoadingItems = {};

    $scope.ployShiftListIsLoaded = false; // show page only when list is loaded

    $scope.editMode = {
      id: null,
      set: engShift => this.id = engShift.id,
      cancel: () => {this.id = null; $scope.$broadcast('resetTimeValues')},
      isActive: engShift => this.id === engShift.id,
    };

    $scope.ployEngsOrderBy = {
        value: 'checkin_time',
        reverse: false
    };

    $scope.showReviewTooltipForShiftEng = EngagementShiftService.showReviewTooltipForShiftEng;

    $scope.filterShiftResults = (filters) => {
        $scope.collapsedListItems = {};
        EngagementShiftService.filter(filters);
    };

    $scope.approvedListIsSelected = EngagementShiftService.approvedListIsSelected;

    $scope.getCurrentEngagementShiftsToDisplay = EngagementShiftService.getCurrentEngagementShiftsToDisplay;

    $scope.getAutocompleteData = EngagementShiftService.getAutocompleteData;

    $scope.getShiftsForPloy = (ployShift) => {
        EngagementShiftService.getShiftsForPloy(ployShift).then(function () {
            let index = ployShift.ploy.id.toString()+ployShift.employee.id.toString();
            $scope.currentlyLoadingItems[index] = false;
        })
    };

    $scope.downloadShifts = EngagementShiftService.downloadShifts;

    $scope.getShiftsToApproveCount = EngagementShiftService.getShiftsToApproveCount;

    $scope.approveShift = EngagementShiftService.approveShift;

    $scope.displayApprovedList = (decision) => {
        EngagementShiftService.displayApprovedList(decision).then(() => {
            $scope.collapsedListItems = {};
            $scope.ployShiftListIsLoaded = true;
        });
    };

    $scope.collapseListItem = (ployShift) => {
        let index = ployShift.ploy.id.toString()+ployShift.employee.id.toString(); // ploy id and employee id as unique key for collapsing
        $scope.collapsedListItems[index] = !_.get($scope.collapsedListItems, index, true);
        if (!ployShift.engShifts) {
            $scope.currentlyLoadingItems[index] = true;
            $scope.getShiftsForPloy(ployShift);
        }
    };

    $scope.isListItemCollapsed = (ployShift) => {
        return _.get($scope.collapsedListItems, ployShift.ploy.id.toString()+ployShift.employee.id.toString(), true);
    };

    $scope.isListItemLoading = (ployShift) => {
        return _.get($scope.currentlyLoadingItems, ployShift.ploy.id.toString()+ployShift.employee.id.toString(), true);
    };

    $scope.sortPloyShifts = sortBy => {
        EngagementShiftService.setSortBy(sortBy);
    };

    $scope.sortEngsShifts = sortBy => {
        $scope.ployEngsOrderBy.value = sortBy;
        $scope.ployEngsOrderBy.reverse = !$scope.ployEngsOrderBy.reverse;
    };

    $scope.saveWorkLog = (engagement) => {
        $scope.$broadcast('updateTimeValues', engagement);
        EngagementShiftService.saveWorkLog(engagement).$promise.then( () => {
            $scope.editMode.cancel();
        }, err => {
            AlertBanner.publish({
                type: 'error',
                message: $filter('translate')('CHECK_IN_OUT_PAGE__MODAL_ERROR__' + err.data[0]),
                timeCollapse: 4000
            });
        });
    };

    $scope.approvePloyShift = function(ployShift) {
        Modal.confirm({
            title : $filter('translate')('ENGAGEMENT_SHIFT__MODAL__HEADER__APPROVE_ALL'),
            message : $filter('translate')('ENGAGEMENT_SHIFT__MODAL__MESSAGE__APPROVE_ALL'),
            firstButtonLabel : $filter('translate')('CANCEL'),
            secondButtonLabel : $filter('translate')('OK'),
            secondButtonColor : 'green',
            secondButtonFunction : () => {
                EngagementShiftService.approvePloyShift(ployShift).then(() => {
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('SAVED') + '!',
                        timeCollapse: 4000
                    });
                    $scope.collapsedListItems = {};
                });
            }
        });
    };

    $scope.approveAllShifts = () => {
        Modal.confirm({
            title : $filter('translate')('ENGAGEMENT_SHIFT__MODAL__HEADER__APPROVE_ALL'),
            message : $filter('translate')('ENGAGEMENT_SHIFT__MODAL__MESSAGE__APPROVE_ALL'),
            firstButtonLabel : $filter('translate')('CANCEL'),
            secondButtonLabel : $filter('translate')('OK'),
            secondButtonColor : 'green',
            secondButtonFunction : () => {
                EngagementShiftService.approveAllShifts().then(() => {
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('SAVED') + '!',
                        timeCollapse: 4000
                    });
                });
            }
        });
    };

    $scope.calculateWorkTime = function (engagement) {
        let workTimeDuration = EngagementShiftService.calculateWorkTimeDuration(engagement);
        EngagementShiftService.setWorkTimeForEngagement(engagement, workTimeDuration.asMilliseconds());
        return EngagementShiftService.createWorkTimeString(workTimeDuration);
    };


    $scope.customComparator = function(v1, v2) {
        if($scope.ployEngsOrderBy.value === 'checkin_time' || $scope.ployEngsOrderBy.value === 'checkout_time') {
            let mmt2 = moment(v2.value);

            // Your moment at midnight
            let mmtMidnight2 = mmt2.clone().startOf('day');

            // Difference in minutes
            let diffMinutes2 = mmt2.diff(mmtMidnight2, 'minutes');
            let mmt1 = moment(v1.value);

            // Your moment at midnight
            let mmtMidnight1 = mmt1.clone().startOf('day');

            // Difference in minutes
            let diffMinutes1 = mmt1.diff(mmtMidnight1, 'minutes');

            return (diffMinutes2 > diffMinutes1) ? -1 : 1;
        }
        return (v2.value > v1.value) ? -1 : 1;
    };
    
    $scope.getNumberOfPages = EngagementShiftService.getNumberOfPages;
    $scope.getCurrentPage = EngagementShiftService.getCurrentPage;
    $scope.changePaginationPage = (selectedPage) => {
        if (selectedPage <= 0 || selectedPage > EngagementShiftService.getNumberOfPages()) return;
        EngagementShiftService.changePaginationPage(selectedPage).then(() => $scope.collapsedListItems = {});
    };

}]);

angular.module('engagementShift')
.service('EngagementShiftService', ['User', 'EngagementResource', 'WorkLogResource', 'AlertBanner', '$filter', 'Modal', '$analytics', 'Constants',
    function (User, EngagementResource, WorkLogResource,  AlertBanner, $filter, Modal, $analytics, Constants) {

    let EngagementShiftService = {};

    let currentEngagementShiftsToDisplay = [];

    let shiftsToApproveCount = 0;

    let displayApprovedList = false;

    let autocompleteData = [];

    let paginationData = {
        page: 1,
        pageSize: 10,
        resultsCount: 0
    };

    let filters = {};

    let order = {
        sortBy: 'ploy__created',
        reverse: false,
    };

    let showReviewTooltipEngId = undefined;

    EngagementShiftService.showReviewTooltipForShiftEng = (engShift, $index) => {
        if (engShift.approved && !engShift.any_review_exists && $index === 0) {
            return true
        }
        return showReviewTooltipEngId === engShift.id
    };

    EngagementShiftService.downloadShifts = (loadApproved) => {
        EngagementResource.downloadShifts({
            'approved': (Boolean(loadApproved)) ? 1 : 0,
            'person': filters.person,
            'from': filters.from,
            'to': filters.to,
        }).$promise.then(() => {
            AlertBanner.publish({
                type: 'info',
                message: $filter('translate')('ENGAGEMENT_SHIFT__DOWNLOAD__SUCCESS') + ' ' + User.get().email,
                timeCollapse: 8000
            });
        });
    };

    EngagementShiftService.loadShifts = (loadApproved, selectedPage) => {
        return EngagementResource.getShift({
            'approved': (Boolean(loadApproved)) ? 1 : 0,
            'page': selectedPage || paginationData.page,
            'page_size': paginationData.pageSize,
            'person': filters.person,
            'from': filters.from,
            'to': filters.to,
            'ordering': order.sortBy,
        }).$promise.then(data => {
            currentEngagementShiftsToDisplay = data.results;
            paginationData.resultsCount = data.count;
            !loadApproved ? EngagementShiftService.reloadShiftsToApproveCount() : null;
            EngagementResource.getShiftAutocompleteData({'approved': (Boolean(loadApproved)) ? 1 : 0}).$promise.then(data => {
                autocompleteData = data;
            })
        })
    };

    let fixTimeOrderForDifferentTabs = (decision) => {
        // approved and waiting to approve should have asymmetric date order, that's why manipulate 'ploy__created'
        if (decision !== displayApprovedList) {  // prevent order change when double click on tabs
            let ordering = order.sortBy;  // needed to avoid checking on changed value
            if (ordering === 'ploy__created') { order.sortBy = '-ploy__created'; }
            if (ordering === '-ploy__created') { order.sortBy = 'ploy__created'; }
        }
    };

    EngagementShiftService.displayApprovedList = (decision) => {
        paginationData.page = 1;
        fixTimeOrderForDifferentTabs(decision);
        return EngagementShiftService.loadShifts(decision).then(() => {
            displayApprovedList = decision;
        });
    };

    EngagementShiftService.reloadShiftsToApproveCount = () => {
      EngagementResource.getShiftToApproveCount().$promise.then(count => shiftsToApproveCount = count.to_approve);
    };

    EngagementShiftService.changePaginationPage = (selectedPage) => {
        return EngagementShiftService.loadShifts(displayApprovedList, selectedPage).then( () => {
            paginationData.page = selectedPage;
        });
    };

    EngagementShiftService.getCurrentEngagementShiftsToDisplay = () => currentEngagementShiftsToDisplay;

    EngagementShiftService.approvedListIsSelected = () => displayApprovedList;

    EngagementShiftService.getShiftsToApproveCount = () => shiftsToApproveCount;

    EngagementShiftService.getNumberOfPages = () => Math.ceil(paginationData.resultsCount/paginationData.pageSize);

    EngagementShiftService.getCurrentPage = () => paginationData.page;

    EngagementShiftService.getAutocompleteData = () => autocompleteData;

    EngagementShiftService.getShiftsForPloy = (ployShift) => {
        if (!ployShift.engShifts) {
            return EngagementResource.getShiftsForPloy({
                'id': ployShift.ploy.id,
                'employee_id': ployShift.employee.id,
                'approved' : Boolean(displayApprovedList) ? 1 : 0,
                'person': filters.person,
                'from': filters.from,
                'to': filters.to
            }).$promise.then(engShifts => {
                currentEngagementShiftsToDisplay.map(currPloyShift => {
                    if (currPloyShift === ployShift) {
                        currPloyShift.engShifts = engShifts;
                    }
                });
            });
        }
    };

    EngagementShiftService.saveWorkLog = (engagement) => {
        let workLog = {
            'checkin_time': engagement.checkin_time,
            'checkout_time': engagement.checkout_time,
            'pause_time': engagement.pause_time,
            'engagement': engagement.id,
            'comment' : engagement.comment || undefined,
            'requested_by' : engagement.requested_by || undefined,
            'log_type': Constants.workLogTypes.WORK_LOG_TYPE_EMPLOYER_MODIFICATION,
        };
        return WorkLogResource.save(workLog);
    };

    EngagementShiftService.setWorkTimeForEngagement = (engagement, duration) => {
       currentEngagementShiftsToDisplay.forEach(currPloyShift => {
            if (!!currPloyShift.engShifts) {
                currPloyShift.engShifts.map(shift => {
                    if (shift.id === engagement.id) {
                        shift.work_time = duration
                    }
                })
            }
       });
    };

    EngagementShiftService.approveShift = engagement => {
        let approveShiftFn = () => {
            currentEngagementShiftsToDisplay.map(currPloyShift => {
            if (!!currPloyShift.engShifts) {
                currPloyShift.engShifts.map(engShift => {
                    if (engShift.id === engagement.id) {
                        engShift.approved = true;
                        return EngagementResource.update(engShift).$promise.then(() => {
                            EngagementShiftService.reloadShiftsToApproveCount();
                            $analytics.eventTrack('Single shift approved', {category: 'Ploy'});
                            if (!engShift.any_review_exists) {
                                showReviewTooltipEngId = engShift.id
                            }
                        });
                    }
                })
            }
        })
        };
        if (engagement.overtime_work) {
            return Modal.confirm({
                title: $filter('translate')('ENGAGEMENT_SHIFT__APPROVE_OVERTIME_MODAL__TITLE'),
                message: $filter('translate')('ENGAGEMENT_SHIFT__APPROVE_OVERTIME_MODAL__CONTENT'),
                firstButtonLabel: $filter('translate')('ENGAGEMENT_SHIFT__APPROVE_OVERTIME_MODAL__BUTTON_CANCEL'),
                secondButtonLabel: $filter('translate')('ENGAGEMENT_SHIFT__APPROVE_OVERTIME_MODAL__BUTTON_APPROVE'),
                secondButtonColor: 'red',
                secondButtonFunction: approveShiftFn
            });
        }
        return approveShiftFn();

    };

    EngagementShiftService.approvePloyShift = (ployShift) => {
        return EngagementResource.approvePloyShift({
                'id': ployShift.ploy.id,
                'employee_id': ployShift.employee.id,
                'person': filters.person,
                'from': filters.from,
                'to': filters.to,
            }).$promise.then(() => {
            EngagementShiftService.displayApprovedList(false);
        });
    };

    EngagementShiftService.approveAllShifts = () => {
        return EngagementResource.approveAllShifts({
            'person': filters.person,
            'from': filters.from,
            'to': filters.to,
        }).$promise.then(() => {
            $analytics.eventTrack('All shifts approved', {category: 'Ploy'});
            EngagementShiftService.displayApprovedList(true);
        });
    };

    EngagementShiftService.filter = (f) => {
        filters = f;
        paginationData.page = 1;
        return EngagementShiftService.loadShifts(displayApprovedList);
    };

    EngagementShiftService.setSortBy = (ordering) => {
        if (order.sortBy === String((order.reverse) ? '-' : '') + ordering) {  // check if should change reverse
            order.reverse = !order.reverse;
        }
        order.sortBy = String((order.reverse) ? '-' : '') + ordering;  // add '-' at the beginning if is reverse
        return EngagementShiftService.loadShifts(displayApprovedList);
    };

    /**
     * Calculates work time duration
     * Requires engagement with: checkin_time, checkout_time, pause_time, work_time
     * @param engagement
     * @returns {duration}
     */
    EngagementShiftService.calculateWorkTimeDuration = (engagement) => {
        let end = moment(engagement.checkout_time);
        let startTime = moment(engagement.checkin_time);
        let duration = moment.duration(end.diff(startTime));
        let pause = new moment(engagement.pause_time, 'HH:mm:ss');
        let mmtMidnight = pause.clone().startOf('day');
        let diffMinutes = moment.duration(pause.diff(mmtMidnight));
        // subtract pause time
        return moment.duration(duration - diffMinutes);
    };

    /**
     * Return nice string with calculated work time
     * @param duration
     * @returns {string} - work time in format H:mm(h)
     */
    EngagementShiftService.createWorkTimeString = (duration) => {
        let min = duration.minutes().toString();
        min = min.length == 2 ? min : '0' + min;
        return duration.hours() + ':' + min + 'h';
    };

    EngagementShiftService.getTodayPloyShifts = EngagementResource.getTodayPloyShifts;

    return EngagementShiftService;

}]);

angular.module('header')

    .controller('HeaderAnnouncementBarController', ['$scope', 'localStorageService', '$translate', '$timeout', '$rootScope',
        function ($scope, localStorageService, $translate, $timeout, $rootScope) {

            $scope.hideAnnouncement = localStorageService.get('announcement_hide') || false;

            $scope.closeAnnouncement = () => {
                localStorageService.set('announcement_hide', true);
                $scope.hideAnnouncement = true;
            };

            const setAnnouncementVisibility = () => {
                $translate('HEADER_ANNOUNCEMENT__MESSAGE').then(content => {
                    if (content && content.length) {
                        $scope.announcementMessage = content;
                        if ($scope.hideAnnouncement) {
                            if (localStorageService.get('announcement_message') !== content) {
                                $scope.hideAnnouncement = false;
                                localStorageService.set('announcement_hide', false);
                                localStorageService.set('announcement_message', content);
                            }
                        } else {
                            localStorageService.set('announcement_hide', false);
                            localStorageService.set('announcement_message', content);
                        }
                    } else {
                        $scope.hideAnnouncement = true;
                    }
                });
            };

            $rootScope.$on('$translateChangeSuccess', () => {
                setAnnouncementVisibility()
            });

        }]);

angular.module('header')

    .controller('HeaderMyStaffController', ['$scope', 'MyStaff', 'Modal', '$translate', '$filter',
        function ($scope, MyStaff, Modal, $translate, $filter) {

            $scope.staffIsEmpty = () => MyStaff.getAllStaffCount() <= 0;
            $scope.staffCount = () => MyStaff.getAllStaffCount();

        }]);

angular.module('header')

    .controller('HeaderController', ['$scope', '$filter', 'Constants', '$rootScope', 'User', 'AlertBanner', function ($scope, $filter, Constants, $rootScope, User, AlertBanner) {

        $scope.collapsedHeader = true;
        $scope.hideHeaderButtons = false;

        $rootScope.$on('$routeChangeSuccess', (e, current) => {
            $scope.hideHeaderButtons = current.locals.hideHeaderButtons === true;
        });

        $scope.collapseHeader = () => {
            $scope.collapsedHeader = !$scope.collapsedHeader;
        };

        $scope.unpauseProfile = () => {
            User.unpauseProfile().then(() => {
                AlertBanner.publish({
                    type: 'success',
                    message: $filter('translate')('HEADER_LOGGED_IN__UNPAUSE_CALLBACK_MESSAGE'),
                    timeCollapse: 4000
                });
            });
        };

        $scope.userTypes = Constants.userTypes;

    }]);

angular.module('ios-spinner')
.directive('iosSpinner', function () {
    return {
      restrict: 'E',
      //require: [],
      //scope: { },
      //controller: 'RatingController',
      templateUrl: 'src/ios-spinner/html/ios-spinner.html',
      replace: true,
      link: function (scope, element, attrs, ctrls) {
      }
    };
});
angular.module('ipip')

    .controller('IpipDemoController', ['$scope', 'IpipService', 'Constants',
        function ($scope, IpipService, Constants) {

            $scope.ipipChoiceScale = Constants.ipipChoiceScale;
            $scope.exampleChoice = {choice: null}; // nested object to prevent scope duplication in ng-repeat


        }]);

angular.module('ipip')

.controller('IpipIntroductionController', ['$scope', 'IpipService',
    function($scope, IpipService) {



}]);

angular.module('ipip')

    .controller('IpipResultController', ['$scope', 'IpipService', '$location',
        function ($scope, IpipService, $location) {

            $scope.currentResult = null;
            $scope.chartLabels = ['E', 'A', 'C', 'N', 'O'];
            $scope.chartData = [];
            $scope.chartColors = [{
                fillColor: '#eac6ca'
            }]
            $scope.chartOptions = {
                scaleShowVerticalLines: false,
                aspectRatio: 1.4,
                tooltips: {
                    enabled: false
                },
                elements: {
                    point: {
                        radius: 0
                    }
                },
                scale: {
                    ticks: {
                        suggestedMax: 50,
                        suggestedMin: 0
                    },
                    dots: false,
                },

            };

            IpipService.hasResult().then(has => {
                if (!has) {
                    $location.path('/ipip')
                }
            });


            IpipService.getResult().$promise.then(result => {
                $scope.currentResult = result;
                $scope.chartData = [
                    $scope.currentResult.extraversion * 10,
                    $scope.currentResult.agreeableness * 10,
                    $scope.currentResult.conscientiousness * 10,
                    $scope.currentResult.emotional_stability * 10,
                    $scope.currentResult.intellect * 10
                ];
            })


        }]);

angular.module('ipip')

    .controller('IpipController', ['$scope', 'IpipService', 'Constants', '$location',
        function ($scope, IpipService, Constants, $location) {

            $scope.ipipChoiceScale = Constants.ipipChoiceScale;
            $scope.questions = [];
            $scope.questionsChoices = {};
            $scope.choices = [];

            IpipService.hasResult().then(has => {
                if (has) {
                    $location.path('/ipip/result')
                }
            });

            IpipService.listQuestions().$promise.then(questions => {
                $scope.questions = questions;
            })

            IpipService.listChoices().$promise.then(choices => {
                $scope.choices = choices;
                choices.forEach(choice => {
                    $scope.questionsChoices[choice.question] = choice.score;
                });
            })

            $scope.saveChoice = (choiceScore, questionId) => {
                const choiceObj = $scope.choices.find(c => c.question === questionId);
                if (choiceObj) {
                    return IpipService.updateChoice(choiceObj.id, choiceScore).$promise.then(choice => {
                        $scope.choices = $scope.choices.map(c => {
                            if (c.question === questionId) {
                                c.score = choiceScore
                            }
                            return c;
                        })
                    })
                }
                return IpipService.createChoice(questionId, choiceScore).$promise.then(choice => {
                    $scope.choices.push(choice);
                })
            }

            $scope.isQuestionWithoutChoice = () => {
                return $scope.questions.some(q => !$scope.questionsChoices[q.id])
            }

            $scope.saveResults = () => {
                IpipService.createResult().$promise.then((result) => {
                    $location.path('/ipip/result').replace();
                })
            }

        }]);

angular.module('ipip')
    .directive('ipipWorkCultureChart', ['IpipResultChartFactory', function (IpipResultChartFactory) {
        return {
            restrict: 'AE',
            templateUrl: '/src/ipip/html/ipip-work-culture-chart.html',
            scope: {
                result: '<',
            },
            transclude: true,
            link: function (scope, element, attrs) {
               scope.charts = IpipResultChartFactory.generateCharts(scope.result);
            }
        }
    }]);

angular.module('ipip')
    .directive('ipipWorkCultureDescription', ['IpipResultDescriptionFactory', '$translate', '$filter',
        function (IpipResultDescriptionFactory, $translate, $filter) {
            return {
                restrict: 'AE',
                templateUrl: '/src/ipip/html/ipip-work-culture-description.html',
                scope: {
                    result: '<',
                },
                transclude: true,
                link: function (scope, element, attrs) {

                    scope.agreeablenessDescription1 =
                        IpipResultDescriptionFactory.getFactorDescription(
                            scope.result,
                            'work_culture',
                            'agreeableness',
                            'agreeableness_1'
                        )

                    scope.agreeablenessDescription2 =
                        IpipResultDescriptionFactory.getFactorDescription(
                            scope.result,
                            'work_culture',
                            'agreeableness',
                            'agreeableness_2'
                        )

                    scope.conscientiousnessDescription =
                        IpipResultDescriptionFactory.getFactorDescription(
                            scope.result,
                            'work_culture',
                            'conscientiousness',
                            'conscientiousness'
                        )

                }
            }
        }]);

angular.module('ipip')
    .directive('ipipWorkEnvironmentChart', ['IpipResultChartFactory', function (IpipResultChartFactory) {
        return {
            restrict: 'AE',
            templateUrl: '/src/ipip/html/ipip-work-environment-chart.html',
            scope: {
                result: '<',
            },
            transclude: true,
            link: function (scope, element, attrs) {
               scope.charts = IpipResultChartFactory.generateCharts(scope.result);
            }
        }
    }]);

angular.module('ipip')
    .directive('ipipWorkEnvironmentDescription', ['IpipResultDescriptionFactory', '$translate', '$filter',
        function (IpipResultDescriptionFactory, $translate, $filter) {
            return {
                restrict: 'AE',
                templateUrl: '/src/ipip/html/ipip-work-environment-description.html',
                scope: {
                    result: '<',
                },
                transclude: true,
                link: function (scope, element, attrs) {

                    scope.intellectDescription =
                        IpipResultDescriptionFactory.getFactorDescription(
                            scope.result,
                            'work_environment',
                            'intellect',
                            'intellect'
                        )

                    scope.extraversionDescription =
                        IpipResultDescriptionFactory.getFactorDescription(
                            scope.result,
                            'work_environment',
                            'extraversion',
                            'extraversion'
                        )

                    scope.emotionalStabilityDescription =
                        IpipResultDescriptionFactory.getFactorDescription(
                            scope.result,
                            'work_environment',
                            'emotional_stability',
                            'emotional_stability'
                        )

                }
            }
        }]);

angular.module('ipip')
    .directive('ipipWorkTypeChart', ['IpipResultChartFactory', function (IpipResultChartFactory) {
        return {
            restrict: 'AE',
            templateUrl: '/src/ipip/html/ipip-work-type-chart.html',
            scope: {
                result: '<',
            },
            transclude: true,
            link: function (scope, element, attrs) {
               scope.charts = IpipResultChartFactory.generateCharts(scope.result);
            }
        }
    }]);

angular.module('ipip')
    .directive('ipipWorkTypeDescription', ['IpipResultDescriptionFactory', '$translate', '$filter',
        function (IpipResultDescriptionFactory, $translate, $filter) {
            return {
                restrict: 'AE',
                templateUrl: '/src/ipip/html/ipip-work-type-description.html',
                scope: {
                    result: '<',
                },
                transclude: true,
                link: function (scope, element, attrs) {

                    scope.conscientiousnessDescription1 =
                        IpipResultDescriptionFactory.getFactorDescription(
                            scope.result,
                            'work_type',
                            'conscientiousness',
                            'conscientiousness_1'
                        )

                    scope.conscientiousnessDescription2 =
                        IpipResultDescriptionFactory.getFactorDescription(
                            scope.result,
                            'work_type',
                            'conscientiousness',
                            'conscientiousness_2'
                        )

                    scope.intellectDescription =
                        IpipResultDescriptionFactory.getFactorDescription(
                            scope.result,
                            'work_type',
                            'intellect',
                            'intellect'
                        )

                }
            }
        }]);

angular.module('ipip')

.filter('ipipQuestionName', ['LanguageService', function(LanguageService) {
    return function(question) {
        if (!question) {return}
        let language = LanguageService.getCurrentLanguage();
        let question_name = question['name_'+language];
        return question_name || question.name
    };
}]);

angular.module('ipip')

    .factory('IpipChoiceResource', ['$resource', function ($resource) {
        return $resource('/api/ipip/choice/:id/', {id: '@id'}, {
            update: {method: 'PATCH'},
        });
    }]);

angular.module('ipip')

    .factory('IpipQuestionResource', ['$resource', function ($resource) {
        return $resource('/api/ipip/question/:id', {id: '@id'}, {

        });
    }]);

angular.module('ipip')

    .factory('IpipResultResource', ['$resource', function ($resource) {
        return $resource('/api/ipip/result/:id', {id: '@id'}, {
            current: {
                method: 'GET',
                url: '/api/ipip/result/current/',
                isArray: false
            }
        });
    }]);

angular.module('ipip')

    .factory('IpipResultChartFactory', ['IpipResultResource', function (IpipResultResource) {
        const stepSize = 25;

        const transformResultData = (score) => {
            score = angular.copy(score * 10)
            score = score > stepSize ? score : (-score)
            return score / 2
        }

        const generateChart = (factor) => {
            return {
                options: {
                    scaleShowVerticalLines: false,
                    maintainAspectRatio: false,
                    responsive: true,
                    tooltips: {
                        enabled: false
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
                                drawTicks: false
                            },
                            ticks: {
                                display: false,
                                stepSize: stepSize,
                                min: -stepSize,
                                max: stepSize
                            }
                        }],
                        yAxes: [{
                            gridLines: {
                                drawTicks: false
                            },
                            ticks: {
                                display: false,
                            }
                        }]
                    }
                },
                data: [transformResultData(factor)]
            }
        }

        const generateCharts = (result) => {
          if (!result) {
              console.error('No result for chart')
          }
          return {
              intellectChart: generateChart(result.intellect),
              extraversionChart: generateChart(result.extraversion),
              emotionalStabilityChart: generateChart(result.emotional_stability),
              agreeablenessChart: generateChart(result.agreeableness),
              conscientiousnessChart: generateChart(result.conscientiousness),
          }
        };

        return {
            generateCharts
        };
    }]);

angular.module('ipip')

    .factory('IpipResultDescriptionFactory', ['IpipResultResource', function (IpipResultResource) {

        const getFactorDescription = (result, category, factor, translationKey) => {
            category = category.toUpperCase();
            factor = factor.toLowerCase();
            translationKey = translationKey.toUpperCase();
            if (result[factor] >= 1 && result[factor] < 1.7) {
                return `IPIP_RESULT_DESCRIPTION__${category}__${translationKey}_1`
            }
            if (result[factor] >= 1.7 && result[factor] < 2.5) {
                return `IPIP_RESULT_DESCRIPTION__${category}__${translationKey}_2`
            }
            if (result[factor] >= 2.5 && result[factor] < 3.3) {
                return `IPIP_RESULT_DESCRIPTION__${category}__${translationKey}_3`
            }
            if (result[factor] >= 3.3 && result[factor] < 4.2) {
                return `IPIP_RESULT_DESCRIPTION__${category}__${translationKey}_4`
            }
            if (result[factor] >= 4.2) {
                return `IPIP_RESULT_DESCRIPTION__${category}__${translationKey}_5`
            }

            return 'ERROR'
        }

        return {
            getFactorDescription
        };
    }]);

angular.module('ipip')

    .service('IpipService', ['IpipQuestionResource', 'IpipChoiceResource', 'IpipResultResource',
        function (IpipQuestionResource, IpipChoiceResource, IpipResultResource) {

            const IpipService = {};

            IpipService.listQuestions = IpipQuestionResource.query;
            IpipService.listChoices = IpipChoiceResource.query;
            IpipService.updateChoice = (choiceId, choiceScore) => {
                return IpipChoiceResource.update({id: choiceId, score: choiceScore})
            };
            IpipService.createChoice = (questionId, choiceScore) => {
                return IpipChoiceResource.save({question: questionId, score: choiceScore})
            };
            IpipService.createResult = IpipResultResource.save;
            IpipService.getResult = IpipResultResource.current;
            IpipService.hasResult = () => {
                return IpipResultResource.current().$promise.then(result => {
                    return Promise.resolve(Object.keys(result).length > 2);
                });
            }
            IpipService.hasChoices = () => {
                return IpipChoiceResource.query().$promise.then(result => {
                    return Promise.resolve(!!result.length);
                });
            }
            return IpipService;

        }]);

angular.module('kyc')

    .controller('DocumentPermissionController', ['$scope', 'KycConstants', 'DocumentPermissionResource', 'AlertBanner',
        '$filter',
        ($scope, KycConstants, DocumentPermissionResource, AlertBanner, $filter) => {

            DocumentPermissionResource.get().$promise.then(documentPermissions => {
                $scope.documentPermissions = documentPermissions;
            });

            $scope.saveDocumentPermissions = (permission) => {
                DocumentPermissionResource.update(permission).$promise.then(() => {}, error => {
                    AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')('DOCUMENT-PERMISSION__ERROR-WHILE-SAVE__ERROR_MESSAGE'),
                        timeCollapse: 4000
                    });
                });
            };

            $scope.documentTranslationKeys = KycConstants.documentTranslationKeys;

    }]);

angular
    .module('myPloys')
    .directive('kycDocumentElement', [ 'KycService', '$rootScope', 'KycConstants', '$filter', '$window', function (KycService, $rootScope, KycConstants, $filter, $window) {
        return {
            scope: {
                title : '@',
                description : '@',
                disablePages: '@',
                getMethod : '=',
                files : '=',
                constantType : '=',
                mandatory: '=',
                limit: '=',
                verified: '=',
            },
            link: function(scope, element, attrs) {
                let loadPages = () => {
                    scope.pageNumbers = [...Array(7).keys()].slice(1).map(number => {
                        return {'value': number, 'name': number + ' ' + $filter('translate')('KYC__ELEMENT_PAGE_WORD')}
                    });
                };
                loadPages();
                $rootScope.$on('$translateChangeSuccess', () => { // workaround for translations inside input
                    loadPages();
                });
                scope.kycConstants = KycConstants;
                scope.isCollapsed = true;
                scope.orderedToSent = KycService.getOrderedToSent;
                scope.isDocumentBeingUploaded = KycService.getIsDocumentBeingUploaded;
                scope.collapse = () => {
                    scope.isCollapsed = !scope.isCollapsed;
                    $rootScope.$broadcast('kyc-document-collapse', {'isCollapsed': scope.isCollapsed, 'constantType': scope.constantType});
                };
                $rootScope.$on('kyc-document-collapse', (event, eventObj) => {
                    !eventObj.isCollapsed && eventObj.constantType !== scope.constantType ? scope.isCollapsed = true : null;
                });
                scope.uploadDocumentPictureByDocType = KycService.uploadDocumentPictureByDocType;
                scope.deleteImg = KycService.removePicture;
                scope.savePageNumber = KycService.changePageNumber;
                scope.isImage = (path) => {
                    return path.includes('.png') || path.includes('.jpg') || path.includes('.jpeg') ||
                           path.includes('.PNG') || path.includes('.JPG') || path.includes('.JPEG');
                };
                scope.getFileIcon = (path) => {
                    if (path.includes('.pdf') || path.includes('.PDF')) return 'fa fa-file-pdf-o';
                    if (path.includes('.doc') || path.includes('.DOC')) return 'fa fa-file-word-o';
                    return 'fa fa-file-o';
                };
                scope.setFieldCompleted = picture => {
                    return scope.fieldCompleted = picture.document_pictures.length > 0;
                };
                scope.toFilename = url => {
                    if (url) {
                         return url.replace(/^.*[\\\/]/, ''); // get filename from url
                    }
                    return url
                };
                scope.documentUpdatedRecently = (picture) => {
                    if (!picture) {
                        return false;
                    }
                    return moment(picture.updated).isAfter(moment(scope.orderedToSent()));
                };
                scope.goToRequestCriminalRecord = () => {
                    $window.open('https://politi.dk/straffeattest/bestil-privat-straffeattest', '_blank');
                }
            },
            templateUrl: 'src/kyc/html/directives/kyc-document-element.html'
        }
    }]);

angular.module('kyc')

    .factory('DocumentPermissionResource', ['$resource', ($resource) => {
        return $resource('/api/document-permission/:id/', {id: '@id'}, {
            get: { isArray: true },
            update: {method: 'PATCH'},
        })
    }]);

angular.module('kyc')

    .factory('DocumentPictureResource', ['$resource', function ($resource) {
        return $resource('/api/document-picture/:id/', {id: '@id'}, {
            get: { isArray: true },
            update: { method: 'PATCH' },
        })
    }]);

angular.module('kyc')

    .factory('DocumentResource', ['$resource', function ($resource) {
        return $resource('/api/document/:id/', {id: '@id'}, {
            get: { isArray: true },
            updateDocumentPermissions: {
                method: 'POST',
                url: '/api/document/update_document_permissions/',
            }
        })
    }]);

angular.module('kyc')

    .factory('VerificationRequestResource', ['$resource', function ($resource) {

        return $resource('/api/verification-request/:id/', {id: '@id'}, {
            get: { isArray: true },
            getCurrent: {
                method: 'GET',
                url: '/api/verification-request/get_current/',
            },
            getCurrentForCompany: {
                method: 'GET',
                url: '/api/verification-request/get_current_for_company/',
            },
            sendToVerification: {
                method: 'POST',
                url: '/api/verification-request/:id/send_to_verification/',
            },
            updateVerification: {
                method: 'POST',
                url: '/api/verification-request/:id/update_verification/',
            },
        })

    }]);

angular.module('kyc')

.factory('KycConstants', [function() {
    let KycConstants = {};

    KycConstants.IDValue = 0;
    KycConstants.passportValue = 1;
    KycConstants.driverLicenseValue = 2;
    KycConstants.proofOfAddressValue = 3;
    KycConstants.picture = 11;
    KycConstants.criminalRecord = 12;
    KycConstants.workPermit = 13;
    KycConstants.truckLicence = 14;
    KycConstants.cv = 15;
    KycConstants.other = 16;

    KycConstants.documentTypes = [
        { name: 'ID', value: KycConstants.IDValue },
        { name: 'PASSPORT', value: KycConstants.passportValue },
        { name: 'DRIVER_LICENSE', value: KycConstants.driverLicenseValue },
        { name: 'PROOF_OF_ADDRESS', value: KycConstants.proofOfAddressValue },
        { name: 'PICTURE', value: KycConstants.picture },
        { name: 'CRIMINAL_RECORD', value: KycConstants.criminalRecord },
        { name: 'WORK_PERMIT', value: KycConstants.workPermit },
        { name: 'TRUCK_LICENSE', value: KycConstants.truckLicence },
        { name: 'CV', value: KycConstants.cv },
        { name: 'OTHER_LICENSES_OR_CERTS', value: KycConstants.other },
    ];

    KycConstants.documentTranslationKeys = {
        15: 'DOCUMENT__CV',  // cv
        14: 'DOCUMENT__TRUCK-LICENSE',  // truck license
        12: 'DOCUMENT__CRIMINAL-RECORD',  // criminal record
    };

    return KycConstants;

}]);

angular.module('kyc')

    .service('KycService', ['VerificationRequestResource', 'DocumentResource', 'DocumentPictureResource', 'User', 'Upload', 'KycConstants', 'Modal', '$translate', '$location', '$analytics', '$filter', '$rootScope',
        function (VerificationRequestResource, DocumentResource, DocumentPictureResource, User, Upload, KycConstants, Modal, $translate, $location, $analytics, $filter, $rootScope) {

            let KycService = {};
            let verificationRequest = {};
            let passports = {};
            let driverLicenses = {};
            let picture = {};
            let criminalRecord = {};
            let workPermit = {};
            let truckLicence = {};
            let cv = {};
            let ID = {};
            let other = {};
            let waitingForReview;
            let verifiedPositive;
            let verifiedNegative;
            let orderedToSent;
            let isDocumentBeingUploaded = false;

            let triedCreateRequest = false;  // used to avoid unfinished loop
            let allRequiredDocumentsSet = false;

            KycService.getVerificationRequest = () => verificationRequest;
            KycService.getCriminalRecord = () => criminalRecord;
            KycService.getWorkPermit = () => workPermit;
            KycService.getCv = () => cv;
            KycService.getID = () => ID;
            KycService.getOrderedToSent = () => orderedToSent;
            KycService.getIsDocumentBeingUploaded = () => isDocumentBeingUploaded;

            let validateRequiredDocumentPictureElement = (elem) => {
                if (!(elem.length > 0 && elem[0].document_pictures.length > 0)) {
                    allRequiredDocumentsSet = false;
                }
            };

            KycService.loadVerificationRequests = () => {
                VerificationRequestResource.getCurrent().$promise.then((request) => {
                    verificationRequest = request;
                    if (!request.id && !triedCreateRequest) {
                        KycService.createVerificationRequest();
                        triedCreateRequest = true;
                        return;
                    }
                    if (!request.documents) {
                        return;
                    }
                    let documents = request.documents;
                    passports = documents.filter((x) => x.type == KycConstants.passportValue);
                    driverLicenses = documents.filter((x) => x.type == KycConstants.driverLicenseValue);
                    picture = documents.filter((x) => x.type == KycConstants.picture);
                    criminalRecord = documents.filter((x) => x.type == KycConstants.criminalRecord);
                    workPermit = documents.filter((x) => x.type == KycConstants.workPermit);
                    truckLicence = documents.filter((x) => x.type == KycConstants.truckLicence);
                    cv = documents.filter((x) => x.type == KycConstants.cv);
                    ID = documents.filter((x) => x.type == KycConstants.IDValue);
                    other = documents.filter((x) => x.type == KycConstants.other);
                    waitingForReview = request.ordered_to_sent != null;
                    orderedToSent = request.ordered_to_sent;
                    verifiedPositive = Boolean(request.verified_positive);
                    verifiedNegative = request.received && !Boolean(request.verified_positive);

                    let requiredElements = [picture, criminalRecord, ID];
                    if (User.isOutsideOfEU()) {
                        requiredElements.push(workPermit);  // work permit required, if user defined country as other than Denmark while registration
                    }
                    allRequiredDocumentsSet = true;
                    requiredElements.forEach((elem) => {
                        validateRequiredDocumentPictureElement(elem);
                    });
                });
            };
            KycService.loadVerificationRequests();

            KycService.createVerificationRequest = () => {
                return VerificationRequestResource.save().$promise.then(() => {
                    KycService.loadVerificationRequests();
                });
            };

            KycService.uploadDocumentPictureByDocType = (files, documentType) => {
                DocumentResource.query({
                    'type': documentType,
                    'request': verificationRequest.id
                }).$promise.then((documents) => {
                    if (documents[0]) {
                        KycService.uploadDocumentPicture(files, documents[0].id);
                    } else {
                        if (verificationRequest) {
                            DocumentResource.save({
                                'type': documentType,
                                'request': verificationRequest.id
                            }).$promise.then((document) => {
                                KycService.uploadDocumentPicture(files, document.id);
                            })
                        } else {
                            VerificationRequestResource.save().$promise.then((createdRequest) => {
                                DocumentResource.save({
                                    'type': documentType,
                                    'request': createdRequest.id
                                }).$promise.then((document) => {
                                    KycService.uploadDocumentPicture(files, document.id);
                                })
                            });
                        }
                    }
                });
                // If document type is profile picture and user has no avatar - set user avatar
                if (documentType === KycConstants.picture) {
                    User.hasDefaultAvatar().then(has => {
                        if (has && files.length) {
                            User.upload_avatar(files[0]);
                        }
                    });
                }
            };

            KycService.uploadDocumentPicture = function (files, documentId) {
                const file = files[0];
                isDocumentBeingUploaded = true;
                $analytics.eventTrack('Pro upload document', {category: 'Registration'});
                Upload.upload({
                    url: '/api/document-picture/upload_document_picture/',
                    data: {
                        document_image: file, document_id: documentId
                    },
                }).then(response => {
                    KycService.loadVerificationRequests();
                    isDocumentBeingUploaded = false;
                    $rootScope.$broadcast('profile-updated');
                }, err => {
                    Modal.alert({
                        title: $filter('translate')('KYC_SERVICE__DOCUMENT_UPLOAD_FAILED'),
                        message: $filter('translate')('KYC_SERVICE__DOCUMENT_UPLOAD_FAILED__DESCRIPTION'),
                        buttonColor: 'red'
                    });
                    isDocumentBeingUploaded = false;
                });
            };

            KycService.removePicture = (id) => {
                DocumentPictureResource.remove({id: id}).$promise.then(() => {
                    KycService.loadVerificationRequests();
                });
            };

            KycService.changePageNumber = (id, pageNumber) => {
                DocumentPictureResource.update({id: id, page: pageNumber}).$promise.then(() => {
                    KycService.loadVerificationRequests();
                });
            };

            KycService.removeDocument = (documentId) => {
                DocumentResource.remove({'id': documentId}).$promise.then(() => {
                    KycService.loadVerificationRequests();
                });
            };

            KycService.sendToVerification = () => {
                KycService.getVerificationRequest().$promise.then((request) => {
                    $analytics.eventTrack('Pro send to verification', {category: 'Registration'});
                    VerificationRequestResource.sendToVerification({'id': request.id}).$promise.then(() => {
                        //modal
                        Modal.alert({
                            title: $filter('translate')('KYC_SUCCES_MODAL_TITLE'),
                            message: $filter('translate')("KYC_SUCCES_MODAL_BODY"),
                            buttonColor: 'green',
                        });
                        $location.path('/profile-settings');
                    }, (error) => {
                        if (error.data) {
                            if (error.data[0]) {
                                Modal.alert({
                                    title: $filter('translate')('KYC__SEND_TO_VERIFICATION_FAILED__MODAL_TITLE'),
                                    message: $filter('translate')(error.data[0]),
                                    buttonColor: 'red',
                                })
                            } else {
                                let message = '';
                                for (let key in error.data) {
                                    message += $filter('translate')('KYC__MODAL__' + key + ' : ' + error.data[key][0]) + " ";
                                }
                                Modal.alert({
                                    title: $filter('translate')('KYC__SEND_TO_VERIFICATION_FAILED__MODAL_TITLE'),
                                    message: message,
                                    buttonColor: 'red',
                                })
                            }
                        }
                    });
                });
            };

            KycService.updateVerification = () => {
                KycService.getVerificationRequest().$promise.then((request) => {
                    VerificationRequestResource.updateVerification({'id': request.id}).$promise.then(() => {
                        Modal.alert({
                            title: $filter('translate')('KYC_SUCCES_MODAL_TITLE'),
                            message: $filter('translate')("KYC_SUCCES_MODAL_BODY"),
                            buttonColor: 'green',
                        });
                        $location.path('/profile-settings');
                    });
                });
            };

            KycService.getAllRequiredDocumentsSet = () => {
                return allRequiredDocumentsSet;
            };

            KycService.getIDUploaded = () => ID.length > 0 && ID[0].document_pictures.length > 0;

            return KycService;

        }
    ]);

angular.module('leaveReview')

.controller('LeaveReviewController', ['$scope', 'User', '$routeParams', 'Engagement', 'LeaveReview', '$uibModal', 'AlertBanner', '$filter', '$location', 'MyStaff',
                                      function($scope, User, $routeParams, Engagement, LeaveReview, $uibModal, AlertBanner, $filter, $location, MyStaff) {
    var engagementId = $routeParams.id;

    $scope.engagement = Engagement.get(engagementId);

    $scope.isEmployee = Engagement.isEmployee;

    $scope.isEmployer = Engagement.isEmployer;

    $scope.form = {};

    $scope.normal_rating = true;
    $scope.ratingStates = [
        {stateOn: 'glyphicon-ok-sign', stateOff: 'glyphicon-ok-circle'},
        {stateOn: 'glyphicon-star', stateOff: 'glyphicon-star'},
        {stateOn: 'glyphicon-heart', stateOff: 'glyphicon-ban-circle'},
        {stateOn: 'glyphicon-heart'},
        {stateOff: 'glyphicon-off'}
    ];

    $scope.saveReview = function(form) {
        form.created_by = User.get().id;
        form.engagement = $scope.engagement.id;
        form.receiver = $scope.engagement.employee.id;  // if worker leaves review
        if( form.created_by == form.receiver ) {  // if employer leaves review
            form.receiver = $scope.engagement.ploy.created_by.id;
        }
        LeaveReview.save(form).$promise.then(function(review) {
            $scope.reviewSaved();
            $scope.checkMyStaffStatus(review);
        }, function() {
            $scope.reviewFailed();
        });

        $scope.reviewSaved = function () {
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('REVIEW_HAS_BEEN_SAVED'),
                timeCollapse: 7000
            });
            redirect();
        };

        $scope.reviewFailed = function () {
             AlertBanner.publish({
                type: 'error',
                message: $filter('translate')('YOU_ALREADY_LEFT_A_REVIEW_IN_THIS_PLOY'),
                timeCollapse: 8000
            });
            redirect();
        };

        let redirect = () => {
            if($routeParams.next) {
                $location.path($routeParams.next);
            } else {
                $location.path('/my-ploys/' + engagementId + '/conversation');
            }
        };

        $scope.checkMyStaffStatus = function (review) {
            if (review.overall < 4 && !$scope.engagement.is_employee) {
                MyStaff.removeUserFromStaffPrompt($scope.engagement.employee, false, 'LEAVE_REVIEW__REMOVE_FROM_STAFF_PROMPT__MESSAGE');
            }
        }
    }

}]);

angular.module('leaveReview')

.service('LeaveReview', ['$resource', 'RequestTransform', function ($resource, RequestTransform) {
    return $resource('/api/review/:id', {receiver:'@id'}, {
        update: {method: 'PATCH'},
        'query': {
            method:'GET',
            isArray:true,
            transformResponse: RequestTransform.getPaginatedCount
        },
        'getAll': {
            url : '/api/review/get_all/:id',
            method:'GET',
            isArray:true
        },
        'getForCompany': {
            url : '/api/review/company_reviews/',
            method:'GET',
            isArray:true
        },
    });
}]);

angular.module("template.rating", [])
  .run(["$templateCache", function ($templateCache) {
    $templateCache.put("template/rating/rating_normal",
      "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\">" +
      "    <i ng-repeat=\"r in range track by $index\" ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"fa\" ng-class=\"$index < value && (r.stateOn || 'fa-star active') || (r.stateOff || 'fa-star')\">" +
      "    <span class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>" +
      "    </i>" +
      "</span>");
    $templateCache.put("template/rating/rating_slide",
      "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\">\n" +
      "    <i ng-repeat=\"r in range track by $index\" ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"slide\" ng-class=\"$index == value - 1 && ('blue choosen') || ($index < value && (r.stateOn || 'blue') || (r.stateOff || 'white'))\">\n" +
      "    {{ $index + 1 }} \n" +
      "    </i>\n" +
      "</span>");
}]);
angular.module('logIn')


.controller('LogInController', ['$scope', 'Auth', 'Constants', 'AlertBanner', '$filter', '$uibModal', '$routeParams',
    function($scope, Auth, Constants, AlertBanner, $filter, $uibModal, $routeParams) {

    $scope.form = {};
    if ($routeParams.email) {
        $scope.form.email = $routeParams.email;
    }
    $scope.logIn = function(form) {
        Auth.login(form).then(function() { } , function(error) {
            AlertBanner.publish({
                type: 'error',
                message: $filter('translate')('INVALID_EMAIL_OR_PASSWORD'),
                timeCollapse: 2000
            });
        });
    };

    $scope.enterHandler =function(e) {
        if (e.which==13) {
            $scope.logIn($scope.form)
        }
    };

    $scope.resetPassword = function () {
        $uibModal.open({
            templateUrl: 'src/modals/html/modal-reset-password.html',
            controller: 'ResetPasswordController',
            windowClass: 'modal-vertical-centered'
        })
    };

    $scope.oauthLogin = Auth.oauthLogin;
    $scope.logout = Auth.logout;
    $scope.patterns = Constants.patterns;


}]);

angular.module('logIn')


.controller('NewPasswordController', ['$scope', 'User', '$routeParams', 'Constants', '$location', '$filter', 'AlertBanner',
    function($scope, User, $routeParams, Constants, $location, $filter, AlertBanner) {
    $scope.patterns = Constants.patterns;
    $scope.token = $routeParams.token;
    $scope.generateNewPassword = function(form) {
        User.generateNewPassword($routeParams.token, form.password, form.confirm_password).$promise.then(function() {
            $location.path('/log-in');
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('PASSWORD_HAS_BEEN_CHANGED'),
                timeCollapse: 5000
            });
        });
    }
        
}]);
angular.module('meployScout')

.controller('MeployScoutCardsController', ['$scope', 'MatchMe', 'Constants', '$location', function($scope, MatchMe, Constants, $location) {

    MatchMe.resetMatching();
    MatchMe.loadScoutMeployees().then(() => {
        $scope.matchMeployees = MatchMe.getMeployees;
        $scope.countInitialScoutMeployees = $scope.matchMeployees().length;
    });

    $scope.matchMe = MatchMe.getStatus();
    $scope.toggleMatchMe = MatchMe.toggleMatchMe;

    $scope.approveMeployee = (currentMatchMeployee) => {
        MatchMe.approveMeployeeToStaff(currentMatchMeployee);
        MatchMe.log($scope.user().id, Constants.alvaLogs.LOG_SCOUT_APPROVE, 'added to staff user ' + currentMatchMeployee.id);
    };
    $scope.declineMeployee = (currentMatchMeployee) => {
        MatchMe.declineScoutMeployee(currentMatchMeployee);
        MatchMe.log($scope.user().id, Constants.alvaLogs.LOG_SCOUT_DECLINED, 'declined user ' + currentMatchMeployee.id);
    };

    $scope.seeHowItWorks = () => {
        MatchMe.log($scope.user().id, Constants.alvaLogs.LOG_SCOUT_HOW_IT_WORKS_CLICK, '');
        $location.path('/help_meploy_scout');
    };

    $scope.seeFullProfile = (userId) => {
        MatchMe.log($scope.user().id, Constants.alvaLogs.LOG_SCOUT_SEE_FULL_PROFILE, 'see profile of user id: ' + userId);
        $location.path('/profile/' + userId);
    };

    $scope.goToDeclinedUsers = () => {
        MatchMe.log($scope.user().id, Constants.alvaLogs.LOG_SCOUT_SEE_REJECTED_PROFILES, '');
        $location.path('/meploy-scout/declined-users');
    };

}]);

angular.module('meployScout')

.controller('MeployScoutDeclinedUsersController', ['$scope', 'MatchMe', 'Constants', function($scope, MatchMe, Constants) {

    MatchMe.resetMatching();
    MatchMe.loadDeclinedMeployees();

    $scope.declinedUsers = MatchMe.getDeclinedMeployees;
    $scope.declinedUsersListLoaded = MatchMe.getDeclinedMeployeesListStatus;

    $scope.removeUserFromDeclinedUsers = (user) => {
        MatchMe.removeUserFromDeclinedMeployees(user);
        MatchMe.log($scope.user().id, Constants.alvaLogs.LOG_SCOUT_REMOVE_FROM_REJECTED, 'remove from rejected user id: ' + user.id);
    };

}]);

angular.module('meployScout')

.controller('MeployScoutController', ['$scope', 'Category', 'Constants', '$location', 'MatchMe',
    function($scope, Category, Constants, $location, MatchMe) {

    $scope.form = MatchMe.getScoutFormData();

    $scope.allCategories = [];

    $scope.rzSliderOptions = {
        floor: 0,
        ceil: 100,
        step: 25,
        maxLimit: 100,
        minLimit: 0,
        showSelectionBar: true,
        showTicks: true,
        getSelectionBarColor: () =>  {
            return '#25BD3C'
        },
        getPointerColor: () =>  {
            return '#25BD3C'
        },
        showTicksValues: false,
        hideLimitLabels: true,
        hidePointerLabels: true,
    };

    $scope.scout = form => {
        MatchMe.setScoutForm(form);
        MatchMe.log($scope.user().id, Constants.alvaLogs.LOG_SCOUT_SEARCH, form);
        $location.path('/meploy-scout/start')
    };


    Category.getAll().$promise.then(categories => {
        $scope.allCategories = categories;
        $scope.form.category_1 = $scope.form.category_1 ? _.find(categories, {'slug': $scope.form.category_1}) : categories[0];
        $scope.form.category_2 = $scope.form.category_2 ? _.find(categories, {'slug': $scope.form.category_2}) : categories[1];
    });

}]);

angular.module('meployScout')

.factory('MeployScoutResource', ['$resource', function($resource) {
    return $resource('/api/meploy-scout/', {

    });
}]);

angular.module('meployScout')

.factory('MeployScout', ['Constants', function(Constants) {

    let MeployScout = {};


    return MeployScout;


}]);
angular.module('modals')

.controller('ModalAlertController', [
    '$scope', 'title', 'message', 'buttonLabel', 'buttonFunction', 'buttonColor',
    function($scope, title, message, buttonLabel, buttonFunction, buttonColor) {
        $scope.title = title;
        $scope.message = message;
        $scope.buttonLabel = buttonLabel;
        $scope.buttonFunction = buttonFunction;
        $scope.buttonColor = buttonColor;
    }]);

angular.module('core')
.controller('ModalCalendarController', [
    '$scope', '$translate', '$uibModal','Modal','staffObject', '$rootScope',
    function($scope, $translate, $uibModal, Modal, staffObject, $rootScope,) {
        $scope.meployee = staffObject.meployee;

        $rootScope.$on("$routeChangeSuccess", () => {
            $scope.$close(); // Always close modal when route changes
        });

    }]);

angular.module('modals')


.controller('ModalChooseLegalFormController', ['$scope', 'User', 'Constants',
        function($scope, User, Constants) {

    User.get().$promise.then(function(user) {
       $scope.form = angular.copy(user);
    });

    $scope.chooseOption = function (option) {
        $scope.form.legal_form = (option == Constants.legalForms.PRIVATE) ? Constants.legalForms.PRIVATE : Constants.legalForms.COMPANY;
        User.save($scope.form).then(function () {
            $scope.$close();
        });
    };

}]);

angular.module('modals')

.controller('ModalCompanyDocumentsController', ['$scope', 'companyId', 'CompanyDocument',
    function($scope, companyId, CompanyDocument) {

    $scope.companyDocuments = [];
    CompanyDocument.loadActiveDocuments(companyId).then(documents => {
        documents.forEach(document => $scope.companyDocuments.push(document))
    });

}]);

angular.module('modals')

.controller('ModalConfirmWorkRequirementsController', [
    '$scope', 'engagement', 'Engagement', function($scope, engagement, Engagement) {

        $scope.checkboxes = [];
        $scope.engagement = engagement;
        $scope.applyToPloyFn = Engagement.applyToPreApproved;

        /**
         * Returns 'true' if validation is failing
         */
        $scope.applyValidationIsMissing = () => {
            return Engagement.applyValidationIsMissing($scope.engagement.ploy);
        };

    }]);

angular.module('modals')

.controller('ModalConfirmController', [
    '$scope', 'title', 'message', 'firstButtonLabel', 'firstButtonColor', 'firstButtonFunction', 'secondButtonLabel', 'secondButtonColor', 'secondButtonFunction', 'onCloseFunction',
    function($scope, title, message, firstButtonLabel, firstButtonColor, firstButtonFunction, secondButtonLabel, secondButtonColor, secondButtonFunction, onCloseFunction) {
        $scope.title = title;
        $scope.message = message;
        $scope.firstButtonLabel = firstButtonLabel;
        $scope.firstButtonColor = firstButtonColor;
        $scope.firstButtonFunction = firstButtonFunction;
        $scope.secondButtonLabel = secondButtonLabel;
        $scope.secondButtonColor = secondButtonColor;
        $scope.secondButtonFunction = secondButtonFunction;
        $scope.onCloseFunction = onCloseFunction;
    }]);

angular.module('modals')

    .controller('ModalCropImageController', [
        '$scope', 'image', 'Upload', function ($scope, image, Upload) {

            $scope.uploadedImage = image;
            $scope.croppedImage = '';
            $scope.blockingObject = {block: true};

            $scope.saveImage = () => {
                $scope.blockingObject.render(dataURL => {
                    $scope.$close(dataURL);
                });
            };
        }]);

angular.module('modals')

.controller('ModalEditMessageController', [
    '$scope', 'message', 'Engagement', 'AlertBanner', '$filter',
    function($scope, message, Engagement, AlertBanner, $filter) {
        $scope.message = angular.copy(message);
        
        $scope.editEvent = function (event) {
            Engagement.updateComment(event).$promise.then(function () {
                $scope.$close();
                Engagement.updateEngagement();
                AlertBanner.publish({
                    type: 'success',
                    message: $filter('translate')('SAVED') + '!',
                    timeCollapse: 4000
                });
            });
        }
    }]);

angular.module('modals')

.controller('ModalInvitationLinkController', [
    '$scope', '$location', 'AlertBanner', '$filter', 'Constants', 'user',
    function($scope, $location, AlertBanner, $filter, Constants, user) {
        $scope.location = $location.path();
        $scope.siteUrl = Constants.siteUrl;
        $scope.userId = user().id;
        $scope.copySuccess = function () {
            AlertBanner.publish({
                type: 'info',
                message: $filter('translate')('COPIED'),
                timeCollapse: 4000
            });
        };
    }]);

angular.module('modals')
    .controller('InviteStaffModalController', ['$scope', 'MyStaffResource', 'Constants', '$filter', 'AlertBanner',
        function ($scope, MyStaffResource, Constants, $filter, AlertBanner) {
        $scope.form = {};

        $scope.inviteToStaff = (email) => {
            MyStaffResource.inviteToStaff({'email': email}).$promise.then(response => {
                AlertBanner.publish({
                    type: 'success',
                    message: $filter('translate')('INVITE_TO_STAFF__SUCCESS_MESSAGE'),
                    timeCollapse: 10000,
                });
                $scope.form = {};
                $scope.$close();
            });
        };

        $scope.patterns = Constants.patterns;
    }]);

angular.module('modals')

.controller('ModalLightboxController', [
    '$scope', 'image', 'description',
    function($scope, image, description) {
        $scope.image = image;
        $scope.description = description;
    }]);
angular.module('modals')

    .controller('ModalProfilePauseController', [
        '$scope', 'User', function ($scope, User) {
            $scope.pauseDays = 0;
            $scope.form = {
                pause_due: null
            }
            $scope.setPauseDue = () => {
                const due = moment().add($scope.pauseDays, 'days').set({hour: 23, minute: 59});
                User.setPauseDue(due).then(() => {
                    $scope.$close();
                });
            }
        }]);

angular.module('modals')


.controller('ModalRedeemTimeCardController', ['$scope', 'User', 'engagement', 'Payment', 'Auth', 'Verification', 'AlertBanner', '$filter', '$rootScope',
        function($scope, User, engagement, Payment, Auth, Verification, AlertBanner, $filter, $rootScope) {

        $scope.user = function () {
            return User.get();
        };
        $scope.engagement = engagement;
        $scope.getHourDiscountChoices = User.getHourDiscountChoices;
        $scope.startStripe = Payment.startStripe;

}]);
angular.module('modals')

.controller('ModalReopenPloyController', [
    '$scope', 'buttonFunction', 'ploy',
    function($scope, buttonFunction, ploy) {
        $scope.buttonFunction = buttonFunction;
        $scope.ploy = ploy;
        $scope.ploy.new_ployees_needed = ploy.ployees_needed;
        $scope.ploy.has_new_ployees_needed_value = false;
    }]);

angular.module('modals')


.controller('ResetPasswordController', ['$scope', 'User', '$routeParams', 'Constants', 'AlertBanner', '$filter',
    function($scope, User, $routeParams, Constants, AlertBanner, $filter) {


    $scope.patterns = Constants.patterns;
    $scope.sendResetLink = function(form) {
        User.sendResetLink(form.email).$promise.then(function() {
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('RESET_SUCCESS'),
                timeCollapse: 5000
            });
            $scope.$close();
        }, function(error) {
            AlertBanner.publish({
                type: 'error',
                message: $filter('translate')('EMAIL_INCORRECT_OR_REQUIRED'),
                timeCollapse: 5000
            });
        });
    };

}])
angular.module('modals')

    .controller('ModalSetOriginCountryController', ['$scope', 'GeoResource', 'User',
        function ($scope, GeoResource, User) {

            $scope.form = {};
            GeoResource.getCountriesList().$promise.then(countries => {
                $scope.countries = countries;
            });

            $scope.updateOriginCountry = (country) => {
                User.updateOriginCountry(country).$promise.then(profile => {
                    $scope.$close();
                    User.get().profile.origin_country = profile.origin_country;
                })
            }

        }]);

angular.module('modals')

.controller('ModalShareController', [
    '$scope', 'ploy', '$location', 'AlertBanner', '$filter', 'Socialshare', 'Constants', 'Ploy',
    function($scope, ploy, $location, AlertBanner, $filter, Socialshare, Constants, PloyService) {
        $scope.ploy = ploy;
        $scope.location = $location.path();
        $scope.facebookConf = Constants.facebook;
        $scope.copySuccess = function () {
            AlertBanner.publish({
                type: 'info',
                message: $filter('translate')('COPIED'),
                timeCollapse: 4000
            });
        };

        $scope.share = function (provider) {
            if(provider == 'facebook') {

                if (typeof FB != "undefined") {
                    FB.ui({
                        method: 'share',
                        href: 'http://meploy.me' + $scope.location,
                        name: ploy.category.name_da + ' '+ ploy.amount_employee + 'DKK,-',
                        caption: ploy.category.name_da + ' '+ ploy.amount_employee + 'DKK,-',
                        description: 'Posted by ' + ploy.created_by.first_name
                    }, function(response) {  // callback
                        if (response && !response.error_message) {
                            console.log('Posting completed.');
                            PloyService.share(ploy, 'facebook');
                        } else {
                            console.log('Error while posting.');
                        }
                    });
                } else {
                    window.fbAsyncInit = function() {
                        console.log(FB);
                        FB.init({
                            appId      : $scope.facebookConf.appId,
                            xfbml      : true,
                            version    : $scope.facebookConf.version
                        });

                        FB.ui({
                            method: 'share',
                            href: 'http://meploy.me' + $scope.location,
                            name: ploy.category.name_da + ' '+ ploy.amount_employee + 'DKK,-',
                            caption: ploy.category.name_da + ' '+ ploy.amount_employee + 'DKK,-',
                            description: 'Posted by ' + ploy.created_by.first_name
                        }, function(response) {  // callback
                            if (response && !response.error_message) {
                                console.log('Posting completed.');
                                PloyService.share(ploy, 'facebook');
                            } else {
                                console.log('Error while posting.');
                            }
                        });
                    };
                }

                (function(d, s, id){
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) {return;}
                    js = d.createElement(s); js.id = id;
                    js.src = "//connect.facebook.net/en_US/sdk.js";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'facebook-jssdk'));

            } else {
                return Socialshare.share({
                    'provider': provider,
                    'attrs': {
                        'socialshareUrl': 'http://meploy.me' + $scope.location,
                        'socialshareText' : ploy.category.name_da + ' '+ ploy.amount_employee + 'DKK,-',
                        'socialshareDescription' : 'Posted by ' + ploy.created_by.first_name
                    }
                });
            }
        }
    }]);

angular.module('modals')


.controller('modalPhoneVerifyController', ['$scope', 'User', '$location', 'Constants', 'Auth', 'Verification', 'AlertBanner', '$filter', '$rootScope',
        function($scope, User, $location, Constants, Auth, Verification, AlertBanner, $filter, $rootScope) {

        User.get().$promise.then(function(user) {
        $scope.form = angular.copy(user);
         });

        $scope.checkCode = function (code) {
            Verification.verifyPhone(code).$promise.then(function() {
              $scope.$close();
              User.refresh();
              $rootScope.$broadcast('user-verified-phone');
              AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('VERIFIED') + '!',
                timeCollapse: 4000
              });
            }, function () {
             $scope.phoneActivationCode.wrongCode = true
            })
        };

        $scope.sendSMSCode = function (form) {
            User.resendSmsCode();
            AlertBanner.publish({
                type: 'info',
                message: $filter('translate')('CONFIRMATION_CODE_HAS_BEEN_SENT_TO') + ' ' + form.phone,
                timeCollapse: 4000
            });
        };

        $scope.checkCodeAndSaveProfile = function (form) {
            Verification.verifyPhone(form.phone_verify_code).$promise.then(function() {
                form.phone_verify = true;
                User.save(form).then(function () {
                    $scope.$close();
                    User.refresh();
                    $rootScope.$broadcast('user-verified-phone');
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('PHONE_NUMBER_VERIFIED') + '!',
                        timeCollapse: 4000
                    });
                });
            }, function () {
             AlertBanner.publish({
                type: 'error',
                message: $filter('translate')('VERIFICATION_FAILED'),
                timeCollapse: 4000
              });
            })
        };
}]);
angular.module('core')

.service('LightBox', [ '$uibModal', function ($uibModal) {

    this.open = function (image, description) {
        return $uibModal.open({
            templateUrl: 'src/modals/html/modals/defined/modal-lightbox.html',
            controller: 'ModalLightboxController',
            windowClass: 'modal-lightbox modal-vertical-centered',
            resolve: {
                image: function () {
                    return image || ''
                },
                description: function () {
                    return description || ''
                }
            }
        })
    }

}])
angular.module('modals')

    .service('Modal', ['$uibModal', '$templateRequest', function ($uibModal, $templateRequest) {

        const checkParameterType = (value, valueName, expectedType) => {
            return new Promise((resolve, reject) => {
                if (typeof value !== "undefined" && typeof value !== expectedType) {
                    console.error(`ERR: "${valueName}" must be type of ${expectedType} not ${typeof value}.`);
                    reject()
                }
                resolve()
            });
        };

        this.alert = function (data) {

            /**
             * Display alert modal window with one button.
             * @param {String} title - title of modal
             * @param {String} message - message inside modal
             * @param {String} buttonLabel - label inside ok button || "OK" as default
             * @param {function} buttonFunction - function what should be executed after click on 'ok' button || as default does nothing
             */

            $uibModal.open({
                templateUrl: 'src/modals/html/modals/defined/modal-alert.html',
                controller: 'ModalAlertController',
                windowClass: 'modal-alert modal-vertical-centered',
                backdrop: checkParameterType(data.staticBackdrop, 'staticBackdrop', 'boolean').then(() => data.staticBackdrop ? 'static' : true),
                resolve: {
                    title: function () {
                        return checkParameterType(data.title, 'title', 'string').then(() => {
                            return data.title || ''
                        });
                    },
                    message: function () {
                        return checkParameterType(data.message, 'message', 'string').then(() => {
                            return data.message || ''
                        });
                    },
                    buttonLabel: function () {
                        return checkParameterType(data.firstButtonLabel, 'firstButtonLabel', 'string').then(() => {
                            return data.firstButtonLabel || 'OK'
                        });
                    },
                    buttonFunction: function () {
                        return checkParameterType(data.buttonFunction, 'buttonFunction', 'function').then(() => {
                            return data.buttonFunction || function () {}
                        });
                    },
                    buttonColor: function () {
                        return checkParameterType(data.buttonColor, 'buttonColor', 'string').then(() => {
                            return data.buttonColor || ''
                        });
                    },
                }
            })
        };

        this.confirm = function (data) {

            /**
             * Displays modal window with two buttons. Used for confirmation purposes.
             * @param {String} title - title of modal
             * @param {String} message - message inside modal
             * @param {String} firstButtonLabel - label inside first button || "NO" as default
             * @param {String} firstButtonColor - color of first button ( red or green ) || default "white"
             * @param {function} firstButtonFunction - function executed after click on first button
             * @param {String} secondButtonLabel - label inside second button || "YES" as default
             * @param {String} secondButtonColor - color of second button ( red or green ) || default "white"
             * @param {function} secondButtonFunction - function executed after click on second button
             * @param {Boolean} staticBackdrop - choose whether backdrop should be static || as default set to false
             */

            return $uibModal.open({
                templateUrl: 'src/modals/html/modals/defined/modal-confirm.html',
                controller: 'ModalConfirmController',
                windowClass: 'modal-confirm modal-vertical-centered',
                backdrop: checkParameterType(data.staticBackdrop, 'staticBackdrop', 'boolean').then(() => data.staticBackdrop ? 'static' : true),
                resolve: {
                    title: function () {
                        return checkParameterType(data.title, 'title', 'string').then(() => {
                            return data.title || ''
                        });
                    },
                    message: function () {
                        return checkParameterType(data.message, 'message', 'string').then(() => {
                            return data.message || ''
                        });
                    },
                    firstButtonLabel: function () {
                        return checkParameterType(data.firstButtonLabel, 'firstButtonLabel', 'string').then(() => {
                            return data.firstButtonLabel || 'NO'
                        });
                    },
                    firstButtonColor: function () {
                        return checkParameterType(data.firstButtonColor, 'firstButtonColor', 'string').then(() => {
                            return data.firstButtonColor || ''
                        });
                    },
                    firstButtonFunction: function () {
                        return checkParameterType(data.firstButtonFunction, 'firstButtonFunction', 'function').then(() => {
                            return data.firstButtonFunction || function () {
                            }
                        });
                    },
                    secondButtonLabel: function () {
                        return checkParameterType(data.secondButtonLabel, 'secondButtonLabel', 'string').then(() => {
                            return data.secondButtonLabel || 'YES'
                        });
                    },
                    secondButtonColor: function () {
                        return checkParameterType(data.secondButtonColor, 'secondButtonColor', 'string').then(() => {
                            return data.secondButtonColor || ''
                        });
                    },
                    secondButtonFunction: function () {
                        return checkParameterType(data.secondButtonFunction,'secondButtonFunction', 'function').then(() => {
                            return data.secondButtonFunction || function () {
                            }
                        });
                    },
                    onCloseFunction: function () {
                        return checkParameterType(data.onCloseFunction, 'onCloseFunction', 'function').then(() => {
                            return data.onCloseFunction || function () {
                            }
                        });

                    }
                }
            })
        };

    }]);

angular.module('myActivity')

.controller('MyActivityController', ['$scope', 'MyActivity', 'User', 'Constants', 'AlertBanner', '$filter', function ($scope, MyActivity, User, Constants, AlertBanner, $filter) {

    $scope.occupations = Constants.occupations;
    $scope.listResultTabs = MyActivity.listResultsTabs;

    $scope.currentYear = new Date().getFullYear();
    $scope.yearsRange = [];
    for(var i=2015; i<=$scope.currentYear; i++) {
        $scope.yearsRange.unshift(i);
    }

    $scope.getUserOccupationDataPartial = function (period, data_type) {
        if(!period) {
            period = $scope.currentYear;
        }
        User.getActivityPart(User.get().occupation, User.get().id, data_type, period).$promise.then(function(data) {
            $scope.occupationDataHours = data.hours;
            $scope.occupationDataHoursMinutes = Math.round((data.hours - Math.floor(data.hours)) * 60);
            $scope.occupationDataHoursHours = Math.floor(data.hours);
            $scope.occupationDataCount = data.count;
            $scope.occupationDataHoursEarned = data.earned;
            $scope.occupationDataHoursSpent = data.spent;
            $scope.doCalculations(data, period, data_type);
        });
    };
    $scope.getUserOccupationDataPartial($scope.currentYear, 'posted');

    User.get().$promise.then(function(user) {
        $scope.form = angular.copy(user);
        $scope.currentOccupation = _.find(Constants.occupations, {value: user.occupation});
        if ($scope.currentOccupation) {
            // $scope.currentOccupation.incomePeriod
            $scope.getUserOccupationDataPartial($scope.period, $scope.listResultTabs.active);
        }
    });

    $scope.updateOccupation = function(form, period) {
        User.save(form).then(function(user) {
            $scope.currentOccupation = _.find(Constants.occupations, {value: user.occupation});
            // $scope.currentOccupation.incomePeriod
            $scope.getUserOccupationDataPartial(period, $scope.listResultTabs.active);
        });
    };

    $scope.doCalculations = function(data, period, data_type) {
        if(data.limit == -1) {
            $scope.progressBarPercent = 0;
            return
        }

        if(data_type == 'posted') {
            data.limit = $scope.currentOccupation.outcome;
        }

        if(data_type != 'posted' && $scope.currentOccupation.incomePeriod == 'month' && period != 'month') {
            $scope.progressBarPercent = Math.round(data.hours * 150 / data.limit / 12 * 100);
        } else {
            $scope.progressBarPercent = Math.round(data.hours * 150 / data.limit * 100);
        }
    };


    $scope.downloadActivity = function() {
        User.downloadActivity().$promise.then(function() {
            AlertBanner.publish({
                type: 'info',
                message: $filter('translate')('YOUR_ACTIVITY_HAS_BEEN_SENT_TO') + ' ' + User.get().email,
                timeCollapse: 8000
            });
        });
    };
}]);
angular.module('myActivity')

.factory('MyActivity', [ function () {

    var MyActivity = {};

    MyActivity.listResultsTabs = {
        active: 'posted',
        activate: function (type) {
            MyActivity.listResultsTabs.active = type
        }
    };

    return MyActivity;
}]);
angular.module('myCalendar')
    .controller('MyCalendarPopoverController', ['$scope', 'MyCalendar', 'MyCalendarConstants', '$attrs', 'User',
        function ($scope, MyCalendar, MyCalendarConstants, $attrs, User) {
            $scope.isInternal = false;
            $scope.cellDate = $attrs.$$element.context.parentNode.parentNode.parentNode.previousSibling.getAttribute('date');
            User.get().$promise.then(user => {
                $scope.isInternal = user.is_internal;
            })
        }]);

angular.module('myCalendar')
    .controller('MyCalendarController', ['$scope', '$rootScope', 'MyCalendar', 'MyCalendarConstants', 'MyCalendarUtils', '$translate', 'Modal', '$location', '$filter', '$compile', 'User',
        function ($scope, $rootScope, MyCalendar, MyCalendarConstants, MyCalendarUtils, $translate, Modal, $location, $filter, $compile, User) {

            let startDay = new Date();
            let endDay = new Date();
            let events = [];
            $scope.currUser = {};

            let handleEventRender = (event, element) => {
                element = MyCalendarUtils.addPopoverToEvent(event, element);
                $compile(element)($scope);
            };

            let createCalendarPlaceholderEvent = (eventDate) => {
                events.push(MyCalendarUtils.makeEvent(eventDate, 'placeholder'));
            };

            let createOrUpdateEvent = (eventDate, type) => {
                const event = events.find(event => !event.extendedProps.isPlaceholder && moment(event.start).toISOString() === eventDate);
                if (event) {
                    return MyCalendar.updateAvailability(event.id, type).$promise.then((createdEvent) => {
                        const newEvent = MyCalendarUtils.makeEvent(createdEvent.day, createdEvent.type, createdEvent.id);
                        addCalendarEvent(newEvent);
                    });
                }
                MyCalendar.setAvailability(eventDate, type).$promise.then((createdEvent) => {
                    const newEvent = MyCalendarUtils.makeEvent(createdEvent.day, createdEvent.type, createdEvent.id);
                    addCalendarEvent(newEvent);
                });
            };

            let addCalendarEvent = (createdEvent) => {
                // events = events.filter(
                //     currEvent => moment(currEvent.start).format('DD-MM-YYYY') !== moment(createdEvent.start).format('DD-MM-YYYY')
                // );
                $('#my-calendar').fullCalendar('refetchEvents');
                // todo: ^^^ replace specific events instead of refetching all of them
            };

            let loadPlaceholderEvents = (user) => {
                for (const date = moment(startDay); date.diff(moment(endDay)) < 0; date.add(1, 'days')) {
                    if (MyCalendarUtils.allowCreatePlaceholderEvent(date, events, user)) {
                        createCalendarPlaceholderEvent(date.toDate());
                    }
                }
            };

            let loadCalendarEvents = () => {
                return new Promise((resolve, reject) => {
                    const dateTo = moment(endDay).format('YYYY-MM-DD');
                    MyCalendar.getAvailableDays(dateTo).$promise.then(days => {
                        const newEvents = days.map(day => {
                            return MyCalendarUtils.makeEvent(day.day, day.type.toLowerCase(), day.id);
                        });
                        events = [...newEvents];
                        resolve();
                    })
                });
            };

            let prepareAllEvents = (user) => {
                return new Promise((resolve, reject) => {
                    loadCalendarEvents().then(() => {
                        loadPlaceholderEvents(user);
                        resolve(events)
                    });
                })
            };

            let allowBulkUpdate = (currentViewDate) => {
                if (currentViewDate.isAfter(moment().startOf('month').add(2, 'M'))) {
                    Modal.alert({
                        title: $filter('translate')('MY_CALENDAR__MODAL_DATE_TOO_FAR__TITLE'),
                        message: $filter('translate')('MY_CALENDAR__MODAL_DATE_TOO_FAR__DESCRIPTION'),
                    });
                    return false
                }
                return !$scope.currUser.is_internal
            };

            $scope.calendarOptions = {
                defaultView: 'month',
                height: 600,
                editable: false,
                header: {
                    left: 'month',
                    center: 'title',
                    right: 'prev,next'
                },
                events: (start, end, timezone, callback) => {
                    User.get().$promise.then(user => {
                        $scope.currUser = user;
                        $translate('YES').then(() => {
                            prepareAllEvents(user).then(preparedEvents => {
                                callback(preparedEvents);
                            });
                        });
                    });
                },
                lazyFetching: false,
                eventRender: handleEventRender,
                firstDay: 1,
                viewRender: (view) => {
                    startDay = view.start;
                    endDay = view.end;
                }

            };


            $scope.markAsNotAvailable = (cellDate) => {
                createOrUpdateEvent(cellDate, MyCalendarConstants.types.NOT_AVAILABLE);
            };

            $scope.markAsAvailable = (cellDate) => {
                createOrUpdateEvent(cellDate, MyCalendarConstants.types.AVAILABLE);
            };

            // $scope.markAsVacation = (cellDate) => {
            //     createOrUpdateEvent(cellDate, MyCalendarConstants.types.VACATION);
            // };

            $scope.markAllDaysAvailable = () => {
                const currentViewDate = $('#my-calendar').fullCalendar('getDate');
                if (allowBulkUpdate(currentViewDate)) {
                    MyCalendar.markMonthAsAvailable(currentViewDate.month() + 1, currentViewDate.year()).$promise.then(() => {
                        $('#my-calendar').fullCalendar('refetchEvents');
                    });
                }
            };

            $scope.markAllDaysNotAvailable = () => {
                const currentViewDate = $('#my-calendar').fullCalendar('getDate');
                if (allowBulkUpdate(currentViewDate)) {
                    MyCalendar.markMonthAsNotAvailable(currentViewDate.month() + 1, currentViewDate.year()).$promise.then(() => {
                        $('#my-calendar').fullCalendar('refetchEvents');
                    });
                }
            };

        }])
;

angular.module('myCalendar')

.factory('MyCalendarResource', ['$resource', function($resource) {

    return $resource('/api/tcalendar/:id/', {id: '@id'}, {
        get: { isArray: true },
        save: { method: 'POST' },
        'markMonthAsAvailable': {
            url: '/api/tcalendar/mark_month_available/',
            method: 'POST',
        },
        'markMonthAsNotAvailable': {
            url: '/api/tcalendar/mark_month_not_available/',
            method: 'POST',
        },
        'getSmallUserCalendar': {
            url: '/api/tcalendar/staff_meployee_calendar/',
            method: 'GET',
            isArray: true
        },
        'getMeployeeCalendar': {
            url: '/api/tcalendar/staff_meployee_calendar/',
            method: 'GET',
            isArray: true
        },
        'update': {
            url: '/api/tcalendar/:id/',
            method: 'PATCH',
        }
    })

}]);

angular.module('myCalendar').factory("MyCalendarUtils", function (MyCalendarConstants, $filter) {


    let getEventTitle = (eventType) => {
        switch (eventType.toUpperCase()) {
            case MyCalendarConstants.types.AVAILABLE:
                return $filter('translate')('MY_CALENDAR__EVENT__AVAILABLE__TITLE');
            case MyCalendarConstants.types.NOT_AVAILABLE:
                return $filter('translate')('MY_CALENDAR__EVENT__NOT_AVAILABLE__TITLE');
            case MyCalendarConstants.types.SICK:
                return $filter('translate')('MY_CALENDAR__EVENT__SICK_DAY__TITLE');
            case MyCalendarConstants.types.VACATION:
                return $filter('translate')('MY_CALENDAR__EVENT__VACATION__TITLE');
            case MyCalendarConstants.types.PLOY:
                return $filter('translate')('MY_CALENDAR__EVENT__PLOY__TITLE');
            default:
                return ''
        }
    };

    let getEventBackgroundColor = (eventType) => {
        switch (eventType.toUpperCase()) {
            case MyCalendarConstants.types.AVAILABLE:
                return '#3ad4a9';
            case MyCalendarConstants.types.NOT_AVAILABLE:
                return '#c1c1c1';
            case MyCalendarConstants.types.SICK:
                return '#db1c45';
            case MyCalendarConstants.types.VACATION:
                return '#E37738';
            case MyCalendarConstants.types.PLOY:
                return '#21bfdc';
            default:
                return 'transparent'
        }
    };

    let makeEvent = (eventDate, eventType, id) => {
        const eventDay = angular.copy(eventDate);
        return {
            id: id || undefined,
            title: `${moment(eventDate).format('DD/MM')}\n${getEventTitle(eventType)}`,
            start: eventDay,
            end: eventDay,
            backgroundColor: getEventBackgroundColor(eventType),
            borderColor: getEventBackgroundColor(eventType),
            textColor: '#ffffff',
            extendedProps: {
                isPlaceholder: eventType === 'placeholder',
                isSick: eventType === MyCalendarConstants.types.SICK.toLowerCase(),
                isPloy: eventType === MyCalendarConstants.types.PLOY.toLowerCase(),
                isVacation: eventType === MyCalendarConstants.types.VACATION.toLowerCase()
            }
        }
    };

    let allowCreatePlaceholderEvent = (date, events, user) => {
        const eventForDayExists = (day) => {
            return events.some(event => {
                return moment(event.start).format('YYYY-MM-DD') === day.format('YYYY-MM-DD')
            });
        };
        if (eventForDayExists(date)) {
            return false
        }
        if (date.isBefore(moment().subtract(1, 'days'))) {
            return false
        }
        if (date.isAfter(moment().startOf('month').add(3, 'M'))) {
            return false
        }
        if (user.is_internal) {
            return false
        }
        return true
    };

    let addPopoverToEvent = (event, element) => {
        if (!event.extendedProps.isPloy && !event.extendedProps.isSick && !event.extendedProps.isVacation) {
            element.attr({ // render meployees list into tooltip
                'uib-popover-template': "'/src/my-calendar/html/my-calendar-popover.html'",
                'popover-trigger': 'outsideClick',
                'popover-class': 'my-calendar-popover',
                'popover-animation': false,
                'date': event.start.toISOString()
            });
            return element;
        }
    };

    return {
        makeEvent: makeEvent,
        allowCreatePlaceholderEvent: allowCreatePlaceholderEvent,
        addPopoverToEvent: addPopoverToEvent
    }
});

angular.module('myCalendar')

.factory('MyCalendarConstants', [function() {
    var MyCalendarConstants = {};

    MyCalendarConstants.types = {
        AVAILABLE: 'AVAILABLE',
        NOT_AVAILABLE: 'NOT_AVAILABLE',
        VACATION: 'VACATION',
        SICK: 'SICK',
        PLOY: 'PLOY',
    };

    return MyCalendarConstants;

}]);

angular.module('myCalendar')

.service('MyCalendar', ['MyCalendarResource', 'MyCalendarConstants', 'EngagementResource',
    function(MyCalendarResource, MyCalendarConstants, EngagementResource) {

        var MyCalendarService = {};

        MyCalendarService.setAvailability = (day, type) => {
            return MyCalendarResource.save({'day': day, 'type': type});
        };

        MyCalendarService.updateAvailability = (id, type) => {
            return MyCalendarResource.update({'id': id, 'type': type});
        };

        MyCalendarService.getPloys = () => {
            return EngagementResource.myCalendarEngagements();
        };

        MyCalendarService.getPloysForPrevMonth = (viewStart, viewEnd) => {
            return EngagementResource.myCalendarPrevEngagements({
                'view_start': viewStart, 'view_end': viewEnd
            });
        };

        MyCalendarService.getAvailableDays = (date_to) => {
            if (date_to) {
                return MyCalendarResource.get({'date_to': date_to});
            }
            return MyCalendarResource.get();
        };
        MyCalendarService.getMeployeeAvailableDays = (user_id) => {
            return MyCalendarResource.getMeployeeCalendar({user:user_id});
        };

        MyCalendarService.markMonthAsAvailable = (month, year) => {
            return MyCalendarResource.markMonthAsAvailable({'month': month, 'year': year});
        };

        MyCalendarService.markMonthAsNotAvailable = (month, year) => {
            return MyCalendarResource.markMonthAsNotAvailable({'month': month, 'year': year});
        };

        return MyCalendarService;

}]);

angular.module('myCompany')
    .controller('CompanyDocumentsAcceptanceLogsController', ['$scope', 'CompanyDocument',
        function ($scope, CompanyDocument) {

            $scope.companyDocumentsAcceptances = [];
            CompanyDocument.queryDocumentsAcceptations().$promise.then(response => {
                $scope.companyDocumentsAcceptances = response.results;
                $scope.companyDocumentsAcceptancesResults = angular.copy($scope.companyDocumentsAcceptances);
            });

            $scope.filters = {};
            $scope.filters.usernameFiltering = '';

            $scope.companyDocuments = CompanyDocument.getMyCompanyDocuments;

            $scope.filterLogs = () => {
                $scope.companyDocumentsAcceptancesResults = $scope.companyDocumentsAcceptances
                    .filter(log => log.user.full_name.toLowerCase().includes($scope.filters.usernameFiltering.toLowerCase()));
                if ($scope.filters.companyDocumentFiltering) {
                    $scope.companyDocumentsAcceptancesResults = $scope.companyDocumentsAcceptancesResults
                        .filter(log => log.document.id === $scope.filters.companyDocumentFiltering);
                }
            }

        }]);

angular.module('myCompany')
.controller('CompanyStatsController', ['$scope', 'Stat', '$translate', '$rootScope', function ($scope, Stat, $translate, $rootScope) {

    $scope.chartLabels = [
        moment('2019-01', "YYYY-MM").format('MMMM'),
        moment('2019-02', "YYYY-MM").format('MMMM'),
        moment('2019-03', "YYYY-MM").format('MMMM'),
        moment('2019-04', "YYYY-MM").format('MMMM'),
        moment('2019-05', "YYYY-MM").format('MMMM'),
        moment('2019-06', "YYYY-MM").format('MMMM'),
        moment('2019-07', "YYYY-MM").format('MMMM'),
        moment('2019-08', "YYYY-MM").format('MMMM'),
        moment('2019-09', "YYYY-MM").format('MMMM'),
        moment('2019-10', "YYYY-MM").format('MMMM'),
        moment('2019-11', "YYYY-MM").format('MMMM'),
        moment('2019-12', "YYYY-MM").format('MMMM')
    ];

    let currentYear = new Date().getFullYear();

    $scope.chartData = [];

    $scope.years = {
        availableYears: [],
        selectedYear: currentYear,
        switchYear: year => {
            if (year === $scope.years.selectedYear) return;
            loadStats(year).then(() => {
                $scope.years.selectedYear = year
            })
        }
    };


    $scope.chartOptions = {
        legend: {
            display: true
        },
        scales: {
            yAxes: [{
                id: 'left-y-axis',
                type: 'linear',
                position: 'left'
            }, {
                id: 'right-y-axis',
                type: 'linear',
                position: 'right'
            }]
        }
    };

    $scope.chartDatasets = [
        {
            label: $translate.instant('COMPANY_STATS__CHART_LEGEND__APPROVED_SHIFT_HOURS'),
            yAxisID: 'left-y-axis',
            borderColor: 'rgba(151,187,205,1)',
            backgroundColor: 'rgba(151,187,205,0.5)'
        },
        {
            label: $translate.instant('COMPANY_STATS__CHART_LEGEND__TOTAL_SALARY_PAID'),
            yAxisID: 'right-y-axis',
            borderColor: 'rgba(220,220,220,1)',
            backgroundColor: 'rgba(220,220,220,0.5)'
        },
        {
            label: $translate.instant('COMPANY_STATS__CHART_LEGEND__MEPLOYEES_HIRED'),
            yAxisID: 'left-y-axis',
            borderColor: 'rgba(77,83,96,0.7)',
            backgroundColor: 'rgba(77,83,96,0.5)'
        }
    ];

    $rootScope.$on('$translateChangeSuccess', () => { // to fix loading chart until translations are ready
        $scope.chartDatasets[0].label = $translate.instant('COMPANY_STATS__CHART_LEGEND__APPROVED_SHIFT_HOURS')
        $scope.chartDatasets[1].label = $translate.instant('COMPANY_STATS__CHART_LEGEND__TOTAL_SALARY_PAID')
        $scope.chartDatasets[2].label = $translate.instant('COMPANY_STATS__CHART_LEGEND__MEPLOYEES_HIRED')
    });

    let loadStats = year => {
        $scope.chartData = [];
        return Stat.getCompanyStats(year).$promise.then(stats => {
            stats.forEach(dataSeries => {
                $scope.chartData.push(_.values(dataSeries))
            })
        });
    };
    loadStats(currentYear);

    Stat.getCompanyStatsAvailableYears().$promise.then(years => {
        $scope.years.availableYears = years.reverse();
    })
}]);

angular.module('myCompany')
.controller('EditCompanyController', ['$scope', 'Company', '$location', 'AlertBanner', '$filter', 'User', 'MeployerOnboardingBar',
    function($scope, Company, $location, AlertBanner, $filter, User, MeployerOnboardingBar) {

    $scope.form = {};

    Company.getCompany().$promise.then(company => {
        $scope.form = company;
    });

    $scope.saveCompany = form => {
        Company.updateCompany(form).$promise.then(succ => {
             AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('SAVED') + '!',
                timeCollapse: 4000
             });
             if (form.color) User.get().company.color = form.color;
             MeployerOnboardingBar.loadCompanyInvoiceSettings();
            $location.path('/my-company')
        }, err => {
            console.log(err)
            if (err.data.postal_code || err.data.invoice_postal_code) {
                AlertBanner.publish({
                    type: 'error',
                    message: $filter('translate')('INVALID_POSTAL_CODE') + '!',
                    timeCollapse: 4000
                })
            }
        });
    };

    $scope.colorPickerOptions = {
        size: 50,
        roundCorners: true,
        total: 6,
        customColors: [
            '#C41A20',
            '#3C6BD0',
            '#28B224',
            '#EB9A2E',
            '#30c7cb',
        ]
    };


}]);

angular.module('myCompany')
.controller('EditCompanyDocumentsModalController', ['$scope', 'document', 'CompanyDocument',
    function($scope, document, CompanyDocument) {
    $scope.form = angular.copy(document);
    $scope.form.filename = document.file.replace(/^.*[\\\/]/, '');
    $scope.updateCurrentDocument = doc => {
        CompanyDocument.updateCompanyDocument(doc).$promise.then(() => {
            $scope.$close();
        })
    }

}]);

angular.module('myCompany')
.controller('EditCompanyDocumentsController', ['$scope', 'CompanyDocument', 'Upload', 'AlertBanner', '$filter', 'User', '$uibModal', 'Modal', '$translate',
    function($scope, CompanyDocument, Upload, AlertBanner, $filter, User, $uibModal, Modal, $translate) {

    $scope.documents = CompanyDocument.getMyCompanyDocuments;
    $scope.uploadingInProgress = false;

    $scope.uploadCompanyDocument = files => {
        if (files && files.length) {
            const file = files[0];
            $scope.uploadingInProgress = true;
            Upload.upload({
                url: '/api/company-document/',
                data: {
                    file: file,
                },
            }).then(response => {
                $scope.editDocument(response.data);
                $scope.uploadingInProgress = false;
            }, err => {
                $scope.uploadingInProgress = false;
            });
        }
    };

    $scope.openDocument = document => {
        window.open(document.file, '_blank');
    };

    $scope.editDocument = doc => {
        return $uibModal.open({
            templateUrl: '/src/my-company/html/modals/edit-document-modal.html',
            windowClass: 'modal-vertical-centered',
            controller: 'EditCompanyDocumentsModalController',
            size: 'sm',
            backdrop: 'static',
            resolve: {
                document: () => {
                    return doc
                }
            }
        }).result.then(() => {
            CompanyDocument.loadMyCompanyDocuments();
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('SAVED')+'!',
                timeCollapse: 4000
            });
        });
    };

    $scope.archiveDocument = document => {
        return Modal.confirm({
            title: $filter('translate')('ARCHIVE'),
            message: $filter('translate')('ARE_YOU_SURE'),
            firstButtonLabel : $filter('translate')('CANCEL'),
            secondButtonLabel : $filter('translate')('ARCHIVE'),
            secondButtonColor : 'red',
            secondButtonFunction : function () {
                CompanyDocument.archiveCompanyDocument(document).$promise.then(() => {
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('COMPANY_DOCUMENTS__DOCUMENT_ARCHIVED'),
                        timeCollapse: 4000
                    });
                    CompanyDocument.loadMyCompanyDocuments();
                }, error => {
                     AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')('COMMUNICATION__ERROR_OCCURED'),
                        timeCollapse: 4000
                    });
                });
            }
        });
    };

    $scope.removeDocument = document => {
        return Modal.confirm({
            title: $filter('translate')('REMOVE'),
            message: $filter('translate')('ARE_YOU_SURE'),
            firstButtonLabel : $filter('translate')('CANCEL'),
            secondButtonLabel : $filter('translate')('REMOVE'),
            secondButtonColor : 'red',
            secondButtonFunction : function () {
                CompanyDocument.removeCompanyDocument(document.id).$promise.then(() => {
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('COMPANY_DOCUMENTS__DOCUMENT_REMOVED'),
                        timeCollapse: 4000
                    });
                    CompanyDocument.loadMyCompanyDocuments();
                }, error => {
                     AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')('COMMUNICATION__ERROR_OCCURED'),
                        timeCollapse: 4000
                    });
                });
            }
        });
    };



}]);

angular.module('myCompany')
.controller('MyCompanyController', ['$scope', 'Company', 'CompanyDocument', 'Modal', '$filter',
    function($scope, Company, CompanyDocument, Modal, $filter) {

    $scope.company = {};
    $scope.companyMembers = [];
    $scope.companyDocuments = CompanyDocument.getMyCompanyDocuments;

    Company.getMembers().$promise.then(members => {
        $scope.companyMembers = members;
    });

    Company.getCompany().$promise.then(company => {
        $scope.company = company;
    });

    $scope.requestNewMember = () => {
        Modal.alert({
            title: $filter('translate')('COMPANY_MEMBERS__MODAL__TITLE'),
            message: $filter('translate')('COMPANY_MEMBERS__MODAL__CONTENT'),
            buttonColor: 'green',
        })
    };

    $scope.uploadCompanyLogo = Company.uploadLogo;

}]);

angular.module('myCompany')
.controller('PloysSettingsController', ['$scope', 'Company', 'AlertBanner', '$filter', '$location', 'User',
    function($scope, Company, AlertBanner, $filter, $location, User) {

    $scope.form = {};
    User.get().$promise.then(user => {
        $scope.form.staffing_permission = user.company.staffing_permission;
        $scope.form.address_annotation = user.company.address_annotation;
        $scope.form.require_clean_criminal_record = user.company.require_clean_criminal_record;
        $scope.form.pause_between_eng = user.company.pause_between_eng;
    });

    $scope.savePloysSettingsForm = form => {
        return Company.updateCompany(form).$promise.then(company => {
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('SAVED') + '!',
                timeCollapse: 3000
            });
            Object.keys(form).forEach((key) => {
                User.get().company[key] = form[key]
            });
            $location.path('my-company')
        });
    };

}]);

angular.module('myPayments')
.controller('MyPaymentsController', ['$scope', 'Ploy', '$filter', 'Category', '$translate', '$location', 'MyPayments',
    function($scope, Ploy, $filter, Category, $translate, $location, MyPayments) {

        
    $scope.loadMorePloys = MyPayments.loadMorePloys;

    $scope.loadInvoices = MyPayments.loadMorePloys;

    $scope.ploys = MyPayments.getPloys;

    $scope.invoices = MyPayments.getInvoices;

    $scope.noResults = MyPayments.getNoResults;

    $scope.listResultTabs = MyPayments.listResultsTabs;

    $scope.disableInfiniteScroll = MyPayments.infiniteScrollDisabled;

    $scope.payFor = (ployId) => {
        $location.path('/my-payments/for/' + ployId)
    };

    $scope.payForAll = () => {
        let unpaidPloys = $scope.ploys().reduce( (acc, curr) => {
            return acc.concat(curr.id)
        }, []);
        $location.path('/my-payments/for/' + unpaidPloys)
    };

    $scope.downloadInvoice = signature => {
        window.open('/api/consolidated-payment?signature=' + signature, '_blank');
    };

    MyPayments.loadMorePloys();
    MyPayments.loadInvoices();

}]);

angular.module('myPayments')
.controller('PayForController', ['$scope', '$routeParams', 'PayFor', 'User', '$location', 'ProfileSettings',
    function($scope, $routeParams, PayFor, User, $location, ProfileSettings) {

    $scope.ploys = PayFor.getPloys;
    $scope.paramsPloysNumber = PayFor.getParamsPloysNumber;
    $scope.overallMoney = PayFor.getOverallMoney;
    $scope.payEveryone = PayFor.payEveryone;

    User.getCurrentPaymentType().then(type => $scope.currentPaymentType = type);

    if ($routeParams.ploy) {
        PayFor.loadPloysFromParams($routeParams.ploy);
    }

    $scope.goToPaymentSettings = () => {
        ProfileSettings.redirection.set($location.path()); // Redirect to payment settings but save previous route
        $location.path('/my-company/edit')
    };

    $scope.goToEngagement = (engId) => {
        $location.path('/my-ploys/' + engId + '/conversation');
    }

}]);

angular.module('myPayments')
.controller('PaymentsArchiveController', ['$scope', 'Ploy', '$filter', 'Category', '$translate', '$location', 'PaymentsArchive',
    function($scope, Ploy, $filter, Category, $translate, $location, PaymentsArchive) {

    PaymentsArchive.previousPloys();

    $scope.previousPloys = PaymentsArchive.previousPloys;

    $scope.ploys = PaymentsArchive.getPloys;

    $scope.listResultTabs = PaymentsArchive.listResultsTabs;

    $scope.pagesPloys = {
        current : PaymentsArchive.getCurrentPagePloys,
        disableInfiniteScroll: PaymentsArchive.infiniteScrollDisabledPloys
    };

}]);

angular.module('myPayments')

.factory('MyPaymentsResource', ['$resource', function($resource) {
    return  $resource('/api/consolidated-payment/:id', {id:'@id'},{
        pay: {
            method: 'POST',
            url: '/api/consolidated-payment/create_payment/'
        }
    });
 }]);
angular.module('myPayments')

.service('MyPayments', ['AlertBanner', '$q', '$filter', 'Ploy', 'MyPaymentsResource', 'Payment',
    function (AlertBanner, $q, $filter, Ploy, MyPaymentsResource, Payment) {

    var MyPaymentsService = {};

    var ploys = [];

    var invoices = [];

    MyPaymentsService.listResultsTabs = {
        active: 'unpaid',
        activate: function (type) {
            MyPaymentsService.listResultsTabs.active = type
        }
    };

    MyPaymentsService.loadMorePloys = () => {
        Ploy.unPaidWithoutPayment().$promise.then(unpaidPloys => {
            ploys = unpaidPloys;
            if (unpaidPloys.length<=0) {
                MyPaymentsService.listResultsTabs.activate('invoices')
            }
        });
    };

    MyPaymentsService.loadInvoices = () => {
        Payment.getInvoices().$promise.then(response_invoices => {
            invoices = response_invoices;
            if (response_invoices.length<=0) {
                MyPaymentsService.listResultsTabs.activate('unpaid')
            }
        });
    };

    MyPaymentsService.getPloys = () => {
      return ploys;
    };

    MyPaymentsService.getInvoices= () => {
      return invoices;
    };

    MyPaymentsService.getNoResults = () => {
        return ploys.length <= 0 && invoices.length <= 0;
    };

    MyPaymentsService.pay = (engagements, payment_type) => {
      return MyPaymentsResource.pay({engagements: engagements, payment_type: payment_type})
    };

    return MyPaymentsService;

}]);

angular.module('myPayments')

.factory('PayFor', ['MyPayments', 'Payment', 'Constants', 'Ploy', 'HandleServerErrors', '$location', 'AlertBanner', '$filter', function (MyPayments, Payment, Constants, Ploy, HandleServerErrors, $location, AlertBanner, $filter) {

    var PayFor = {};

    let ploys = [];

    let paramsPloysNumber = 0;

    let overallMoney = 0;

    PayFor.loadPloysFromParams = paramsPloys => {
        PayFor.reset();
        let paramsPloysList = paramsPloys.split(','); // Create an array from string with ploys ids
        paramsPloysNumber = paramsPloysList.length;

        paramsPloysList.forEach(ploy_id => {
            Ploy.getPaymentPloy({id: ploy_id}).$promise.then(response_ploy => {
                response_ploy.engagements_completed = response_ploy.engagements.filter(eng => {
                    return eng.state == 'ENGAGEMENT_COMPLETED' && eng.has_payment == false
                });
                response_ploy.engagements_completed.map(eng => {
                    return eng.price = eng.work_time_hours * response_ploy.price_employer
                });
                response_ploy.aggregated_payments = response_ploy.engagements_completed.reduce((paymentAccumulator, eng) => {
                         let key = eng['employee'].id;
                            if (!paymentAccumulator[key]) {
                                paymentAccumulator[key] = [];
                                paymentAccumulator[key].engagements = [];
                            }
                            paymentAccumulator[key].engagements.push(eng);
                            paymentAccumulator[key].employee = eng.employee;
                            paymentAccumulator[key].price = 0;
                            paymentAccumulator[key].engagements.forEach(_eng => {
                               return paymentAccumulator[key].price += _eng.price;
                            });
                            paymentAccumulator[key].price = paymentAccumulator[key].price.toFixed(2);
                        return paymentAccumulator;
                },{});
                ploys.push(response_ploy);
                countOverallMoney(response_ploy)
            }, err => {
                console.error(err);
                return $location.path('/my-payments');
            });
        });
    };

    const countOverallMoney = ploy => {
        ploy.engagements_completed.forEach((eng) => {
             overallMoney += ploy.price_employer * eng.work_time_hours;
        });
    };

    PayFor.payEveryone = (ploys, payment_type) => {
        // Prepare list of eng IDs
        let engagementsToPay = ploys.reduce((acc, ploy) => {
            return acc.concat(ploy.engagements_completed.map( eng => {return eng.id}))
        }, []);

        if (engagementsToPay.length == 1 && payment_type == Constants.paymentTypes.PAY_TYPE_STRIPE ) {
        // If there is only one engagement to pay, open standard stripe window instead of creating invoice
            return PayFor.runSinglePayment(ploys, engagementsToPay);
        }

        MyPayments.pay(engagementsToPay, payment_type).$promise.then(invoice_data => {
        // Open PDF if consolidated payment is created or display an error
            window.open('/api/consolidated-payment?signature=' + invoice_data.signature, '_blank');
            $location.path('/my-payments').replace()
        }, HandleServerErrors.handleFormError)
    };

    PayFor.runSinglePayment = (ploys, engagementsToPay) => {
        let ploy = ploys[0];
        let engagement = ploy.engagements.find(eng => {
            return eng.id == engagementsToPay[0]
        });
        engagement.ploy = ploy;
        return Payment.startPayment(engagement).then(() => {
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('PAY_FOR___PAYMENT_SUCCESS'),
                timeCollapse: 4000
            });
            $location.path('/my-payments').replace();
        }, err => {
            AlertBanner.publish({
                type: 'error',
                message: $filter('translate')('PAY_FOR__PAYMENT_ALREADY_EXISTS'),
                timeCollapse: 4000
            })
        })
    };

    PayFor.reset = () => {
        ploys = [];
        paramsPloysNumber = 0;
        overallMoney = 0;
    };

    PayFor.getPloys = () => {
        return ploys
    };

    PayFor.getParamsPloysNumber = () => {
        return paramsPloysNumber
    };

    PayFor.getOverallMoney = () => {
        if(overallMoney == 0) {
            AlertBanner.publish({
                type: 'info',
                message: $filter('translate')('PAY_FOR__NOTHING_TO_CREATE_INVOICE_FOR'),
                timeCollapse: 8000
            });
            $location.path('/my-payments');
        }
        return overallMoney.toFixed(2)
    };

    return PayFor;
}]);

angular.module('myPloys')

.service('PaymentsArchive', ['Engagement', 'Ploy', function (Engagement, Ploy){
    const PAGE_SIZE = 10;

    let PaymentsArchiveService = {};

    let ploys = [];

    // Infinite scroll helpers
    let currentPagePloys = 0;
    let pendingPloys = false;
    let disableInfiniteScrollPloys = false;



    // Getter functions
    PaymentsArchiveService.getPloys = () => ploys;
    PaymentsArchiveService.getCurrentPagePloys = () => currentPagePloys;

    PaymentsArchiveService.infiniteScrollDisabledPloys = () => {
        return disableInfiniteScrollPloys;
    };

    PaymentsArchiveService.previousPloys = () => {
        if (pendingPloys) {return}
        pendingPloys = true;
        currentPagePloys = currentPagePloys + 1;
        Ploy.previousPaid({'page' : currentPagePloys, 'page_size': PAGE_SIZE}).$promise.then(function (ploysList) {
            ploys = _.uniqBy(ploys.concat(ploysList), 'id');
            pendingPloys = false;
            if (ploysList.length == 0) {
                disableInfiniteScrollPloys = true;
            }
        }, (error) => {
            disableInfiniteScrollPloys = true;
            pendingPloys = false;
        });
    };

    return PaymentsArchiveService;

}]);

angular.module('myPloys')
.controller('ArchiveController', ['$scope', 'Ploy', 'Engagement', '$filter', 'Modal', '$translate', '$location', 'MyArchive',
    function($scope, Ploy, Engagement, $filter, Modal, $translate, $location, MyArchive) {

    MyArchive.previousPloys();
    MyArchive.previousEngagements();

    MyArchive.resetPagination();

    $scope.previousPloys = MyArchive.previousPloys;
    $scope.previousEngagements = MyArchive.previousEngagements;

    $scope.ploys = MyArchive.getPloys;
    $scope.engagements = MyArchive.getEngagements;

    $scope.listResultTabs = MyArchive.listResultsTabs;

    $scope.pagesPloys = {
        current : MyArchive.getCurrentPagePloys,
        disableInfiniteScroll: MyArchive.infiniteScrollDisabledPloys
    };

    $scope.pagesEng = {
        current : MyArchive.getCurrentPageEng,
        disableInfiniteScroll: MyArchive.infiniteScrollDisabledEng
    };
        
}]);

angular.module('myPloys')
    .controller('FindReplacementController', ['$scope', 'Engagement', 'crumble', '$location', '$routeParams', 'MyStaff', 'Constants', 'Ploy', '$timeout',
        function ($scope, Engagement, crumble, $location, $routeParams, MyStaff, Constants, Ploy, $timeout) {

            $scope.staffList = MyStaff.getStaff;
            $scope.order = '';
            $scope.engagement = {};
            $scope.addSearchStringFilter = MyStaff.addSearchStringFilter;
            $scope.addAvailabilityFilter = MyStaff.addAvailabilityFilter;
            $scope.findStaff = MyStaff.findStaff;
            $scope.setOrder = MyStaff.setOrder;
            $scope.requestedUsers = {};


            Engagement.get($routeParams.id).$promise.then(function (eng) {
                $scope.engagement = eng;
                if (moment(eng.checkin_time).isBefore(moment())) {
                    return $location.path('/my-ploys/' + eng.ploy.id);
                }
                Ploy.getMyPloy({id: eng.ploy.id}).$promise.then(response_ploy => {
                    // $scope.engagement = response_ploy.engagements.find(eng => eng.id === Number($routeParams.id));
                    response_ploy.engagements.forEach(_eng => {
                        $scope.requestedUsers[_eng.employee.id] = _eng.replacement_for && _eng.replacement_for.id === $scope.engagement.id
                    })
                });

                crumble.update({engagement: eng, ploy: eng.ploy});

            }, err => {
                return $location.path('/my-ploys');
            });

            $scope.getStaffAvailability = (availabilityLevel) => {
                return Constants.staffAvailabilityLevels.find(level => level.value === availabilityLevel).name;
            };

            $scope.goToEditStaff = id => {
                $location.path('/my-staff/edit/' + id);
            };

            $scope.mainSearch = function () {
                MyStaff.newSearching();
            };

            $scope.staffAvailabilityLevels = Constants.staffAvailabilityLevels;

            $scope.createReplacementPloy = (engagement, meployee) => {
                let date = engagement.checkin_time.toISOString()
                $location.path('/post-ploy/for/' + meployee).search({date: date, replacement_for: engagement.id})
            };

            $scope.excludeReplaced = (staffObj) => {
                if ($scope.engagement.id) {
                    return staffObj.meployee.id !== $scope.engagement.employee.id
                }
                return true;
            };

            $scope.requestAllStaff = (engagement) => {
                let date = engagement.checkin_time.toISOString()
                $location.path('/post-ploy/staff/true').search({date: date, replacement_for: engagement.id})
            }

        }]);

angular.module('myPloys')
.controller('MessageToWorkersController', ['$scope', 'Ploy', '$routeParams', 'AlertBanner', '$filter', '$location',
    ($scope, Ploy, $routeParams, AlertBanner, $filter, $location) => {

    $scope.chosenUsers = [];

    Ploy.getChosenUsers({id: $routeParams.id}).$promise.then(chosenUsers => {
        $scope.chosenUsers = chosenUsers;
    });

    let sendMessage = (message) => {
        Ploy.sendMessageToWorkers({id: $routeParams.id, message: message}).$promise.then(response => {
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('MESSAGE_TO_WORKERS__MESSAGE_SENT_TO') + ' '
                    + response.numberOfReceivers + ' ' +
                    $filter('translate')((response.numberOfReceivers === 1) ? 'MESSAGE_TO_WORKERS__SENT_TO_ONE_WORKER' : 'MESSAGE_TO_WORKERS__SENT_TO_MANY_WORKERS'),
                timeCollapse: 5000
            });
            $location.path('/my-ploys/' + $routeParams.id);
        }, error => {
            AlertBanner.publish({
                type: 'error',
                message: $filter('translate')('MESSAGE_TO_WORKERS__SENDING_FAILED'),
                timeCollapse: 5000
            });
        });
    };

    $scope.doSendMessage = _.debounce(sendMessage, 2000, {leading: true});

}]);

angular.module('myPloys')
.controller('MyPloysCalendarController', ['$scope', 'Ploy', 'Engagement', 'MyPloys',  'User', 'LanguageService',
    'Constants', '$uibModal', 'Company', '$filter', '$location', '$compile', 'PloyConstants', '$translate',
    'AlertBanner',
    function($scope, Ploy, Engagement, MyPloys, User, LanguageService,
             Constants, $uibModal, Company, $filter, $location, $compile, PloyConstants, $translate,
             AlertBanner) {

    let myPloysCalendarEvents = [];
    let weekdaysList = [];
    let generatedPloys = [];
    $scope.isCompanyUsingDashboard = false;

    Company.isUsingDashboard().$promise.then((result) => {
        $scope.isCompanyUsingDashboard = result.is_using_dashboard;
    })

    $scope.ployStatuses = PloyConstants.status.filter(status => {
        return !([
            Constants.PloyStatuses.PLOY_STATUS_CANCELLED,
            Constants.PloyStatuses.PLOY_STATUS_PRIVATE,
            Constants.PloyStatuses.PLOY_STATUS_ENDED
        ].includes(status.name))
    });

    $scope.getStatusHelp = (status) => {
        return PloyConstants.helpText[status.name];
    };

    let setWeekdays = (lang) => {
        if (lang === "da") {
            weekdaysList = Constants.danishWeekdaysList;
        }
        if (lang === "en") {
            weekdaysList = Constants.englishWeekdaysList;
        }
    };
    setWeekdays('en');
    setWeekdays(LanguageService.getCurrentLanguage());

    let exportEngPlan = (start, end) => {
        Engagement.downloadEngagementsPlan(start, end).$promise.then(() => {
            AlertBanner.publish({
                type: 'info',
                message: $filter('translate')('MY_PLOYS__CALENDAR__PDF_SENT_TO') + ' ' + User.get().email,
                timeCollapse: 4000
            })
        })
    };

    $scope.getStatusBackground = status => {
        return { 'background-color' : status.calendarColor}
    };

    $scope.exportEngagementsPlan = _.debounce(exportEngPlan, 3000, {leading: true});

    let exportWeekPlanXls = (startDay, endDay) => {
        Engagement.downloadWeekPlanXls(startDay, endDay).$promise.then(() => {
            AlertBanner.publish({
                type: 'info',
                message: $filter('translate')('MY_PLOYS__CALENDAR__XSL_WEEK_PLAY_SENT_TO') + ' ' + User.get().email,
                timeCollapse: 4000,
            });
        });
    };

    $scope.exportWeekPlanXls = _.debounce(exportWeekPlanXls, 3000, {leading: true});

    let ployIsAssignedWithoutAnyWorkers = ploy => {
        // Condition which checks two things
        // 1. If ploy is assigned
        // 2. If there is no workers for this day of ploy
        return ploy.status === Constants.PloyStatuses.PLOY_STATUS_ASSIGNED &&
            !ploy.engagements.some(eng => moment(eng.checkin_time).format("YYYY-MM-DD") == moment(ploy.start_day).format("YYYY-MM-DD") &&
                    Constants.engagementStatesEmployeeChosen.includes(eng.state))
    };

    let generatePloyDays = ploy => {
        let ployDurationInDays = moment(ploy.end_day).diff(moment(ploy.start_day), 'days');
        if (ployDurationInDays >= 1) {
            for (let i = 0; i <= ployDurationInDays; i++) {
                let fakePloy = angular.copy(ploy); // it is important to make copy of original object instead of binding
                let fakeStartDay = moment(ploy.start_day).add(i, 'days');
                let dayValue = weekdaysList.find(weekday => { // find and select correct weekday
                    return weekday.number == fakeStartDay.weekday()
                }).value;
                if (dayValue & ploy.weekdays) { // generate ploy only if weekday fits
                    fakePloy.start_day = fakeStartDay.toDate();
                    if (!ployIsAssignedWithoutAnyWorkers(fakePloy)) { // generate ploy only if there are any workers in this day
                        generatedPloys.push(fakePloy);
                    }
                }
            }
        } else {
            createCalendarEvent(ploy); // if ploy has just one day leave it as is
        }
    };

    let loadCalendarPloys = (start, end) => {
        myPloysCalendarEvents = [];
        generatedPloys = [];
        return Ploy.currentMyCalendarPloys(start, end).$promise.then(response => {
            response.forEach(ploy => {
                generatePloyDays(ploy); // prepare every ploy of multiday ploy as a separate ploy
            });
            generatedPloys.forEach(ploy => {
                createCalendarEvent(ploy); // create calendar events for generated ploys
            })
        });
    };


    let prepareEventTiming = ploy => {
        const weekdaySetting = ploy.weekdays_settings[moment(ploy.start_day).weekday() - 1]
        const startTimeHours = moment(weekdaySetting.start_time).hours();
        const startTimeMinutes = moment(weekdaySetting.start_time).minutes();
        const start = moment(ploy.start_day).set({hour: 0, minute: 0, second: 0, millisecond: 0})
            .add(startTimeHours, 'hours')
            .add(startTimeMinutes, 'minutes');
        const end = moment(start).add(weekdaySetting.hours, 'hours');
        return {'start': start, 'end': end};
    };

    let assignEventColor = ploy => {
        return PloyConstants.status.find(status => {
            return status.name == ploy.status;
        }).calendarColor
    };

    let createCalendarEvent = ploy => {
         myPloysCalendarEvents.push({
                'id': ploy.id,
                'title': $filter('categoryName')(ploy.category) + ' (ID: '+ploy.id+')',
                'start': prepareEventTiming(ploy).start.toDate(),
                'end': prepareEventTiming(ploy).end.toDate(),
                'color': assignEventColor(ploy),
                'borderColor': assignEventColor(ploy),
                'editable': false,
                'extendedProps': {'engagements' : ploy.engagements, 'ployees_needed': ploy.ployees_needed}
            });
    };

    let checkinInDatePeriod = eng => {
        return moment(eng.checkin_time).isBefore(moment().add(14, 'days')) &&
            moment(eng.checkin_time).isAfter(moment().subtract(14, 'days'))
    };

    let handleEventClick = event => {
        window.open('my-ploys/' + event.id, '_blank')
    };

    let renderEventEnagementMeployees = (event, limit) => { // todo: flatten IF conditions
        if (!limit) limit = 999;
        let iterationCounter = 0;
        return event.extendedProps.engagements.reduce((string, eng) => {
            let dayEngExists = event.start.format('DD/MM/YYYY') == moment(eng.checkin_time).format('DD/MM/YYYY');
            let employeeNameAlreadyWritten = string.includes(eng.employee.first_name + ' ' + eng.employee.last_name);
            if (!employeeNameAlreadyWritten && dayEngExists) {
                iterationCounter += 1;
                if (iterationCounter <= limit) {
                    if (eng.state == Constants.engagementStates.ENGAGEMENT_CANCELLED ) {
                        if (checkinInDatePeriod(eng)) {
                            string += '<br /><span class="crossed">' + eng.employee.first_name + ' ' + eng.employee.last_name + '</span>';
                        } else {
                            string += '<br />'
                        }
                    } else {
                        string += '<br /><span>' + eng.employee.first_name + ' ' + eng.employee.last_name + '</span>';
                    }
                    if (iterationCounter == limit) {
                        string += '<br /> + ' + (event.extendedProps.engagements.length - iterationCounter);
                    }
                }
            }
            return string
        }, '')
    };

    let renderEventApprovedMeployees = event => {
        return event.extendedProps.engagements.reduce((acc, eng) => {
            if (Constants.engagementStatesEmployeeChosen.includes(eng.state) && !acc.includes(eng.employee.id)) {
                acc.push(eng.employee.id)
            }
            return acc
        }, []).length
    };

    let addEventAdditionalInfo = (event, element) => {
        if (element.hasClass('fc-day-grid-event')) { // if month view is selected
            element
                .find('.fc-title')
                .append('<br />' + event.extendedProps.engagements.length + ' ' + $translate.instant('MY_PLOYS__CALENDAR__MONTH_VIEW__APPLIED_LABEL'));
        }

        element
            .find('.fc-title')
            .append('<br />' + renderEventApprovedMeployees(event) + '/' + event.extendedProps.ployees_needed + ' ' + $translate.instant('MY_PLOYS__CALENDAR__CHOSEN_LABEL'));

        if (element.hasClass('fc-time-grid-event') && !!renderEventEnagementMeployees(event).length) { // if agenda/week view is selected
            element
                .find('.fc-title')
                .append("<br/> ----" + renderEventEnagementMeployees(event, 30)); // render meployees list inside event
            element
                .attr({ // render meployees list into tooltip
                    'uib-tooltip-html': "\'<p>" + renderEventEnagementMeployees(event, 10) + "</p>\'",
                    'uib-tooltip-append-to-body': true, 'tooltip-placement': 'left'
                });
        }
        $compile(element)($scope);
    };

    $scope.allowDownloadPdf = () => {
        return $scope.currentCalendarView === 'agendaWeek' || $scope.currentCalendarView === 'agendaDay'
    };

    let renderViewEngagementsStats = (start, end) => {
        Engagement.downloadEngagementsSummaryStats(start, end).$promise.then(stats => {
            const calendarHeaderElement = $(".my-ploys-calendar").find('.fc-toolbar');
            if (calendarHeaderElement.find('#engagementsStats')) {
                calendarHeaderElement.find('#engagementsStats').remove();
            }
            calendarHeaderElement.append(
                `<div id="engagementsStats" class="fc-toolbar-stats">
                    <span uib-tooltip="${$translate.instant('MY_PLOYS__CALENDAR__SUMMARY_HOURS_HINT')}">
                        ${$translate.instant('MY_PLOYS__CALENDAR__SUMMARY_HOURS_LABEL')}: 
                        ${$filter('number')(stats.hours || 0, '2')} &nbsp;
                    </span>
                    <span uib-tooltip="${$translate.instant('MY_PLOYS__CALENDAR__SUMMARY_EMPLOYER_COST_HINT')}">
                        ${$translate.instant('MY_PLOYS__CALENDAR__SUMMARY_EMPLOYER_COST_LABEL')}:
                        ${$filter('number')(stats.employer_cost || 0, '2')} &nbsp;
                    </span>
                    <span uib-tooltip="${$translate.instant('MY_PLOYS__CALENDAR__SUMMARY_AVG_PER_HOUR_HINT')}">
                         ${$translate.instant('MY_PLOYS__CALENDAR__SUMMARY_AVG_PER_HOUR_LABEL')}: 
                         ${$filter('number')(stats.avg_per_hour || 0, '2')}
                    </span>
                </div>`
            );
            $compile(calendarHeaderElement)($scope);
        });
    };

    $scope.myPloysCalendarOptions = {
        locale: LanguageService.getCurrentLanguage(),
        defaultView: 'agendaDay',
        events: (start, end, timezone, callback ) => {
            start = start.add(new Date(start.toDate()).getTimezoneOffset(), 'm');  // add information about local timezone
            end = end.add(new Date(end.toDate()).getTimezoneOffset(), 'm');  // add information about local timezone
            start = start.subtract(1, 'days');  // get ploys from day before in case any of them ends after midnight
            loadCalendarPloys(start.toDate(), end.toDate()).then(() => {
                callback(myPloysCalendarEvents) // load ploys only for specific dates
            });
            // renderViewEngagementsStats(start.toDate(), end.toDate());
        },
        eventRender: (event, element) => addEventAdditionalInfo(event, element),
        height: 700,
        header:{
          left: 'month agendaWeek agendaDay',
          center: 'title',
          right: 'today prev,next'
        },
        viewRender: (view, element) => {
            $scope.startDay = view.start.add(new Date(view.start.toDate()).getTimezoneOffset(), 'm').toDate();
            $scope.endDay = view.end.add(new Date(view.end.toDate()).getTimezoneOffset(), 'm').toDate();
            $scope.currentCalendarView = view.name;
            renderViewEngagementsStats(view.start.toDate(), view.end.toDate());
        },
        eventClick: handleEventClick,
        firstDay: 1,
        timeFormat: 'H:mm',
        displayEventTime: true,
        views: {
            agenda: {
                columnHeader: false,
                slotDuration: '01:00:00',
                allDaySlot: false,
                slotLabelFormat: 'HH:mm',
            },

        },
    }

    $scope.switchClient = () => {
        User.switchClient(2).then(() => {
           window.location = DEBUG  ? Constants.dashboardEnvUrls.DEV : Constants.dashboardEnvUrls.PROD;
        });
    }



}]);

angular.module('myPloys')
.controller('MyPloysController', ['$scope', 'Ploy', 'Engagement', 'MyPloys',  'User', 'Constants', '$uibModal', 'Company', '$analytics',
    function($scope, Ploy, Engagement, MyPloys, User, Constants, $uibModal, Company, $analytics) {

    // would be great to do not
    if (MyPloys.getCurrentPagePosted() > 0) {
        MyPloys.restartPostedPloys();
    }
    if (MyPloys.getCurrentPageOngoing() > 0) {
        MyPloys.restartEngagementsOngoing();
    }
    if (MyPloys.getCurrentPageCompleted() > 0) {
        MyPloys.restartEngagementsCompleted();
    }

    $scope.listResultsTabs = MyPloys.listResultsTabs;

    $scope.engagementsOngoing = MyPloys.getEngagementsOngoing;
    $scope.engagementsCompleted = MyPloys.getEngagementsCompleted;
    $scope.postedPloys = MyPloys.getPostedPloys;
    $scope.postedPloysNumber = MyPloys.getPostedPloysNumber;
    $scope.setListResultsActiveTab = MyPloys.setListResultsActiveTab;

    $scope.publishedEngagementsOngoing = MyPloys.publishedEngagementsOngoing;
    $scope.publishedEngagementsCompleted = MyPloys.publishedEngagementsCompleted;
    $scope.publishedPostedPloys = MyPloys.publishedPostedPloys;

    User.get().$promise.then((user) => {
        if (user.user_type == Constants.userTypes.MEPLOYEE) {
            MyPloys.setListResultsActiveTab('applications_ongoing');
            MyPloys.publishedEngagementsOngoing();
            MyPloys.publishedEngagementsCompleted();
        } else {
 
            MyPloys.setListResultsActiveTab('posted');
            MyPloys.publishedPostedPloys();
            Company.getMembers().$promise.then(members => {
                $scope.companyMembers = members;
            });
            $analytics.eventTrack('view_item_list', {
                'items':[{
                    'id': 'my-ploys' + new Date().toISOString().slice(0, 19),
                    'location_id': 'DA',
                    'google_business_vertical': 'jobs'
                    }] 
            });
        }
    });

    $scope.pagesOngoing = {
        current : MyPloys.getCurrentPageOngoing,
        disableInfiniteScroll: MyPloys.infiniteScrollDisabledOngoing
    };

    $scope.pagesCompleted = {
        current : MyPloys.getCurrentPageCompleted,
        disableInfiniteScroll: MyPloys.infiniteScrollDisabledCompleted
    };

    $scope.pagesPosted = {
        current : MyPloys.getCurrentPagePosted,
        disableInfiniteScroll: MyPloys.infiniteScrollDisabledPosted
    };

    $scope.listResultTabs = MyPloys.listResultsTabs;

    $scope.userTypes = Constants.userTypes;
    $scope.legalForms = Constants.legalForms;

    $scope.created_by = '';  // initial value for select to show who posts should be shown
    $scope.setPostedBy = (userId) => {
        $scope.created_by = userId;
        MyPloys.setPostedPloysFilterCreatedBy(userId);
    };

    $scope.filterResults = (filters) => {
        MyPloys.filter(filters);
    };

    $scope.getAutocompleteData = MyPloys.getAutocompleteData;

    $scope.viewLayout = MyPloys.viewLayout;

    $scope.autocompleteTags = [];

    Ploy.getMyPloyTags().$promise.then(ployTags => {
        $scope.autocompleteTags = ployTags;
    });

    let filterByTags = (tags) => {
        let preparedTags = tags.map(item => item.title);
        $scope.filterResults({'tags': preparedTags.join(',')});
    };

    $scope.tagSelected = (tag) => {
        if (!tag) return;
        $scope.selectedTags.push(tag);
        $scope.$broadcast('angucomplete-alt:clearInput', 'searchTagsAutocomplete');
        filterByTags($scope.selectedTags);
    };

    $scope.removeTag = (tag) => {
        $scope.selectedTags = $scope.selectedTags.filter(item => item !== tag);
        filterByTags($scope.selectedTags);
    };

    $scope.selectedTags = [];

    $scope.switchClient = () => {
        User.switchClient(2).then(() => {
           window.location = DEBUG  ? Constants.dashboardEnvUrls.DEV : Constants.dashboardEnvUrls.PROD;
        });
    }

}]);

angular.module('myPloys')
    .controller('PloyManagementController', ['$scope', 'Ploy', '$routeParams', 'LightBox', 'Constants',
        '$location', 'Modal', '$translate', 'SupplementResource', 'AlertBanner', '$filter', '$uibModal', '$interval',
        'crumble', '$rootScope',
        function ($scope, Ploy, $routeParams, LightBox, Constants,
                  $location, Modal, $translate, SupplementResource, AlertBanner, $filter, $uibModal, $interval,
                  crumble, $rootScope) {

            $scope.ployStatuses = Constants.PloyStatuses;

            $scope.groupEngagements = function () {
                let groupedEngagements = $scope.ploy.engagements
                    .reduce((obj, eng) => {
                        const employee_id = eng.employee.id;
                        if (!obj.hasOwnProperty(employee_id)) {
                            obj[employee_id] = {};
                        }
                        if (!obj[employee_id].engagements) {
                            obj[employee_id].engagements = [];
                        }
                        obj[employee_id].engagements.push(eng);
                        obj[employee_id].employee = eng.employee || {};
                        return obj;
                    }, {});
                groupedEngagements = Object.keys(groupedEngagements).map((k) => groupedEngagements[k]).map((prop) => {
                    if (prop.engagements.length === 1) {
                        prop = prop.engagements[0];
                        prop.aggregated = false;
                    } else {
                        prop.aggregated = true;
                    }
                    return prop;
                });
                $scope.ploy.engagements = groupedEngagements;
            };

            $scope.collapsed = {};

            $scope.collapse = (employee_id) => {
                $scope.collapsed[employee_id] = !_.get($scope.collapsed, employee_id, true);
            };

            $scope.isCollapsed = (employee_id) => {
                return _.get($scope.collapsed, employee_id, true);
            };

            let prepareEnagagements = () => {
                // Count meployees applied
                $scope.meployeesApplied = Object.keys(_.countBy($scope.ploy.engagements, function (obj) {
                    if (obj && obj.id) {
                        return obj.employee.id
                    }
                    return obj.engagements[0].employee.id
                })).length;

                // Group engagements
                $scope.groupEngagements();
            };

            $scope.loadPloy = () => {
                Ploy.getMyPloy({id: $routeParams.id}).$promise.then(response_ploy => {
                    $scope.ploy = response_ploy;
                    prepareEnagagements();
                });
            };

            $scope.addLoadedEngagements = engagements => {
                engagements.map(new_eng => {
                    if ($scope.ploy.engagements.some(old_eng => { // add only new engagements
                        return old_eng.id == new_eng.id
                    })) return
                    $scope.ploy.engagements.push(new_eng);
                });
                prepareEnagagements();
            };

            $rootScope.$on('workRequirementsCreated', () => {
                $scope.loadPloy();
            });

            $scope.openLightBox = LightBox.open;

            Ploy.getMyPloy({id: $routeParams.id}).$promise.then(response_ploy => {
                crumble.update({ploy: response_ploy});
                $scope.ploy = response_ploy;
                $scope.meployeesApplied = Object.keys(_.countBy($scope.ploy.engagements, function (obj) {
                    return obj.employee.id
                })).length;
                $scope.groupEngagements();
                loadSupplements(response_ploy.id);
                if (response_ploy.engagements_created === false) {
                    requestAboutGeneratedEngagements();
                }
                if (response_ploy.status === Constants.PloyStatuses.PLOY_STATUS_PUBLISHED || response_ploy.status === Constants.PloyStatuses.PLOY_STATUS_ONGOING) {
                    hasStaffObjsWithoutEngs(response_ploy);
                }
            }, err => {
                return $location.path('/my-ploys/' + $routeParams.id + '/details');
            });

            $scope.supplements = {};

            let loadSupplements = (ployId) => {
                SupplementResource.getSupplementsForPloy({ployId: ployId}).$promise.then((supplements) => {
                    $scope.supplements = supplements;
                })
            };

            $scope.publishPloy = ploy => {
                Ploy.publish(ploy).then(() => {
                    $scope.ploy.status = 'PUBLISHED';
                })
            };

            $scope.unPublishPloy = ploy => {
                Ploy.unPublish(ploy).then(() => {
                    $scope.ploy.status = 'UNPUBLISHED';
                })
            };

            $scope.closePloy = ploy => {
                if ($scope.ploy.can_be_cancelled) {
                    return Modal.confirm({
                        title: $filter('translate')('REMOVE'),
                        message: $filter('translate')('ARE_YOU_SURE'),
                        firstButtonLabel: $filter('translate')('CANCEL'),
                        secondButtonLabel: $filter('translate')('REMOVE'),
                        secondButtonColor: 'red',
                        secondButtonFunction: function () {
                            return Ploy.closePloy({ploy: ploy, id: ploy.id}).$promise.then(() => {
                                AlertBanner.publish({
                                    type: 'success',
                                    message: $filter('translate')('PLOY_CLOSED'),
                                    timeCollapse: 4000
                                });
                                $scope.ploy.status = 'CANCELLED';
                                $scope.loadPloy();
                            }, error => {
                                AlertBanner.publish({
                                    type: 'error',
                                    message: $filter('translate')('PLOY_CLOSED__FAILED'),
                                    timeCollapse: 6000
                                });
                            });
                        }
                    });
                } else {
                    AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')('PLOY_CLOSED__FAILED'),
                        timeCollapse: 6000
                    });
                }
            };

            if (_.get($routeParams, 'dates')) {
                Modal.alert({
                    title: $filter('translate')('POST_PLOY__MODAL_MULTIPLOY_CREATED_TITLE'),
                    message: $filter('translate')('POST_PLOY__MODAL_MULTIPLOY_CREATED')
                });
            }

            $scope.makePloyPublic = ploy => {
                Ploy.makePloyPublic(ploy).result.then(() => {
                    $scope.ploy.is_private = false;
                });
            };

            $scope.makePloyForAllStaff = ploy => {
                Ploy.makePloyForAllStaff(ploy).result.then(() => {
                    $scope.ploy.engagements_created = false;
                    requestAboutGeneratedEngagements();
                });
            };

            let hasStaffObjsWithoutEngs = (ploy) => {
                Ploy.hasStaffObjsWithoutEngs({id: ploy.id}).$promise.then(response => {
                    $scope.staffObjsWithoutEngsExists = response.exists;
                });
            };

            $scope.modalConfirmWithPloyeesNeeded = function (data) {
                return $uibModal.open({
                    templateUrl: 'src/modals/html/modals/modal-reopen-ploy.html',
                    controller: 'ModalReopenPloyController',
                    windowClass: 'modal-confirm modal-vertical-centered',
                    resolve: {
                        buttonFunction: function () {
                            return data.buttonFunction || function () {
                            }
                        },
                        ploy: function () {
                            return data.ploy || {}
                        },
                    }
                })
            };

            $scope.reopenPloy = (ploy) => {
                return $scope.modalConfirmWithPloyeesNeeded({
                    buttonFunction: function (ployeesNeeded) {
                        return Ploy.reopen({id: ploy.id, ployeesNeeded: ployeesNeeded}).$promise.then(function () {
                            AlertBanner.publish({
                                type: 'success',
                                message: $filter('translate')('PLOY_MANAGEMENT__REOPEN_SUCCESS_MESSAGE'),
                                timeCollapse: 4000
                            });
                            $scope.ploy.ployees_needed = ployeesNeeded;
                            $scope.loadPloy();
                        });
                    },
                    ploy: ploy,
                });
            };

            $scope.canReopen = () => {
                // ploy can be reopen when is in future and has some declined engagements
                let now = new Date();
                return $scope.ploy && $scope.ploy.when > now && $scope.ploy.engagements.filter(ploy => ploy.state === Constants.engagementStates.ENGAGEMENT_DECLINED).length > 0;
            };

            $scope.editPloy = ployId => {
                if ($scope.ploy.can_be_cancelled) {
                    $location.path('/edit-ploy/' + ployId);
                } else {
                    AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')('PLOY_CANNOT_BE_CHANGED_AFTER_CHOOSE_EMPLOYEE'),
                        timeCollapse: 6000
                    });
                }
            };

            $scope.canSendMassMessageToChosen = () => {
                /**
                 * "Send message to chosen" button is shown when ploy is for few persons (ployees needed) and in state
                 * 'ongoing', 'assigned' or further
                 */
                return $scope.ploy && $scope.ploy.ployees_needed > 1 && [
                    Constants.PloyStatuses.PLOY_STATUS_ASSIGNED,
                    Constants.PloyStatuses.PLOY_STATUS_ONGOING,
                    Constants.PloyStatuses.PLOY_STATUS_COMPLETED,
                    Constants.PloyStatuses.PLOY_STATUS_ENDED
                ].includes($scope.ploy.status);
            };

            let requestAboutGeneratedEngagements = () => {
                /**
                 * Interval function to ask for engagements generated in celery task. Only needed if ploy marked as waiting.
                 */
                let checkIfHasGeneratedEngagements = $interval(() => {
                    Ploy.getMyPloy({id: $routeParams.id}).$promise.then(response_ploy => {
                        $scope.addLoadedEngagements(response_ploy.engagements);
                        if (response_ploy.engagements_created === true) {
                            $scope.ploy.engagements_created = response_ploy.engagements_created;
                            $interval.cancel(checkIfHasGeneratedEngagements);
                            if (response_ploy.status === Constants.PloyStatuses.PLOY_STATUS_PUBLISHED || response_ploy.status === Constants.PloyStatuses.PLOY_STATUS_ONGOING) {
                                hasStaffObjsWithoutEngs(response_ploy);
                            }
                        }
                    });
                }, 1000);
                $scope.$on('$destroy', function () {  // destroy interval on leaving page
                    $interval.cancel(checkIfHasGeneratedEngagements);
                });
            };

            $scope.isGapInEngagements = (engagementSet) => {
                return engagementSet.engagements.some(eng => {
                    return Constants.engagementStatesAbsentOrSick.includes(eng.state)
                })
            };

            $scope.isEngCancelledOrAbsent = (engagement) => {
                return Constants.engagementStatesAbsentOrSick.includes(engagement.state)
            };

            $scope.goToFindReplacementPage = (engagement) => {
                return $location.path('/my-ploys/' + engagement.id + '/find-replacement');
            };

            $scope.goToConversationPage = (engagement) => {
                if (!$location.path().includes('find-replacement')) {
                    return $location.path('/my-ploys/' + engagement.id + '/conversation');
                }
            };

            $scope.goToPostedPloy = (ployId) => {
                return $location.path('/my-ploys/' + ployId )
            };

            $scope.isEngInFuture = (engagement) => {
                return moment(engagement.checkin_time).isSameOrAfter(moment())
            }

        }]);

angular.module('myPloys')
.controller('TodayShiftsController', ['$scope', 'EngagementShiftService', 'Constants', '$interval', 'Ploy',
    function($scope, EngagementShiftService, Constants, $interval, Ploy) {

    EngagementShiftService.getTodayPloyShifts().$promise.then(response => {
        if (!response.length) $scope.noResults = true;
        $scope.shiftsDatePeriods = groupEngagementsToDatePeriods(response);
    });

    $scope.displayWorkTime = (engagement) => {
        let workTimeDuration = EngagementShiftService.calculateWorkTimeDuration(engagement);
        return EngagementShiftService.createWorkTimeString(workTimeDuration);
    };

    let groupEngagementsToDatePeriods = engagements => {
        let engSorted = {};
        engagements.forEach(eng => {
            if (!engSorted[eng.should_start_datetime + eng.should_end_datetime]) {
                engSorted[eng.should_start_datetime + eng.should_end_datetime] = {};
                engSorted[eng.should_start_datetime + eng.should_end_datetime].start_time = eng.checkin_time;
                const hours = Ploy.transformTimeToInteger(eng.ploy.hours).hours;
                const minutes = Ploy.transformTimeToInteger(eng.ploy.hours).minutes;
                engSorted[eng.should_start_datetime + eng.should_end_datetime].end_time = moment(eng.checkin_time).add(hours, 'hours').add(minutes, 'minutes').toDate();
                engSorted[eng.should_start_datetime + eng.should_end_datetime].start_in_previous_day = eng.start_in_previous_day;
                engSorted[eng.should_start_datetime + eng.should_end_datetime].engs = [];
            }
            engSorted[eng.should_start_datetime + eng.should_end_datetime].engs.push(eng);
        });
        return engSorted;
    };

    $scope.engStates = Constants.engagementStates;

    let interval = $interval(() => {
        EngagementShiftService.getTodayPloyShifts().$promise.then(response => {
            $scope.shiftsDatePeriods = groupEngagementsToDatePeriods(response);
        });
    }, 10000);
    $scope.$on('$destroy', function () {  // destroy interval on leaving page
        $interval.cancel(interval);
    });

    $scope.stateOrdering = function(v1, v2) {  // right now not used, check TODO in html file
        return v1.checked_in ? 1 : -1
    };

}]);

angular
    .module('myPloys')
    .directive('cardsListElementEngagement', [ 'User', 'Constants', '$translate', '$filter', function(User, Constants, $translate, $filter) {
        return {
            scope: {
                engagement : '=',
            },
            link: (scope, element, attrs) => {
                scope.displayEngDate = (eng) => {
                    if (!eng) { return '' }
                    if (!eng.ploy.one_day_job && Constants.engagementStatesNotApproved.indexOf(eng.state) !== -1) {
                        return $translate.instant('MY_PLOYS__START_DAY') + ' ' + $filter('date')(eng.ploy.start_day, 'dd-MM-yyyy') +  ' ' +
                            $translate.instant('MY_PLOYS__END_DAY') + ' ' + $filter('date')(eng.ploy.end_day, 'dd-MM-yyyy');
                    }
                    return $filter('date')(eng.checkin_time, 'dd-MM-yyyy HH:mm');
                };

                /**
                 * Checks if engagement is outdated and requires some action.
                 * Should be actually visible only in Ongoing engagements list for workers
                 * @param eng
                 * @returns {boolean}
                 */
                scope.isEngagementOutdated = (eng) => {
                    return new Date(eng.checkout_time) < new Date() &&
                        eng.state == Constants.engagementStates.EMPLOYER_CHOSE_EMPLOYEE;
                };
            },
            template: `
                <a ng-href="/my-ploys/{{ engagement.id }}/conversation">
                    <div class="cards-list-element">
                        <div class="cards-list-element-avatar">
                            <img ng-src="{{ engagement.ploy.created_by.avatar_url }}" class="cards-list-element-avatar-image">
                        </div>
                        <div class="cards-list-element-content">
                            <div class="cards-list-element-title">
                                <img ng-src="{{ engagement.ploy.category.icon }}" class="cards-list-element-category"/>
                                {{ engagement.ploy.category | categoryName }}
                                | {{ 'CARDS_LIST_ELEMENT__SALARY_AMOUNT_PER_HOUR' | translate : { amount : engagement.ploy.price_employee.toFixed(2) } }}
                            </div>
                            <show-engagement-status engagement="engagement"></show-engagement-status>
                            <div class="cards-list-element-description">{{ engagement.ploy.description | words: 8 }}</div>
                            <div class="cards-list-element-details">
                                <span ng-class="{'alert-error__inline': isEngagementOutdated(engagement)}">
                                    <i class="fa fa-calendar-o"></i>&nbsp;{{ displayEngDate(engagement) }}
                                    <i class="fa fa-exclamation-circle" ng-if="isEngagementOutdated(engagement)" tooltip-placement="auto top"
                                        uib-tooltip="{{ 'CARDS_LIST_ELEMENT_ENG__OUTDATED_REQUIRES_ATTENTION__TOOLTIP' | translate }}"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </a>
            `
        }
    }]);

angular
    .module('myPloys')
    .directive('cardsListElementPloy', [ 'User', function (User) {
        return {
            scope: {
                ploy : '=',
            },
            template: `
                <a ng-href="/my-ploys/{{ ploy.id }}">
                    <div class="cards-list-element">
                        <div class="cards-list-element-avatar">
                            <img ng-src="{{ ploy.category.icon }}" class="cards-list-element-avatar-image">
                            <show-ploy-status ploy="ploy"></show-ploy-status>
                        </div>
                        <div class="cards-list-element-content">
                            <div class="cards-list-element-title">
                                {{ ploy.category | categoryName }} | 
                                {{ "MY_PLOYS__SALARY" | translate }}: 
                                {{ ploy.price_employee | number : 2}}  {{ "MY_PLOYS__SALARY_UNIT" | translate }} 
                            </div>
                            <div ng-class="{ 'list-status-gray' : ploy.engagements == 0, 'list-status-green' : ploy.engagements > 0 }">
                                <ng-pluralize count="ploy.engagements"
                                              when="{'0': '0 {{ &quot;MEPLOYEES_APPLIED&quot; | translate }}',
                                                    'one': '1 {{ &quot;MEPLOYEE_APPLIED&quot; | translate | lowercase }}',
                                                    'other': '{} {{ &quot;MEPLOYEES_APPLIED&quot; | translate | lowercase }}'}">
                                </ng-pluralize>
                            </div>
                            <div class="list-status-gray">
                                <ng-pluralize count="ploy.ployees_needed"
                                              when="{'0': '0 {{ &quot;MEPLOYEE_NEEDED&quot; | translate }}',
                                                    'one': '1 {{ &quot;MEPLOYEE_NEEDED&quot; | translate | lowercase }}',
                                                    'other': '{} {{ &quot;MEPLOYEES_NEEDED&quot; | translate | lowercase }}'}">
                                </ng-pluralize>
                            </div>
                            <div class="cards-list-element-description">{{ ploy.description | words: 16 }}</div>
                            <div class="cards-list-element-description" ng-show="ploy.created_by.id !== user.id">
                                {{ 'MY_PLOYS__POSTED_BY' | translate }} <strong>{{ploy.created_by.full_name}}</strong>
                            </div>

                            <div class="cards-list-element-details">
                                <span class="when-element">ID: {{ploy.id}}</span>
                                &nbsp;&nbsp;&nbsp;
                                <i class="fa fa-calendar-o"></i>
                                <span ng-if="ploy.one_day_job" class="when-element">{{ ploy.start_day | date: 'dd-MM-yyyy' }}</span>
                                <span ng-if="!ploy.one_day_job" class="when-element">{{ ploy.start_day | date: 'dd-MM-yyyy' }} - </span>
                                <span ng-if="!ploy.one_day_job" class="when-element"> {{ ploy.end_day | date: 'dd-MM-yyyy' }}</span>
                                &nbsp;&nbsp;&nbsp;
                                <span class="when-element"><i class="fa fa-clock-o"></i> {{ ploy.start_time | date: 'HH:mm' }} - {{ ploy.end_time | date: 'HH:mm' }}</span>
                                
                                <span ng-if="ploy.tag.length">
                                    &nbsp;&nbsp;&nbsp;
                                    <i class="fa fa-tags" aria-hidden="true"></i>
                                    <span ng-repeat="tag in ploy.tag" class="ploy-tag">{{ tag.name }} </span>
                                </span>
                                
                            </div>
                        </div>
                    </div>
                </a>
            `,
            link: function (scope) {
                User.get().$promise.then((user) => {
                    scope.user = user;
                });
            }
        }
    }]);

angular.module('myPloys')

.factory('MatchMeResource', ['$resource', function($resource) {
    return  $resource('/api/match/:id/get/', {id: '@id'},{
        get: {
            method: 'GET',
            url: '/api/match/:id/get/',
            isArray: true
        },
        scout: {
            method: 'GET',
            url: '/api/scout/',
            isArray: true
        },
        declineUser: {
            method: 'POST',
            url: '/api/declined-user/',
        },
        declinedUsersList: {
            method: 'GET',
            url: '/api/declined-user/',
            isArray: true
        },
        deleteUserFromDeclined: {
            method: 'POST',
            url: '/api/declined-user/:id/delete/',
        },
        alvaLog: {
            method: 'POST',
            url: '/api/alva-log/',
        },
    });
 }]);

angular.module('myPloys')

.service('MyArchive', ['Engagement', 'Ploy', function (Engagement, Ploy){
    const PAGE_SIZE = 10;

    let MyArchiveService = {};

    let engagements = [];
    let ploys = [];

    // Infinite scroll helpers
    let currentPagePloys = 0;
    let pendingPloys = false;
    let disableInfiniteScrollPloys = false;

    let currentPageEng = 0;
    let pendingEng = false;
    let disableInfiniteScrollEng = false;


    // Getter functions
    MyArchiveService.getPloys = () => ploys;
    MyArchiveService.getEngagements = () => engagements;
    MyArchiveService.getCurrentPagePloys = () => currentPagePloys;
    MyArchiveService.getCurrentPageEng = () => currentPageEng;

    MyArchiveService.infiniteScrollDisabledPloys = () => {
        return disableInfiniteScrollPloys;
    };

    MyArchiveService.infiniteScrollDisabledEng = () => {
        return disableInfiniteScrollEng;
    };

    MyArchiveService.resetPagination = () => {
        currentPageEng = currentPagePloys = 0
    };

    MyArchiveService.previousPloys = () => {
        if (pendingPloys) {return}
        pendingPloys = true;
        currentPagePloys = currentPagePloys + 1;
        Ploy.previous({'page' : currentPagePloys, 'page_size': PAGE_SIZE}).$promise.then(function (ploysList) {
            ploys = _.uniqBy(ploys.concat(ploysList), 'id');
            pendingPloys = false;
            if (ploys.length == 0) {
                MyArchiveService.listResultsTabs.active = 'applications';
            }
            if (ploysList.length == 0) {
                disableInfiniteScrollPloys = true;
            }
        }, (error) => {
            console.log(error);
            disableInfiniteScrollPloys = true;
            pendingPloys = false;
        });
    };

    MyArchiveService.previousEngagements = () => {
        if (pendingEng) {return}
        pendingEng = true;
        currentPageEng = currentPageEng + 1;
        return Engagement.previousEngagements({'page' : currentPageEng, 'page_size': PAGE_SIZE}).$promise.then(function(engagementsList) {
            engagements = _.uniqBy(engagements.concat(engagementsList), 'id');
            pendingEng = false;
            if (engagements.length == 0) {
                MyArchiveService.listResultsTabs.active = 'posted';
            }
            if (engagementsList.length == 0) {
                disableInfiniteScrollEng = true;
            }
        }, (error) => {
            console.log(error);
            disableInfiniteScrollEng = true;
            pendingEng = false;
        });
    };

    MyArchiveService.listResultsTabs = {
        active: 'posted',
        activate: function (type) {
            MyArchiveService.listResultsTabs.active = type
        }
    };

    return MyArchiveService;

}]);

angular.module('myPloys')
.factory('MatchMe', ['MatchMeResource', '$timeout', '$rootScope', 'AlertBanner', '$filter', 'Constants', 'Engagement', '$q', '$translate', 'MyStaff', '$location',
    function(MatchMeResource, $timeout, $rootScope, AlertBanner, $filter, Constants, Engagement, $q, $translate, MyStaff, $location) {

    var MatchMeTurnedOn = false;

    var MatchMe = {};

    var meployees = [];

    var declinedMeployees = [];

    var declinedMeployeesLoaded = false;

    var approvedMeployees = [];

    var ploy_id;

    var scoutForm = {
        verification_level: 30
    };

    MatchMe.resetMatching = ployId => {
      ploy_id = ployId;
      meployees = [];
      declinedMeployees = [];
      approvedMeployees = [];
    };

    MatchMe.loadMatchMeMeployees = () => {
        return MatchMeResource.get({id: ploy_id}).$promise.then( response_meployees => { // Load available meployees to hire or add to staff
            if (response_meployees.length <=0) {
                meployees = [];
                return
            }
            meployees = _.unionBy(meployees, response_meployees, 'id');
        });
    };

    MatchMe.loadScoutMeployees = () => {
        if( !scoutForm.postal_code) {  // require from user to put data in form => if data not stored in service, redirect to form
            $location.path('/meploy-scout');
        }
        return MatchMeResource.scout(scoutForm).$promise.then( response_meployees => { // Load available meployees to hire or add to staff
            if (response_meployees.length <=0) {
                return;
            }
            meployees = _.unionBy(meployees, response_meployees, 'id');
        });
    };

    MatchMe.loadDeclinedMeployees = () => { // Load declined meployees
        declinedMeployeesLoaded = false;
        MatchMeResource.declinedUsersList().$promise.then(response_declinements => {
            if (response_declinements.length <=0) declinedMeployeesLoaded = true;
            response_declinements.forEach(declinement => {
                declinedMeployeesLoaded = true;
                declinement.meployee.date_declined = declinement.date_declined;
                declinedMeployees.push(declinement.meployee)
            })
        })
    };

    MatchMe.removeUserFromDeclinedMeployees = declinedMeployee => {
        return MatchMeResource.deleteUserFromDeclined({'id': declinedMeployee.id }).$promise.then( () => {
            declinedMeployees = declinedMeployees.filter(meployee => {
                return meployee.id != declinedMeployee.id
            });
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('MEPLOY_SCOUT_DECLINED_USERS__DELETED_FROM_DECLINED_SUCCESS_MESSAGE'),
                timeCollapse: 3000
            });
        });
    };


    MatchMe.getStatus = () => {
      return MatchMeTurnedOn
    };

    MatchMe.toggleMatchMe = () => {
      MatchMeTurnedOn = !MatchMeTurnedOn
    };

    MatchMe.getMeployees = () => {
      return meployees;
    };

    MatchMe.getDeclinedMeployeesListStatus = () => {
        return declinedMeployeesLoaded;
    };

    MatchMe.setPloy = ployId => {
        ploy_id = ployId
    };

    MatchMe.approveMeployeeToPloy = (approvedMeployee, ployId)  => {
        var deffered = $q.defer();

        if (meployees.length == 1) {
            MatchMe.loadMatchMeMeployees();
        }

        Engagement.createPreApprovedForMyPloy({
           'ploy_id' : ployId,
           'employee_id' : approvedMeployee.id
        }).$promise.then((response) => {
            Engagement.preApprove(response.engagement);
            deffered.resolve('created');
            $rootScope.$broadcast('stack-cards-anim', {id: approvedMeployee.id, zoomIn: true});
            $timeout(() => { // timeout needed to run the css animation first
                approvedMeployees.push(meployees.shift());
                MatchMe.loadMatchMeMeployees();
            }, 100);
        }, error => {
            deffered.reject('error');
            AlertBanner.publish({
                type: 'error',
                message: $filter('translate')('SOMETHING_WENT_WRONG_PLEASE_CONTACT_WITH_SUPPORT'),
                timeCollapse: 4000
            })
        });

        return deffered.promise;
    };

    MatchMe.approveMeployeeToStaff = approvedMeployee => {
        var deffered = $q.defer();

        if (meployees.length == 1) {
            MatchMe.loadScoutMeployees()
        }

        MyStaff.addToStaff(approvedMeployee.id).then(function () {
            deffered.resolve('created');
            $rootScope.$broadcast('stack-cards-anim', {id: approvedMeployee.id, zoomIn: true});
            $timeout(() => { // timeout needed to run the css animation first
                approvedMeployees.push(meployees.shift())
            }, 100);
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('PROFILE__ADD_TO_STAFF__SUCCEED', {name: approvedMeployee.first_name}),
                timeCollapse: 5000
            });
        });

        return deffered.promise;
    };

    MatchMe.declineMeployee = (declinedMeployee) => {
        $rootScope.$broadcast('stack-cards-anim', { id: declinedMeployee.id, throwOut: true});
        $timeout(() => { // timeout needed to run the css animation first

            if (meployees.length == 1) {
                MatchMe.loadMatchMeMeployees()
            }

            if (declinedMeployees.some(meployee => meployee.id == declinedMeployee.id)) {
                meployees.shift();
                return
            }

            MatchMeResource.declineUser({'meployee': declinedMeployee.id}).$promise.then( () => {
                declinedMeployees.push(meployees.shift())
            });

        }, 100);
    };

    MatchMe.declineScoutMeployee = (declinedMeployee) => {
        $rootScope.$broadcast('stack-cards-anim', { id: declinedMeployee.id, throwOut: true});
        $timeout(() => { // timeout needed to run the css animation first

            if (declinedMeployees.some(meployee => meployee.id == declinedMeployee.id)) {
                meployees.shift();
                return
            }

            MatchMeResource.declineUser({'meployee': declinedMeployee.id}).$promise.then( () => {
                declinedMeployees.push(meployees.shift());
                if (meployees.length == 0) {
                    MatchMe.loadScoutMeployees();
                }
            });

        }, 100);
    };

    MatchMe.getDeclinedMeployees = () => {
        return declinedMeployees;
    };

    MatchMe.meployeeIsDeclined = meployee => {
      return declinedMeployees.some(declinedMeployee => {
          return meployee.id == declinedMeployee.id
      })
    };

    MatchMe.setScoutForm = (form) => {
        form.category_1 = (form.category_1) ? form.category_1.slug : '';
        form.category_2 = (form.category_2) ? form.category_2.slug : '';
        scoutForm = form;
    };

    MatchMe.getScoutFormData = () => {
        return scoutForm;
    };

    MatchMe.log = (created_by, event, data) => {
        MatchMeResource.alvaLog({'created_by': created_by, 'event': event, 'data': data});
    };

    return MatchMe;
}]);

angular.module('myPloys')

.service('MyPloys', ['Engagement', 'Ploy', function (Engagement, Ploy) {

    const PAGE_SIZE = 10;

    let MyPloysService = {};

    let engagementsOngoing = [];
    let engagementsCompleted = [];
    let postedPloys = [];
    let myPloys = [];
    let postedPloysNumber = null;

    // Infinite scroll helpers
    let currentPageOngoing = 0;
    let pendingOngoing = false;
    let disableInfiniteScrollOngoing = false;

    let currentPageCompleted = 0;
    let pendingCompleted = false;
    let disableInfiniteScrollCompleted = false;

    let currentPagePosted = 0;
    let pendingPosted = false;
    let disableInfiniteScrollPosted = false;

    let currentMyPloys = 0;
    let pendingMyPloys = false;
    let disableInfiniteScrollMyPloys = false;

    let postedPloysFilterCreatedBy = null;
    let filters = {};
    let autocompleteData = [];

    let tagFilters = [];

    // Getters functions
    MyPloysService.getEngagementsOngoing = () => engagementsOngoing;
    MyPloysService.getEngagementsCompleted = () => engagementsCompleted;
    MyPloysService.getPostedPloys = () => postedPloys;
    MyPloysService.getMyPloys = () => myPloys;
    MyPloysService.getPostedPloysNumber = () => postedPloysNumber;
    MyPloysService.getCurrentPageOngoing = () => currentPageOngoing;
    MyPloysService.getCurrentPageCompleted = () => currentPageCompleted;
    MyPloysService.getCurrentPagePosted = () => currentPagePosted;
    MyPloysService.getCurrentMyPloys = () => currentMyPloys;

    // Force reload posted ploys
    MyPloysService.restartEngagementsOngoing = () => {
        engagementsOngoing = [];
        currentPageOngoing = 0;
        pendingOngoing = false;
        disableInfiniteScrollOngoing = false;
    };

    MyPloysService.restartEngagementsCompleted = () => {
        engagementsCompleted = [];
        currentPageCompleted = 0;
        pendingCompleted = false;
        disableInfiniteScrollCompleted = false;
    };

    MyPloysService.restartPostedPloys = () => {
        postedPloys = [];
        postedPloysNumber = null;
        currentPagePosted = 0;
        pendingPosted = false;
        disableInfiniteScrollPosted = false;
    };


    MyPloysService.infiniteScrollDisabledOngoing = () => {
      return disableInfiniteScrollOngoing;
    };

    MyPloysService.infiniteScrollDisabledCompleted = () => {
      return disableInfiniteScrollCompleted;
    };

    MyPloysService.infiniteScrollDisabledPosted = () => {
      return disableInfiniteScrollPosted;
    };

    MyPloysService.infiniteScrollDisabledMyPloys = () => {
      return disableInfiniteScrollMyPloys;
    };

    MyPloysService.publishedEngagementsOngoing = () => {
        if (pendingOngoing || disableInfiniteScrollOngoing) {return}
        pendingOngoing = true;
        currentPageOngoing = currentPageOngoing + 1;
        return Engagement.publishedEngagementsOngoing({'page' : currentPageOngoing, 'page_size': PAGE_SIZE}).$promise.then((engagements) => {
            engagementsOngoing = _.uniqBy(engagementsOngoing.concat(engagements), 'id');
            pendingOngoing = false;
            if (engagementsOngoing.length == 0) {
                MyPloysService.listResultsTabs.active = 'applications_completed';
            }
            if (engagements.length == 0) {
                disableInfiniteScrollOngoing = true;
            }
        }, (error) => {
            disableInfiniteScrollOngoing = true;
            pendingOngoing = false;
            if (currentPageOngoing == 1) {
                MyPloysService.listResultsTabs.active = 'applications_completed';
            }
        });
    };

    MyPloysService.publishedEngagementsCompleted = () => {
        if (pendingCompleted || disableInfiniteScrollCompleted) {return}
        pendingCompleted = true;
        currentPageCompleted = currentPageCompleted + 1;
        return Engagement.publishedEngagementsCompleted({'page' : currentPageCompleted, 'page_size': PAGE_SIZE}).$promise.then((engagements) => {
            engagementsCompleted = _.uniqBy(engagementsCompleted.concat(engagements), 'id');
            pendingCompleted = false;
            if (engagementsCompleted.length == 0) {
                MyPloysService.listResultsTabs.active = 'applications_ongoing';
            }
            if (engagements.length == 0) {
                disableInfiniteScrollCompleted = true;
            }
        }, (error) => {
            disableInfiniteScrollCompleted = true;
            pendingCompleted = false;
            if (currentPageCompleted == 1) {
                MyPloysService.listResultsTabs.active = 'applications_ongoing';
            }
        });
    };

    MyPloysService.publishedPostedPloys = () => {
        if (pendingPosted || disableInfiniteScrollPosted) {return}
        pendingPosted = true;
        currentPagePosted = currentPagePosted + 1;
        return Ploy.published({
            'page' : currentPagePosted,
            'page_size': PAGE_SIZE,
            'created_by': postedPloysFilterCreatedBy,
            'person': filters.person,
            'from': filters.from,
            'to': filters.to,
            'tags': filters.tags,
        }).$promise.then((ploys) => {
            postedPloys = _.uniqBy(postedPloys.concat(ploys), 'id');
            pendingPosted = false;
            if (ploys.length == 0) {
                disableInfiniteScrollPosted = true;
            }
            postedPloysNumber = postedPloys.length;
        }, (error) => {
            disableInfiniteScrollPosted = true;
            pendingPosted = false;
        });
    };

    MyPloysService.loadMyPloys = () => {
        if (pendingMyPloys || disableInfiniteScrollMyPloys) { return }
        pendingMyPloys = true;
        currentMyPloys = currentMyPloys + 1;
        return Ploy.getMyPloys({'page': currentMyPloys, 'page_size': PAGE_SIZE}).$promise.then(ploys => {
            myPloys = _.uniqBy(myPloys.concat(ploys), 'id');
            pendingMyPloys = false;
            if (ploys.length == 0) {
                disableInfiniteScrollMyPloys = true;
            }
        }, error => {
            disableInfiniteScrollMyPloys = true;
            pendingMyPloys = false;
        })
    };

    MyPloysService.listResultsTabs = {
        active: 'posted',
        activate: function (type) {
            MyPloysService.listResultsTabs.active = type
        }
    };

    MyPloysService.setListResultsActiveTab = (tabName) => {
        MyPloysService.listResultsTabs.active = tabName;
    };

    MyPloysService.setPostedPloysFilterCreatedBy = (userId) => {
        postedPloysFilterCreatedBy = userId;
        MyPloysService.restartPostedPloys();
        MyPloysService.publishedPostedPloys();
    };

    // Filter does work only for posted ploys
    MyPloysService.filter = (f) => {
        if (f['tags'] !== undefined) {  // tags and the rest of params is send separably - that's why it this checking
            tagFilters = f['tags'];
        } else {
            filters = f;
        }
        filters['tags'] = tagFilters;
        MyPloysService.restartPostedPloys();
        return MyPloysService.publishedPostedPloys();
    };

    Ploy.getPloyFilterAutocompleteData().$promise.then(data => {
        autocompleteData = data;
    });

    MyPloysService.getFilters = () => filters;

    MyPloysService.getAutocompleteData = () => autocompleteData;

    MyPloysService.viewLayout = {
        list: true,
        switchLayout: () => MyPloysService.viewLayout.list = !MyPloysService.viewLayout.list
    };

    return MyPloysService;



}]);

angular.module('myStaff')
.controller('AddUsersToGroupController', ['$scope', 'StaffGroupsService', '$routeParams', 'User', '$location', 'StaffGroupsResource',
    ($scope, StaffGroupsService, $routeParams, User, $location, StaffGroupsResource) => {

        $scope.singleUserCase = false;
        $scope.staffGroups = StaffGroupsService.getStaffGroups;
        $scope.staffUsers = [];

        let staffUsersIds = $routeParams.staff_users.split(',');
        staffUsersIds.forEach(userId => {
            User.getTargetData({id: userId}).$promise.then(user => {
                $scope.staffUsers.push(user);
                checkSingleUserCase();
            });
        });

        // if one user only - do changes in run and at start mark which groups are marked for this user
        let checkSingleUserCase = () => {
            if (staffUsersIds.length === 1) {
                $scope.singleUserCase = true;
                StaffGroupsService.resetSelectedGroups();
                StaffGroupsResource.get().$promise.then(groups => {
                    groups.forEach(group => {
                        if (group.members.length && group.members.some(el => el.id === $scope.staffUsers[0].id )) {
                            StaffGroupsService.toggleGroupSelect(group.id);
                        }
                    });
                });
            }
        };

        $scope.toggleGroupSelect = (groupId) => {
            if ($scope.singleUserCase) {
                StaffGroupsService.toggleGroupSelectForSingleUser(groupId, $scope.staffUsers[0].staff_id);
            } else {
                StaffGroupsService.toggleGroupSelect(groupId);
            }
        };

        $scope.getGroupBackground = StaffGroupsService.getGroupBackground;

        $scope.searchString = StaffGroupsService.getSearchString();
        $scope.orderBy = StaffGroupsService.getOrderBy();

        $scope.setSearchString = StaffGroupsService.setSearchString;
        $scope.setOrder = StaffGroupsService.setOrderBy;

        $scope.getSelectedGroups = StaffGroupsService.getSelectedGroups;

        $scope.isGroupChecked = (groupId) => {
            return $scope.getSelectedGroups().indexOf(groupId) > -1;
        };

        $scope.addUsersToGroup = () => {
            if ($scope.singleUserCase) {
                $location.path('/my-staff');
            }
            $scope.getSelectedGroups().forEach(groupId => {
                let data = {
                    id: groupId,
                    members: $scope.staffUsers.map(su => su.staff_id),
                };
                StaffGroupsService.addMembers(data);
            });
            StaffGroupsService.resetSelectedGroups();
            $location.path('/my-staff');
        };

}]);

angular.module('myStaff')
.controller('DeletedStaffController', ['$scope', 'MyStaff', 'AlertBanner', '$filter',
    function ($scope, MyStaff, AlertBanner, $filter) {

    $scope.deletedStaff = [];
    $scope.inStaffUsers = {};

    MyStaff.getDeleted().$promise.then(deletedStaffItems => {
        $scope.deletedStaff = deletedStaffItems;
    })

    $scope.addToStaff = (meployee) => {
        MyStaff.addToStaff(meployee.id).then(() => {
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('PROFILE__ADD_TO_STAFF__SUCCEED', {name: meployee.first_name}),
                timeCollapse: 2000
            });
            $scope.inStaffUsers[meployee.id] = true;
            MyStaff.actionsAfterAddToRemoveFromStaff(false);
        });
    };

    $scope.getRemovedDate = date => {
        return moment(date).fromNow()
    }

}]);

angular.module('myStaff')
.controller('EditStaffController', ['$scope', '$filter', 'Category', '$routeParams', '$location', 'MyStaff',
    'AlertBanner', 'Modal', 'crumble', 'StaffGroupsResource', 'StaffGroupsService', 'Constants',
    function ($scope, $filter, Category, $routeParams, $location, MyStaff,
              AlertBanner, Modal, crumble, StaffGroupsResource, StaffGroupsService, Constants) {

    $scope.staffSalaryRules = [];

    MyStaff.getSingleStaffObject($routeParams.id).$promise.then(staffObj => {
        $scope.staffObj = angular.copy(staffObj);
        $scope.form = angular.copy(staffObj);
        if ($scope.form.extrasalaryinfo) {
            $scope.extraSalaryInfoForm = $scope.form.extrasalaryinfo
        } else {
            $scope.extraSalaryInfoForm = {pension: false}
        }
        crumble.update({username: staffObj.meployee.first_name + ' ' + staffObj.meployee.last_name});
    }, () => {
        return $location.path('/my-staff');
    });

    $scope.deleteUserFromMyStaff = user => {
        MyStaff.removeUserFromStaffPrompt(user, '/my-staff');
    };

    $scope.staffAvailabilityLevels = Constants.staffAvailabilityLevels;

    $scope.snoozeMeployee = (value, id) => {
        let temp = {id: id, snooze: value};
        MyStaff.updateStaffObject(temp);
    };

    $scope.trustedChange = (value, id) => {
        let temp = {id: id, trusted: value};
        MyStaff.updateStaffObject(temp);
    };

    $scope.saveRate = form => {
        let tempForm = angular.copy(form);
        tempForm.id = form.meployee.id;
        delete tempForm.meployee;
        delete tempForm.extrasalaryinfo;
        MyStaff.updateStaffObject(tempForm);
    };

    $scope.saveExtraSalary = form => {
        let tempForm = {
            id: $scope.staffObj.meployee.id,
            extrasalaryinfo: form
        };
        MyStaff.updateStaffObject(tempForm);
    };

    MyStaff.querySalary($routeParams.id).$promise.then(salaryRules => {
       salaryRules.forEach(salaryRule => $scope.staffSalaryRules.push(salaryRule));
    });

    $scope.addStaffSalaryRule = staffSalaryRule => {
        staffSalaryRule.staff = $routeParams.id;
        MyStaff.setSalary(staffSalaryRule).$promise.then(salarySettingsRule => {
            $scope.staffSalaryRules.push(salarySettingsRule);
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('SAVED') + '!',
                timeCollapse: 4000
            });
        }, err => {
            AlertBanner.publish({
                type: 'error',
                message: $filter('translate')('COMMUNICATION__SERVER_ERROR'),
                timeCollapse: 3000,
            });
        });
    };

    $scope.removeStaffSalaryRule = staffSalaryRule => {
        let removeRule = () => {
            MyStaff.deleteSalary(staffSalaryRule.id).$promise.then(() => {
                AlertBanner.publish({
                    type: 'success',
                    message: $filter('translate')('SAVED') + '!',
                    timeCollapse: 4000
                });
                $scope.staffSalaryRules = $scope.staffSalaryRules.filter(rule => rule.id !== staffSalaryRule.id);
            });
        };
        return Modal.confirm({
            title: $filter('translate')('REMOVE'),
            message: $filter('translate')('ARE_YOU_SURE'),
            secondButtonLabel: $filter('translate')('NO_THANKS'),
            firstButtonLabel: $filter('translate')('YES'),
            firstButtonColor: 'green',
            firstButtonFunction: removeRule,
        });
    };

    $scope.removeUserFromGroup = (groupID, staffObjID) =>{
         StaffGroupsResource.removeMembers({id: groupID, members: [staffObjID]}).$promise.then(() => {
             $scope.staffObj.groups = $scope.staffObj.groups.filter(group => group.id !== groupID);
             StaffGroupsService.loadStaffGroups({}); // <-- reload members thumbnails in staff group list
         });
    }

}]);

angular.module('myStaff')
    .controller('MyStaffController', ['$scope', 'Ploy', '$filter', 'Category', '$translate', '$location', 'MyStaff', '$routeParams', 'AlertBanner', 'User', '$uibModal', 'StaffGroupsService', 'Constants',
        function ($scope, Ploy, $filter, Category, $translate, $location, MyStaff, $routeParams, AlertBanner, User, $uibModal, StaffGroupsService, Constants) {

            $scope.form = MyStaff.getFilters();

            $scope.form.categories = MyStaff.getCategories;

            $scope.allCategories = Category.getAll();

            $scope.staff = MyStaff.getStaff;

            $scope.findStaff = MyStaff.findStaff;

            $scope.newSearching = MyStaff.newSearching;

            $scope.noResults = MyStaff.getResultsState;

            $scope.filters = MyStaff.getFilters;

            $scope.categories = MyStaff.getCategories;

            $scope.orderBy = MyStaff.getOrderBy();

            $scope.addCompletedPloysFilter = MyStaff.addCompletedPloysFilter;

            $scope.addAddressFilter = MyStaff.addAddressFilter;

            $scope.addCategoryFilter = MyStaff.addCategoryFilter;

            $scope.addSearchStringFilter = MyStaff.addSearchStringFilter;

            $scope.addAvailabilityFilter = MyStaff.addAvailabilityFilter;

            $scope.setOrder = MyStaff.setOrder;

            $scope.listResultTabs = MyStaff.listResultsTabs;

            $scope.selectedToHire = MyStaff.getSelectedToHire;

            $scope.selectToHire = MyStaff.selectToHire;

            $scope.resetSelectedToHire = MyStaff.resetSelectedToHire;

            $scope.noOneToHire = MyStaff.noOneToHire;

            $scope.hasAnyStaff = true;

            $scope.resultsView = MyStaff.resultsView;

            $scope.getStaffCount = MyStaff.getStaffCount;

            $scope.staffAvailabilityLevels = Constants.staffAvailabilityLevels;

            User.hasAnyStaff().$promise.then(function (response) {
                $scope.hasAnyStaff = response.has_staff;
            });

            $scope.hire = {}; // used as ng-model in hire checkboxes for both views

            $scope.hireSelected = function () {
                $location.path('/post-ploy/for/' + $scope.selectedToHire())
            };

            $scope.addToGroup = () => {
                StaffGroupsService.resetSelectedGroups();
                $location.path('/my-staff/add-users-to-group/' + $scope.selectedToHire());
            };

            $scope.exportSelected = function () {
                $location.path('/my-staff/export/' + $scope.selectedToHire());
            };

            if ($routeParams.hire) {
                AlertBanner.publish({
                    type: 'info',
                    message: $filter('translate')('MY_STAFF__HIRE_INSTRUCTIONS'),
                    timeCollapse: 5000
                });
            }

            $scope.mainSearch = function () {
                MyStaff.newSearching();
                if ($scope.mobileBreakpoint()) {
                    $scope.filtersCollapsed = true;
                }
            };

            $scope.disableInfiniteScroll = MyStaff.infiniteScrollDisabled;

            $scope.filtersCollapsed = $scope.mobileBreakpoint();

            $scope.resetFilters = function () {
                $scope.form = {};
                MyStaff.resetFilters();
            };

            $scope.resetSelectedToHire();

            $scope.staffGroups = StaffGroupsService.getStaffGroups;
            $scope.goToStaffGroups = () => {
                $location.path('/my-staff/groups');
            };

            $scope.openFullCalendar = function (staffObj) {
                $uibModal.open({
                    templateUrl: 'src/modals/html/modal-calendar.html',
                    controller: 'ModalCalendarController',
                    windowClass: 'modal-calendar',
                    backdrop: 'static',
                    resolve: {
                        staffObject: function () {
                            return staffObj
                        }
                    }
                });
            };

            $scope.openInviteTempModal = () => {
                $uibModal.open({
                    templateUrl: 'src/modals/html/modal-invite-staff.html',
                    controller: 'InviteStaffModalController',
                    backdrop: 'static',
                    windowClass: 'modal-confirm modal-vertical-centered',
                });
            };

            $scope.goToStaffArchive = () => {
                $location.path('/my-staff/deleted-staff');
            };

            $scope.setVerticalOffset(MyStaff.initialVerticalOffset, () => {MyStaff.initialVerticalOffset = 0});

        }]);

angular.module('myStaff')
.controller('StaffGroupsController', ['$scope', '$location', 'StaffGroupsService', 'MyStaff', 'Constants', 'User',
    ($scope, $location, StaffGroupsService, MyStaff, Constants, User) => {

        $scope.goToAddGroup = () => {
            $location.path('/my-staff/groups/add');
        };

        $scope.goToMyStaff = () => {
            $location.path('/my-staff');
        };

        $scope.staffGroups = StaffGroupsService.getStaffGroups;
        $scope.toggleGroupSelect = StaffGroupsService.toggleGroupSelect;
        $scope.getSelectedGroups = StaffGroupsService.getSelectedGroups;

        $scope.removeSelectedGroups = StaffGroupsService.removeSelectedGroups;

        $scope.noOneToHire = () => $scope.getSelectedGroups().length;

        $scope.isGroupChecked = (groupId) => {
            return $scope.getSelectedGroups().some(_grId => _grId === groupId);
        };

        $scope.hireSelected = () => {
            $location.path('/post-ploy/group/' + $scope.getSelectedGroups().join());
        };

        $scope.editGroup = (groupId) => {
            $location.path('/my-staff/groups/edit/' + groupId);
        };

        $scope.getThumbnailPosition = index => {
            let pixels = index*12;
            return pixels.toString() + 'px';
        };


        $scope.getGroupBackground = StaffGroupsService.getGroupBackground;


        $scope.modifyNote = StaffGroupsService.modifyNote;

        $scope.getStaffCount = MyStaff.getStaffCount;

        $scope.searchString = StaffGroupsService.getSearchString();
        $scope.orderBy = StaffGroupsService.getOrderBy();

        $scope.setSearchString = StaffGroupsService.setSearchString;
        $scope.setOrder = StaffGroupsService.setOrderBy;
        $scope.resetFilters = () => {
           StaffGroupsService.resetFilters().then(() => {
               $scope.searchString = '';
               $scope.orderBy = '-id'
           });
        };

        $scope.noResults = StaffGroupsService.getResultsState;
}]);

angular.module('myStaff')
    .controller('StaffGroupsAddEditController', ['$scope', 'StaffGroupsService', '$location', '$routeParams', 'MyStaff', 'AlertBanner', '$filter',
        ($scope, StaffGroupsService, $location, $routeParams, MyStaff, AlertBanner, $filter) => {

            $scope.selectedStaff = [];

            $scope.colorPickerOptions = {
                size: 50,
                roundCorners: true,
                total: 6,
                customColors: [
                    '#C41A20',
                    '#3C6BD0',
                    '#28B224',
                    '#EB9A2E',
                    '#30c7cb',
                    '#f8f8f8',
                ]
            };

            $scope.isStaffSelectorVisible = false;

            $scope.transformSelectedStaffObjects = (target_meployees) => {
                $scope.selectedStaff = target_meployees.reduce((acc, curr) => {
                    acc.push(curr.id);
                    return acc;
                }, []);
            };

            if ($routeParams.id) {
                StaffGroupsService.getSingle({id: $routeParams.id}).$promise.then(response => {
                    $scope.staffGroup = response;
                    $scope.staffGroup.staffs.map(staffId => {
                        $scope.selectedStaff.push(staffId)
                    });
                    $scope.isStaffSelectorVisible = true; // load selector only when staff is already loaded
                });
            } else {
                $scope.isStaffSelectorVisible = true;
            }

            if ($routeParams.first_members_id) {
                AlertBanner.publish({
                    type: 'info',
                    message: $filter('translate')('STAFF-GROUPS__FIRST_GROUP_INFO'),
                    timeCollapse: 5000
                });
            }

            $scope.uploadGroupImage = (file, groupId) => {
                $scope.staffGroup.color = null;
                StaffGroupsService.uploadGroupImage(file, groupId).then((data) => {
                    $scope.staffGroup.image_url = data.image;
                });
            };

            $scope.saveStaffGroup = (staffGroup) => {
                staffGroup.members = $scope.selectedStaff;
                StaffGroupsService.saveStaffGroup(staffGroup).$promise.then(staffGroup => {
                    StaffGroupsService.loadStaffGroups();
                    $location.path('/my-staff/groups');
                })
            };


            $scope.groupPrimaryOptions = [
                {
                    name: 'STAFF_GROUP__PRIMARY__LABEL',
                    value: true,
                },
                {
                    name: 'STAFF_GROUP__SECONDARY__LABEL',
                    value: false,
                }
            ];

            $scope.removeGroup = () => {
                StaffGroupsService.removeGroup($routeParams.id)
            };

        }]);

angular.module('myStaff')
    .directive('groupsDragndropSelector', [ 'Ploy', 'StaffGroupsService',
        function(Ploy, StaffGroupsService) {
            return {
                 scope: {
                   onUpdatedTargetGroups: '&',
                   selectedGroups: '<'
                 },
                 templateUrl: '/src/my-staff/html/directives/groups-dragndrop-selector.html',
                 controller: function ($scope) {
                     $scope.groupsSelection = {
                         selected: null,
                         lists: {"source": [], "target": []}
                     };
                     $scope.movedFromTargetSelection = (index) => {
                         $scope.groupsSelection.lists.target.splice(index, 1);
                         $scope.onUpdatedTargetGroups({target_groups: $scope.groupsSelection.lists.target})
                     };
                     $scope.movedFromSourceSelection = (index) => {
                         $scope.groupsSelection.lists.source.splice(index, 1);
                         $scope.onUpdatedTargetGroups({target_groups: $scope.groupsSelection.lists.target})
                     };

                     StaffGroupsService.getStaffGroups().forEach(group => {
                         $scope.groupsSelection.lists.source.push(group);
                         if ($scope.selectedGroups) {
                             $scope.selectedGroups.map(selectedGroupId => {
                                 $scope.groupsSelection.lists.source = $scope.groupsSelection.lists.source.filter(groupObj => {
                                     if (groupObj.id == selectedGroupId) {
                                         $scope.groupsSelection.lists.target.push(groupObj);
                                     }
                                     return groupObj.id !== parseInt(selectedGroupId)
                                 });
                             })
                         }
                     });


                 },
            };
        }
    ]);

angular.module('myStaff')
    .directive('salarySetter', ['LanguageService', 'Constants', function(LanguageService, Constants) {
        return {
            scope: {
                'ngModel' : '=', // Array with supplements/rules
                'onRuleAdded': '&', // Fied when supplement/rule is added
                'editable': '<' // False if user shouldn't be able to add new supplements/rules
            },
            restrict: 'E',
            templateUrl: '/src/my-staff/html/directives/salary-setter.html',
            transclude: true,
            link: function ($scope, element, attrs, ctrls) {

                $scope.weekdays = [];

                $scope.setWeekdays = (lang) => {
                    if (lang === "da") {
                        $scope.weekdays = angular.copy(Constants.danishWeekdaysList);

                    }
                    if (lang === "en") {
                        $scope.weekdays = angular.copy(Constants.englishWeekdaysList);
                    }
                };
                $scope.setWeekdays('en');
                $scope.setWeekdays(LanguageService.getCurrentLanguage());

                if (!$scope.weekdays.some(weekday => weekday.value === 31)) {
                    $scope.weekdays.push({name: 'workweek', value: 31, number: -1});
                }
                if (!$scope.weekdays.some(weekday => weekday.value === 127)) {
                    $scope.weekdays.push({name: 'all', value: 127, number: -2});
                }

                $scope.staffSalaryRule = {
                    'end_of_month_day': 23,
                    'weekdays': 127
                };

                $scope.addSalaryRule = (rule) => {
                    rule.weekdays = (rule.weekdays) ? rule.weekdays : 127;
                    $scope.onRuleAdded({'rule': rule});
                    $scope.staffSalaryRule = {
                        'end_of_month_day': 23,
                        'weekdays': 127
                    };
                };
            }
        };
    }]);

angular.module('myStaff')
    .directive('staffDragndropSelector', ['Ploy', 'MyStaff', 'Modal', '$filter',
        function (Ploy, MyStaff, Modal, $filter) {
            return {
                scope: {
                    onUpdatedTargetMeployees: '&', // function fires when drag action is performed. Selected staff array is passed as argument.
                    selectedMeployees: '<', // choose whether you want to pass initial Meployees ID's or Staffs ID's
                    selectedStaff: '<', // choose whether you want to pass initial Meployees ID's or Staffs ID's
                    workAvailabilityParams: '<'
                },
                templateUrl: '/src/my-staff/html/directives/staff-dragndrop-selector.html',
                controller: function ($scope) {
                    $scope.targetNameFiltering = '';
                    $scope.listResultsLimit = 10;
                    $scope.staffSelection = {
                        selected: null,
                        lists: {"staff": [], "target": []}
                    };

                    $scope.movedFromStaffSelection = (staffObj) => {
                        const index = $scope.staffSelection.lists.staff.indexOf(staffObj);
                        $scope.staffSelection.lists.staff.splice(index, 1);
                        $scope.onUpdatedTargetMeployees({target_meployees: $scope.staffSelection.lists.target})
                    };

                    $scope.movedFromTargetSelection = (staffObj) => {
                        const index = $scope.staffSelection.lists.target.indexOf(staffObj);
                        $scope.staffSelection.lists.target.splice(index, 1);
                        $scope.onUpdatedTargetMeployees({target_meployees: $scope.staffSelection.lists.target})
                    };

                    const checkForUnavailableStaff = (staffAvailableForWorkList) => {
                        const nonAvailableMeployees = $scope.staffSelection.lists.target.filter(staffObj => {
                            return !staffAvailableForWorkList.some(staffID => staffID === staffObj.id);
                        });
                        if (nonAvailableMeployees.length > 0) {
                            const names = nonAvailableMeployees.reduce((acc, curr, index) => {
                                return index > 0 ? acc + `, ${curr.meployee.first_name} ${curr.meployee.last_name}` : `${curr.meployee.first_name} ${curr.meployee.last_name}`;
                            }, '');
                            Modal.alert({
                                title: $filter('translate')('WARNING'),
                                message: $filter('translate')('POST_EDIT_PLOY__AUDIENCE_SELECTOR__TAB__SELECTED__UNAVAILABLE_USERS_ALERT') + ` ${names}`,
                                backdrop: false,
                                buttonFunction: function () {
                                    $scope.staffSelection.lists.target = $scope.staffSelection.lists.target.filter(staffObj => {
                                        return staffAvailableForWorkList.some(staffID => staffID === staffObj.id);
                                    });
                                    $scope.onUpdatedTargetMeployees({target_meployees: $scope.staffSelection.lists.target});
                                }
                            })
                        }
                    };

                    let fillLists = () => {
                        if ($scope.selectedMeployees) {
                            $scope.selectedMeployees.map(meployeeId => {
                                $scope.staffSelection.lists.staff = $scope.staffSelection.lists.staff.filter(staffObj => {
                                    meployeeId = parseInt(meployeeId);
                                    if (staffObj.meployee.id === meployeeId && !$scope.staffSelection.lists.target.some(staff => staff.meployee.id === meployeeId)) {
                                        $scope.staffSelection.lists.target.push(staffObj);
                                    }
                                    return staffObj.meployee.id !== meployeeId
                                });
                            })
                        }
                        if ($scope.selectedStaff) {
                            $scope.selectedStaff.map(staffId => {
                                staffId = parseInt(staffId);
                                $scope.staffSelection.lists.staff = $scope.staffSelection.lists.staff.filter(staffObj => {
                                    if (staffObj.id === staffId && !$scope.staffSelection.lists.target.some(staff => staff.id === staffId)) {
                                        $scope.staffSelection.lists.target.push(staffObj);
                                    }
                                    return staffObj.id !== staffId
                                });
                            })
                        }
                    };

                    const loadStaffData = () => {
                        $scope.staffSelection.lists.staff = [];
                        MyStaff.querySimpleList({
                            'page_size': 999,
                            'exclude_snoozed': true
                        }).$promise.then(staffObjects => {
                            if ($scope.workAvailabilityParams) {
                                return MyStaff.getAvailableStaffList($scope.workAvailabilityParams).$promise.then(staffAvailableForWork => {
                                    $scope.staffSelection.lists.staff = staffObjects.results.filter(staff => {
                                        return staffAvailableForWork.some(staffID => staffID === staff.id);
                                    });
                                    fillLists();
                                    checkForUnavailableStaff(staffAvailableForWork);
                                });
                            }
                            $scope.staffSelection.lists.staff = staffObjects.results;
                            fillLists();
                        });
                    };
                    loadStaffData();

                    $scope.$watch('workAvailabilityParams', () => {
                        if ($scope.workAvailabilityParams && $scope.workAvailabilityParams.weekdays !== 0) {
                            loadStaffData();
                        }
                    }, true);


                    $scope.expandListResults = () => {
                        $scope.listResultsLimit = undefined;
                    };

                },
            };
        }
    ]);

angular.module('myStaff')

.factory('MyStaffResource', ['$resource', 'RequestTransform', function($resource, RequestTransform) {
  return  $resource('/api/staff/:id/', {id:'@id'},{
          'query': {
              method:'GET',
              transformResponse: RequestTransform.getPaginatedCountWithCount,
          },
          'update': {
              method:'PATCH'
          },
          'get': {
              method:'GET',
              url: '/api/staff/:id/single_staff_item/'
          },
          'setSalary': {
              method:'POST',
              url: '/api/meployee-salary/'
          },
          'querySalary': {
              method:'GET',
              url: '/api/meployee-salary/',
              isArray: true
          },
          'deleteSalary': {
              method:'DELETE',
              url: '/api/meployee-salary/:id/',
          },
          'querySimpleList': {
            method:'GET',
            url: '/api/staff/company/'
          },
          'getStaffMeployeeIds': {
            method:'GET',
            url: '/api/staff/get_staff_meployee_ids/'
          },
          'getAvailableStaffList': {
            method:'POST',
            url: '/api/staff/get_available_staff_workers_list/',
            isArray: true
          },
          'isInStaff': {
              method:'GET',
              url: '/api/staff/is_in_staff/'
          },
          'isTrustedToModifyTime': {
              method: 'GET',
              url: '/api/staff/is_trust_modify_time_user/',
          },
          'isTrustedToPostPloyByWorker': {
              method: 'GET',
              url: '/api/staff/is_worker_trusted_to_post/',
          },
          'getPercentageInactiveStaffUsers': {
              method:'GET',
              url: '/api/staff/inactive_staff_users/'
          },
          'inviteToStaff': {
              method: 'POST',
              url: '/api/staff/invite_to_staff/',
          },
          'getDeleted': {
              method:'GET',
              url: '/api/staff/get_deleted/',
              isArray: true
          },
      });
 }]);

angular.module('myStaff')

.factory('StaffGroupsResource', ['$resource', 'RequestTransform', function($resource, RequestTransform) {
    return  $resource('/api/staff-group/:id/', {id:'@id'},{
        'query': {
            method: 'GET',
            isArray: true,
            transformResponse: RequestTransform.getPaginatedCount
        },
        'update': {
            method:'PATCH'
        },
        'get': {
            method:'GET',
            isArray: true,
            url: '/api/staff-group/:id/'
        },
        'getSingle': {
            method:'GET',
            url: '/api/staff-group/:id/'
        },
        'removeGroups': {
            method:'PATCH',
            url: '/api/staff-group/remove_groups/',
            isArray: true
        },
        addMembers: {method: 'PATCH', url: '/api/staff-group/:id/add_members/', isArray: true},
        removeMembers: {method: 'PATCH', url: '/api/staff-group/:id/remove_members/', isArray: true}
    });
}]);

angular.module('myStaff')

.service('MyStaff', ['MyStaffResource', 'AlertBanner', '$q', '$filter', 'Modal', 'StaffGroupsService', '$location', '$analytics',
    function (MyStaffResource, AlertBanner, $q, $filter, Modal, StaffGroupsService, $location, $analytics) {

    let MyStaffService = {};

    let filters = {};

    let categories = [];

    let staff = [];

    let staffCount = 0;

    let allStaffCount = 0; // number of all staff irrespective of current filters

    let selectedToHire = [];

    let orderBy = '';

    let availability = '';

    let currentPage = 1;

    let disableInfiniteScroll = false;

    let noResults = false;

    let pending = false;

    let backPath = '/my-staff';

    MyStaffService.resultsView = {
        grid: true,
        setGridView: isGrid => {
            MyStaffService.resultsView.grid = isGrid;
            if (!isGrid) {
                $analytics.eventTrack('MyStaff view changed to list', {category: 'User Interface'});
            }
        },
        isGridView: () => MyStaffService.resultsView.grid,
    };

    MyStaffService.query = MyStaffResource.query;

    MyStaffService.querySimpleList = MyStaffResource.querySimpleList;

    MyStaffService.getStaffCount = () => staffCount;

    MyStaffService.getAllStaffCount = () => allStaffCount;

    MyStaffService.initialVerticalOffset = 0;

     MyStaffService.getAvailableStaffList = (params) => {
        return MyStaffResource.getAvailableStaffList(params);
    };

    MyStaffService.getSingleStaffObject = function(id) {
        return MyStaffResource.get({id: id });
    };

    MyStaffService.removeFromMyStaff = function (id) {
        return MyStaffResource.remove({id: id }).$promise.then(() => {
            return Promise.resolve(allStaffCount -= 1);
        });
    };

    MyStaffService.addToStaff = function (meployee_id) {
        return MyStaffResource.save({'meployee': meployee_id}).$promise.then(() => {
            return Promise.resolve(allStaffCount += 1);
        });
    };

    MyStaffService.actionsAfterAddToRemoveFromStaff = (redirectLocation) => {
        MyStaffService.newSearching();  // to add/remove this user from my staff list
        StaffGroupsService.loadStaffGroups();  // and from my staff groups
        staffCount = staff.length;
        if (redirectLocation) {
            $location.path(redirectLocation);
        }
    };


    MyStaffService.removeUserFromStaffPrompt = function (user, redirectLocation, customMessage) {
        return Modal.confirm({
            title : $filter('translate')('MY_STAFF__REMOVE_FROM_STAFF_MODAL__TITLE'),
            message: $filter('translate')(customMessage) || '',
            firstButtonLabel : $filter('translate')('MY_STAFF__REMOVE_FROM_STAFF_MODAL__BUTTON_CANCEL'),
            secondButtonLabel : $filter('translate')('MY_STAFF__REMOVE_FROM_STAFF_MODAL__BUTTON_DELETE'),
            secondButtonColor : 'red',
            secondButtonFunction : function () {
                return MyStaffResource.remove({id: user.id}).$promise.then(() => {
                    MyStaffService.actionsAfterAddToRemoveFromStaff(redirectLocation);
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('MY_STAFF__REMOVE_FROM_STAFF_MODAL__REMOVE_SUCCEED'),
                        timeCollapse: 4000
                    });
                });
            }
        });
    };

    MyStaffService.updateStaffObject = function(form) {
        return MyStaffResource.update(form).$promise.then((response) => {
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('SAVED') + '!',
                timeCollapse: 4000
            });
            let idx = staff.findIndex(s => s.id === response.id);
            if (idx > -1) {
                staff[idx] = response;
            }
        });
    };


    MyStaffService.setAllStaffCount = () => {
        return MyStaffResource.getStaffMeployeeIds().$promise.then(function (response) {
            allStaffCount = response.meployees.length;
        })
    };
    MyStaffService.setAllStaffCount();

    MyStaffService.findStaff = () => {
        if (pending || disableInfiniteScroll) {
            return
        }
        pending = true;
        return MyStaffResource.query({'city_or_region': filters.address, 'search_string' : filters.searchString,
            'completed_ploys': filters.completed_ploys, 'category': categories, 'availability' : filters.availability, 'ordering': (orderBy) ? orderBy : undefined,
            'page' : currentPage}).$promise.then(function (response) {
            let results = response.results;
            staffCount = response.count;
            currentPage += 1;
            pending = false;
            staff = staff.concat(results);
            if (filters && results.length === 0) {
                noResults = true;
                disableInfiniteScroll = true;
            } else {
                noResults = false
            }
        }, function () {
            disableInfiniteScroll = true;
            pending = false;
        });
    };

    MyStaffService.getStaff = function () {
        return staff;
    };

    MyStaffService.getFilters = function () {
        return filters;
    };

    MyStaffService.getCategories = function () {
        return categories;
    };

    MyStaffService.getResultsState = function () {
        return noResults;
    };

    MyStaffService.getCurrentPage = function () {
        return currentPage;
    };

    MyStaffService.infiniteScrollDisabled = function () {
        return disableInfiniteScroll;
    };

    MyStaffService.selectToHire = function (id) {
        if (selectedToHire.indexOf(id) <= -1) {
          selectedToHire.push(id);
        } else if (selectedToHire.indexOf(id) > -1) {
            MyStaffService.deselectToHire(id);
        }
    };

    MyStaffService.deselectToHire = function (id) {
        index = selectedToHire.indexOf(id);
        return selectedToHire.splice(index, 1);
    };

    MyStaffService.resetSelectedToHire = function () {
       selectedToHire = [];
    };

    MyStaffService.getSelectedToHire = function () {
        return selectedToHire;
    };

    MyStaffService.noOneToHire= function () {
        for (let i in selectedToHire) {
            if (selectedToHire[i]) return false;
        }
        return true;
    };

    MyStaffService.setOrder = function (order) {
        orderBy = order;
        MyStaffService.newSearching();
        MyStaffService.findStaff();
    };

    MyStaffService.getOrderBy = function () {
        return orderBy;
    };

    MyStaffService.addCompletedPloysFilter = function (value) {
        filters.completed_ploys = value
    };

    MyStaffService.addAddressFilter = function (value) {
        filters.address = value
    };

    MyStaffService.addSearchStringFilter = function (value) {
        filters.searchString = value
    };

    MyStaffService.addCategoryFilter = function (category) {
        categories[0] = category;
    };

    MyStaffService.addAvailabilityFilter = function (availabilityLevel) {
        filters.availability = availabilityLevel;
    };

    MyStaffService.newSearching = function () {
        MyStaffService.setAllStaffCount();
        disableInfiniteScroll = false;
        currentPage = 1;
        staff = [];
        return Promise.resolve(MyStaffService.findStaff());
    };

    MyStaffService.resetFilters = function () {
        filters.completed_ploys = 0;
        filters.address = undefined;
        filters.searchString = undefined;
        filters.availability = '';
        orderBy = '';
        categories = [];
        MyStaffService.newSearching();
    };

    MyStaffService.setBackPath = (path) => {
        backPath = path;
    };

    MyStaffService.getBackPath = () => {
        let path = backPath;
        backPath = '/my-staff';
        return path;
    };

    MyStaffService.findStaff();

    MyStaffService.querySalary = (staffId) => {
      return MyStaffResource.querySalary({'staff': staffId});
    };

    MyStaffService.deleteSalary = (id) => {
      return MyStaffResource.deleteSalary({'id': id});
    };


    MyStaffService.setSalary = MyStaffResource.setSalary;

    MyStaffService.getStaffMeployeeIds = MyStaffResource.getStaffMeployeeIds;

    MyStaffService.getPercentageInactiveStaffUsers = MyStaffResource.getPercentageInactiveStaffUsers;

    MyStaffService.isInStaff = companyId => {
        return MyStaffResource.isInStaff({'company_id': companyId});
    };

    MyStaffService.getDeleted = MyStaffResource.getDeleted;

    return MyStaffService;

}]);

angular.module('myStaff')

.service('StaffGroupsService', ['StaffGroupsResource', 'AlertBanner', 'Modal', '$filter', '$location', 'Upload',
    function(StaffGroupsResource, AlertBanner, Modal, $filter, $location, Upload) {

        let StaffGroupsService = {};

        let staffGroups = {};

        let selectedGroups = [];

        let noResults = false;

        let searchString = '';
        let orderBy = '-id';

        StaffGroupsService.getSingle = StaffGroupsResource.getSingle;

        StaffGroupsService.query = StaffGroupsResource.query;

        StaffGroupsService.getGroupBackground = group => {
            return group.image_url ? { 'background-image': 'url('+group.image_url+')' }: { 'background-color' : group.color}
        };

        StaffGroupsService.saveStaffGroup = (data) => {
            if (data.id) {
                return StaffGroupsResource.update(data);
            }
            return StaffGroupsResource.save(data);
        };

        StaffGroupsService.getStaffGroups = () => staffGroups;

        StaffGroupsService.loadStaffGroups = (queryParams) => {
            return StaffGroupsResource.get(queryParams).$promise.then((response) => {
                staffGroups = response;
                response.length <= 0 ? noResults = true : noResults = false;
            });
        };
        StaffGroupsService.loadStaffGroups({});

        StaffGroupsService.addMembers = (data, showAlertBannerInfo) => {
            StaffGroupsResource.addMembers(data).$promise.then((groups) => {
                groups.forEach(group => {
                    let idx = staffGroups.findIndex(g => g.id === group.id);
                    staffGroups[idx] = group;
                });
                if (showAlertBannerInfo) {
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('SAVED'),
                        timeCollapse: 750
                    });
                }
            });
        };

        StaffGroupsService.removeSelectedGroups = () => {
            return Modal.confirm({
                title : $filter('translate')('STAFF_GROUPS__REMOVE_MODAL_TITLE'),
                firstButtonLabel : $filter('translate')('CANCEL'),
                secondButtonLabel : $filter('translate')('REMOVE'),
                secondButtonColor : 'red',
                secondButtonFunction : function () {
                    return StaffGroupsResource.removeGroups(selectedGroups).$promise.then(function () {
                        StaffGroupsService.loadStaffGroups();
                        StaffGroupsService.resetSelectedGroups();
                        AlertBanner.publish({
                            type: 'success',
                            message: $filter('translate')('STAFF_GROUPS__REMOVED_ALERT_BANNER'),
                            timeCollapse: 5000
                        });
                    });
                }
            });
        };

        StaffGroupsService.removeMembers = (data, showAlertBannerInfo) => {
            StaffGroupsResource.removeMembers(data).$promise.then(groups => {
                groups.forEach(group => {
                    let idx = staffGroups.findIndex(g => g.id == group.id);
                    staffGroups[idx] = group;
                });
                if (showAlertBannerInfo) {
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('SAVED'),
                        timeCollapse: 750
                    });
                }
            });
        };

        StaffGroupsService.removeGroup = (id) => {
            return Modal.confirm({
                title : $filter('translate')('STAFF_GROUPS__REMOVE_MODAL_TITLE'),
                firstButtonLabel : $filter('translate')('CANCEL'),
                secondButtonLabel : $filter('translate')('REMOVE'),
                secondButtonColor : 'red',
                secondButtonFunction : function () {
                    return StaffGroupsResource.remove({id: id}).$promise.then(function () {
                        StaffGroupsService.loadStaffGroups();
                        AlertBanner.publish({
                            type: 'success',
                            message: $filter('translate')('STAFF_GROUPS__REMOVED_ALERT_BANNER'),
                            timeCollapse: 5000
                        });
                        $location.path('/my-staff/groups');
                    });
                }
            });
        };

        StaffGroupsService.uploadGroupImage = (files, groupId) => {
        return new Promise((resolve, reject) => {
           if (files && files.length) {
               let file = files[0];
                Upload.upload({
                    url: '/api/staff-group/upload_group_image/',
                    data: {
                        image: file, groupId: groupId
                    },
                }).then(response => {
                    return resolve(response)
                }, err => {
                    return reject(err);
                });
            }
        });
    };

        StaffGroupsService.modifyNote = (groupId, note) => {
            StaffGroupsService.saveStaffGroup({id: groupId, note: note}).$promise.then(() => {
                AlertBanner.publish({
                    type: 'success',
                    message: $filter('translate')('SAVED') + '!',
                    timeCollapse: 4000
                });
            });
        };

        StaffGroupsService.loadWithParams = () => {
            StaffGroupsService.loadStaffGroups({'search_string': searchString, 'ordering': orderBy});
        };

        StaffGroupsService.getSearchString = () => searchString;
        StaffGroupsService.getOrderBy = () => orderBy;
        StaffGroupsService.getResultsState = () => noResults;

        StaffGroupsService.setSearchString = (phrase) => {
            searchString = phrase;
            StaffGroupsService.loadWithParams();
        };

        StaffGroupsService.setOrderBy = (order) => {
            orderBy = order;
            StaffGroupsService.loadWithParams();
        };

        StaffGroupsService.resetFilters = () => {
           searchString = '';
           orderBy = '-id';
           return Promise.resolve(StaffGroupsService.loadWithParams());
        };

        StaffGroupsService.toggleGroupSelect = (groupId) => {
            if (selectedGroups.some(id => id === groupId)) {
                let idx = selectedGroups.indexOf(groupId);
                selectedGroups.splice(idx, 1);
            } else {
                selectedGroups.push(groupId);
            }
        };

        StaffGroupsService.toggleGroupSelectForSingleUser = (groupId, singleUserStaffId) => {

            StaffGroupsService.toggleGroupSelect(groupId);

            let data = {
                id: groupId,
                members: [singleUserStaffId],
            };

            // remember that this is after toggle is done
            let _staffGroup = staffGroups.filter(_groupItem => _groupItem.id === groupId).shift(); //  Select group
            if (_staffGroup.staffs.some(_staffId => _staffId === singleUserStaffId)) {  // Check if selected staff member is in group
                StaffGroupsService.removeMembers(data, false); // Remove staff member from group
            } else {
                StaffGroupsService.addMembers(data, false); // Add staff member to the group
            }
        };

        StaffGroupsService.getSelectedGroups = () => selectedGroups;
        StaffGroupsService.resetSelectedGroups = () => selectedGroups = [];

        return StaffGroupsService;

}]);

angular.module('notifications-dropdown')

.controller('NotificationsDropdownController', ['$scope', 'Notification', '$location', 'Constants', function($scope, Notification, $location, Constants) {

    $scope.infiniteScrollInNotifications = false;

    $scope.goToNotification = function(notificationGroup) {
        const notificationUrl = notificationGroup.items[0].url;
        notificationGroup.items.forEach(notification => {
            if (!notification.date_read) {
                notification.date_read = new Date();
                Notification.update(notification).$promise.then(updated_notification => {
                    notification = updated_notification;
                })
            }
        });
        $location.url(notificationUrl);
    };

    $scope.unreadItemsExists = function (notification) {
        let data = {'date_read' : null};
        if (_.filter(notification.items, data).length > 0) {
            return true
        }
    };

    $scope.unreadNotificationsExists = function (notifications) {
        let data = {'date_read' : null};
        if (_.filter(notifications, data).length > 0) {
            return true
        }
    };

    $scope.goToSingleNotification = function(notification, url) {
            if(!notification.date_read) {
                notification.date_read = new Date();
                notification.$update().then(function() {
                    $scope.get_count = Notification.get_count;
                });
            }
        $location.url(url);
    };

    $scope.page = {
        current: 1,
        finished: false
    };

    $scope.notifications = [];
    $scope.notifications_previous = [];
    $scope.notificationsLoaded = false;
    $scope.notification_messages = Constants.notification_messages;

    $scope.prevGroupsCreatedValue = 0;
    $scope.getMoreNotifications = function (groupsCreated) {
        if (
            groupsCreated < (($scope.page.current - 1) * 8)
            && $scope.page.finished == false
            && groupsCreated != $scope.prevGroupsCreatedValue
        ) {
            $scope.prevGroupsCreatedValue = groupsCreated;
            $scope.getNotifications();
            $scope.page.current -= 1;
        }
    };

    $scope.runInfiniteScroll = function () {
      $scope.infiniteScrollInNotifications = true;
    };

    $scope.getNotifications = function (event) {
        $scope.block = true;
              Notification.current($scope.page.current).$promise.then(function (notifications) {
                $scope.block = false;
                $scope.notificationsLoaded = true;
                $scope.page.current += 1;
                $scope.notifications = $scope.notifications.concat(notifications);
                if (notifications.length == 0) {
                  $scope.page.finished = true;
                }
              },
              function () {
                $scope.page.finished = true;
              });
            };
    $scope.getNotifications();
}])
;

angular.module('notifications-dropdown')

.directive('notificationsDropdown', function() {
  return {
    templateUrl: 'src/notifications-dropdown/html/notifications-dropdown.html',
    restrict: 'E',
    transclude: true
  };

});

angular.module('notifications-dropdown')

.factory('Notification', ['NotificationResource', function (NotificationResource) {
    var notifications = [];
    var notificationFactory = {};

    notificationFactory.get = NotificationResource.get;

    notificationFactory.current = function(page) {
                notifications = NotificationResource.current({'page': page});
                return notifications;
    };

    notificationFactory.query = function() {
        notifications = NotificationResource.query();
        return notifications;
    };

    notificationFactory.update = NotificationResource.update;

    notificationFactory.get_count = function() {
        return _.filter(notifications, function(notification) {
            return !notification.date_read;
        }).length;
    };

    return notificationFactory;
}]);

angular.module('notifications-dropdown')

.factory('NotificationResource', ['$resource' , 'RequestTransform' , function($resource, RequestTransform) {
    return  $resource('/api/notification/:id/', {id:'@id'},{
        update: {method: 'PATCH'},
        'query': {
            method: 'GET',
            isArray: true,
            transformResponse: RequestTransform.getPaginatedCount
        },
        current: {
            method: 'GET',
            isArray: true,
            url: '/api/notification/current/',
            params: {page_size: 8},
            transformResponse: RequestTransform.getPaginatedCount
        },
        getCount: {method: 'POST', url: '/api/notification/get_count/'}
    });
}]);
angular.module('onboarding-bar')

.controller('OnboardingProgressCvController', ['$scope', 'OnboardingBar', 'User', '$location',
    function ($scope, OnboardingBar, User, $location) {

    $scope.countProgressDegrees = OnboardingBar.countProgressDegrees;

    let calculateCvProgress = () => {
        User.getCvProgress().$promise.then((data) => {
            $scope.progress = data.progress;
        });
    }
    calculateCvProgress();

    $scope.goToCvEdition = () => {
        $location.path('/cv/edit');
    }

    $scope.$on('cv-updated', () => {
        calculateCvProgress();
    });

}]);

angular.module('onboarding-bar')

.controller('OnboardingProgressProfileController', ['$scope', 'OnboardingBar', 'User', '$location', 'VerificationRequestResource', 'Modal', '$filter',
    function ($scope, OnboardingBar, User, $location, VerificationRequestResource, Modal, $filter) {

    $scope.countProgressDegrees = OnboardingBar.countProgressDegrees;

    let calculateProfileProgress = () => {
        User.getProfileProgress().$promise.then(data => {
            $scope.progress = data.progress;
            if (data.progress === 100 && !data.verification_request_sent) {
                sendToVerification(data.verification_request_id);
            }
        })
    }
    calculateProfileProgress();

    $scope.goToProfileEdition = () => {
        $location.path('/edit-profile');
    }

    $scope.$on('profile-updated', () => {
        calculateProfileProgress();
    });

    let sendToVerification = (verificationRequestId) => {
        VerificationRequestResource.sendToVerification({'id': verificationRequestId}).$promise.then(() => {
            Modal.alert({
                title: $filter('translate')('EDIT_PRO_PROFILE__SUCCESS_ALERT__TITLE'),
                message: $filter('translate')("EDIT_PRO_PROFILE__SUCCESS_ALERT__CONTENT"),
                buttonColor: 'green',
            });
        });
    }

}]);

angular.module('onboarding-bar')

.service('OnboardingBar', [function() {

    let OnboardingBar = {};

    OnboardingBar.countProgressDegrees = (progress) => {
        let rightProgressDeg = 180;
        let leftProgressDeg = 180;
        // Start calculating left side of the progressbar
        if (progress >= 100) {
            rightProgressDeg = 180;
            leftProgressDeg = 180;
        }
        if (progress >= 90 && progress < 100) {
            rightProgressDeg = 180;
            leftProgressDeg = 180 - (180 / 6);
        }
        if (progress >= 80 && progress < 90) {
            rightProgressDeg = 180;
            leftProgressDeg = 180 - (180 / 6) * 2;
        }
        if (progress >= 70 && progress < 80) {
            rightProgressDeg = 180;
            leftProgressDeg = 180 - (180 / 6) * 3;
        }
        if (progress >= 60 && progress < 70) {
            rightProgressDeg = 180;
            leftProgressDeg = 180 - (180 / 6) * 4;
        }
        if (progress >= 50 && progress < 60) {
            rightProgressDeg = 180;
            leftProgressDeg = 180 - (180 / 6) * 5;
        }
        // Start calculating right side of the progressbar
        if (progress >= 40 && progress < 50) {
            rightProgressDeg = 180 - (180 / 5);
            leftProgressDeg = 0;
        }
        if (progress >= 30 && progress < 40) {
            rightProgressDeg = 180 - (180 / 5) * 2;
            leftProgressDeg = 0;
        }
        if (progress >= 20 && progress < 30) {
            rightProgressDeg = 180 - (180 / 5) * 3;
            leftProgressDeg = 0;
        }
        if (progress >= 10 && progress < 20) {
            rightProgressDeg = 180 - (180 / 5) * 4;
            leftProgressDeg = 0;
        }
        if (progress > 0 && progress < 10) {
            rightProgressDeg = 180 - (180 / 5) * 5;
            leftProgressDeg = 0;
        }
        if (progress <= 0) {
            rightProgressDeg = 0;
            leftProgressDeg = 0;
        }
        return {rightProgressDeg, leftProgressDeg}
    }

    return OnboardingBar;

}])

angular.module('ployByWorker')
.controller('PloyByWorkerController', ['$scope', '$routeParams', 'MyStaffResource', '$location', 'Engagement',
    'CompanyResource', 'PloyByWorkerResource', 'AlertBanner', '$filter', 'crumble',
    function($scope, $routeParams, MyStaffResource, $location, Engagement, CompanyResource, PloyByWorkerResource,
             AlertBanner, $filter, crumble) {

    $scope.ployByWorker = {};
    $scope.requestedByAutocomplete = [];

    $scope.calendarMinDate = new Date();
    $scope.calendarMaxDate = new Date();
    $scope.calendarMaxDate.setDate($scope.calendarMaxDate.getDate() + 1);

    MyStaffResource.isTrustedToPostPloyByWorker({'engagementId': $routeParams.engagementId}).$promise.then(response => {
        if (response.isTrustedToPost) {
            Engagement.get($routeParams.engagementId).$promise.then(engagement => {
                crumble.update({engagement: engagement, ploy: engagement.ploy});
                $scope.ployByWorker.engagement_id = engagement.id;
                // $scope.ployByWorker.start_day = engagement.ploy.start_day
                $scope.clearStartDay();
                $scope.ployByWorker.start_time = engagement.ploy.start_time;
                $scope.ployByWorker.weekdays = countWeekday($scope.ployByWorker.start_day);
                CompanyResource.getCompanyMembersAutocomplete({'companyId': engagement.ploy.company}).$promise.then(companyMembers => {
                    $scope.requestedByAutocomplete = companyMembers;
                });
            });
        } else {
            $location.path('/');
        }
    });

    $scope.startDateChanged = (newStartDate) => {
        $scope.ployByWorker.weekdays = countWeekday(newStartDate);
    };

    $scope.clearStartDay = () => {
        $scope.ployByWorker.start_day = new Date();
        $scope.ployByWorker.start_day.setHours(0);
        $scope.ployByWorker.start_day.setMinutes(0);
        $scope.ployByWorker.start_day.setSeconds(0);
        $scope.ployByWorker.start_day.setMilliseconds(0);
    };

    let countWeekday = (date) => {
        let weekday = date.getDay();
        weekday = ((weekday + 6) % 7);  // return weekdays as numbers (Mon - 0, Sun - 6)
        return Math.pow(2, weekday);
    };

    $scope.createPloyByWorker = (ployByWorker) => {
        try {
            ployByWorker.requested_by_id = $scope.requestedByAutocomplete.find(user => user.full_name === ployByWorker.requested_by).id;
        } catch (e) {
            $scope.ployByWorker.requested_by = '';
            let errorMessage = 'PLOY_BY_WORKER__CHOOSE_REQUESTED_BY_FROM_AUTOCOMPLETE';
            AlertBanner.publish({
                type: 'error',
                message: $filter('translate')(errorMessage),
                timeCollapse: 4000
            });
            return;
        }
        PloyByWorkerResource.save(ployByWorker).$promise.then(engagement => {
            $location.path('/my-ploys/' + engagement.id + '/conversation');
        }, error => {
            let errorMessage = (error.data[0]) ? error.data[0] : 'SOMETHING_WENT_WRONG_PLEASE_CONTACT_WITH_SUPPORT';
            AlertBanner.publish({
                type: 'error',
                message: $filter('translate')(errorMessage),
                timeCollapse: 4000
            });
        });
    };

    $scope.dataIsMissing = () => {
        return !$scope.ployByWorker.requested_by || !$scope.ployByWorker.start_day || !$scope.ployByWorker.start_time;
    };

}]);

angular.module('ployByWorker')

.factory('PloyByWorkerResource', ['$resource', function($resource) {
    return $resource('/api/ploy-by-worker/');
}]);

angular.module('ployTemplate')
.controller('PloyTemplateCreateEditController', ['$scope', 'Category', 'Constants', 'PloyTemplateService', '$location',
    'SalaryRulesResource', 'User', 'AlertBanner', '$filter', '$routeParams', 'PloyTemplateResource',
    'Ploy', 'SalaryGroupService', '$rootScope', 'WorkRequirementResource', '$timeout',
    ($scope, Category, Constants, PloyTemplateService, $location,
     SalaryRulesResource, User, AlertBanner, $filter, $routeParams, PloyTemplateResource,
     Ploy, SalaryGroupService, $rootScope, WorkRequirementResource, $timeout) => {

    $scope.template = {
        supplement: [],
        is_salary_type: false,
        ployees_needed: 1,
        hours: 3,
        paid_pause_time: false,
        start_time: new Date(),
        salary_group: null,
        work_requirement: [],
        max_pause_time: 0,
    };
    $scope.ployeesNeededMaxValue = Constants.ployeesNeededMaxValue;
    $scope.tempHours = 8;
    $scope.tempMinutes = 0;
    $scope.hours = Constants.hours;
    $scope.minutes = Constants.minutes;
    $scope.salaryGroups = SalaryGroupService.getSalaryGroups;
    $scope.postalCodeNotFound = false;
    $scope.advancedOptionsCollapsed = true;
    $scope.showUnpaidPause = false;

    User.get().$promise.then((user) => {
        $scope.minPriceHour = user.profile.price_hour || 120;
        $scope.template.address_annotation = user.company.address_annotation
    });


    /**
     * Set salary setting group for template if creates new template (not edit or built from ploy)
     */
    SalaryRulesResource.hasSalarySettings().$promise.then(data => {
        $scope.hasSalarySettings = data.has_salary_settings;
        if (data.has_salary_settings && !$routeParams.ploy_template_id && !$routeParams.ploy_id) {
            SalaryGroupService.getList().$promise.then(groups => {
                $scope.template.is_salary_type = true;
                $scope.template.salary_group = groups.find(group => group.is_default === true).id;
            });
        }
    });


    /**
     * Case - edit ploy template
     */
    if ($routeParams.ploy_template_id) {
        $scope.edit = true;
        PloyTemplateResource.get({id: $routeParams.ploy_template_id}).$promise.then(
            template => {
                setAdvancedOptionsVisibility(template);
                $scope.template = template;
                $scope.template.is_salary_type = !template.price_hour;
                $scope.tempHours = Ploy.transformTimeToInteger($scope.template.hours).hours;
                $scope.tempMinutes = Ploy.transformTimeToInteger($scope.template.hours).minutes;
                $scope.template.category = findCategory($scope.template.category.slug);
                $scope.template.salary_group = checkSalarySettingsForTemplate(template.salary_group);
            });
    }


    /**
     * Case - create template from existing ploy
     */
    if ($routeParams.ploy_id) {
        Ploy.get({id: $routeParams.ploy_id}).$promise.then(ploy => {
            delete ploy.id;
            setAdvancedOptionsVisibility(ploy);
            $scope.template = angular.extend({}, $scope.template, ploy);
            $scope.disableManualSalaryManipulation = !User.get().can_edit_salary;
            $scope.tempHours = Ploy.transformTimeToInteger($scope.template.hours).hours;
            $scope.tempMinutes = Ploy.transformTimeToInteger($scope.template.hours).minutes;
            $scope.template.category = findCategory($scope.template.category.slug);
            $scope.template.salary_group = checkSalarySettingsForTemplate(ploy.salary_group);
        });
    }

    $scope.calculatePloyHours = (tempHours, tempMinutes) => {
        $scope.template.hours = Ploy.transformTimeToDecimal(tempHours, tempMinutes);
    };

    $scope.allCategories = [];
    Category.getAll().$promise.then(categories => {
        $scope.allCategories = categories;
    });

    $scope.setPaidPauseTimeIfPossible = (value) => {
        $scope.template.paid_pause_time = value;
        $scope.template.max_pause_time = $scope.template.paid_pause_time ? 30 : 0;
        if (!value) { $scope.template.free_pause_time = 0 }
    };

    $scope.lastSetAddress = '';

    $scope.onPlaceChangedCheck = () => {
        if (!$scope.template.postal_code) {
            $scope.postalCodeNotFound = true;
        }
        $timeout(function () {
            if ($scope.lastSetAddress != $scope.template.address) {
                $scope.template.postal_code = '';
                $scope.postalCodeNotFound = true;
            }
        }, 500);
    };

    $scope.onPlaceChanged = place => {
        let result = Ploy.onPlaceChangedHandler(place, $scope.template, $scope.lastSetAddress);
        $scope.template = result.obj;
        $scope.postalCodeNotFound = result.postalCodeNotFound;
        $scope.lastSetAddress = result.lastSetAddress;
        $scope.$apply();
    };

    $scope.useSalarySettingsType = (isSalaryType) => {
        $scope.template.is_salary_type = isSalaryType;
        if (isSalaryType) {
            $scope.template.price_hour = null;
        } else {
            $scope.template.salary_group = null;
        }
    };

    $scope.createTemplate = (template) => {
        PloyTemplateService.savePloyTemplate(template).$promise.then(response => {
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('PLOY_TEMPLATES__EDIT__TEMPLATE_CREATED'),
                timeCollapse: 3000,
            });
            PloyTemplateService.loadPloyTemplates().then(() => {
                $location.path('/ploy-templates')
            });
        }, err => {
            if (err.status == 400) {
                return AlertBanner.publish({
                    type: 'error',
                    message: $filter('translate')(err.data[0]),
                    timeCollapse: 3000,
                });
            }
            AlertBanner.publish({
                type: 'error',
                message: $filter('translate')('COMMUNICATION__SERVER_ERROR'),
                timeCollapse: 3000,
            });
        });
    };

    $scope.showUnpaidPauseForm = () => {
        $scope.showUnpaidPause = true;
    };

    let setAdvancedOptionsVisibility = (obj) => {
        /**
         * Show advanced options if has set work_requirements or tags
         * 'obj' can be a ploy or template instance
         */
        if (obj.work_requirement.length > 0 || obj.tag.length > 0) {
            $scope.advancedOptionsCollapsed = false;
        }
    };

    let findCategory = (categorySlug) => {
        /**
         * Finds category in list of categories fitting to template
         * Use to set category after ploy/ployTemplate is loaded
         */
        return $scope.allCategories.find(category => category.slug === categorySlug);
    };

    let checkSalarySettingsForTemplate = (salaryGroup) => {
        /**
         * Check if given salary group is still available and set it to template if possible
         */
        SalaryRulesResource.hasSalarySettings().$promise.then(data => {
            if (data.has_salary_settings && salaryGroup) {
                $scope.template.salary_group = salaryGroup;
            } else {
                $scope.template.salary_group = undefined;
            }
        });
    };

}]);

angular.module('ployTemplate')
.controller('PloyTemplatesController', ['$scope', '$location', 'PloyTemplateService', 'AlertBanner', '$filter', 'Modal',
    ($scope, $location, PloyTemplateService, AlertBanner, $filter, Modal) => {

    $scope.goToCreateTemplate = () => {
        $location.path('/ploy-template/create');
    };

    $scope.goToSalarySettings = () => {
        $location.path('/salary-rules/base-salary');
    };

    PloyTemplateService.resetSelectedTemplates();

    $scope.selectTemplate = PloyTemplateService.selectTemplate;

    $scope.getSelectedTemplates = PloyTemplateService.getSelectedTemplates;

    $scope.removeSelectedTemplates = () => {
        return Modal.confirm({
            title: $filter('translate')('PLOY_TEMPLATES__REMOVE_MODAL_TITLE'),
            firstButtonLabel: $filter('translate')('CANCEL'),
            secondButtonLabel: $filter('translate')('REMOVE'),
            secondButtonColor: 'red',
            secondButtonFunction: () => {
                return PloyTemplateService.removeSelectedTemplates().$promise.then(() => {
                    PloyTemplateService.loadPloyTemplates().then(() => {
                        PloyTemplateService.resetSelectedTemplates();
                        AlertBanner.publish({
                            type: 'success',
                            message: $filter('translate')('PLOY_TEMPLATES__TEMPLATES_REMOVED_SUCCESS'),
                            timeCollapse: 4000
                        });
                    })
                }, err => {
                    AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')('COMMUNICATION__ERROR_OCCURED'),
                        timeCollapse: 4000
                    });
                });
            },
        });
    };

    $scope.ployTemplates = PloyTemplateService.getPloyTemplates;

    $scope.myPloys = PloyTemplateService.getSavedJobPosting;

    $scope.loadMyPloys = PloyTemplateService.loadSavedJobPosting;
    $scope.loadMyPloys();

}]);

angular.module('ployTemplate')
    .directive('templateSlider', ['PloyTemplateService', function(PloyTemplateService) {
        return {
            scope: {
                'templates' : '<',
                'onTemplateSelect' : '&',
                'selectOnly': '<'
            },
            restrict: 'E',
            templateUrl: '/src/ploy-template/html/template-slider.html',
            transclude: true,
            link: function (scope, element, attrs, ctrls) {

                scope.slickConfig = {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: true,
                    centerPadding: '40px',
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            }
                        },
                    ]
                }
            }
        };
    }]);

angular.module('ployTemplate')

.factory('PloyTemplateResource', ['$resource', ($resource) => {

    return $resource('/api/ploy-template/:id/', {id: '@id'}, {
        get: { method: 'GET'},
        save: { method: 'POST' },
        update: { method: 'PATCH' },
        remove: { method: 'DELETE' },
        removeTemplates: {
              method:'PATCH',
              url: '/api/ploy-template/remove_templates/',
              isArray: true
        },
    });

}]);

angular.module('ployTemplate')

.service('PloyTemplateService', ['PloyTemplateResource', 'Ploy',
    function(PloyTemplateResource, Ploy) {

    let PloyTemplateService = {};

    let ployTemplates = {};

    let selectedTemplates = [];

    let savedJobPostings = {};

    PloyTemplateService.getPloyTemplates = () => ployTemplates;

    PloyTemplateService.resetSelectedTemplates = () => selectedTemplates = [];

    PloyTemplateService.getSelectedTemplates = () => selectedTemplates;

    PloyTemplateService.removeSelectedTemplates = () => {
      return PloyTemplateResource.removeTemplates(selectedTemplates);
    };

    PloyTemplateService.selectTemplate = (templateId) => {
        selectedTemplates = _.xor(selectedTemplates, [templateId]);
    };

    PloyTemplateService.loadPloyTemplates = () => {
        return PloyTemplateResource.query().$promise.then((response) => {
            ployTemplates = response;
        });
    };
    PloyTemplateService.loadPloyTemplates();

    PloyTemplateService.getSingleTemplate = (templateId) => {
        return PloyTemplateResource.get({id: templateId});
    };

    PloyTemplateService.savePloyTemplate = (data) => {
        if (data.id) {
            return PloyTemplateResource.update(data);
        }
        return PloyTemplateResource.save(data);
    };

    PloyTemplateService.reloadPloyTemplates = () => {
        ployTemplates = {};
        PloyTemplateService.loadPloyTemplates();
    };

    PloyTemplateService.getSavedJobPosting = () => savedJobPostings;

    PloyTemplateService.loadSavedJobPosting = () => {
        Ploy.getMyPloys({'page': 1, 'page_size': 9}).$promise.then(ploys => {  // takes only first 9 results
            savedJobPostings = ploys
        }, error => console.log(error));
    };

    return PloyTemplateService;

}]);

angular.module('ploys')

.controller('PublicApplicantsListController', ['$scope', 'Ploy', 'Engagement', 'Constants', '$filter', 'Verification',
    function($scope, Ploy, Engagement, Constants, $filter, Verification) {

    $scope.applicants = [];
    $scope.myEngInThisPloy = {};


    Ploy.getPublicEngagementsList({'id': $scope.ploy.id}).$promise.then(applicants => {
        $scope.applicants = $filter('sortEngagementByState')(applicants);
    });

    let getMyEngagement = () => {
        Ploy.getMyEngagementForPloy({'id': $scope.ploy.id}).$promise.then(eng => {
            $scope.myEngInThisPloy = eng;
        });
    };
    getMyEngagement();



    $scope.engStates = Constants.engagementStates;

    $scope.getTimeDuration = eng => {
        return moment(eng.last_event.created).fromNow()
    };

    $scope.cancelEngagement = (eng) => {
        eng.ploy = $scope.ploy;
        Engagement.cancel(eng).then(() => {
            getMyEngagement();
        });
    };

    $scope.applyToPloy = (eng) => {
        eng.ploy = $scope.ploy;
        Verification.verifyEmployeeProcedure().then(function () {
            Engagement.askForWorkRequirements(eng).then(() => {
                Engagement.applyToPreApproved(eng).then(() => {
                    getMyEngagement();
                });
            });
        });
    };

}]);

angular.module('ploys')

.controller('MapController', ['$scope', '$interval', 'Map', 'uiGmapGoogleMapApi', function($scope, $interval, Map, uiGmapGoogleMapApi) {
    $scope.control = {};

    $scope.refreshMap = function() {
        $scope.control.refresh($scope.map.center);
    };

    $scope.map = Map.map(14);
    if ($scope.ploy) {
        $scope.map.center={latitude: $scope.ploy.lat, longitude: $scope.ploy.lon };

        $scope.marker = {
          id: 0,
          coords: {
            latitude: ($scope.ploy.lat - 0.0031),  // minus 'value' to make transparent market in center
            longitude: $scope.ploy.lon
          },
          options: {
              draggable: false,
              icon: {
                  url: cdn+'/static/img/markers/marker-50-opacity.png'
              }
          }
        };

    }

    $scope.options =  {
        scrollwheel: false,
        zoomControl: false,
        scaleControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        draggable: false,
        autocomplete: true
    };

    var events = {
            places_changed: function (searchBox) {
                place = searchBox.getPlaces()[0];
                if (!place) return;
                angular.extend($scope.ploy,Ploy.parseAddressComponents(place.address_components));
                $scope.map.center={latitude: place.geometry.location.lat(), longitude: place.geometry.location.lng() };
                $scope.map.center_marker = $scope.map.center;
                $scope.ploy.lat = String(place.geometry.location.lat()).slice(0, 8);
                $scope.ploy.lon = String(place.geometry.location.lng()).slice(0, 8);
                $scope.ploy.address = place.formatted_address;
            }
    };
    $scope.searchbox = {template:'searchbox.tpl.html', events:events};
}])

angular.module('ploys')

.controller('PloyPublicController', ['$scope', '$location', 'AlertBanner', '$filter', 'Verification', '$routeParams',
    'Constants', 'Ploy', 'Engagement', '$uibModal', 'User', 'Auth', 'SupplementResource', 'crumble', 'Stat',
    function($scope, $location, AlertBanner, $filter, Verification, $routeParams, Constants, Ploy, Engagement,
             $uibModal, User, Auth, SupplementResource, crumble, Stat) {

    let ployStatuses = Constants.PloyStatuses;
    let legalForms = Constants.legalForms;
    let userTypes = Constants.userTypes;
    $scope.userTypes = userTypes;
    $scope.engagementExist = false;
    $scope.cleanCriminalRecordRequired = false;
    $scope.categoryVerificationIsMissing = false;
    $scope.supplements = [];

    Ploy.getPublicPloy({id:$routeParams.id}).$promise.then(response_ploy => {

        if (response_ploy.status == ployStatuses.PLOY_STATUS_UNPUBLISHED || response_ploy.is_live_ploy) {
            return $location.path('/page-not-found');
        }

        if ( [ployStatuses.PLOY_STATUS_ASSIGNED, ployStatuses.PLOY_STATUS_ENDED, ployStatuses.PLOY_STATUS_CANCELLED].includes(response_ploy.status)
            && User.get().user_type == userTypes.MEPLOYEE /* do not display for meployers as they do not apply */ ) {
            $scope.ploy_is_taken = true;
        }

        if (response_ploy.created_by.legal_form == legalForms.PRIVATE && User.get().legal_form == legalForms.COMPANY && response_ploy.created_by.id != User.get().id) { // prevent applying companies to other company's ploys
            $scope.company_to_company = true;
        }

        // TODO: shouldn't be is_company?
        if(response_ploy.created_by.id == User.get().id) {
            $scope.ploy_is_mine = true
        }

        if (User.isAuthenticated()) {
            User.get().$promise.then(user => {
                Engagement.engagementExists(user.id, response_ploy.id).$promise.then(response => {
                    $scope.engagementExist = response.exists;
                    if (response_ploy.is_private && !user.company && !$scope.engagementExist) {
                        $location.path('/').replace()
                    }
                });
                if(response_ploy.company.require_clean_criminal_record && !user.profile.criminal_record) {
                    $scope.cleanCriminalRecordRequired = true
                }
                if (response_ploy.category.based_on_verification) {
                    $scope.categoryVerificationIsMissing = !User.get().category.some((category) => category.id === response_ploy.category.id);
                }
                Stat.recordPloyView(response_ploy.id);
            })
        }

        SupplementResource.getSupplementsForPloy({ployId: response_ploy.id}).$promise.then((supplements) => {
            $scope.supplements = supplements;
        });

        crumble.update({ploy: response_ploy});
        $scope.ploy = response_ploy;
    });


    $scope.goToApplyApplication = function (ployId) {
        Verification.verifyEmployeeProcedure().then(() => {
            $location.path('apply-application/' + ployId);
        });
    };


    $scope.createEngagement = ploy => { // Creates engagement with Inquiry status
        if ($scope.engagementExist) return;
        Engagement.create({'ploy_id': ploy.id}).$promise.then(data => {
            $location.path('/my-ploys/' + data.engagement + '/conversation');
        }, error => {
            let errorMessage = (error.data[0]) ? error.data[0] : 'SOMETHING_WENT_WRONG_PLEASE_CONTACT_WITH_SUPPORT';
            AlertBanner.publish({
                type: 'error',
                message: $filter('translate')(errorMessage),
                timeCollapse: 4000
            });
        });
    };

    $scope.shareIt = ploy => {
        return $uibModal.open({
            templateUrl: 'src/modals/html/modal-share.html',
            windowClass: 'modal-vertical-centered',
            controller: 'ModalShareController',
            resolve: {
                ploy: () => {
                    return  ploy || ''
                }
            }
        })
    };

    $scope.showApplicantsList = () => {
        return User.isAuthenticated() &&
            $scope.ploy.id &&
            $scope.ploy.is_private &&
            ($scope.ploy.status == Constants.PloyStatuses.PLOY_STATUS_PUBLISHED ||
            $scope.ploy.status == Constants.PloyStatuses.PLOY_STATUS_ONGOING) &&
            $scope.engagementExist;
    };

    $scope.ployHasDifferentWorkHours = () => {
        const startTimes = Object.values($scope.ploy.weekdays_settings).filter(w => {
           return w.start_time !== null
        }).map(w => w.start_time.toISOString())
        const endTimes = Object.values($scope.ploy.weekdays_settings).filter(w => {
           return w.end_time !== null
        }).map(w => w.end_time.toISOString())
        const startTimesEqual = startTimes.every( (val, i, arr) => val === arr[0] )
        const endTimesEqual = endTimes.every( (val, i, arr) => val === arr[0] )
        return !startTimesEqual || !endTimesEqual;
    }


}]);

angular.module('ploys')
    .directive('ployAudienceSelector', ['PloyConstants', 'User', 'Modal', '$filter', 'Company', 'MyStaff',
        function (PloyConstants, User, Modal, $filter, Company, MyStaff) {
            return {
                scope: {
                    onAudienceSelected: '&',
                    availableWorkers: '=',
                    targetMeployees: '=',
                    targetGroups: '=',
                    staffingPermission: '=',
                    ploy: '=',
                },
                templateUrl: '/src/ploys/html/directives/ploy-audience-selector.html',
                controller: function ($scope) {
                    $scope.workAvailabilityParams = {};
                    $scope.percentageInactiveStaffMeployees = 0;
                    $scope.hasAnyStaff = false;
                    $scope.hasAnyStaffGroups = false;

                    $scope.audiences = PloyConstants.ployAudienceTypes;

                    $scope.currentAudience = PloyConstants.ployAudienceTypes.public;

                    $scope.isAudienceSelected = audience => audience == $scope.currentAudience;

                    $scope.selectTargetAudience = (audience) => {
                        $scope.currentAudience = audience;
                        $scope.onAudienceSelected({audience: audience});
                    };

                    $scope.$watch('ploy', () => {
                        $scope.workAvailabilityParams = {
                            start_time: $scope.ploy.start_time,
                            start_day: moment($scope.ploy.start_day).set({hour: 0, minute: 0, second: 0}).toDate(),
                            end_day: moment($scope.ploy.end_day).set({hour: 0, minute: 0, second: 0}).toDate(),
                            hours: $scope.ploy.hours,
                            weekdays: $scope.ploy.weekdays
                        };
                        if (!$scope.workAvailabilityParams.weekdays) {
                            $scope.targetMeployees = [];
                            $scope.targetGroups = [];
                            $scope.selectTargetAudience(PloyConstants.ployAudienceTypes.public)
                        }
                    }, true);

                    if ($scope.targetMeployees && $scope.targetMeployees.length > 0) {
                        if ($scope.targetMeployees[0] === 'all') {
                            $scope.selectTargetAudience($scope.audiences.staff);
                        } else {
                            $scope.selectTargetAudience($scope.audiences.selected);
                        }
                    }

                    if ($scope.targetGroups && $scope.targetGroups.length > 0) {
                        $scope.selectTargetAudience($scope.audiences.group);
                    }

                    $scope.transformSelectedMeployees = (target_meployees) => {
                        $scope.targetMeployees = target_meployees.reduce((acc, curr) => {
                            acc.push(curr.meployee.id);
                            return acc;
                        }, []);
                    };

                    $scope.transformSelectedGroups = (target_groups) => {
                        $scope.targetGroups = target_groups.reduce((acc, curr) => {
                            acc.push(curr.id);
                            return acc;
                        }, []);
                    };

                    User.hasAnyStaff().$promise.then(function (response) {
                        $scope.hasAnyStaff = response.has_staff;
                        if ($scope.hasAnyStaff) {
                            MyStaff.getPercentageInactiveStaffUsers().$promise.then(response => {
                                $scope.percentageInactiveStaffMeployees = response.percentage_inactive;
                            });
                        }
                    });

                    User.hasAnyStaffGroups().$promise.then(function (response) {
                        $scope.hasAnyStaffGroups = response.has_staff_groups;
                    });

                    $scope.staffingPermissionModal = staffingPermission => {
                        if (staffingPermission && !User.get().company.staffing_permission) {
                            return Modal.confirm({
                                title: $filter('translate')('STAFFING_PERMISSION_MODAL__TITLE'),
                                message: $filter('translate')('STAFFING_PERMISSION_MODAL__SUBTITLE'),
                                firstButtonLabel: $filter('translate')('NO_THANKS'),
                                secondButtonLabel: $filter('translate')('YES'),
                                secondButtonColor: 'green',
                                staticBackdrop: true,
                                secondButtonFunction: () => {
                                    return Company.updateCompanyProperty({'staffing_permission': true}).$promise.then(company => {
                                        User.get().company.staffing_permission = company.staffing_permission;
                                    });
                                },
                            });
                        }
                    };


                },
            };
        }
    ]);

angular.module('ploys')
    .directive('ployCalendar',['$rootScope', function($rootScope,) {
        return {
            scope: {
                'ngModel' : '=',
                'dateChanged': '&',
                'resetButton': '&',
                'todayButton': '&',
                'minDate': '=',
                'maxDate': '=',
            },
            restrict: 'AE',
            templateUrl: '/src/ploys/html/ploy-calendar.html',
            link: function (scope, element, attrs, ctrls) {

                scope.datepickerOptions = {
                    maxMode: 'day',
                    showWeeks: false,
                    minDate: scope.minDate,
                    maxDate: scope.maxDate,
                };

                scope.$watch('minDate', function(value) {
                    scope.datepickerOptions.minDate = value;
                    value > scope.ngModel ? scope.ngModel = value : null;
                });

                scope.$watch('maxDate', function(value) {
                    scope.datepickerOptions.maxDate = value;
                    value > scope.ngModel ? scope.ngModel = value : null;
                });

            }
        };
    }]);


angular
    .module('ploys')
    .directive('showEngagementStatus', [ 'User',
        function(User) {
            return {
                 scope: {
                   engagement : '=',
                   size : '=',
                   border : '=',
                 },
                 controller: function($scope, EngagementConstants) {
                     $scope.getEngagementColor = function () {
                        if ($scope.engagement && $scope.engagement.state ) {
                            var engagement = _.find(EngagementConstants.status, { name: $scope.engagement.state }) || {};
                            return engagement.color
                        }
                     };
                 },
                 template: '<div ng-class="{\'big\' : size == \'big\', \'no-border\' : border == false}" class="list-status-{{ getEngagementColor() }}"> {{ engagement.state | translate }} </div>' ,
            };
        }
    ]);

angular.module('ploys')
    .directive('showPloyAlert', ['$timeout', 'User', 'UserResource', 'Constants',
        function ($timeout, User, UserResource, Constants) {
            return {
                scope: {
                    ployIsTaken: '<',
                    engagementExists: '<',
                    companyToCompany: '<',
                    cleanCriminalRecordRequired: '<',
                    categoryVerificationIsMissing: '<',
                },
                templateUrl: '/src/ploys/html/directives/show-ploy-alert.html',
                controller: function ($scope) {
                    const userTypes = Constants.userTypes;

                    if (User.isAuthenticated() && User.get().user_type === userTypes.MEPLOYEE) {
                        UserResource.getProfileProgress().$promise.then(data => {
                            $scope.profileComplete = data.progress;
                        });
                    }
                },
            };
        }
    ]);

angular
    .module('ploys')
    .directive('showPloyStatus', [ 'User',
        function(User) {
            return {
                 scope: {
                   ploy: '=',
                   helpText: '<'
                 },
                 controller: function ($scope, PloyConstants, $element, $attrs, $transclude) {
                     $scope.ployConstants = PloyConstants;
                     $scope.getPloyStatusColor = function () {
                        if ($scope.ploy && $scope.ploy.status ) {
                            let ploy = _.find(PloyConstants.status, { name: $scope.ploy.status }) || {};
                            return ploy.color
                        }
                     };
                     $scope.getStatusHelp = () => {
                        if ($scope.ploy && $scope.ploy.status ) {
                            return PloyConstants.helpText[$scope.ploy.status];
                        }
                     };

                 },
                 template: '' +
                     '<div ng-show="!helpText" class="list-status-bold-{{ getPloyStatusColor() }}"> {{ ploy.status | translate }} </div>' +
                     '<div ng-show="helpText" class="list-status-bold-{{ getPloyStatusColor() }}" uib-popover="{{getStatusHelp() | translate }}"  popover-class="profile-completion-popover" popover-trigger="mouseenter" > {{ ploy.status | translate }} </div>' +
                     '<div ng-show="helpText && ploy.is_private" class="list-status list-status-block list-status-mepgreen" uib-popover="{{ \'PLOY_STATUS_PRIVATE__HELP\' | translate }}"  popover-class="profile-completion-popover" popover-trigger="mouseenter"> {{ \'PRIVATE\' | translate }} </div>' +
                     '',
            };
        }
    ]);

angular.module('ploys')
    .directive('showPloyWorkdaysTable', ['Constants',
        function (Constants) {
            return {
                scope: {
                    ploy: '<',
                    condensed: '<',
                },
                templateUrl: '/src/ploys/html/directives/show-ploy-workdays-table.html',
                controller: function ($scope) {
                    $scope.weekdaysList = [];
                    $scope.setWeekdays = () => {
                        $scope.weekdaysList = angular.copy(Constants.englishWeekdaysList);
                    };
                    $scope.setWeekdays();
                },
            };
        }
    ]);

angular.module('ploys')
.filter('displayPloyDuration', ['$filter', function ($filter) {
    return (ploy) => {
        if (!ploy) return '';
        if (ploy.one_day_job) {
            return $filter('date')(ploy.start_day, "dd.MM")
        }
        return $filter('date')(ploy.start_day, "dd.MM") + ' - ' + $filter('date')(ploy.end_day, "dd.MM")
    };
}]);

angular.module('ploys')
.filter('ployHours', ['$filter', '$translate', function ($filter, $translate) {
    let hoursFilter = hours => {
        if (!hours) return '';

        let decimalToHours = hours => {
            let hrs = parseInt(Number(hours));
            let min = Math.round((Number(hours) - hrs) * 60);
            if (min>0) {
                return hrs + $translate.instant('PLOY_HOURS_FILTER__HOURS') + ' ' +
                min + $translate.instant('PLOY_HOURS_FILTER__MINUTES');
            }
            return hrs + $translate.instant('PLOY_HOURS_FILTER__HOURS');
        };
        return decimalToHours(hours)
    };
    hoursFilter.$stateful = true;
    return hoursFilter;
}]);

angular.module('ploys')
.filter('sortEngagementByState', ['Constants', function (Constants) {
    let sortyByEng = (state) => {
        switch (state) {
            case Constants.engagementStates.ENGAGEMENT_PAID:
                return 7;

            case Constants.engagementStates.ENGAGEMENT_COMPLETED:
                return 6;

            case Constants.engagementStates.EMPLOYER_CHOSE_EMPLOYEE:
                return 5;

            case Constants.engagementStates.EMPLOYER_PRE_APPROVE:
                return 4;

            case Constants.engagementStates.ENGAGEMENT_EMPLOYEE_APPLIED:
                return 3;

            case Constants.engagementStates.ENGAGEMENT_INQUIRY_SENT:
                return 2;

            case Constants.engagementStates.ENGAGEMENT_DECLINED:
                return 1;

            case Constants.engagementStates.ENGAGEMENT_CANCELLED:
                return 0;
        }
        return 0;
    };

    return (items, field) => {
        if (!items) items = [];
        return items.sort((a, b) => {
            return (sortyByEng(a.state) < sortyByEng(b.state) ? 1 : -1);
        });
    };
}]);

angular.module('ploys')
    .factory('CategoryResource', [
        '$resource',
        function ($resource) {
            return $resource('/api/category/:slug/', {slug: '@slug'});
        }]);

angular.module('ploys')

.factory('EngagementResource', ['$resource', 'RequestTransform', function($resource, RequestTransform) {
    return  $resource('/api/engagement/:id/', {id:'@id'},{
        create: { method:'POST', url: '/api/engagement-start/'},
        'getList': {
              method:'GET',
              isArray: true
        },
        'getShift': {
            method: 'GET',
            url: '/api/ploy/shift_ploys/',
            transformResponse: RequestTransform.getPaginatedCountWithCount
        },
        'getShiftsForPloy': {
            method: 'GET',
            isArray: true,
            url: '/api/ploy/:id/shifts_for_ploy/'
        },
        'getTodayPloyShifts': {
            method: 'GET',
            isArray: true,
            url: '/api/ploy/today_ploy_shifts/'
        },
        'approveAllShifts': {
            method: 'POST',
            url: '/api/ploy/approve_all_shifts/'
        },
        'approvePloyShift': {
            method: 'POST',
            url: '/api/ploy/:id/approve_shifts_for_ploy_employee_pair/'
        },
        'getShiftToApproveCount': {
            method: 'GET',
            url: '/api/ploy/number_of_shifts_to_approve/'
        },
        'getShiftAutocompleteData': {
            method: 'GET',
            isArray: true,
            url: '/api/ploy/autocomplete_names/'
        },
        'downloadShifts': {
            method: 'POST',
            url: '/api/user/download_shifts/'
        },
        'downloadWorkerSalaryShifts': {
            method: 'POST',
            url: '/api/user/download_worker_salary_shifts/'
        },
        'engagementsPlan': {
            method: 'GET',
            url: '/api/ploy-plan/engagement-plan/'
        },
        engagementsSummaryStats: {
            method: 'GET',
            url: '/api/ploy-plan/engagement-sum-stat/'
        },
        'weekPlanXls': {
            method: 'GET',
            url: '/api/ploy-plan/week-plan-xls/',
        },
        update: { method:'PATCH' },
        engagementExists: { method:'POST', url: '/api/engagement/engagement_exists/' },
        preApproveForMyPloy: { method:'POST', url: '/api/engagement/preapprove_for_my_ploy/' },
        myCalendarEngagements: { method:'GET', url: '/api/engagement/my_calendar_engagements/', isArray: true },
        myCalendarPrevEngagements: { method:'GET', url: '/api/engagement/my_calendar_prev_engagements/', isArray: true },
        currentEngagementsListOngoing: {
            method: 'GET',
            url: '/api/engagement/current_my_engagements_ongoing/',
            isArray: true,
            transformResponse: RequestTransform.getPaginatedCount
        },
        currentEngagementsListCompleted: {
            method: 'GET',
            url: '/api/engagement/current_my_engagements_completed/',
            isArray: true,
            transformResponse: RequestTransform.getPaginatedCount
        },
        previousEngagementsList: {
            method: 'GET',
            url: '/api/engagement/:id/previous_my_engagements/',
            isArray: true,
            transformResponse: RequestTransform.getPaginatedCount
        },
        workerSalary: {
            method: 'GET',
            url: '/api/engagement/worker_salary/',
            isArray: true,
        },
        workerSalaryShifts: {
            method: 'GET',
            url: '/api/engagement/worker_salary_shifts/',
            isArray: true,
        },
        getEngagementToReplace: {
            method: 'GET',
            url: '/api/engagement/get_eng_to_replace/',
        },
    });
}]);

angular.module('ploys')

.factory('EventResource', ['$resource', function($resource) {
    return  $resource('/api/event/:id/', {id:'@id'},{
        update: { method:'PATCH' },
        update_comment : {
            method: 'POST',
            url : '/api/event/:id/update_comment/'
        }
    });
 }]);
angular.module('ploys')

.factory('PaymentResource', ['$resource', function($resource) {
   return  $resource('/api/payment/:id/start/', {id:'@id'}, {
       'start': {
           method: 'POST',
           url: '/api/payment/:id/start/'
       },
       'completeStripe': {
           method: 'POST',
           url: '/api/payment/:id/complete_stripe/'
       },
       getInvoices : {
           method: 'GET',
           isArray: true,
           url: '/api/consolidated-payment/invoices/'
       }
       });
 }]);
angular.module('ploys')

.factory('PloyResource', ['$resource', 'RequestTransform', function ($resource, RequestTransform) {
    return $resource('/api/ploy/:id/', {id: '@id'}, {
        update: {method: 'PATCH'},
        'query': {
            method: 'GET',
            isArray: true,
            transformResponse: RequestTransform.getPaginatedCount
        },
        close: {method: 'POST', url: '/api/ploy/:id/close/'},
        publish: {method: 'POST', url: '/api/ploy/:id/publish/'},
        reopen: {method: 'POST', url: '/api/ploy/:id/reopen/'},
        makePublic: {method: 'POST', url: '/api/ploy/:id/make_public/'},
        makeForAllStaff: {method: 'POST', url: '/api/ploy/:id/make_for_all_staff/'},
        hasStaffObjsWithoutEngs: {method: 'POST', url: '/api/ploy/:id/has_staff_without_engs/'},
        unPublish: {method: 'POST', url: '/api/ploy/:id/unpublish/'},
        singlePloy: {method: 'GET', url: '/api/ploy/:id/my_ploy/'},
        publicPloy: {method: 'GET', url: '/api/ploy/:id/public_ploy/'},
        ployWithoutEngagementsWithPayment: {
            method: 'GET',
            url: '/api/ploy/:id/my_ploy_without_engagements_with_payment/'
        },
        currentPloysList: {
            method: 'GET',
            url: '/api/ploy/:id/current_my_ploys/',
            isArray: true,
            transformResponse: RequestTransform.getPaginatedCount
        },
        currentMyCalendarPloys: {
            method: 'GET',
            url: '/api/ploy/current_my_calendar_ploys/',
            isArray: true,
        },
        currentUnpaidPloysList: {
            method: 'GET',
            url: '/api/ploy/:id/current_my_ploys_unpaid/',
            isArray: true
        },
        getMeployerEngagements: {
            method: 'GET',
            url: '/api/ploy/get_meployer_engagements/',
            isArray: true
        },
        currentUnpaidWithoutPaymentPloysList: {
            method: 'GET',
            url: '/api/ploy/:id/current_my_ploys_unpaid_without_pending_payments/',
            isArray: true
        },
        previousPloysList: {
            method: 'GET',
            url: '/api/ploy/:id/previous_my_ploys/',
            isArray: true,
            transformResponse: RequestTransform.getPaginatedCount
        },
        previousPaidPloysList: {
            method: 'GET',
            url: '/api/ploy/:id/previous_my_ploys_paid/',
            isArray: true,
            transformResponse: RequestTransform.getPaginatedCount
        },
        currentEngagementsList: {
            method: 'GET',
            url: '/api/ploy/:id/current_my_engagements/',
            isArray: true,
            transformResponse: RequestTransform.getPaginatedCount
        },
        previousEngagementsList: {
            method: 'GET',
            url: '/api/ploy/:id/previous_my_engagements/',
            isArray: true,
            transformResponse: RequestTransform.getPaginatedCount
        },
        getMyPloys: {
            method: 'GET',
            url: '/api/ploy/my_ploys/',
            isArray: true,
            transformResponse: RequestTransform.getPaginatedCount
        },
        getDefaultValuesForNewPloy: {
            method: 'GET',
            cache: false,
            url: '/api/ploy-default/:id/'
        },
        getAvailableWorkers: {
            method: 'POST',
            url: '/api/ploy/get_available_workers/'
        },
        getPloyFilterAutocompleteData: {
            method: 'GET',
            isArray: true,
            url: '/api/ploy/ploy_filter_autocomplete_names/',
        },
        getChosenUsers: {
            method: 'GET',
            isArray: true,
            url: '/api/ploy/:id/get_chosen_users/',
        },
        sendMessageToWorkers: {
            method: 'POST',
            url: '/api/ploy/:id/send_message_to_workers/',
        },
        publicEngagements: {
            method: 'GET',
            isArray: true,
            url: '/api/ploy/:id/public_engagements/'
        },
        myEngagementForPloy: {
            method: 'GET',
            url: '/api/ploy/:id/my_engagement_for_ploy/'
        },
        myPloyTags: {
            method: 'GET',
            isArray: true,
            url: '/api/ploy/my_ploy_tags/',
        }
    });
}]);

angular.module('ploys')
    .factory('SalaryPredictResource', [
        '$resource',
        function ($resource) {
            return $resource('/api/salary_rule/predict/');
        }]);

angular.module('ploys')
.service('Category', ['CategoryResource', '$q', function(CategoryResource, $q) {
        var categories = CategoryResource.query();

        this.getAll = function(){
          return categories
        };
    }
]);

angular.module('ploys')

.service('EngagementConstants', ['$translate', '$filter', 'Engagement', '$location', 'User', 'AlertBanner', 'Modal', 'BankAccount',
    '$window', 'Verification', 'Constants',
    function ($translate, $filter, Engagement, $location, User, AlertBanner, Modal, BankAccount,
              $window, Verification, Constants) {

    let debounceDuration = 400;
    this.status = [
        {
            'name': 'COMMENT',
            'value': 'Comment'
        },
        {
            'name': 'EMPLOYER_CHOSE_EMPLOYEE',
            'value': 'Employee chosen',
            'color' : 'green',
            'description_meployee' : 'MARK PLOY AS COMPLETED WHEN JOB WILL BE DONE',
            'description_meployer' : 'PAYMENT_WILL_START_AFTER_MEPLOYEENAME_MARKED_PLOY_AS_COMPLETED',
            'event_message' : 'MEPLOYERNAME_APPROVED_MEPLOYEENAME_FOR_THIS_PLOY',
            'actions_meployee' : {
                'first_button' : {
                    'button_text' : 'PLOY_COMPLETED',
                    'button_function' : _.debounce(eng => {
                        if (User.get().can_receive_payment) {
                            Engagement.completed(eng);
                        } else {
                            Modal.alert({
                                title: $filter('translate')('BANK_ACCOUNT'),
                                message: $filter('translate')('MISSING_BANK_ACCOUNT_INFO'),
                                buttonFunction : function () {
                                    BankAccount.redirection.set('my-ploys/' + eng.id + '/conversation');
                                    $location.path('/edit-profile/bank');
                                }
                            })
                        }
                    }, debounceDuration),
                    'button_tooltip' : 'CONVERSATION__PLOY_COMPLETED__TOOLTIP',
                    'button_class' : 'button-bb',
                    'button_disabled': function (eng) {
                        return new Date() < eng.checkout_time;
                    },
                }
            },
            'actions_meployeer' : {
                'first_button' : {
                    'button_text' : 'DECLINE',
                    'button_function' : _.debounce(eng => {
                        Engagement.decline(eng);
                    }, debounceDuration, {leading: true}),
                    'button_class' : 'button-dg',
                    'button_tooltip' : 'CONVERSATION__DECLINE__TOOLTIP',
                }
            },
        },
        {
            'name': 'EMPLOYER_PRE_APPROVE',
            'value': 'Pre-approve',
            'color' : 'green',
            'description_meployee' : 'MEPLOYERANME_PREAPPROVED_YOU_CLICK_ON_APPLY_TO_TAKE_THIS_JOB',
            'description_meployer' : 'MEPLOYEENAME_WILL_BE_AUTOMATICALLY_APPROVED_AFTER_APPLY',
            'event_message' : 'MEPLOYERNAME_PRE_APPROVED_MEPLOYEENAME',
            'actions_meployee' : {
                'first_button' : {
                    'button_text' : 'APPLY',
                    'button_function' : _.debounce(eng => {
                        Verification.verifyEmployeeProcedure().then(() => {
                            Engagement.askForWorkRequirements(eng).then(() => {
                                Engagement.applyToPreApproved(eng);
                            });
                        });
                    }, debounceDuration),
                    'button_class' : 'button-gg',
                    'button_tooltip' : 'CONVERSATION__APPLY_TO_PREAPPROVED__TOOLTIP',
                },
                'second_button' : {
                    'button_text' : 'CANCEL',
                    'button_function' : function (eng) {
                        Engagement.cancel(eng).then(() => {
                            User.askForProfilePause(eng);
                        });
                    },
                    'button_class' : 'button-dg',
                    'button_tooltip' : 'CONVERSATION__CANCEL__TOOLTIP',
                }
            },
            'actions_meployeer' : {
                'first_button' : {
                    'button_text' : 'DECLINE',
                    'button_function' : _.debounce(eng => {
                        Engagement.decline(eng);
                    }, debounceDuration),
                    'button_class' : 'button-dg',
                    'button_tooltip' : 'CONVERSATION__DECLINE__TOOLTIP',
                }
            },
        },
        {
            'name': 'ENGAGEMENT_CREATED',
            'value': 'Created',
            'color' : 'orange',
            'description_meployee' : 'JUST_CLICK_APPLY_WHEN_YOU_WILL_BE_READY',
            'description_meployer' : 'INQUIRY_FROM',
            'actions_meployee' : {
                'first_button' : {
                    'button_text' : 'APPLY',
                    'button_function' : function (eng) {
                        Verification.verifyEmployeeProcedure().then(() => {
                            $location.path('/apply-application/' + eng.ploy.id);
                        });
                    },
                    'button_class' : 'button-gg',
                    'button_tooltip' : 'CONVERSATION__APPLY__TOOLTIP',
                }
            },
            'actions_meployeer' : {
                'first_button' : {
                    'button_text' : 'PRE_APPROVE',
                    'button_function' : _.debounce(eng => {
                        Engagement.preApprove(eng);
                    }, debounceDuration),
                    'button_class' : 'button-gg',
                    'button_tooltip' : 'CONVERSATION__PRE_APPROVE__TOOLTIP',
                }
            },
        },
        {
            'name': 'ENGAGEMENT_INQUIRY_SENT',
            'value': 'Inquired',
            'color' : 'orange',
            'description_meployee' : 'JUST_CLICK_APPLY_WHEN_YOU_WILL_BE_READY',
            'description_meployer' : 'INQUIRY_FROM',
            'actions_meployee' : {
                'first_button' : {
                    'button_text' : 'APPLY',
                    'button_function' : function (eng) {
                        Verification.verifyEmployeeProcedure().then(() => {
                            $location.path('/apply-application/' + eng.ploy.id);
                        })
                    },
                    'button_class' : 'button-gg',
                    'button_tooltip' : 'CONVERSATION__APPLY__TOOLTIP',
                }
            },
            'actions_meployeer' : {
                'first_button' : {
                    'button_text' : 'PRE_APPROVE',
                    'button_function' : _.debounce(eng => {
                        Engagement.preApprove(eng);
                    }, debounceDuration),
                    'button_class' : 'button-gg',
                    'button_tooltip' : 'CONVERSATION__PRE_APPROVE__TOOLTIP',
                }
            },
        },
        {
            'name': 'ENGAGEMENT_EMPLOYEE_APPLIED',
            'value': 'Applied',
            'color' : 'green',
            'description_meployee' : 'WAITING_FOR_MEPLOYERNAME_APPROVEMENT',
            'description_meployer' : 'MEPLOYEENAME_IS_WAITING_FOR_YOUR_APPROVEMENT',
            'event_message' : 'MEPLOYEENAME_APPLIED_TO_THIS_PLOY',
            'actions_meployee' : {
                'first_button' : {
                    'button_text' : 'CANCEL',
                    'button_function' : _.debounce(eng => {
                        Engagement.cancel(eng);
                    }, debounceDuration),
                    'button_class' : 'button-dg',
                    'button_tooltip' : 'CONVERSATION__CANCEL__TOOLTIP',
                }
            },
            'actions_meployeer' : {
                'first_button' : {
                    'button_text' : 'DECLINE',
                    'button_function' : _.debounce(eng => {
                        Engagement.decline(eng);
                    }, debounceDuration),
                    'button_class' : 'button-dg',
                    'button_tooltip' : 'CONVERSATION__DECLINE__TOOLTIP',
                },
                'second_button' : {
                    'button_text' : 'APPROVE',
                    'button_function' : _.debounce(eng => {
                        Engagement.approve(eng).then(function (data) {
                            Engagement.createJobAddressComment(eng)
                        }, error => { console.log(error); });
                    }, debounceDuration),
                    'button_class' : 'button-gg',
                    'button_tooltip' : 'CONVERSATION__APPROVE__TOOLTIP',
                }
            },
        },
        {
            'name': 'ENGAGEMENT_DECLINED',
            'value': 'Declined',
            'color' : 'gray',
            'description_meployee' : 'SORRY_MEPLOYERNAME_CHOSE_SOMEONE_ELSE_FOR_THIS_PLOY',
            'description_meployer' : 'YOU_DECLINED_MEPLOYEENAME',
            'event_message' : 'MEPLOYEENAME_DECLINED_MEPLOYERNAME',
            'actions_meployee' : {
                'first_button' : {
                    'button_text' : 'PLOY_SEARCH',
                    'button_function' : function () {
                        $location.path('/search')
                    },
                    'button_class' : 'button-bb'
                }
            },
        },
        {
            'name': 'ENGAGEMENT_COMPLETED',
            'value': 'Completed',
            'color' : 'blue',
            'description_meployee' : 'COMPLETED_INFO_PAYMENT_INFO',
            'description_meployer' : 'MEPLOYEENAME_MARKED_PLOY_AS_COMPLETED',
            'event_message' : 'MEPLOYEENAME_MARKED_PLOY_AS_COMPLETED',
            'actions_meployee' : {
                'first_button' : {
                    'button_text' : 'PAYMENT_SETTINGS',
                    'button_function' : function () {
                        $location.path('/edit-profile/bank');
                    },
                    'button_class' : 'button-bb'
                },
                'second_button' : {
                    'button_text' : 'CONVERSATION__CREATE_PLOY_BY_WORKER__BUTTON',
                    'button_function' : eng => {
                        $location.path('/ploy-by-worker/' + eng.id);
                    },
                    'button_class' : 'button-gg',
                    'button_tooltip' : 'CONVERSATION__CREATE_PLOY_BY_WORKER__BUTTON__TOOLTIP',
                    'isHidden': (eng) => !eng.ploy.is_company_trusted
                }
            },
            'actions_meployeer' : {
                'first_button' : {
                    'button_text' : 'PAY_VIA_INVOICE',
                    'button_function' : function (eng) {
                        $location.path('/my-payments/for/' + eng.ploy.id);
                    },
                    'button_class' : 'button-bb',
                    'isHidden' : function (eng) {
                        return eng.receipt_url || (eng.ploy.created_by.user_type != Constants.userTypes.MEPLOYER || eng.ploy.created_by.legal_form != Constants.legalForms.COMPANY)
                    }
                },
                'second_button' : {
                    'button_text' : 'ENGAGEMENT_CONSTANTS__SEE_INVOICE',
                    'button_function' : function (eng) {
                        window.open(eng.receipt_url, '_blank');
                    },
                    'button_class' : 'button-bb',
                    'isHidden' : function (eng) {
                        return !eng.receipt_url
                    }
                }
            },
        },
        {
            'name': 'ENGAGEMENT_PAID',
            'value': 'Paid',
            'color' : 'blue',
            'description_meployee' : 'THANKS_FOR_HELPING_OUT_DONT_FORGET_TO_LEAVE_REVIEW',
            'description_meployer' : 'THANKS_FOR_HELPING_OUT_DONT_FORGET_TO_LEAVE_REVIEW',
            'event_message' : 'MEPLOYERNAME_PAID_MEPLOYEENAME',
            'actions_meployee' : {
                'first_button' :  {
                    'button_text' : 'LEAVE_REVIEW',
                    'button_function' : function (eng) {
                        if (!eng.review_exists) {
                            $location.path('/leave-review/' + eng.id).search('next=/my-ploys/'+eng.id+'/conversation');
                        } else if (eng.review_exists) {
                            AlertBanner.publish({
                                type: 'error',
                                message: $filter('translate')('YOU_ALREADY_LEFT_A_REVIEW_IN_THIS_PLOY'),
                                timeCollapse: 4000
                            })
                        }
                    },
                    'button_class' : 'button-bb',
                    'isHidden' : function (eng) {
                        return eng.review_exists
                    }
                },
            },
            'actions_meployeer' : {
                'first_button' : {
                    'button_text' : 'LEAVE_REVIEW',
                    'button_function' : function (eng) {
                        if (!eng.review_exists) {
                            $location.path('/leave-review/' + eng.id);
                        } else if (eng.review_exists) {
                            AlertBanner.publish({
                                type: 'error',
                                message: $filter('translate')('YOU_ALREADY_LEFT_A_REVIEW_IN_THIS_PLOY'),
                                timeCollapse: 4000
                            })
                        }
                    },
                    'button_class' : 'button-bb',
                    'isHidden' : function (eng) {
                        return eng.review_exists
                    }
                },
                'second_button' : {
                    'button_text' : 'RECEIPT_INVOICE',
                    'button_function' : function (eng) {
                        if (!eng.receipt_url && !eng.invoice_url) {
                            return AlertBanner.publish({
                                type: 'error',
                                message: $filter('translate')('ERROR_WHILE_DOWNLOADING_DOCUMENT_PLEASE_CONTACT_SUPPORT'),
                                timeCollapse: 4000
                            })
                        }
                        if (eng.receipt_url) {
                            $window.open(eng.receipt_url, '_blank');
                        } else {
                            $window.open(eng.invoice_url, '_blank');
                        }

                    },
                    'button_class' : 'button-gg'
                }
            }
        },
        {
            'name': 'ENGAGEMENT_CANCELLED',
            'value': 'Cancelled',
            'color' : 'gray',
            'description_meployee' : 'YOU_CANCELLED_YOUR_APPLICATION_IN_THIS_PLOY',
            'description_meployer' : 'MEPLOYEENAME_CANCELLED_HIS_APPLICATION',
            'event_message' : 'MEPLOYEENAME_CANCELLED_HIS_APPLICATION',
        },
        {
            'name': 'ENGAGEMENT_CLOSED',
            'value': 'Closed',
            'color' : 'gray',
            'description_meployee' : 'ENG_CONSTANTS__WORKER_VIEW__ENGAGEMENT_CLOSED',
            'description_meployer' : 'ENG_CONSTANTS__EMPLOYER_VIEW__ENGAGEMENT_CLOSED',
            'event_message' : '',
        },
        {
            'name': 'ENGAGEMENT_ABSENT',
            'value': 'Absent',
            'description_meployee' : 'ENG_CONSTANTS__YOU_WERE_ABSENT',
            'description_meployer' : 'ENG_CONSTANTS__WORKER_WAS_ABSENT',
            'color': "red",
        },
        {
            'name': 'ENGAGEMENT_SICK',
            'value': 'Sick',
            'description_meployee' : 'ENG_CONSTANTS__YOU_WERE_SICK',
            'description_meployer' : 'ENG_CONSTANTS__WORKER_WAS_SICK',
            'color': "red",
        },
        {
            'name': 'ENGAGEMENT_SICK_WITH_PAYMENT',
            'value': 'Sick with payment',
            'description_meployee' : 'ENG_CONSTANTS__YOU_WERE_SICK_WITH_PAYMENT',
            'description_meployer' : 'ENG_CONSTANTS__WORKER_SICK_WITH_PAYMENT',
            'color': "red",
        },
        {
            'name': 'ENGAGEMENT_APPROVE_FIRST_APPLY',  // needed to avoid issue in searching of events
        }];

    }]);

angular.module('ploys')

.service('Engagement', ['EngagementResource', 'EventResource', 'User', '$uibModal', '$location', '$rootScope', '$filter', 'AlertBanner', 'Verification',
                        function (EngagementResource, EventResource, User, $uibModal, $location, $rootScope, $filter, AlertBanner, Verification) {

    let engagement = {};

    this.isEmployee = function() {
        return engagement.is_employee;
    };

    this.isEmployer = function() {
        return !engagement.is_employee;
    };

    this.create = function(form){
        return EngagementResource.create(form);
    };

    this.createPreApprovedForMyPloy = form => {
        return EngagementResource.preApproveForMyPloy(form);
    };

    this.get = function(id) {
        engagement = EngagementResource.get({'id': id});
        return engagement;
    };

    this.refresh = function(engagement) {
        return EngagementResource.get({'id': engagement.id});
    };

    this.query = function() {
        engagement = EngagementResource.query({});
        return engagement;
    };

    this.engagementExists = function(user_id, ploy_id) {
        return EngagementResource.engagementExists({'user': user_id, 'ploy': ploy_id});
    };

    let createEvent = function(event, eng) {
        return new Promise((resolve, reject) => {
            if(!eng) {
                eng = engagement;
            }
            if(eng.id) {
                event.engagement = eng.id;
            }

            return EventResource.save(event).$promise.then(function (response) {
                if (event.event_type != "COMMENT") {
                    if (event.event_type == 'ENGAGEMENT_EMPLOYEE_APPLIED' && eng.state == 'EMPLOYER_PRE_APPROVE' ) {
                        eng.state = 'EMPLOYER_CHOSE_EMPLOYEE';
                    } else {
                        eng.state = event.event_type;
                    }
                }

                if (eng.hasOwnProperty('events')) {
                    eng.events.push(response);
                }
                return resolve(response);
            }, error => {
                let errorMessage = (error.data[0]) ? error.data[0] : 'SOMETHING_WENT_WRONG_PLEASE_CONTACT_WITH_SUPPORT';
                AlertBanner.publish({
                    type: 'error',
                    message: $filter('translate')(errorMessage),
                    timeCollapse: 4000
                });
                return reject(errorMessage);
            });
        })
    };

    this.createComment = function(event){
        event.event_type = "COMMENT";
        return createEvent(event);
    };

    this.createJobAddressComment = function(eng){
        const event = {};
        event.event_type = "COMMENT";
        event.automatic = true;
        event.data = $filter('translate')('JOB_ADDRESS') + ': ' + eng.ploy.address;
        if (eng.ploy.address_annotation) {
            event.data += ', ' + eng.ploy.address_annotation
        }
        return createEvent(event);
    };

    this.updateComment = function (event) {
        return EventResource.update_comment(event);
    };

    /**
     * Popup with question about understanding that this is multi-day ploy
     * is displayed and work-requirements checkbox list if
     * ploy is for many days or has work requirements.
     * At the end - always this.applyToPloy is triggered if success path.
     */

    this.askForWorkRequirements = (engagement) => {
        return new Promise((resolve, reject) => {
            if (!engagement.ploy.one_day_job || !(engagement.ploy.work_requirement.length === 0)) {
                return $uibModal.open({
                    templateUrl: 'src/modals/html/modals/modal-confirm-work-requirements.html',
                    controller: 'ModalConfirmWorkRequirementsController',
                    windowClass: 'modal-confirm modal-vertical-centered',
                    resolve: {
                        engagement: function () {
                            return engagement;
                        }
                    }
                });
            } else {
                return resolve(engagement);
            }
        });
    };

    this.applyToPloy = function (ploy, comment) {
        return new Promise((resolve, reject) => {
            Verification.verifyEmployeeProcedure().then(() => {
                EngagementResource.create({
                    'ploy_id': ploy.id,
                    'event_type': 'ENGAGEMENT_EMPLOYEE_APPLIED',
                    'data': comment,
                }).$promise.then((created) => {
                    return resolve(created.engagement);
                }, error => {
                    if (!error) return;  // if error is missing - case for new users. Check because empty reject may be returned by frontend
                    let errorMessage = (error.data[0]) ? error.data[0] : 'SOMETHING_WENT_WRONG_PLEASE_CONTACT_WITH_SUPPORT';
                    AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')(errorMessage),
                        timeCollapse: 4000
                    });
                });
            }, () => {
                return reject()
            })
        });
    };

    this.preApprove = function(eng){
        const event = {};
        event.event_type = "EMPLOYER_PRE_APPROVE";
        return createEvent(event, eng);
    };

    this.applyToPreApproved = function (eng) {
        const event = {};
        event.event_type = "ENGAGEMENT_EMPLOYEE_APPLIED";
        return createEvent(event, eng);
    };

    this.approve = function(eng){
        const event = {};
        event.event_type = "EMPLOYER_CHOSE_EMPLOYEE";
        return createEvent(event, eng);
    };

    this.cancel = function(eng){
        const event = {};
        event.event_type = "ENGAGEMENT_CANCELLED";
        return createEvent(event, eng);
    };

    this.decline = function(eng){
        const event = {};
        event.event_type = "ENGAGEMENT_DECLINED";
        return createEvent(event, eng);
    };

    this.completed = function(eng){
        const event = {};
        event.event_type = "ENGAGEMENT_COMPLETED";
        return createEvent(event, eng);
    };

    this.updateEngagement = function() {
        $rootScope.$broadcast('update-engagement');
    };

    this.publishedEngagementsOngoing = function(page) {
        engagement = EngagementResource.currentEngagementsListOngoing(page);
        return engagement;
    };

    this.publishedEngagementsCompleted = function(page) {
        engagement = EngagementResource.currentEngagementsListCompleted(page);
        return engagement;
    };

    this.previousEngagements = function(page) {
        engagement = EngagementResource.previousEngagementsList(page);
        return engagement;
    };

    this.downloadEngagementsPlan = (start, end) => {
        return EngagementResource.engagementsPlan({fromDate: start, toDate: end});
    };

    this.downloadEngagementsSummaryStats = (start, end) => {
        return EngagementResource.engagementsSummaryStats({fromDate: start, toDate: end});
    };

    this.downloadWeekPlanXls = (start, end) => {
        return EngagementResource.weekPlanXls({fromDate: start, toDate: end});
    };

    this.getEngagementToReplace = (id) => {
        return EngagementResource.getEngagementToReplace({engagement: id});
    };

    /**
     * Returns 'true' if validation is failing
     */
    this.applyValidationIsMissing = (ploy) => {
        if (!ploy) return false;
        if (!ploy.one_day_job && !ploy.confirmMultidayPloy) return true;
        if (ploy.work_requirement.length) {
            if (!ploy.workRequirementList) return true;
            let workRequirementListArray = Object.entries(ploy.workRequirementList);
            let someUnchecked = workRequirementListArray.map(elem => elem[1]).includes(false);
            if (
                workRequirementListArray.length !== ploy.work_requirement.length ||  // check if all required are checked
                someUnchecked === true  // verifies if some requirement was checked and then unchecked
            ) {
                return true;
            }
        }
        return false;
    };

    this.anyChosenEngagementWithCompanyExists = companyId => {
        return EngagementResource.anyChosenEngagementWithCompanyExists({'company_id': companyId});
    };



}]);

angular.module('ploys')

.service('Event', ['EventResource', function (EventResource) {
    this.create = function(form){
        return EventResource.save(form);
    };

    this.createComment = function(engagementId, event){
        event.event_type = "COMMENT";
        event.engagement = engagementId;
        return EventResource.save(event);
    };
}]);


angular.module('ploys')

.factory('Payment', ['PaymentResource', 'User', 'Engagement', 'Constants', '$uibModal', 'AlertBanner', '$filter', '$analytics', '$q', function (PaymentResource, User, Engagement, Constants, $uibModal, AlertBanner, $filter, $analytics, $q ) {



    var paymentService = {};
    paymentService.startStripe = function(engagement, hours_discount){
        var deffered = $q.defer();
        var paymentData = {};
        var handler = StripeCheckout.configure({
                key: Constants.stripe_key,
                token: function(token) {
                    console.log(token);
                    PaymentResource.completeStripe({id: paymentData.id}, {
                            stripe_token: token.id
                    },
                    function (response) {
                         Engagement.updateEngagement();
                         deffered.resolve('paid');
                         $analytics.eventTrack('Ploy paid', {category: 'Ploy', action: 'Ploy paid', value: response.amount * Constants.fee});
                        }, function () {
                          AlertBanner.publish({
                            type: 'error',
                            message: $filter('translate')('PAYMENT_FAILED_PLEASE_CONTACT_WITH_SUPPORT'),
                            timeCollapse: 4000
                        })
                        });
                    }
        });

        PaymentResource.start({id: engagement.id, hours_discount:hours_discount}, function(payment) {

            if (payment.total_cents <= 0){
                Engagement.updateEngagement();
                User.refresh(); // todo: optimize
                deffered.resolve('paid');
            }
            paymentData = payment;

            if( engagement.ploy.hours == hours_discount ) {  // if engagement payed by time cards, no need to load stripe popup
                Engagement.updateEngagement();
                User.refresh();
            } else {
                handler.open({
                    email: User.get().email,
                    name: 'meploy.me',
                    description: engagement.ploy.id,
                    currency: 'DKK',
                    amount: parseInt(payment.total_cents)
                });
            }
        });

        return deffered.promise;

    };

    paymentService.startWithFreeHours = function(eng){
        $uibModal.open({
            templateUrl: '/src/modals/html/modal-redeem-time-card.html',
            windowClass: 'modal-vertical-centered',
            size: 'sm',
            controller: 'ModalRedeemTimeCardController',
            resolve: {
                engagement: function () {
                    return eng;
                }
        }
        });
    };

    paymentService.startPayment = (engagement) => {
        if (User.get().hours_discount) {
            return paymentService.startWithFreeHours(engagement);
        } else {
            return paymentService.startStripe(engagement);
        }
    };

    paymentService.getInvoices = () => {
      return PaymentResource.getInvoices();
    };

    return paymentService;
}]);

angular.module('ploys')

    .service('PloyConstants', [function () {

        this.status = [
            {
                'name': 'PUBLISHED',
                'color': 'color-gg',
                'calendarColor': '#13b58a'
            },
            {
                'name': 'UNPUBLISHED',
                'color': 'color-da',
                'calendarColor': '#828282'
            },
            {
                'name': 'CANCELLED',
                'color': 'color-da',
                'calendarColor': '#A0A0A0'
            },
            {
                'name': 'ENDED',
                'color': 'color-bb',
                'calendarColor': '#F03E4F'
            },
            {
                'name': 'ASSIGNED',
                'color': 'color-gg',
                'calendarColor': '#1ca2bb'
            },
            {
                'name': 'PRIVATE',
                'color': 'color-gg',
                'calendarColor': '#13b58a'
            },
            {
                'name': 'ONGOING',
                'color': 'color-gg',
                'calendarColor': '#cf3849'
            },
            {
                'name': 'COMPLETED',
                'color': 'color-gg',
                'calendarColor': '#3f51b5'
            }
        ];

        this.helpText = {
            ASSIGNED: 'PLOY_STATUS_ASSIGNED__HELP',
            ENDED: 'PLOY_STATUS_ENDED__HELP',
            CANCELLED: 'PLOY_STATUS_CANCELLED__HELP',
            PRIVATE: 'PLOY_STATUS_PRIVATE__HELP',
            PUBLISHED: 'PLOY_STATUS_PUBLISHED__HELP',
            UNPUBLISHED: 'PLOY_STATUS_UNPUBLISHED__HELP',
            ONGOING: 'PLOY_STATUS_ONGOING__HELP',
            COMPLETED: 'PLOY_STATUS_COMPLETED__HELP',
        };

        this.ployAudienceTypes = {
            public: 'COMMUNITY',
            staff: 'STAFF',
            selected: 'SELECTED',
            group: 'GROUP'
        }

    }]);


angular.module('ploys')
.factory('PloyFilter', [ function() {

        var PloyFilter = {
          ploy : {},
          categories : []
        };

        PloyFilter.set = function(filters, categories) {
          PloyFilter.ploy = filters;
          PloyFilter.categories = categories;
        };

        PloyFilter.getPloyFilters = function () {
          return PloyFilter.ploy
        };

        PloyFilter.getCategoriesFilters = function () {
          return PloyFilter.categories
        };

    return PloyFilter;
}])
angular.module('ploys')
.factory('Ploy', ['PloyResource', '$analytics', '$filter', 'AlertBanner', '$location', 'Modal', '$translate', 'HandleServerErrors', 'Constants',
    function(PloyResource, $analytics, $filter, AlertBanner, $location, Modal, $translate, HandleServerErrors, Constants) {
    var ploy = {};

    var ployFactory = {};

    var ploys;


    ployFactory.get = PloyResource.get;

    ployFactory.getPublicPloy = PloyResource.publicPloy;

    ployFactory.getMyPloy = PloyResource.singlePloy;

    ployFactory.getPaymentPloy = PloyResource.ployWithoutEngagementsWithPayment;

    ployFactory.query = function() {
        ploys = PloyResource.query();
        return ploys;
    };

    ployFactory.getDefaultValuesForNewPloy = function(json_array) {
        ploys = PloyResource.getDefaultValuesForNewPloy(json_array);
        return ploys;
    };


    ployFactory.published = function(page) {
        ploys = PloyResource.currentPloysList(page);
        return ploys;
    };

    ployFactory.unPaid = function() {
        ploys = PloyResource.currentUnpaidPloysList();
        return ploys;
    };

    ployFactory.unPaidWithoutPayment = function() {
        ploys = PloyResource.currentUnpaidWithoutPaymentPloysList();
        return ploys;
    };


    ployFactory.publishedEngagements = function() {
        ploys = PloyResource.currentEngagementsList();
        return ploys;
    };

    ployFactory.previous = function(page) {
        ploys = PloyResource.previousPloysList(page);
        return ploys;
    };

    ployFactory.currentMyCalendarPloys = (start, end) => {
        ploys = PloyResource.currentMyCalendarPloys({'from': start, 'to': end});
        return ploys;
    };

    ployFactory.previousPaid = function(page) {
        ploys = PloyResource.previousPaidPloysList(page);
        return ploys;
    };

    ployFactory.getAvailableWorkers = function(startDay, endDay) {
        startDay = moment(startDay).format("YYYY-MM-DD");
        endDay = moment(endDay).format("YYYY-MM-DD");
        return PloyResource.getAvailableWorkers({start_day: startDay, end_day: endDay});
    };


    ployFactory.getMyPloys = PloyResource.getMyPloys;

    ployFactory.previousEngagements = function() {
        ploys = PloyResource.previousEngagementsList();
        return ploys;
    };

    ployFactory.publish = function (ploy) {
        return PloyResource.publish({ploy: ploy, id: ploy.id}).$promise.then(function () {
            AlertBanner.publish({
                type: 'info',
                message: $filter('translate')('PLOY_PUBLISHED'),
                timeCollapse: 4000
            });
        });
    };

    ployFactory.unPublish = function (ploy) {
        return PloyResource.unPublish({ploy: ploy, id: ploy.id}).$promise.then(function () {
            AlertBanner.publish({
                type: 'info',
                message: $filter('translate')('PLOY_UNPUBLISHED'),
                timeCollapse: 4000
            });
        });
    };

    ployFactory.transformTimeToInteger = hours => {
        let hrs = parseInt(Number(hours));
        let min = Math.round((Number(hours) - hrs) * 60);
        return {hours: hrs, minutes: min};
    };

    ployFactory.transformTimeToDecimal = (hours, minutes) => {
        if (hours === 12) {
            minutes = 0;
        }
        let timeToDecimal = (time) => {
            let arr = time.split(':');
            let dec = parseInt((arr[1] / 6) * 10, 10);
            return parseFloat(parseInt(arr[0], 10) + '.' + (dec < 10 ? '0' : '') + dec);
        };
        let time = moment().set({hour: hours, minute: minutes, second: 0, millisecond: 0});
        time = time.format('hh:mm');
        return timeToDecimal(time);
    };

    ployFactory.onPlaceChangedHandler = (place, obj, lastSetAddress) => {
        let placeData = ployFactory.parseAddressComponents(place.address_components);
        let postalCodeNotFound = false;

        if (!placeData.postal_code){
            obj.postal_code = '';
            postalCodeNotFound = true;
            return {obj: obj, postalCodeNotFound: postalCodeNotFound, lastSetAddress: lastSetAddress};
        }

        angular.extend(obj, placeData);
        obj.lat = String(place.geometry.location.lat()).slice(0, 8);
        obj.lon = String(place.geometry.location.lng()).slice(0, 8);
        lastSetAddress = place.formatted_address;
        return {obj: obj, postalCodeNotFound: postalCodeNotFound, lastSetAddress: lastSetAddress};
    };


    ployFactory.closePloy = PloyResource.close;

    ployFactory.reopen = PloyResource.reopen;

    ployFactory.makePloyPublic = (ploy) => {
        return Modal.confirm({
            title: $filter('translate')('MAKE_PLOY_PUBLIC__MODAL_TITLE'),
            message: $filter('translate')('ARE_YOU_SURE'),
            firstButtonLabel : $filter('translate')('CANCEL'),
            secondButtonLabel : $filter('translate')('PLOY_MANAGEMENT__MAKE_PUBLIC_BUTTON'),
            secondButtonColor : 'red',
            secondButtonFunction : function () {
                return PloyResource.makePublic({ploy: ploy, id: ploy.id}).$promise.then(function(){
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('MAKE_PLOY_PUBLIC__SUCCESS_MESSAGE'),
                        timeCollapse: 4000
                    });
                });
            }
        });
    };

    ployFactory.makePloyForAllStaff = (ploy) => {
        return Modal.confirm({
            title: $filter('translate')('MAKE_FOR_ALL_STAFF__MODAL_TITLE'),
            message: $filter('translate')('MAKE_FOR_ALL_STAFF__MODAL_MESSAGE'),
            firstButtonLabel: $filter('translate')('CANCEL'),
            secondButtonLabel: $filter('translate')('PLOY_MANAGEMENT__MAKE_FOR_ALL_STAFF_BUTTON'),
            secondButtonColor: 'red',
            secondButtonFunction: () => {
                return PloyResource.makeForAllStaff({ploy: ploy, id: ploy.id}).$promise.then(() => {
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('MAKE_FOR_ALL_STAFF__SUCCESS_MESSAGE'),
                        timeCollapse: 4000
                    });
                });
            }
        });
    };

    ployFactory.hasStaffObjsWithoutEngs = PloyResource.hasStaffObjsWithoutEngs;

    ployFactory.update = PloyResource.update;

    ployFactory.savePloy = function (form) {
        if (form.id) {
            return PloyResource.update(form).$promise.then(response => {
                return response
            }, HandleServerErrors.handleFormError)
        } else {
            return PloyResource.save(form).$promise.then(response => {
                let ploy = response;
                $analytics.eventTrack('Ploy posted', {
                    category: 'Ploy',
                    action: 'Ploy created',
                    label: 'Post ploy'
                });
                $analytics.eventTrack('purchase', {
                    value: ploy.hours * 15 * ploy.working_days_number, currency: 'DKK',
                    'items': [{
                        'id': 'ploy' + new Date().toISOString().slice(0, 19),
                        'location_id': 'DA',
                        'google_business_vertical': 'jobs'
                    }]
                });
                return response
            }, HandleServerErrors.handleFormError)
        }
    };

    var addressComponentsFieldMap = {
        street_number: 'street_number',
        route: 'route',
        postal_code: 'postal_code',
        locality: 'locality',
        country: 'country'
    };

    ployFactory.parseAddressComponents = function(address_components) {
        var parsedAddress = {};

        angular.forEach(address_components,function(address_component) {
            angular.forEach(address_component.types,function(adress_component_type) {
                if (adress_component_type in addressComponentsFieldMap) {
                    parsedAddress[addressComponentsFieldMap[adress_component_type]]=address_component.long_name;
                }
            })
        });

        return parsedAddress;
    };

    ployFactory.getBasePloyParams = (user) => {
        let temp = new Date();
        return {
            hours: Constants.hours[5].value,  // set default to 8 hours => Constants.hours[5] == 8
            ployees_needed: 1,
            weekdays: 0,
            end_day:temp,
            start_day:temp,
            start_time:temp,
            pension_hour: 0,
        }
    };

    ployFactory.isPlaceWithinRestrictions = function(place) {
      var allowedCities = [
        'copenhagen',
        'københavn',
        'amager',
        'frederiksberg',
        'tårnby',
        'dragør',
        'hvidovre',
        'rødovre',
        'hellerup',
        'glostrup',
        'charlottenlund',
        'kastrup',
        'gentofte',
        'københavn k',
        'kongens lyngby',
        'virum',
        'søborg',
        'greve strand'
      ];


        if (!place || !place.address_components){
            return false;
        }
        var parsedAddress = ployFactory.parseAddressComponents(place.address_components);

        if (!parsedAddress.locality){
            return false
        }

        console.log(parsedAddress.locality, _.includes(allowedCities, parsedAddress.locality));
        return _.includes(allowedCities, parsedAddress.locality.toLowerCase());

    };

    ployFactory.getPloyFilterAutocompleteData = PloyResource.getPloyFilterAutocompleteData;

    ployFactory.getChosenUsers = PloyResource.getChosenUsers;

    ployFactory.sendMessageToWorkers = PloyResource.sendMessageToWorkers;

    ployFactory.getPublicEngagementsList = PloyResource.publicEngagements;

    ployFactory.getMyEngagementForPloy = PloyResource.myEngagementForPloy;

    ployFactory.getMyPloyTags = PloyResource.myPloyTags;

    return ployFactory;
}]);

angular.module('postEditPloy')
    .controller('PostPloyMultidayPopoverController', ['$scope', 'Modal', '$filter', 'User', 'Constants', function ($scope, Modal, $filter, User, Constants) {
        $scope.switchClient = () => {

            let confirmFn = () => {
                User.switchClient(2).then(() => {
                    window.location = DEBUG ? Constants.dashboardEnvUrls.DEV : Constants.dashboardEnvUrls.PROD;
                });
            }

            return Modal.confirm({
                title: $filter('translate')('POST_EDIT_PLOY__TEMPLATE_OVERWRITE_ALERT__TITLE'),
                message: $filter('translate')('POST_EDIT_PLOY__TEMPLATE_REDIRECT_ALERT__MESSAGE'),
                secondButtonLabel: $filter('translate')('YES'),
                firstButtonLabel: $filter('translate')('NO_THANKS'),
                secondButtonColor: 'green',
                secondButtonFunction: confirmFn,
            });

        }
    }])


angular.module('postEditPloy')
.controller('PostEditPloyController', ['$scope', 'User', 'Ploy', '$location', 'PloyFormStorage', 'Constants', '$routeParams',
    'Category', '$filter', 'Verification', 'AlertBanner', '$timeout', '$q','$analytics',
    'SalaryPredictResource', 'SupplementResource', 'SalaryRulesResource', 'StaffGroupsService', 'PloyTemplateService',
    'Modal', '$translate', 'SalaryGroupService', 'PloyConstants', 'Company', 'Engagement',
    function ($scope, User, Ploy, $location, PloyFormStorage, Constants, $routeParams, Category, $filter, Verification,
              AlertBanner, $timeout, $q, $analytics, SalaryPredictResource, SupplementResource,
              SalaryRulesResource, StaffGroupsService, PloyTemplateService, Modal, $translate, SalaryGroupService,
              PloyConstants, Company, Engagement) {

    $scope.tempHours = Constants.hours[5].value;
    $scope.tempMinutes = 0;
    $scope.hours = Constants.hours;
    $scope.minutes = Constants.minutes;
    $scope.ployeesNeededMaxValue = Constants.ployeesNeededMaxValue;
    $scope.ploy = {
        is_salary_type: true,  // 'salary' or 'manual'
        notify_on_apply: true,
        target_meployees: [],
        target_groups: [],
        work_requirement: [],
        max_pause_time: undefined,
    };
    $scope.supplements = [];
    $scope.allCategories = [];
    $scope.hasSalarySettings = false;
    $scope.daysWithoutWeekdaysChoose = Constants.daysWithoutWeekdaysChoose;
    $scope.dates = _.get($routeParams,'dates',false);
    $scope.date = _.get($routeParams,'date',false);
    $scope.user = User.get();
    $scope.editMode = false;
    $scope.promiseChain = [];
    $scope.postalCodeNotFound = false;
    $scope.promiseChain2 = [];
    $scope.selectedTemplate = undefined;
    $scope.hasAnyPloyTemplates = false;
    $scope.usersAvailableForWork = 0;
    $scope.loading = false;
    $scope.advancedOptionsCollapsed = true;
    $scope.showUnpaidPause = false;

    User.get().$promise.then((user) => {
        $scope.minPriceHour = user.profile.price_hour || 120;
        $scope.loadSupplements();
        $scope.ploy.address_annotation = user.company.address_annotation
    });

    $scope.postForStaff = () => {
        if ($scope.ploy.target_meployees) {
            return $scope.ploy.target_meployees[0] === 'all'
        }
    };
    $scope.postForGroups = () => {
        if ($scope.ploy.target_groups) {
            return $scope.ploy.target_groups.length > 0
        }
    };
    $scope.postForSelected = () => {
        if ($scope.ploy.target_meployees) {
            return $scope.ploy.target_meployees.length > 0
        }
    };

    let showLoader = () => $scope.loading = true;
    let hideLoader = () => $scope.loading = false;

    $scope.calculatePloyHours = (hours, minutes) => {
        $scope.ploy.hours = Ploy.transformTimeToDecimal(hours, minutes);
    };

    $scope.user = User.get;

    var timeout = $timeout(function(){});

    SalaryRulesResource.hasSalarySettings().$promise.then(data => {
        $scope.hasSalarySettings = data.has_salary_settings;
        if ($scope.hasSalarySettings) {
            $scope.salaryGroups = SalaryGroupService.getSalaryGroups;
            if (!($routeParams.ploy_id || $routeParams.duplicate_ploy_id)) {  // set default salary group only when posting a new ploy
                SalaryGroupService.getList().$promise.then(groups => {
                    $scope.ploy.salary_group = groups.find(group => group.is_default === true).id;
                });
            }
        } else {
            $scope.ploy.is_salary_type = false;
        }
    });

    User.hasAnyPloyTemplates().$promise.then(response => {
        $scope.hasAnyPloyTemplates = response.has_ploy_templates;
        $scope.getPloyTemplates = PloyTemplateService.getPloyTemplates;
    });

    let getUsersAvailableForWork = (startDay, endDay) => {
        if (!isValidDate(startDay) || !isValidDate(endDay)) { return }  // validate if dates are correct
        Ploy.getAvailableWorkers(startDay, endDay).$promise.then(workers => {
           $scope.usersAvailableForWork = workers.count;
        });
    };

    let isValidDate = (d) => {
        return d instanceof Date && !isNaN(d);
    };

    $scope.switchPloyType = audience => {
        let setPublicAudience = () => {
            $scope.ploy.target_meployees = [];
            $scope.ploy.target_groups = [];
        };
        let setStaffAudience = () => {
            $scope.ploy.target_groups = [];
            $scope.ploy.target_meployees = ['all'];
        };
        let setSelectedAudience = () => {
            $scope.ploy.target_groups = [];
            if ($scope.postForStaff()) {
                $scope.ploy.target_meployees.shift();
            }
        };
        let setGroupsAudience = () => {
            $scope.ploy.target_meployees = [];
        };

        // $scope.ploy.ployees_needed = undefined;

        switch (audience) {
          case PloyConstants.ployAudienceTypes.public:
              setPublicAudience();
              break;
          case PloyConstants.ployAudienceTypes.staff:
              setStaffAudience();
              break;
          case PloyConstants.ployAudienceTypes.selected:
              setSelectedAudience();
              break;
          case PloyConstants.ployAudienceTypes.group:
              setGroupsAudience();
              break;
        }
    };

    $scope.usePloyTemplate = (template) => {
        let useTemplate = () => {
            PloyTemplateService.getSingleTemplate(template.id).$promise.then(fullTemplate => {
                $scope.selectedTemplate = fullTemplate.id;
                $scope.useSalarySettingsType(!fullTemplate.price_hour);
                // delete below added because weekdays should be send from ploy choose, not from value saved in template
                delete fullTemplate.weekdays;
                // below - make sure that salary group from template was not removed
                if ($scope.hasSalarySettings && !$scope.salaryGroups().find(elem => elem.id === fullTemplate.salary_group)) {
                    delete fullTemplate.salary_group;
                }
                angular.extend($scope.ploy, fullTemplate);
                $scope.tempHours = Ploy.transformTimeToInteger(fullTemplate.hours).hours;
                $scope.tempMinutes = Ploy.transformTimeToInteger(fullTemplate.hours).minutes;
                if (fullTemplate.work_requirement.length > 0 || fullTemplate.tag.length > 0) {
                    $scope.advancedOptionsCollapsed = false;
                }
                $scope.calculatePloyHours($scope.tempHours, $scope.tempMinutes);
                $scope.ploy.id = undefined;
                $scope.ploy.ploy_template = fullTemplate.id;
                $scope.supplements = fullTemplate.supplement; // TODO: move supplements into ploy body (like in templates)?
                $scope.ploy.category = $scope.allCategories.find(category => {
                    return category.slug === fullTemplate.category.slug;
                });
                if (fullTemplate.free_pause_time) {
                    $scope.showUnpaidPause = true;
                }
            }, err => {
                AlertBanner.publish({
                    type: 'error',
                    message: $filter('translate')('COMMUNICATION__SERVER_ERROR'),
                    timeCollapse: 3000,
                });
            });
        };
        return Modal.confirm({
            title: $filter('translate')('POST_EDIT_PLOY__TEMPLATE_OVERWRITE_ALERT__TITLE'),
            message: $filter('translate')('POST_EDIT_PLOY__TEMPLATE_OVERWRITE_ALERT__MESSAGE'),
            secondButtonLabel: $filter('translate')('YES'),
            firstButtonLabel: $filter('translate')('NO_THANKS'),
            secondButtonColor: 'green',
            secondButtonFunction: useTemplate,
        });
    };

    $scope.showFactor = (temp_agency) => {
        if($scope.editMode) {
            return $scope.ploy.temp_agency;
        }
        return temp_agency;
    };

    $scope.clearStartDay = () => {
        $scope.ploy.start_day = new Date();
        $scope.datePeriodInDays = 0; // Reset ploy duration in days
    };

    $scope.clearEndDay = () => {
        $scope.ploy.end_day = new Date();
        $scope.datePeriodInDays = 0; // Reset ploy duration in days
    };

    $scope.startDateChanged = (newStartDate) => {
        $scope.datePeriodInDays = moment($scope.ploy.end_day).diff(moment(newStartDate), 'days'); // Calculate ploy duration with new date.
        $scope.$broadcast('ployDateChanged', {startDay: newStartDate}); // Broadcast for work-days directive
        getUsersAvailableForWork(newStartDate, $scope.ploy.end_day);
    };

    $scope.endDateChanged = (newEndDate) => {
        $scope.datePeriodInDays = moment(newEndDate).diff(moment($scope.ploy.start_day), 'days'); // Calculate ploy duration with new date.
        $scope.$broadcast('ployDateChanged', {endDay: newEndDate}); // Broadcast for work-days directive
        getUsersAvailableForWork($scope.ploy.start_day, newEndDate);
    };


    // debounce for uib-timepicker
    // ng model option debounce doesnt work correctly
    $scope.timeHasChanged = function(category, start_time){
        $timeout.cancel(timeout); //cancel the last timeout
        timeout = $timeout(function(){
            $scope.getLastSalary(category,start_time);
        }, 500);
    };

    User.getFeeHour().$promise.then((feeHour) => {
        $scope.feeHour = feeHour.value;
    });


    let salaryPredict = (ploy, startDay, endDay, isMultidayPredict) => {
        if (startDay === undefined || ploy.paid_pause_time === undefined || ploy.start_time === undefined) {
            return;  // wait for more data: some data is missing
        }
        SalaryPredictResource.save({
            hours: ploy.hours,
            end_day: endDay,
            start_day: startDay,
            start_time: ploy.start_time,
            weekdays: ploy.weekdays,
            paid_pause_time: ploy.paid_pause_time,
            max_pause_time: ploy.max_pause_time,
            base_salary: ploy.price_hour,
            supplements: $scope.supplements,
            salary_group_id: ploy.salary_group || undefined,
        }).$promise.then((data) => {
            if (isMultidayPredict) {
                data.start_day = startDay;
                $scope.salary_prediction.push(data);
            } else {
                $scope.salary_prediction = data;
            }
        }, err => {
            $scope.useSalarySettingsType(false);
            $scope.hasSalarySettings = false;
        });
    };

    $scope.requestSalary = () => {
        $timeout.cancel(timeout); //cancel the last timeout
        timeout = $timeout(function(){
            $scope.ploy.weekdays = fixWeekdayForPredict();
            if ($scope.dates) {
                $scope.salary_prediction = [];
                $scope.ploy.start_day.forEach(startDay => {
                    salaryPredict($scope.ploy, startDay, startDay, true);
                });
                return;
            }
            let startDay = $scope.ploy.start_day;
            let endDay = $scope.ploy.end_day;
            salaryPredict($scope.ploy, startDay, endDay, false);
        }, 1000);
    };


    $scope.$watchGroup(['ploy.hours', 'ploy.price_hour', 'ploy.end_day','ploy.start_day','ploy.start_time','ploy.weekdays','ploy.paid_pause_time', 'ploy.max_pause_time', 'supplements', 'ploy.salary_group'], function(newVal, oldVal) {
        return $scope.requestSalary(); // TODO: Remove it from watcher to avoid input lags
    });

    Company.getCompany().$promise.then(company => {
        $scope.ploy.paid_pause_time = company.paid_pause_time;
        if (!$scope.ploy.id) {  // only if new ploy
            $scope.ploy.max_pause_time = (company.paid_pause_time) ? 30 : 0;
        }
    });

    $scope.setPaidPauseTimeIfPossible = (value) => {
        $scope.user().can_edit_salary ? $scope.ploy.paid_pause_time = value : null;
        $scope.ploy.max_pause_time = $scope.ploy.paid_pause_time ? 30 : 0;
        if (!value) { $scope.ploy.free_pause_time = 0 }
    };

    $scope.getLastDescription = (category,start_time) => {
        if (!$routeParams.ploy_id && !$scope.selectedTemplate && category) {
            let data = start_time?{id:_.get(category,'id'),hour:moment(start_time).utc().hour()}:{id:_.get(category,'id')};
            Ploy.getDefaultValuesForNewPloy(data).$promise.then(function (data) {
                $scope.ploy['address'] = _.get(data,'address');
                $scope.ploy['description'] = _.get(data,'description');
                $scope.ploy['postal_code'] = _.get(data,'postal_code');
                $scope.ploy['route'] = _.get(data,'route');
                $scope.ploy['street_number'] = _.get(data,'street_number');
                $scope.ploy['lat'] = _.get(data,'lat');
                $scope.ploy['lon'] = _.get(data,'lon');
                $scope.ploy['price_hour'] = _.get(data,'price_hour');
                $scope.ploy['pension_hour'] = _.get(data,'pension_hour');
                $scope.lastSetAddress = $scope.ploy['address'];
            });
        }
    };

    if (PloyFormStorage.hasPloyForm()){
        $scope.ploy = PloyFormStorage.getPloyForm();
    }

    Category.getAll().$promise.then(categories => {
        $scope.allCategories = categories;
    });


    if ($routeParams.ploy_id || $routeParams.duplicate_ploy_id) { // Edit existing ploy
        $scope.editMode = !!$routeParams.ploy_id;
        Ploy.get({id:$routeParams.ploy_id||$routeParams.duplicate_ploy_id}).$promise.then(data => {
            if (data.company.id != User.get().company.id) return $location.path('page-not-found');  // Show 404 page if is trying to edit someone's ploy
            let temp_ploy = data;
            if (temp_ploy.work_requirement.length > 0 || temp_ploy.tag.length > 0) {
                $scope.advancedOptionsCollapsed = false;
            }
            if($routeParams.duplicate_ploy_id) {
                delete temp_ploy.id;
                delete temp_ploy.status;
                delete temp_ploy.is_private;
                delete temp_ploy.engagements;
            }
            $scope.ploy = temp_ploy;
            $scope.tempHours = Ploy.transformTimeToInteger(temp_ploy.hours).hours;
            $scope.tempMinutes = Ploy.transformTimeToInteger(temp_ploy.hours).minutes;
            $scope.ploy.category = $scope.allCategories.find(category => {
                return category.slug == data.category.slug;
            });
            $scope.startDateChanged(temp_ploy.start_day);
            $scope.endDateChanged(temp_ploy.end_day);

            if ($routeParams.duplicate_ploy_id && $routeParams.since && $routeParams.to) {
                $scope.ploy.start_day = new Date(moment($routeParams.since).startOf('day'));
                $scope.ploy.end_day = new Date(moment($routeParams.to).startOf('day'));
            }
            if (temp_ploy.free_pause_time) {
                $scope.showUnpaidPause = true;
            }
        }, err => $location.path('/my-ploys'));
    } else { // Create new public ploy
        let fun = () => {
            let deferred = $q.defer();
            User.get().$promise.then(function(user){
                $scope.ploy = angular.extend($scope.ploy, Ploy.getBasePloyParams(user));
                $scope.ploy.staffing_permission = user.company.staffing_permission;
                deferred.resolve();
            });
            return deferred.promise;
        };

        $scope.promiseChain.push(fun);
    }

    if ($routeParams.target_meployees) { // Ploy for selected meployees
        let fun = () => {
            let deferred = $q.defer();
            $scope.ploy.target_meployees = $routeParams.target_meployees.split(",");
            $scope.ploy.ployees_needed = $scope.ploy.target_meployees.length;
            deferred.resolve();
            return deferred.promise;
        };
        $scope.promiseChain.push(fun);
    }

    if ($routeParams.replacement_for) { // Ploy as replacement for specified engagement
        let fun = () => {
            let deferred = $q.defer();
            Engagement.getEngagementToReplace($routeParams.replacement_for).$promise.then(eng => {
                $scope.ploy.replacement_for = eng.id;
                $scope.ploy.start_time = eng.checkin_time;
                $scope.ploy.paid_pause_time = eng.ploy.paid_pause_time;
                $scope.ploy.max_pause_time = eng.ploy.max_pause_time;
                $scope.ploy.description = eng.ploy.description;
                $scope.ploy.work_requirement = eng.ploy.work_requirement;
                $scope.ploy.tag = eng.ploy.tag;
                $scope.ploy.free_pause_time = eng.ploy.free_pause_time;
                $scope.ploy.category = $scope.allCategories.find(cat => cat.slug === eng.ploy.category.slug);
                $scope.ploy.address = eng.ploy.address;
                $scope.ploy.postal_code = eng.ploy.postal_code;
                $scope.supplements = eng.ploy.supplement;
                $scope.tempHours = Ploy.transformTimeToInteger(eng.ploy.hours).hours;
                $scope.tempMinutes = Ploy.transformTimeToInteger(eng.ploy.hours).minutes;
                $scope.ploy.salary_group = $scope.salaryGroups().find(sg => sg.id === eng.ploy.salary_group).id;
            });
            deferred.resolve();
            return deferred.promise;
        };
        $scope.promiseChain.push(fun);
    }

    if ($routeParams.all_staff) { // Creates engagements with Pre-approved status for all people from the staff
        let fun = () => {
            let deferred = $q.defer();
            $scope.ploy.target_meployees = ['all'];
            deferred.resolve();
            return deferred.promise;
        };
        $scope.promiseChain.push(fun);
    }

    if ($routeParams.allGroup) {
        let fun = () => {
            let deferred = $q.defer();
            $scope.ploy.target_groups = $routeParams.allGroup.split(",");
            deferred.resolve();
            return deferred.promise;
        };
        $scope.promiseChain.push(fun);
    }

    $scope.getStaffGroups = () => {
        let res = StaffGroupsService.getStaffGroups();
        return (res.length) ? res.filter(group => $scope.ploy.target_groups.findIndex(g => g == group.id) > -1) : [];
    };

    $scope.targetGroupsMeployeeCount = () => {
        return $scope.getStaffGroups().reduce((acc, group) => {
            return acc + group.members.length
        }, 0);
    };

    $scope.initializeDatesFromCalendar = () => {
        if($scope.dates) {
            var dates = JSON.parse(atob(_.get($routeParams,'dates')));
            $scope.ploy.start_day = [];
            angular.forEach(dates,function(date){
                $scope.ploy.start_day.push(new Date(date));
            });
            $scope.ploy.start_day.sort(function(a,b){
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return b - a;
            });
        }
        if ($routeParams.date) {
            const date = $routeParams.date;
            $scope.ploy.start_day = moment(date).startOf('day').toDate();
            $scope.ploy.end_day = moment(date).startOf('day').toDate();
        }
        getUsersAvailableForWork($scope.ploy.start_day, $scope.ploy.end_day);
    };

    $scope.saveOnePloy = (ploy, supplements, redirect) => {
        if ($scope.hasSalarySettings && !User.get().can_edit_salary && !ploy.is_salary_type) {
            hideLoader();
            return AlertBanner.publish({
                type: 'error',
                message: $filter('translate')('BASE_SALARY__CHANGES_NOT_ALLOWED_INFO'),
                timeCollapse: 4000
            });
        }
        ploy.supplement = supplements;
        Ploy.savePloy(ploy).then(response_ploy => {
            if (ploy.saveAsTemplate) {
                let template = angular.copy(ploy);
                delete template.id;
                if (supplements) {
                    template.supplement = supplements.map(s => { s.weekdays = 127; return s });
                }
                if (ploy.work_requirement) {
                    template.work_requirement = angular.copy(ploy.work_requirement);
                }
                PloyTemplateService.savePloyTemplate(template).$promise.then(response => {
                    PloyTemplateService.reloadPloyTemplates();
                }, err => {
                    hideLoader();
                    console.log('error when save template');
                    console.log(err);
                });
            }
            if (redirect) {
                $location.path('/my-ploys/'+ response_ploy.id).search({});
                hideLoader();
            }
        }, error => hideLoader());
    };

    $scope.savePloys = (ploy, supplements) => {
        // ensure that start_day and end_day does not keep start time information - only information about day
        if (!$scope.dates) {
            ploy.start_day = moment(ploy.start_day).startOf('day');
            ploy.end_day = moment(ploy.end_day).startOf('day');
        }

        let ploy_start_day = _.get(ploy,'start_day');
        if (_.isArray(ploy_start_day)) {
            var temp_ploy = {};
            for (let i = 0; i < _.size(ploy_start_day); i++) {
                temp_ploy = angular.extend({}, ploy);
                temp_ploy.start_day = ploy_start_day[i];
                temp_ploy.end_day = ploy_start_day[i];
                if(i < _.size(ploy_start_day)-1) {
                    $scope.saveOnePloy(temp_ploy, supplements, false);
                } else {
                    $scope.saveOnePloy(temp_ploy, supplements, true);
                }
            }
            return;
        }
        $scope.saveOnePloy(ploy, supplements, true);
    };



    const ployInPastCheck = ploy => {
        return new Promise((resolve, reject) => {
            if (moment(ploy.start_day).isBefore(moment().subtract(1, 'days'))) {
                return Modal.confirm({
                    title: $filter('translate')('POST_EDIT_PLOY__PLOY_IN_PAST_CONFIRM_MODAL__TITLE'),
                    message: $filter('translate')('POST_EDIT_PLOY__PLOY_IN_PAST_CONFIRM_MODAL__CONTENT'),
                    firstButtonLabel: $filter('translate')('CANCEL'),
                    secondButtonLabel: $filter('translate')('CONTINUE'),
                    secondButtonColor: 'green',
                    firstButtonFunction: reject,
                    secondButtonFunction: resolve,
                    onCloseFunction: reject,
                    staticBackdrop: true
                });
            } else {
                resolve();
            }
        })
    };


    $scope.create = (ploy, supplements) => {
        showLoader();
        let dayOrder = [6,0,1,2,3,4,5];
        if($scope.datePeriodInDays > $scope.daysWithoutWeekdaysChoose) {
            if (((1 << (dayOrder[ploy.start_day.getDay()])) & ploy.weekdays) == 0) {
                AlertBanner.publish({
                    type: 'error',
                    message: $filter('translate')('START_DAY_MUST_BE_IN_WEEKDAYS'),
                    timeCollapse: 4000
                });
                return hideLoader();
            }
            if (((1 << (dayOrder[ploy.end_day.getDay()])) & ploy.weekdays) == 0) {
                AlertBanner.publish({
                    type: 'error',
                    message: $filter('translate')('START_DAY_MUST_BE_IN_WEEKDAYS'),
                    timeCollapse: 4000
                });
                return hideLoader();
            }
        }

        if (User.get().legal_form == null) {
            hideLoader();
            Verification.chooseLegalFormModal();
        } else {
            Verification.verifyUserProcedure().then(() => {
                ployInPastCheck(ploy).then(() => {
                    $scope.savePloys(ploy, supplements);
                }, () => hideLoader());
            }, () => hideLoader())
        }

    };

    $scope.lastSetAddress = '';

    $scope.onPlaceChangedCheck = () => {
        if (!$scope.ploy.postal_code) {
            $scope.postalCodeNotFound = true;
        }
        $timeout(function () {
            if ($scope.lastSetAddress != $scope.ploy.address) {
                $scope.ploy.postal_code = '';
                $scope.postalCodeNotFound = true;
            }
        }, 500);
    };

    $scope.onPlaceChanged = place => {
        let result = Ploy.onPlaceChangedHandler(place, $scope.ploy, $scope.lastSetAddress);
        $scope.template = result.obj;
        $scope.postalCodeNotFound = result.postalCodeNotFound;
        $scope.lastSetAddress = result.lastSetAddress;
        $scope.$apply();
    };

    $scope.runInitPromises = () => {
        $scope.promiseChain2 = $scope.promiseChain[0];
        $scope.promiseChain.shift();
        if(_.size($scope.promiseChain)) {
            angular.forEach($scope.promiseChain,(promise) => {
               $scope.promiseChain2= typeof $scope.promiseChain2 === "function"?$scope.promiseChain2().then(promise):$scope.promiseChain2.then(promise);
            });
            $scope.promiseChain2.then($scope.initializeDatesFromCalendar);
            return
        }
        if ($scope.promiseChain2) {
            $scope.promiseChain2().then($scope.initializeDatesFromCalendar);
        }
    };

    $scope.runInitPromises();

    $scope.calcTotalCost = () => {
        if ($scope.salary_prediction) {
            return $scope.salary_prediction.avg_salary_per_hour * $scope.user().factor;
        }
    };

    $scope.multiplyByFactor = (value) => {
        return value * $scope.user().factor
    };

    $scope.useSalarySettingsType = (isSalaryType) => {
        $scope.ploy.is_salary_type = isSalaryType;
        if (isSalaryType) {
            $scope.ploy.price_hour = undefined;
        }
    };

    let fixWeekdayForPredict = () => {
        if ($scope.ploy.weekdays === 0 &&
            moment($scope.ploy.end_day).diff(moment($scope.ploy.start_day), 'days') <= $scope.daysWithoutWeekdaysChoose) {
            $scope.ploy.weekdays = Math.pow(2, ($scope.ploy.start_day.getDay() + 6) % 7);
            if ($scope.ploy.start_day.getDay() !== $scope.ploy.end_day.getDay()) {
                $scope.ploy.weekdays += Math.pow(2, ($scope.ploy.end_day.getDay() + 6) % 7);
            }
        }
        return $scope.ploy.weekdays;
    };


    $scope.addSupplement = (supplement) => {
        $scope.requestSalary();
    };

    $scope.removeSupplement = (supplement) => {
        $scope.requestSalary();
    };

    $scope.loadSupplements = () => {
        SupplementResource.getSupplementsForPloy({ployId: $routeParams.ploy_id || $routeParams.duplicate_ploy_id}).$promise.then((supplements) => {
            $scope.supplements = supplements;
        })
    };

    $scope.showUnpaidPauseForm = () => {
        $scope.showUnpaidPause = true;
    }

    $scope.formatFactor = factor => {
        return `${( (factor - 1) * 100).toFixed(2)}%`
    }



}]);

angular.module('profile-settings')

.controller('AccountSettingsController', ['$scope', 'User', '$location', 'Constants', 'Auth', 'Modal', '$filter',
    'LanguageService', 'Verification', 'AlertBanner',
    function($scope, User, $location, Constants, Auth, Modal, $filter, LanguageService, Verification, AlertBanner) {
    User.get().$promise.then(function(user) {
        $scope.form = angular.copy(user);
        if ($scope.form.language !== LanguageService.getCurrentLanguage()) {
            $scope.form.language = LanguageService.getCurrentLanguage();
        }
    });
    $scope.patterns = Constants.patterns;
    $scope.oauthLogin = Auth.oauthLogin;
    $scope.setLanguage = LanguageService.setLanguage;
    $scope.languages = Constants.languages;
    $scope.countries = Constants.countries;
    $scope.newPassword = false;
    $scope.verifyMyEmail = Verification.sendVerificationEmail;


    $scope.passwordPlaceholder = function () {
      if (!$scope.newPassword) {
          return '••••••'
      } else {
          return $filter('translate')('NEW_PASSWORD');
      }
    };

    $scope.unLockPasswordInput = function () { $scope.newPassword = true };

    $scope.deleteMyAccount = function () {
        Modal.confirm({
          title : $filter('translate')('DELETE_MY_ACCOUNT'),
          message : $filter('translate')('CONFIRM_ACCOUNT_DELETE'),
          firstButtonLabel : $filter('translate')('CANCEL'),
          secondButtonLabel : $filter('translate')('DELETE'),
          secondButtonColor : 'red',
          secondButtonFunction : function () {
          return User.delete();
          }
        });
    };

    $scope.changePassword = function(form, form_name) {
        User.changePassword(form).$promise.then(function(){
            $location.path('/profile-settings');
        }, function(error){
            AlertBanner.publish({
                type: 'error',
                message: $filter('translate')('PAYMENT_FAILED_PLEASE_CONTACT_WITH_SUPPORT'),
                timeCollapse: 4000
            })
        });
    };

    $scope.saveAccountSettings = function(user) {
        let data = {
            'id': user.id,
            'email': user.email,
            'language': user.language,
            'country': user.country
        }
        if (user.password) {
            data['password'] = user.password;
        }
        return User.changeAccountSettings(data).$promise.then(function() {
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('SAVED') + '!',
                timeCollapse: 4000
            });
            $location.path('/profile-settings');
        });
    };

}]);

angular.module('profile-settings')

.controller('NotificationSettingsController', ['$scope', 'UserResource', 'User', 'AlertBanner', '$filter', '$location',
        function($scope, UserResource, User, AlertBanner, $filter, $location) {

    User.get().$promise.then(user => $scope.form = angular.copy(user));

    $scope.saveNotifications = form => {
      User.save(form).then(() => $location.path('/profile-settings'))
    }

}]);
angular.module('profile-settings')

.controller('PrivacySettingsController', ['$scope', 'UserResource', 'User', 'AlertBanner', '$filter', '$location',
        function($scope, UserResource, User, AlertBanner, $filter, $location) {

    User.get().$promise.then(user => $scope.form = angular.copy(user));

    $scope.savePrivacy = form => {
      User.save(form).then( () => $location.path('/profile-settings'));
    }

}]);
angular.module('profile-settings')

    .controller('newProfileSettingsController', ['$scope', 'UserResource', 'User', 'Constants', '$uibModal', 'Upload',
        function ($scope, UserResource, User, Constants, $uibModal, Upload) {
            $scope.picFile = '';
            $scope.upload = (picFile) => {
                Upload.base64DataUrl(picFile).then(base64image => {
                    $uibModal.open({
                        templateUrl: 'src/modals/html/modal-crop-image.html',
                        controller: 'ModalCropImageController',
                        windowClass: 'modal-alert modal-vertical-centered',
                        backdrop: 'static',
                        resolve: {
                            image: () => base64image
                        }
                    }).result.then(base64data => {
                        User.upload_avatar_64(base64data);
                    })
                });
                $scope.picFile = '';
            };
            $scope.profileComplete = 0;
            $scope.profileCompletePercentage = () => {
                return UserResource.getProfileProgress().$promise.then(data => {
                    $scope.profileComplete = data.progress;
                })
            };

            $scope.userTypes = Constants.userTypes;
        }]);

angular.module('profile-settings')


.controller('VerificationsSettingsController', ['$scope', 'User', '$location', 'Constants', 'Auth', 'Verification',
        function($scope, User, $location, Constants, Auth, Verification) {

    $scope.patterns = Constants.patterns;
    $scope.userTypes = Constants.userTypes;
    $scope.oauthLogin = Auth.oauthLogin;
    $scope.verifyAndSavePhoneDirectlyFromForm= Verification.verifyAndSavePhoneDirectlyFromForm;
    $scope.saveVerificationSettings = Verification.saveUserCheckPhone;
    $scope.sendVerificationEmail = Verification.sendVerificationEmail;
    $scope.form = {};

    User.get().$promise.then(user => $scope.form = angular.copy(user));

    $scope.$on('user-verified-phone', () => $scope.form.phone_verify = true);


}]);

angular.module('profile-settings')

.factory('BankAccount',
    function() {

    let BankAccount = {};

    let redirectAfterAccountChangedPath = '';
    
    BankAccount.redirection = {
        set : path => redirectAfterAccountChangedPath = path,
        get: () => redirectAfterAccountChangedPath,
        destroy: () => redirectAfterAccountChangedPath = ''
    };

    return BankAccount;

});

angular.module('profile-settings')

.service('ProfileSettings', ['$resource', function($resource) {
    let redirectAfterAccountChangedPath;

    this.redirection = {
        set : (path) => redirectAfterAccountChangedPath = path ,
        get: (defaultRoute) => {
            return redirectAfterAccountChangedPath || defaultRoute
        },
        destroy: () => redirectAfterAccountChangedPath = ''
    };
}])

.service('Certificate', ['$resource', function($resource) {
    var CertificateResource = $resource('/api/certificate/:id/', {id:'@id'}, {
        update: { method: 'PATCH' }
    });
    this.get = CertificateResource.get;
    this.save = CertificateResource.save;
    this.update = CertificateResource.update;
    this.remove = CertificateResource.remove;
}])

.service('CertificatePicture', ['$resource', function($resource) {
    var CertificatePictureResource = $resource('/api/certificate-picture/:id/', {id:'@id'}, {
        update: { method: 'PATCH' }
    });
    this.update = CertificatePictureResource.update;
    this.remove = CertificatePictureResource.remove;
}])

.service('Work', ['$resource', function($resource) {
    var WorkResource = $resource('/api/work/:id/', {id:'@id'}, {
        update: { method: 'PATCH' }
    });
    this.get = WorkResource.get;
    this.save = WorkResource.save;
    this.update = WorkResource.update;
    this.remove = WorkResource.remove;
}])

.service('Language', ['$resource', function($resource) {
    var LanguageResource = $resource('/api/language/:id/', {id:'@id'});
    this.save = LanguageResource.save;
    this.remove = LanguageResource.remove;
}])

.service('Skill', ['$resource', function($resource) {
    var SkillResource = $resource('/api/skill/:id/', {id:'@id'});
    this.save = SkillResource.save;
    this.remove = SkillResource.remove;
}])

.service('Hobby', ['$resource', function($resource) {
    var HobbyResource = $resource('/api/hobby/:id/', {id:'@id'});
    this.save = HobbyResource.save;
    this.remove = HobbyResource.remove;
}])

.service('School', ['$resource', function($resource) {
    var SchoolResource = $resource('/api/school/:id/', {id:'@id'}, {
        update: { method: 'PATCH' }
    });
    this.get = SchoolResource.get;
    this.save = SchoolResource.save;
    this.update = SchoolResource.update;
    this.remove = SchoolResource.remove;
}])

.service('Projects', ['$resource', function($resource) {
    var ProjectsResource = $resource('/api/user-project/:id/', {id:'@id'}, {
        update: { method: "PATCH" }
    });
    this.save = ProjectsResource.save;
    this.update = ProjectsResource.update;
    this.remove = ProjectsResource.remove;
}]);

angular.module('profile-settings')

.factory('Verification', ['UserResource', 'User', '$location', '$uibModal', 'Modal', '$filter', 'AlertBanner', '$q', '$auth', 'Constants', 'Auth',
    function(UserResource, User, $location, $uibModal, Modal, $filter, AlertBanner, $q, $auth, Constants, Auth) {

    var Verification = {};

    Verification.sendVerificationEmail = function () {
        UserResource.sendVerificationEmail(User.get().email).$promise.then(function () {
            return AlertBanner.publish({
                type: 'info',
                message: $filter('translate')('WE_HAVE_SENT_EMAIL_WITH_CONFIRMATION'),
                timeCollapse: 6000
            });
        });
    };

    Verification.saveUserCheckPhone = function (user) {
        if (user.phone.replace("+", "") != User.get().phone) {
            User.save(user).then(function() {
                Verification.verifyPhoneWindow(user.phone);
            });
        } else {
            User.save(user).then(function() {
                $location.path('/profile-settings');
            });
        }
    };

    Verification.verifyPhone = function(code) {
        return UserResource.verifyPhone({'phone_verify_code': code});
    };

    Verification.verifyAndSavePhoneDirectlyFromForm =  function (newPhone) {
       if (newPhone != User.get().phone) {
            return User.updateUserProperty('phone', newPhone).then(function () {
                Verification.verifyPhoneWindow();
            });
       }
       return Verification.verifyPhoneWindow();
    };

    Verification.verifyPhoneWindow = function () {
        return $uibModal.open({
            templateUrl: 'src/modals/html/modal-verify-phone.html',
            windowClass: 'modal-vertical-centered',
            controller: 'modalPhoneVerifyController'
        })
    };
    
    Verification.enterAndVerifyPhoneWindow = function () {
        return $uibModal.open({
                templateUrl: 'src/modals/html/modal-enter-and-verify-phone.html',
                windowClass: 'modal-vertical-centered',
                controller: 'modalPhoneVerifyController'
        })
    };

    Verification.chooseLegalFormModal = function () {
        return $uibModal.open({
            templateUrl: 'src/modals/html/modal-choose-legal-form.html',
            windowClass: 'modal-vertical-centered choose-legal-form-modal',
            controller: 'ModalChooseLegalFormController'
        })
    };

    Verification.confirmEmail = function(token) {
        return UserResource.confirmEmail({'token': token});
    };

    Verification.verifyEmail = function(email) {
        return UserResource.verifyEmail({'email': email});
    };

    Verification.verifyUserProcedure = function () { // common required verifications for meployee/meployer

         var deffered = $q.defer();

         if ($auth.isAuthenticated()) {
             User.hasEmailVerified().$promise.then(data => {
                 /*  // do not required email verification currently
                 if (!data.email_verify) {
                     let message = (User.get().user_type == Constants.userTypes.MEPLOYEE) ?
                         'PLEASE_CONFIRM_YOUR_EMAIL_BEFORE_APPLYING' : 'PLEASE_CONFIRM_YOUR_EMAIL';
                     return Modal.alert({
                         title: $filter('translate')('CONFIRM_EMAIL'),
                         message: $filter('translate')('WE_HAVE_SENT_EMAIL_WITH_CONFIRMATION_LINK_TO')
                             + ' ' + User.get().email + '. '
                             + $filter('translate')(message)
                     })
                 }
                 */
                 if (!User.get().phone_verify && !User.get().phone) {
                     return Verification.enterAndVerifyPhoneWindow()
                 }
                 if (!User.get().phone_verify && User.get().phone) {
                     return Verification.verifyPhoneWindow();
                 }
                 return deffered.resolve();
             });
         } else {
             Auth.setRedirect($location.path()); // Save URL and take user back to this location after log in
             $location.path('/log-in');
             deffered.reject('UNAUTHENTICATED');
         }
        return deffered.promise;
    };

    Verification.verifyEmployeeProcedure = () => { // verifications only for meployee
        return new Promise((resolve, reject) => {
            Verification.verifyUserProcedure().then(()=> {
                if (User.get().profile.suspended) {
                    AlertBanner.publish({
                         type: 'error',
                         message: $filter('translate')('PROFILE_SUSPENDED_ALERT'),
                         timeCollapse: 4000
                     });
                     return reject()
                }
                if ( !User.get().user_typeform_data || (User.get().user_typeform_data && !User.get().user_typeform_data.nationality) ) {
                    Modal.confirm({
                        title: $filter('translate')('APPLICATION__MISSING_COMPLETE_PROFILE__TITLE'),
                        message: $filter('translate')('APPLICATION__MISSING_COMPLETE_PROFILE__DESCRIPTION'),
                        firstButtonLabel: $filter('translate')('CANCEL'),
                        secondButtonLabel: $filter('translate')('APPLICATION__MISSING_COMPLETE_PROFILE__ACTION_BUTTON'),
                        secondButtonColor: 'red',
                        secondButtonFunction: () => {
                            $location.path('/edit-profile');
                        }
                    })
                    return reject()
                }
                if ( !User.get().profile.verified && (User.get().user_typeform_data && User.get().user_typeform_data.nationality === 4) ) {
                    Modal.alert({
                        title: $filter('translate')('APPLICATION__OUT_OF_EU_SET__UNVERIFIED__TITLE'),
                        message: $filter('translate')('APPLICATION__OUT_OF_EU_SET__UNVERIFIED__DESCRIPTION'),
                    })
                    return reject()
                }
                return resolve();
            }, () => {
                return  reject()
            })
        })
    };

    return Verification;


}]);

angular.module('profile')

.controller('CompanyProfileController', ['$scope', 'User', 'Constants', '$location', '$routeParams', 'LightBox',
    'LeaveReview', 'AlertBanner', 'MyStaff', '$translate', 'crumble', 'Company',
        function($scope, User, Constants, $location, $routeParams, LightBox,
                 LeaveReview, AlertBanner, MyStaff, $translate, crumble, Company) {


    Company.getCompanyProfile($routeParams.companyId).$promise.then(company => {
        $scope.currCompany = company;
        crumble.update({company: company.name});
        $scope.currCompany.reviews = [];
        Company.getOpenPloys(company.id).$promise.then(ploys => {
             $scope.currCompany.openPloys = ploys;
        });
        LeaveReview.getForCompany({'company_id': company.id}).$promise.then(reviews => {
            reviews.forEach(review => $scope.currCompany.reviews.push(review));
        });
    })

    $scope.showTextExpander = string => {
        return string.split(' ').length > 20;
    };

    $scope.expandReview = review => {
      $scope.currCompany.reviews.find(_review => _review.id === review.id).limitCommentWords = 100
    };

    $scope.uploadCompanyLogo = Company.uploadLogo;

}]);

angular.module('profile')

.controller('ProfilePageController', ['$scope', 'User', 'Constants', '$location', '$routeParams', 'LeaveReview', 'LightBox',
    'AlertBanner', 'MyStaff', '$translate', 'crumble', 'Company', 'UserResource', '$filter', 'GeoResource',
        function($scope, User, Constants, $location, $routeParams, LeaveReview, LightBox,
                 AlertBanner, MyStaff, $translate, crumble, Company, UserResource, $filter, GeoResource) {

    User.getProfile($routeParams.userId).$promise.then(function(user) {
        $scope.currUser = user;
        crumble.update({username: user.first_name + ' ' +user.last_name});
        if (user.company && user.company.id) {
            $location.path('/company/' + user.company.id).replace();
        }
    });

    $scope.uploadCompanyLogo = Company.uploadLogo;

    $scope.occupations = Constants.occupations;

    $scope.userTypes = Constants.userTypes;
    $scope.legalForms = Constants.legalForms;

    $scope.limitReviews = 1;

    $scope.goToSettings = function () {
        $location.path('edit-profile')
    };

    $scope.showAllReviews = function () {
        LeaveReview.getAll({'receiver': $scope.currUser.id}).$promise.then(function(reviews) {
            $scope.currUser.reviews_received = reviews;
            $scope.limitReviews = reviews.length;
        });
    };

    $scope.openLightBox = LightBox.open;

    $scope.hireMeployee = function () {
        $location.path('/post-ploy/for/' + $scope.currUser.id)
    };

    $scope.switchStaff = function (meployee_id) {
        if (!$scope.currUser.is_in_my_staff) {
            MyStaff.addToStaff(meployee_id).then(() => {
                AlertBanner.publish({
                    type: 'success',
                    message: $filter('translate')('PROFILE__ADD_TO_STAFF__SUCCEED', {name: $scope.currUser.first_name}),
                    timeCollapse: 5000
                });
                $scope.currUser.is_in_my_staff = true;
                MyStaff.actionsAfterAddToRemoveFromStaff(false);
            });
        } else {
            MyStaff.removeFromMyStaff(meployee_id).then(() => {
                AlertBanner.publish({
                    type: 'success',
                    message: $filter('translate')('PROFILE__REMOVE_FROM_STAFF__SUCCEED', {name: $scope.currUser.first_name}),
                    timeCollapse: 5000
                });
                $scope.currUser.is_in_my_staff = false;
                MyStaff.actionsAfterAddToRemoveFromStaff(false);
            });
        }
    };

    $scope.goToVerifications = (partVerified) => {
        if (!partVerified && $scope.currUser.id == $scope.user().id) {
            $location.path('/verifications');
        }
    };

    $scope.goToApplication = (partVerified) => {
        if (!partVerified && $scope.currUser.id == $scope.user().id) {
            $location.path('/application');
        }
    };

    UserResource.getProfileProgress().$promise.then(data => {
        $scope.profileComplete = data.progress;
    });

    GeoResource.getCountriesList().$promise.then(countries => {
        $scope.countries = countries;
    });

    $scope.getCountryName = (countryCode) => {
        return ($scope.countries) ? $scope.countries[countryCode] : '';
    }

}]);

angular.module('profile')

.controller('ProjectsCarouselController',  ['$scope', 'User', '$routeParams',
        function($scope, User, $routeParams) {

  $scope.templateUrl = 'src/profile/html/carousel-template.html';
  $scope.myInterval = 3000;
  $scope.noWrapSlides = false;
  $scope.active = 0;
  var slides = $scope.slides = [];
  var currIndex = 0;

  User.getProfile($routeParams.userId).$promise.then(function (user) {
      $scope.currUser.user_projects.forEach(project => {
        addSlide(project.project_image_url, project.project_caption);
      });
  });

  var addSlide = (image, caption) => {
    slides.push({
      image: image,
      text: caption,
      id: currIndex++
    });
  };










}]);


angular
    .module('profile')
    .directive('showRating', [
        function() {
            return {
                 scope: {
                   rating : '@',
                   size : '@',
                   hideStar: '<'
                 },
                controller: function ($scope) {
                     $scope.displayRating = rating => {
                         return Math.round( rating * 10) / 10
                     }
                },
                template: '<div ng-if="rating > 2" class="rating-stars rating-stars--{{ size }}">' +
                    '<span class="user-stars icon-star-1" ng-hide="hideStar"></span>\n' +
                    '<span class="rating-stars__number">{{ displayRating(rating) }}' +
                    '      <small class="rating-stars__scale">/ 5</small>\n' +
                    '</span>' +
                    '</div>'
            };
        }
    ]);


angular
    .module('profile')
    .directive('showStars', [
        function() {
            return {
                 scope: {
                   avg : '@',
                   centered : '='
                 },
                 controller: function($scope) {
                   $scope.numberOfStars = function (avg) {
                     return _.range(Math.floor(avg))
                   };
                   $scope.halfStars = function (avg) {
                     return Math.round(avg * 2) / 2 != Math.floor(avg);
                   };
                 },
                 template: '<div class="stars-container" ng-class="{ \'stars-container-centered\' : centered == true }">' +
                 '<span ng-repeat="star in numberOfStars(avg)" >' +
                 '<span class="user-stars icon-star-1"></span>' +
                 '</span>' +
                 '<span ng-if="halfStars(avg)" class="user-stars icon-star-05"></span>' +
                 '</div>',
            };
        }
    ]);


angular
    .module('profile')
    .directive('showUserBiography', [ 'User',
        function(User) {
            return {
                 scope: {
                   limitWords : '@',
                   user : '=',
                   color : '='
                 },
                 template:
                     '<div class="user-biography" ng-class="{ \'user-biography-white\' : color == \'white\'}">' +
                     '{{ user.about | words: limitWords }}' +
                     '<span ng-if="!user.about">Hello! ;)</span>' +
                     '</div>' ,
            };
        }
    ]);


angular
    .module('profile')
    .directive('showUserCategoriesByGroups', [ 'User',
        function(User) {
            return {
                scope: {
                    user : '=',
                },
                restrict: 'AE',
                template: `
                    <div ng-repeat="(category_group, groupCategories) in allCategoriesByGroup" class="category-group">
                        <div ng-if="!!groupCategories[0].category_group" class="category-group-title" style="margin-left: 10px; margin-right: 10px;">
                            <!-- <img src="{{ groupCategories[0].category_group.icon }}" alt="Category icon" height="32"> -->
                            <strong>{{ groupCategories[0].category_group | categoryName }}</strong>
                        </div>
                        <div ng-if="!groupCategories[0].category_group" class="category-group-title" style="margin-left: 10px; margin-right: 10px;">
                            <strong>{{'SIGN_UP_EMPLOYEE__OTHER_CATEGORY_GROUP__NAME' | translate}}</strong>
                        </div>
                        <div class="button-clear" ng-repeat="category in groupCategories" style="display: inline-block; font-weight: normal; border: 1px solid #e3e4e4;">
                            <img src="{{ category.icon }}" alt="Category icon" class="icon-s">
                            {{ category | categoryName }}
                        </div>
                    </div>
                `,
                controller: ["$scope", function ($scope) {
                    $scope.allCategoriesByGroup = _.groupBy($scope.user.category, 'category_group.id');
                }],
            };
        }
    ]);


angular
    .module('profile')
    .directive('showUserCategories', [ 'User',
        function(User) {
            return {
                scope: {
                    limitTo : '<',
                    user : '=',
                    hideNames : '<',
                    hideIcons: '<',
                    size: '@'
                },
                template: `
                    <span tooltip-enable="hideNames" uib-tooltip="{{ category | categoryName }}" 
                          style="margin-bottom: 1rem; margin-right: 1rem;"
                          ng-repeat="category in user.category | limitTo: limitTo" 
                          class="show-user-categories__element show-user-categories__element--size-{{size}}" 
                          ng-class="{\'show-user-categories__element--no-icons\': hideIcons }">
                        <img ng-src="{{ category.icon }}" ng-if="!hideIcons" class="category-icon" />
                        <span ng-hide="hideNames">{{ category | categoryName }}<span ng-show="hideIcons && !$last">,</span>&nbsp;</span>
                    </span>
                    <span ng-show="user.category.length > limitTo">+ {{user.category.length - limitTo}}</span>
                 `,
            };
        }
    ]);

angular.module('referral')


    .controller('ReferralController', ['$scope', '$cookies', 'User', '$location',
        function ($scope, $cookies, User, $location) {

            $scope.invitationSenderUser = {};
            $scope.daysLeft = {};

            const invitedById = $cookies.get('invited_by');
            const invitedByDate = $cookies.get('invited_by_date');
            if (invitedById) {
                User.getInvitationSender(invitedById).$promise.then(user => {
                    $scope.invitationSenderUser = user
                });
            } else {
                $location.path('/')
            }
            if (invitedByDate) {
                $scope.daysLeft = moment(invitedByDate).diff(moment(), 'days');
                if ($scope.daysLeft <= 0) {
                    $cookies.put('invited_by_date', moment().add(31, 'days').toISOString());
                }
            }

            $scope.goToSignup = () => {
                $location.path('/sign-up/new-employee')
            }



        }]);

angular.module('report')
.controller('ReportController', ['$scope', 'Report', '$routeParams', 'Modal', '$translate', '$location', 'crumble', '$filter',
    function($scope, Report, $routeParams, Modal, $translate, $location, crumble, $filter) {
    var goToPloy = function () {
        $location.path('/ploy-detail/' + $routeParams.ploy_id)
    };


    $scope.send_report = function(form) {
        form.ploy_id = $routeParams.ploy_id;
        Report.create(form).then(function(){
            Modal.alert({
                title: $filter('translate')('THANK_YOU'),
                message: $filter('translate')('FEEDBACK_IS_MOST_IMPORTANT_TO_US'),
                buttonFunction: goToPloy
            })
        });
    };
}]);

angular.module('report')
.factory('ReportResource', ['$resource', function($resource) {
    return $resource('/api/report/', {
        create: {method:'POST', url: '/api/report/'}
    });
}]);



angular.module('report')
.service('Report', ['ReportResource', function(ReportResource) {
    
    this.create = function(form){
        return ReportResource.save(form).$promise;
    }

}]);

angular.module('salaryFactor')

  .controller('AddEditSalaryFactorController', ['$scope', 'Constants', 'Modal', '$filter', 'SalaryFactor', 'User',
      'AlertBanner', '$location', 'Company', 'MeployerOnboardingBar',
    function ($scope, Constants, Modal, $filter, SalaryFactor, User, AlertBanner, $location, Company,
              MeployerOnboardingBar) {
        $scope.calculatorData = {};
        $scope.calculatedCosts = {};

        SalaryFactor.getSalaryFactor().$promise.then(factorData => {
           $scope.calculatorData = factorData;
           $scope.calculateTotalSalary();
        });

        let calculateFn = () => {
            console.log($scope.calculatorData);
            Object.keys($scope.calculatorData).map(val => {
                if ($scope.calculatorData[val] === null || $scope.calculatorData[val] === undefined) {
                    $scope.calculatorData[val] = 0
                }
            });
            SalaryFactor.calculateSalaryFactor($scope.calculatorData).$promise.then(data => {
              $scope.calculatedCosts = data;
            });
         };

        $scope.redirectToAgreementSwitcher = () => {
            return Modal.confirm({
                title: $filter('translate')('COLLECTIVE_AGREEMENT__BREADCRUMB'),
                message: $filter('translate')('SIGN_UP_EMPLOYER__COLLECTIVE_AGREEMENT__QUESTION'),
                firstButtonLabel: $filter('translate')('NO'),
                secondButtonLabel: $filter('translate')('YES'),
                secondButtonColor: 'green',
                secondButtonFunction: () => {
                    Company.updateCompanyCollectiveAgreement(true).then(() => {
                        AlertBanner.publish({
                            type: 'success',
                            message: $filter('translate')('SAVED') + ' !',
                            timeCollapse: 3000
                        });
                        return $location.path('/collective-agreements').replace()
                    })
                },
            });
        };

        $scope.calculateTotalSalary = _.debounce(calculateFn, 350, {leading: true, trailing: true});

        $scope.confirmSocialCosts = () => {
            return Modal.confirm({
                title: $filter('translate')('CALCULATE_SALARY_FACTOR__FACTOR_MODAL__TITLE'),
                message: '<b>' + $filter('translate')('CALCULATE_SALARY_FACTOR__FACTOR_MODAL__FACTOR_LABEL')
                    + ' ' + $scope.calculatedCosts.factor + '</b><br/><br/>'
                    + $filter('translate')('CALCULATE_SALARY_FACTOR__FACTOR_MODAL__AGREEMENT_PARAGRAPH'),
                firstButtonLabel: $filter('translate')('CALCULATE_SALARY_FACTOR__FACTOR_MODAL__FIRST_BUTTON_LABEL'),
                secondButtonLabel: $filter('translate')('CALCULATE_SALARY_FACTOR__FACTOR_MODAL__SECOND_BUTTON_LABEL'),
                secondButtonColor: 'green',
                secondButtonFunction: () => {
                    if ($scope.calculatorData.id) {
                        return SalaryFactor.updateSalaryFactor($scope.calculatorData).$promise.then(() => {
                            AlertBanner.publish({
                                type: 'success',
                                message: $filter('translate')('SAVED') + '!',
                                timeCollapse: 4000
                            });
                            $location.path('/salary-factor')
                        })
                    }
                    return SalaryFactor.saveSalaryFactor($scope.calculatorData).$promise.then(() => {
                        AlertBanner.publish({
                            type: 'success',
                            message: $filter('translate')('SAVED') + '!',
                            timeCollapse: 4000
                        });
                        MeployerOnboardingBar.loadSalaryFactorSettings();
                        $location.path('/salary-factor')
                    })
                },
            });
        }

    }]);

angular.module('salaryFactor')

  .controller('SalaryFactorController', ['$scope', 'SalaryFactor', 'SalaryGroupService',
    function ($scope, SalaryFactor, SalaryGroupService) {

         $scope.salaryFactor = {};

         SalaryFactor.getSalaryFactor().$promise.then(factorData => {
             $scope.salaryFactor = factorData;
             SalaryGroupService.getList().$promise.then(groups => {
                $scope.salaryFactor.salary_group = groups.find(group =>  group.id === factorData.salary_group);
             })
         });

         SalaryFactor.getSalaryFactorLogs().$promise.then(logs => {
             $scope.salaryFactorEditHistory = logs;
         });



    }]);

angular.module('salaryFactor')
.directive('factorCalculator', ['SalaryFactor', 'SalaryGroupResource', 'User', function(SalaryFactor, SalaryGroupResource, User) {
  return {
    restrict: 'AE',
    templateUrl: '/src/salary-factor/html/directives/factor-calculator.html',
    scope: {
         ngModel : '=',
         calculatedCosts: '=',
         onValuesChange: '&'
    },
    require: 'ngModel',
    link: function (scope, element, attrs, ngModelCtrl) {
      scope.totalSalary = 0;
      scope.costs = [];
      scope.ngModel = {
        base_salary: null,
        extra_payments: 0,
        pension: 0,
      };
      SalaryFactor.getSalaryFactorCosts().$promise.then(data => {
        scope.costs = data;
      });
      SalaryGroupResource.getList().$promise.then(groups => {
        scope.salaryGroups = groups;
      });
      User.get().$promise.then(user => scope.user = user);



    }
}}]);


angular.module('salaryFactor')

.filter('CostName', ['LanguageService', function(LanguageService) {
    return cost => {
        if (!cost) {return}
        let language = LanguageService.getCurrentLanguage();
        let cost_name = cost['name_'+language];
        return cost_name || cost.name
    };
}]);

angular.module('salaryFactor')

.filter('CostValue', ['$translate', function($translate) {
    return function(cost) {
        if (!cost) {return}
        let mapType = (type) => {
          return type === 'percentage' ? '%' : ' ' + $translate.instant('FACTOR_CALCULATOR__UNIT')
        };

        return cost.value + mapType(cost.type)
    };
}]);

angular.module('salaryFactor')

.factory('SalaryFactorCostResource', ['$resource', function($resource) {
  return  $resource('/api/salary-factor-cost/:id/', {id:'@id'},{
          update: { method:'PATCH'},
      });
  }]);

angular.module('salaryFactor')

.factory('SalaryFactorLogResource', ['$resource', function($resource) {
  return  $resource('/api/salary-factor-log/:id/', {id:'@id'},{
          update: { method:'PATCH'},
      });
  }]);

angular.module('salaryFactor')

.factory('SalaryFactorResource', ['$resource', function($resource) {
  return  $resource('/api/salary-factor/:id/', {id:'@id'},{
          update: { method:'PATCH'},
          getSalaryFactor: {
            method: 'GET',
            url: '/api/salary-factor/get_salary_factor/',
          },
          hasSalaryFactor: {
            method: 'GET',
            url: '/api/salary-factor/has_salary_factor/',
          },
          calculateSalaryFactor: {
            method: 'POST',
            url: '/api/salary-factor/calculate_salary_factor/',
          },
      });
  }]);

angular.module('salaryFactor')


.factory('SalaryFactor', ['SalaryFactorResource', 'SalaryFactorCostResource', 'SalaryFactorLogResource', 'AlertBanner', '$filter', function (SalaryFactorResource, SalaryFactorCostResource, SalaryFactorLogResource, AlertBanner, $filter) {

    let SalaryFactorService = {};

    SalaryFactorService.saveSalaryFactor = SalaryFactorResource.save;

    SalaryFactorService.updateSalaryFactor = SalaryFactorResource.update;

    SalaryFactorService.getSalaryFactor = SalaryFactorResource.getSalaryFactor;

    SalaryFactorService.getSalaryFactorCosts = SalaryFactorCostResource.query;

    SalaryFactorService.calculateSalaryFactor = SalaryFactorResource.calculateSalaryFactor;

    SalaryFactorService.getSalaryFactorLogs = SalaryFactorLogResource.query;

    SalaryFactorService.hasSalaryFactor = SalaryFactorResource.hasSalaryFactor;

    return SalaryFactorService

}]);

angular.module('salaryRules')
.controller('BaseSalaryController', ['$scope', 'SalaryRulesService', '$uibModal', 'Modal', '$translate',
    'User', '$location', 'Company', 'AlertBanner', '$filter', 'SalaryGroupService', 'MeployerOnboardingBar',
    function($scope, SalaryRulesService, $uibModal, Modal, $translate,
             User, $location, Company, AlertBanner, $filter, SalaryGroupService, MeployerOnboardingBar) {

        let events = [];
        let currentWeekday = moment().isoWeekday() - 1;  // 0 - Monday, 6 - Sunday
        let today = new Date();
        $scope.form = {
            weekday_kr_per_hour: 120,
            weekend_kr_per_hour: 120,
            paid_pause_time: true
        };

        $scope.currentUser = User.get();

        let handleDayClick = (date, jsEvent, view) => {
            if (!User.get().can_edit_salary) return;
            let baseSalaryRuleModalInstance = createModal(
                true,
                120,
                moment(date).hour(),
                moment(date).hour(),
                moment(date).minute(),
                moment(date).minute(),
                false);
            baseSalaryRuleModalInstance.result.then((ruleSettings) => {
                if (!ruleSettings) return;
                if (ruleSettings.end_minute === 0) {
                    ruleSettings.end_minute = 59;
                }
                let data = {
                    hourly_pay: ruleSettings.price_hour,
                    weekday: moment(date).weekday(),
                    start_hour: ruleSettings.start_hour,
                    end_hour: ruleSettings.end_hour,
                    start_minute: ruleSettings.start_minute,
                    end_minute: ruleSettings.end_minute,
                    salary_group: $scope.currentSalaryGroup.id,
                };
                SalaryRulesService.setSalaryRule(data).$promise.then((created) => {
                    addToEvents(created);
                    refreshAll();
                }, error => {
                    Modal.alert({
                        title: $filter('translate')('BASE_SALARY__ALERT__SOMETHING_WENT_WRONG'),
                        message: $filter('translate')('BASE_SALARY__ALERT__' + error.data[0]),
                        buttonColor: 'red'
                    });
                });
            });
        };

        $scope.setPaidPause = (value) => {
            Company.updateCompanyProperty({'paid_pause_time': value}).$promise.then((company)=>{
                $scope.form.paid_pause_time = company.paid_pause_time;
                AlertBanner.publish({
                    type: 'success',
                    message: $filter('translate')('SAVED') + '!',
                    timeCollapse: 4000
                });
            });
        };

        Company.getCompany().$promise.then(company => {
            $scope.form.paid_pause_time = company.paid_pause_time;
        });

        let handleEventResize = (event, delta, revertFunc) => {
            if (!User.get().can_edit_salary) return;
            let data = {
                id: event.id,
                end_hour: event.end.hour(),
            };

            // trick to fix issue with ui-calendar when choose range from week calendar
            // without this fix - cannot for sunday by event resize choose to the end of day
            if (event.start.weekday() == 6 && event.end.weekday() == 0) {
                event.end = event.start;
                data.end_hour = 23;
            }

            if (event.start.toISOString().substring(0, 10) != event.end.toISOString().substring(0, 10)) {
                Modal.alert({
                    title: $filter('translate')('BASE_SALARY__ALERT__RULE_MUST_BE_IN_ONE_DAY__TITLE'),
                    message: $filter('translate')('BASE_SALARY__ALERT__RULE_MUST_BE_IN_ONE_DAY__DESCRIPTION'),
                    buttonColor: 'red'
                });
                revertFunc();
                return;
            }

            SalaryRulesService.setSalaryRule(data).$promise.then((updated) => {
                refreshAll();
            }, error => {
                Modal.alert({
                    title: $filter('translate')('BASE_SALARY__ALERT__SOMETHING_WENT_WRONG'),
                    message: $filter('translate')('BASE_SALARY__ALERT__' + error.data[0]),
                    buttonColor: 'red'
                });
                revertFunc()
            });  // revert modification on calendar if error occur
        };

        let handleEventDrop = (event, delta, revertFunc) => {
            if (!User.get().can_edit_salary) return;
            let end = (event.end) ? event.end.hour() : event.start.hour();

            let data = {
                id: event.id,
                start_hour: event.start.hour(),
                end_hour: end,
                weekday: moment(event.start).weekday(),
            };

            SalaryRulesService.setSalaryRule(data).$promise.then((updated) => {
                refreshAll();  // need to refresh weekday for event or will not be deleted by clear correctly
            }, error => {
                Modal.alert({
                    title: $filter('translate')('BASE_SALARY__ALERT__SOMETHING_WENT_WRONG'),
                    message: $filter('translate')('BASE_SALARY__ALERT__' + error.data[0]),
                    buttonColor: 'red'
                });
                revertFunc();
            });
        };

        let handleEventClick = (calEvent, jsEvent, view) => {
            if (!User.get().can_edit_salary) return;
            let baseSalaryRuleModalInstance = createModal(calEvent.paidPauseTime, calEvent.hourlyPay,
                moment(calEvent.start).hour(), moment(calEvent.end).hour(), calEvent.start_minute, calEvent.end_minute, true);
            baseSalaryRuleModalInstance.result.then((ruleSettings) => {
                if (!ruleSettings) return;
                if (ruleSettings.delete) {
                    removeRule(calEvent.id);
                    refreshAll();
                    return;
                }
                let data = {
                    id: calEvent.id,
                    hourly_pay: ruleSettings.price_hour,
                    start_hour: ruleSettings.start_hour,
                    end_hour: ruleSettings.end_hour,
                    start_minute: ruleSettings.start_minute,
                    end_minute: ruleSettings.end_minute,
                };
                SalaryRulesService.setSalaryRule(data).$promise.then((updated) => {
                    // removes event from events and adds again updated one
                    _.remove(events, (event) => {
                        return event.id == updated.id;
                    });
                    addToEvents(updated);
                    refreshAll();
                }, error => {
                    Modal.alert({
                        title: $filter('translate')('BASE_SALARY__ALERT__SOMETHING_WENT_WRONG'),
                        message: $filter('translate')('BASE_SALARY__ALERT__' + error.data[0]),
                        buttonColor: 'red'
                    });
                });
            });
        };

        $scope.calendarOptions = {
            defaultView: 'agendaWeek',
            height: 650,
            editable: User.get().can_edit_salary,
            header: '',
            events: events,
            dayClick: handleDayClick,
            eventResize: handleEventResize,
            eventDrop: handleEventDrop,
            eventClick: handleEventClick,
            firstDay: 1,
            timeFormat: 'H:mm',
            displayEventTime: false,
            views: {
                agenda: {
                    columnHeader: false,
                    slotDuration: '01:00:00',
                    columnFormat: 'dddd',
                    allDaySlot: false,
                    slotLabelFormat: 'HH:mm',
                },
            },
        };

        let getEvents = (currentSalaryGroupId) => {
            SalaryRulesService.getEvents({'salary_group': currentSalaryGroupId}).$promise.then((rules) => {
                rules.forEach((rule) => {
                    removeEvent(rule.id);
                    addToEvents(rule);
                });
            });
        };

        let refreshAll = () => {  // method added because e.g. after resize and/or drop, while new field created - events return to old positions and sizes
            if ($scope.currentSalaryGroup) {
                getEvents($scope.currentSalaryGroup.id);
            }
            MeployerOnboardingBar.loadSalarySettings();
        };
        refreshAll();

        let getEventTitle = (rule, start, end) => {
            if (start.format("HH") === end.format("HH")) {
                return  `${rule.hourly_pay} kr. per hour`
            } else {
                let startTime = rule.start_minute ? `${start.format("HH:mm")}` : `${start.format("HH")}:00`;
                let endTime = rule.end_minute === 59 ? `${end.add(1, 'hours').format("HH")}:00` : `${end.format("HH:mm")}`;
                return  `${startTime} - ${endTime} \n ${rule.hourly_pay} kr. per hour`;
            }
        };

        let addToEvents = (rule) => {
            let start = calcDateBasedOnTimeAndWeekday(rule.start_hour, rule.start_minute, rule.weekday, true);
            let end = calcDateBasedOnTimeAndWeekday(rule.end_hour, rule.end_minute, rule.weekday, false);
            let endToDisplay = angular.copy(end);
            if (!rule.end_minute) {
                endToDisplay.add(1, 'hour');
            }
            let color = "#21bfdc";
            let title = getEventTitle(rule, start, endToDisplay);
            events.push({
                id: rule.id,
                title: title,
                hourlyPay: rule.hourly_pay,
                start: start,
                end: end,
                start_minute: rule.start_minute,
                end_minute: rule.end_minute,
                backgroundColor: color,
                borderColor: color,
                textColor: "white",
            });
        };

        let removeRule = (ruleId) => {
            SalaryRulesService.remove(ruleId).$promise.then(() => {
                removeEvent(ruleId);
            });
        };

        let removeEvent = (id) => {
            _.remove(events, (event) => {
                return event.id == id;
            });
        };

        let clearAllEvents = () => {
            _.remove(events, () => {
                return true;
            });
        };

        let createModal = (paidPauseTime, priceHour, startHour, endHour, startMinute, endMinute, removeOption) => {
            return $uibModal.open({
                templateUrl: 'src/modals/html/modals/defined/modal-salary-rule.html',
                windowClass: 'modal-vertical-centered',
                backdrop: 'static',
                controller: ($scope) => {
                    $scope.price_hour = priceHour;
                    $scope.removeOption = removeOption;
                    $scope.start_hour = startHour;
                    $scope.end_hour = endHour;
                    $scope.start_minute = startMinute;
                    $scope.end_minute = endMinute;
                    $scope.customStartHour = startMinute !== 0;
                    $scope.customEndHour = (endMinute !== 0 && endMinute !== 59);

                    User.get().$promise.then((user) => {
                        $scope.minPriceHour = user.profile.price_hour || 120;
                    });

                    $scope.tempStartTime = moment().set({hour: startHour, minute: startMinute}).toDate();
                    $scope.tempEndTime = moment().set({hour: endHour, minute: endMinute}).toDate();

                    $scope.startHourOptions = Array.from({length: 24}, (v, k) => {
                        return {name: k + ':00', value: k };
                    });
                    $scope.endHourOptions = Array.from({length: 24}, (v, k) => {
                        return {name: (k + 1) + ':00', value: k };
                    });
                    $scope.startHourOptions.push({name: $translate.instant('SALARY__CUSTOM_HOUR__LABEL'), value: false });
                    $scope.endHourOptions.push({name: $translate.instant('SALARY__CUSTOM_HOUR__LABEL'), value: false });

                    $scope.startHourChanged = (startHour) => {
                        if (!startHour) {
                            $scope.customStartHour = true;
                        }
                    };
                    $scope.endHourChanged = (endHour) => {
                        if (!endHour) {
                            $scope.customEndHour = true;
                        }
                    };

                    $scope.transformStartTime = (time) => {
                        $scope.start_hour = moment(time).hours();
                        $scope.start_minute = moment(time).minutes();
                    };

                    $scope.transformEndTime = (time) => {
                        $scope.end_hour = moment(time).hours();
                        $scope.end_minute = moment(time).minutes();
                    }
                }
            });
        };

        const weekdays = {
            WEEKDAYS: [0, 1, 2, 3, 4],
            WEEKENDS: [5, 6],
        };

        $scope.fillDays = (type) => {
            let priceHour = (type == 'WEEKDAYS') ? $scope.form.weekday_kr_per_hour : $scope.form.weekend_kr_per_hour;
            SalaryRulesService.fillDays(type, priceHour, $scope.currentSalaryGroup.id).$promise.then(() => {
                refreshAll();
            }, error => {
                Modal.alert({
                    title: $filter('translate')('BASE_SALARY__ALERT__SOMETHING_WENT_WRONG'),
                    message: $filter('translate')('BASE_SALARY__ALERT__' + error.data),
                    buttonColor: 'red'
                });
            });
        };

        $scope.clearDays = (type) => {
            let clearDaysFn = () => {
                SalaryRulesService.clearDays(type, $scope.currentSalaryGroup.id).$promise.then(() => {
                    weekdays[type].forEach((weekday) => {
                        let toRemoveEvents = _.filter(events, (event) => {
                            return moment(event.start).isoWeekday() - 1 == weekday;
                        });
                        if (toRemoveEvents) {
                            toRemoveEvents.forEach((event) => {
                                removeEvent(event.id);
                            });
                        }
                    });
                    refreshAll();
                }, error => {
                    console.log(error);
                });
            };
            return Modal.confirm({
                title: $filter('translate')('REMOVE'),
                message: $filter('translate')('ARE_YOU_SURE'),
                secondButtonLabel: $filter('translate')('NO_THANKS'),
                firstButtonLabel: $filter('translate')('YES'),
                firstButtonColor: 'green',
                firstButtonFunction: clearDaysFn,
            });
        };

        let calcDateBasedOnTimeAndWeekday = (hour, minute, weekday, isStartTime) => {
            /*
            * notice: date is formatted with .utc() to ignore 02:00 - 03:00 gap caused by DST
            * docs: https://momentjs.com/timezone/docs/#/using-timezones/parsing-ambiguous-inputs/
            * */
            const minutes = minute !== 0 ? minute : isStartTime ? 0 : 59;
            let day = moment(today).utc().set({hours: hour, minutes: minutes, seconds: 0});
            day.add(weekday - currentWeekday, 'day');
            return day;
        };

        User.get().$promise.then((user) => {
            $scope.minPriceHour = user.profile.price_hour || 120;
        });


        let loadCurrentSalaryGroup = () => { $scope.currentSalaryGroup = SalaryGroupService.getCurrentSalaryGroup(); };

        let salaryGroupChangedActions = () => {
            loadCurrentSalaryGroup();
            clearAllEvents();
            refreshAll();
        };

        $scope.$on('currentSalaryGroupChanged', () => {
            salaryGroupChangedActions();
        });

        salaryGroupChangedActions();  // do always at start because currentSalaryGroupChanged may not be triggered

}]);

angular.module('salaryRules')
.controller('OvertimeSalaryController', ['$scope', 'OvertimeSalaryService', 'SalaryGroupService',
    function($scope, OvertimeSalaryService, SalaryGroupService) {

        let clearForm = () => {
            $scope.form = [];
            $scope.form[1] = {};
            $scope.form[2] = {};
            $scope.form[3] = {};
            $scope.form[4] = {};
            $scope.form[5] = {};
        };

        clearForm();  // initial setup

        $scope.saveOvertime = (id, overtimeType, value, hour) => {
            if (!overtimeType) return;
            let data = {
                id: id,
                overtime_pay: value,
                overtime_type: overtimeType,
                hour: hour,
                salary_group: $scope.currentSalaryGroup.id,
            };
            OvertimeSalaryService.setOvertime(data).$promise.then((overtimeSalary) => {
                updateOvertimeSalary(overtimeSalary);
                $scope.form[hour].modified = false;
            }, error => { console.log(error) });
        };

        $scope.removeOvertime = (id, hour) => {
            OvertimeSalaryService.remove({'id': id}).$promise.then(() => {
                $scope.form[hour] = {};
            }, error => { console.log(error); });
        };

        let loadOvertimeSalary = (currentSalaryGroup) => {
            if (!currentSalaryGroup) {
                clearForm();
                return;
            }
            OvertimeSalaryService.getList({'salary_group': currentSalaryGroup.id}).$promise.then((overtimeSalaries) => {
                clearForm();  // important to clean up form fields - some may be defined in other group, not in current
                overtimeSalaries.forEach((overtimeSalary) => {
                    updateOvertimeSalary(overtimeSalary);
                });
            });
        };

        let updateOvertimeSalary = (overtimeSalary) => {
            $scope.form[overtimeSalary.hour].id = overtimeSalary.id;
            $scope.form[overtimeSalary.hour].overtimeType = overtimeSalary.overtime_type;
            $scope.form[overtimeSalary.hour].value = overtimeSalary.overtime_pay;
        };

        $scope.modified = (hour) => {
            if ($scope.form[hour].overtimeType) {
                $scope.form[hour].modified = true;
            }
        };

        let loadCurrentSalaryGroup = () => { $scope.currentSalaryGroup = SalaryGroupService.getCurrentSalaryGroup(); };

        let salaryGroupChangedActions = () => {
            loadCurrentSalaryGroup();
            loadOvertimeSalary($scope.currentSalaryGroup);
        };

        $scope.$on('currentSalaryGroupChanged', () => {
            salaryGroupChangedActions();
        });

        salaryGroupChangedActions();  // do always at start

}]);

angular.module('salaryRules')
.controller('PensionSalaryController', ['$scope', 'PensionSalaryService', 'Modal', '$translate', 'AlertBanner', '$filter', 'SalaryGroupService',
    function($scope, PensionSalaryService, Modal, $translate, AlertBanner, $filter, SalaryGroupService) {

        $scope.form = {};

        let loadPension = () => {
            if ($scope.currentSalaryGroup) {
                PensionSalaryService.get({'salary_group': $scope.currentSalaryGroup.id}).$promise.then((pension) => {
                    $scope.form = pension[0] || {};
                });
            }
        };

        // on change - set value of second to $scope.form.pension_percent - this (it's for employer/worker part division)
        $scope.updateEmployerWorkerDivision = (isEmployer) => {
            let changedValue = (isEmployer) ? $scope.form.employer_part_percent : $scope.form.worker_part_percent;
            if (!$scope.form.pension_percent) {
                $scope.form.worker_part_percent = 0;
                $scope.form.employer_part_percent = 0;
                return;
            }
            let pensionPercent = new Decimal($scope.form.pension_percent);
            let changedValueDecimal = changedValue ? new Decimal(changedValue) : 0;
            if (isEmployer) {
                $scope.form.worker_part_percent = parseFloat(pensionPercent.minus(changedValueDecimal));
            } else {
                $scope.form.employer_part_percent = parseFloat(pensionPercent.minus(changedValueDecimal));
            }
        };

        $scope.updatePension = (form) => {
            if (!form.pension_percent) {
                form.employer_part_percent = 0;
                form.worker_part_percent = 0;
            }
            form['salary_group'] = $scope.currentSalaryGroup.id;
            PensionSalaryService.setPension(form).$promise.then((pension) => {
                AlertBanner.publish({
                    type: 'success',
                    message: $filter('translate')('SAVED') + '!',
                    timeCollapse: 2000
                });
            }, error => {
                Modal.alert({
                    title: $filter('translate')('PENSION_SALARY__ALERT__SOMETHING_WENT_WRONG'),
                    message: $filter('translate')('PENSION_SALARY__ALERT__' + error.data[0]),
                    buttonColor: 'red'
                });
                loadPension();
            });
        };

        let loadCurrentSalaryGroup = () => { $scope.currentSalaryGroup = SalaryGroupService.getCurrentSalaryGroup(); };

        let salaryGroupChangedActions = () => {
            loadCurrentSalaryGroup();
            loadPension();
        };

        $scope.$on('currentSalaryGroupChanged', () => {
            salaryGroupChangedActions();
        });

        salaryGroupChangedActions();  // do always at start

}]);

angular.module('salaryRules').controller('SalaryCostsController', [
    '$scope', 'SalaryGroupService', 'SalaryCostService', 'AlertBanner', '$filter', 'Modal',
    function($scope, SalaryGroupService, SalaryCostService, AlertBanner, $filter, Modal) {

    $scope.form = {};

    let loadCosts = () => {
        if ($scope.currentSalaryGroup) {
            SalaryCostService.get({'salary_group': $scope.currentSalaryGroup.id}).$promise.then(costs => {
                $scope.form = costs[0] || {};
            });
        }
    };

    $scope.updateSalaryCosts = (form) => {
        form['salary_group'] = $scope.currentSalaryGroup.id;
        SalaryCostService.setCosts(form).$promise.then(costs => {
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('SAVED') + '!',
                timeCollapse: 2000
            });
            salaryGroupChangedActions();
        }, error => {
            Modal.alert({
                title: $filter('translate')('SALARY_COST__ALERT__SOMETHING_WENT_WRONG_TITLE'),
                message: $filter('translate')('SALARY_COST__ALERT__SOMETHING_WENT_WRONG_MESSAGE'),
                buttonColor: 'red'
            });
            loadCosts();
        });
    };

    let loadCurrentSalaryGroup = () => { $scope.currentSalaryGroup = SalaryGroupService.getCurrentSalaryGroup(); };

    let salaryGroupChangedActions = () => {
        loadCurrentSalaryGroup();
        loadCosts();
    };

    $scope.$on('currentSalaryGroupChanged', () => {
        salaryGroupChangedActions();
    });

    salaryGroupChangedActions();  // do always at start

}]);

angular.module('salaryRules')
    .controller('SalaryRulesHeaderController', ['$scope', '$location', 'SalaryGroupService', 'Modal', '$translate', 'AlertBanner', '$filter',
        function ($scope, $location, SalaryGroupService, Modal, $translate, AlertBanner, $filter) {


            $scope.currentPath = $location.path();

            $scope.goToBaseSalarySettings = () => {
                $location.path('/salary-rules/base-salary');
            };

            $scope.goToOvertimeSettings = () => {
                $location.path('/salary-rules/overtime');
            };

            $scope.goToPensionSettings = () => {
                $location.path('/salary-rules/pension');
            };

            $scope.goToCostsSettings = () => {
                $location.path('/salary-rules/costs');
            };

            $scope.salaryGroups = SalaryGroupService.getSalaryGroups;

            $scope.removeSalaryGroup = (salaryGroupId) => {
                let removeSalaryGroup = () => {
                    SalaryGroupService.remove({'id': salaryGroupId}).$promise.then(() => {
                        SalaryGroupService.load();
                        AlertBanner.publish({
                            type: 'success',
                            message: $filter('translate')('SAVED') + '!',
                            timeCollapse: 4000
                        });
                    }, error => console.log(error));
                };
                return Modal.confirm({
                    title: $filter('translate')('REMOVE'),
                    message: $filter('translate')('ARE_YOU_SURE'),
                    secondButtonLabel: $filter('translate')('NO_THANKS'),
                    firstButtonLabel: $filter('translate')('YES'),
                    firstButtonColor: 'green',
                    firstButtonFunction: removeSalaryGroup,
                });
            };

            $scope.showSalaryGroupForm = false;

            $scope.wasChangedSalaryGroup = (selected) => {
                if (selected) {
                    SalaryGroupService.setCurrentSalaryGroup(selected);
                }
            };

            $scope.toggleSalaryGroupForm = () => {
                $scope.showSalaryGroupForm = !$scope.showSalaryGroupForm;
                $scope.salaryGroupForm = {};
            };

            $scope.addSalaryGroup = (data) => {
                SalaryGroupService.setSalaryGroup(data).$promise.then((salaryGroupForm) => {
                    SalaryGroupService.load(salaryGroupForm.id);
                    $scope.toggleSalaryGroupForm();
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('SAVED') + '!',
                        timeCollapse: 4000
                    });
                });
            };

            $scope.editSalaryGroup = (salaryGroupId) => {
                SalaryGroupService.get({'id': salaryGroupId}).$promise.then(group => {
                    $scope.salaryGroupForm = group;
                    $scope.showSalaryGroupForm = true;
                });
            };

            $scope.makeDefaultSalaryGroup = (salaryGroupId) => {
                SalaryGroupService.makeDefault({'id': salaryGroupId}).$promise.then(() => {
                    $scope.salaryGroups().map(sg => sg.is_default = false);
                    $scope.currentSalaryGroup.is_default = true;
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('SAVED') + '!',
                        timeCollapse: 4000
                    });
                });
            };

            // Lines below are needed in controllers where currentSalaryGroup is used
            let loadCurrentSalaryGroup = () => {
                $scope.currentSalaryGroup = SalaryGroupService.getCurrentSalaryGroup();
            };
            $scope.$on('currentSalaryGroupChanged', () => {
                loadCurrentSalaryGroup();
            });
            loadCurrentSalaryGroup();  // do always at start

        }]);

angular.module('salaryRules')

.factory('OvertimeSalaryResource', ['$resource', function($resource) {

    return $resource('/api/overtime_salary/:id/', {id: '@id'}, {
        get: { isArray: true },
        save: { method: 'POST' },
        update: { method: 'PATCH' },
        remove: { method: 'DELETE' },
    })

}]);

angular.module('salaryRules')

.factory('PensionSalaryResource', ['$resource', function($resource) {

    return $resource('/api/pension_salary/:id/', {id: '@id'}, {
        get: { isArray: true },
        save: { method: 'POST' },
        update: { method: 'PATCH' },
        remove: { method: 'DELETE' },
    })

}]);

angular.module('salaryRules').factory('SalaryCostResource', [
    '$resource',
    function($resource) {

    return $resource('/api/salary_cost/:id/', {id: '@id'}, {
        get: { isArray: true },
        save: { method: 'POST' },
        update: { method: 'PATCH' },
    })

}]);

angular.module('salaryRules')

.factory('SalaryGroupResource', ['$resource', function($resource) {

    return $resource('/api/salary_group/:id/', {id: '@id'}, {
        getList: { isArray: true },
        save: { method: 'POST' },
        update: {method: 'PATCH'},
        remove: { method: 'DELETE' },
        makeDefault: {
            method: 'POST',
            url: '/api/salary_group/:id/make_default/',
        }
    })

}]);

angular.module('salaryRules')

.factory('SalaryRulesResource', ['$resource', function($resource) {

    return $resource('/api/salary_rule/:id/', {id: '@id'}, {
        get: { isArray: true },
        save: { method: 'POST' },
        update: { method: 'PATCH' },
        remove: { method: 'DELETE' },
        fillDays: {
            method: 'POST',
            url: '/api/salary_rule/fill_days/',
        },
        clearDays: {
            method: 'POST',
            url: '/api/salary_rule/clear_days/',
        },
        hasSalarySettings: {
            method: 'GET',
            url: '/api/salary_rule/has_salary_settings/',
        }
    })

}]);

angular.module('salaryRules')

.service('OvertimeSalaryService', ['OvertimeSalaryResource',
    function(OvertimeSalaryResource) {

    let OvertimeService = {};

    OvertimeService.getList = OvertimeSalaryResource.get;

    OvertimeService.setOvertime = (data) => {
        if (data.id) {
            return OvertimeSalaryResource.update(data);
        }
        return OvertimeSalaryResource.save(data);
    };

    OvertimeService.remove = OvertimeSalaryResource.remove;

    return OvertimeService;

}]);

angular.module('salaryRules')

.service('PensionSalaryService', ['PensionSalaryResource', 'User',
    function(PensionSalaryResource, User) {

        let PensionSalaryService = {};

        PensionSalaryService.get = PensionSalaryResource.get;

        PensionSalaryService.setPension = (data) => {
            if (!User.get().can_edit_salary) return;
            if (data.id) {
                return PensionSalaryResource.update(data);
            }
            return PensionSalaryResource.save(data);
        };

        return PensionSalaryService;

}]);

angular.module('salaryRules').service('SalaryCostService', [
    'User', 'SalaryCostResource',
    function(User, SalaryCostResource) {

    let SalaryCostService = {};

    SalaryCostService.get = SalaryCostResource.get;

    SalaryCostService.setCosts = (data) => {
        if (!User.get().can_edit_salary) return;
        if (data.id) {
            return SalaryCostResource.update(data);
        }
        return SalaryCostResource.save(data);
    };

    return SalaryCostService;

}]);

angular.module('salaryRules')

.service('SalaryGroupService', ['SalaryGroupResource', '$rootScope',
    function(SalaryGroupResource, $rootScope) {

    let SalaryGroupService = {};

    let salaryGroups = [];

    let currentSalaryGroup;

    SalaryGroupService.get = SalaryGroupResource.get;
    SalaryGroupService.getList = SalaryGroupResource.getList;

    SalaryGroupService.load = (currentId) => {
        SalaryGroupResource.getList().$promise.then(groups => {
            if (!groups.length) {
                SalaryGroupResource.save({'name': 'Standard'}).$promise.then(() => {
                    SalaryGroupService.load();
                });
                return;
            }
            salaryGroups = groups;
            SalaryGroupService.setCurrentSalaryGroup(groups.find(sg => currentId ? sg.id == currentId : sg.is_default == true));
        });
    };
    SalaryGroupService.load();

    SalaryGroupService.setCurrentSalaryGroup = (newValue) => {
        currentSalaryGroup = newValue;
        $rootScope.$broadcast('currentSalaryGroupChanged');
    };

    SalaryGroupService.setSalaryGroup = (data) => {
        if (data.id) {
            return SalaryGroupResource.update(data);
        }
        return SalaryGroupResource.save(data);
    };

    SalaryGroupService.makeDefault = SalaryGroupResource.makeDefault;

    SalaryGroupService.remove = SalaryGroupResource.remove;

    SalaryGroupService.getSalaryGroups = () => salaryGroups;

    SalaryGroupService.getCurrentSalaryGroup = () => currentSalaryGroup;

    return SalaryGroupService;

}]);

angular.module('salaryRules')

.service('SalaryRulesService', ['SalaryRulesResource',
    function(SalaryRulesResource) {

    let SalaryRulesService = {};

    SalaryRulesService.getEvents = (params) => {
        return SalaryRulesResource.get(params);
    };

    SalaryRulesService.setSalaryRule = (data) => {
        if (data.id) {
            return SalaryRulesResource.update(data);
        }
        return SalaryRulesResource.save(data);
    };

    SalaryRulesService.remove = (ruleId) => {
        return SalaryRulesResource.remove({'id': ruleId})
    };

    SalaryRulesService.fillDays = (daysType, priceHour, salaryGroup) => {
        return SalaryRulesResource.fillDays({'type': daysType, 'price_hour': priceHour, 'salary_group': salaryGroup});
    };

    SalaryRulesService.clearDays = (daysType, salaryGroup) => {
        return SalaryRulesResource.clearDays({'type': daysType, 'salary_group': salaryGroup});
    };

    return SalaryRulesService;

}]);

angular.module('sayHi')

  .controller('SayHiController', ['$scope', '$auth', 'SayHiService', '$location', 'Modal', '$filter',
    function ($scope, $auth, SayHiService, $location, Modal, $filter) {

      if (typeof MediaRecorder !== "function") {
        $scope.useCustomUploaded = true;
      }

      $scope.uploading = false;
      $scope.uploaded = false;

      $scope.recording = SayHiService.recording;
      $scope.recordedVideoUrl = SayHiService.recordedVideoUrl;

      $scope.startRecording = function (){
        SayHiService.startRecording();
        setTimeout(() => {
          if ($scope.recording()) $scope.stopRecording()
        }, 30000);
      };

      $scope.stopRecording = function (){
        SayHiService.stopRecording();
      };

      $scope.restart = SayHiService.restart;
      $scope.successAlert = () => {
        Modal.alert({
            title: $filter('translate')('SAY-HI__MODAL-UPLOAD-SUCCESS__TITLE'),
            message: $filter('translate')('SAY-HI__MODAL-UPLOAD-SUCCESS__MESSAGE'),
            buttonFunction : function () {
              SayHiService.restart();  // to prevent uploading the same video few times
              $location.path('/application');
            }
          });
      };

      $scope.upload = function () {
        $scope.uploading = true;
        SayHiService.upload().then(function(){
          $scope.uploading = false;
          $scope.uploaded = true;
          $scope.successAlert();
        });
      };

      $scope.uploadManually = () => {SayHiService.uploadManually().then(()=>$scope.successAlert(),()=>console.log('err'))};

    }]);

angular.module('sayHi')

.factory('SayHiResource', ['$resource', ($resource) => {
    return $resource('/api/introduction/', {}, {
        hasUploadedVideo: {
            method: 'GET',
            url: '/api/introduction/video/has_uploaded_video/',
        },
    })
}]);

angular.module('sayHi')

.service('SayHiService', ['$auth', '$q', 'Modal', '$translate', 'SayHiResource', '$filter',
  function ($auth, $q, Modal, $translate, SayHiResource, $filter) {
    let gumVideo;
    let mediaRecorder;
    let recordedBlobs;

    let recording = false;
    let recordedVideoUrl;

    let getRecording = () => recording;
    let getRecordedVideoUrl = () => recordedVideoUrl;

    function restart() {
      gumVideo = null;
      mediaRecorder = null;
      recordedBlobs = null;
      recordedVideoUrl = null;
      recording = false;
    }

    function handleDataAvailable(event) {
      if (event.data && event.data.size > 0) {
        recordedBlobs.push(event.data);
      }
    }

    function upload(videoFile=null) {
      let deferred = $q.defer();
      let fd = new FormData();
      fd.append('filename', 'introduction.webm');
      fd.append('video', (videoFile) ? videoFile : new Blob(recordedBlobs, {type: 'video/webm'}));
      $.ajax({
        type: 'POST',
        url: "/api/introduction/video/",
        data: fd,
        processData: false,
        contentType: false,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'JWT ' + $auth.getToken());
        }
      }).done(function () {
        deferred.resolve(true);
      }).error(function (err) {
        Modal.alert({
          title: $filter('translate')('SAY_HI__MODAL__UPLOAD_ERROR_TITLE'),
          message: $filter('translate')('SAY_HI__MODAL_UPLOAD_ERROR_DESCRIPTION'),
          buttonColor: 'red',
        });
      });
      return deferred.promise;
    }

    function startRecording() {
      recording = true;
      navigator.mediaDevices.getUserMedia({
        audio: true,
        video: true
      }).then(function (stream) {
        record(stream)
      }).catch((err) => {
        /* handle the error */
        restart();
        console.error(err);
        Modal.alert({
          title: $filter('translate')('SAY_HI__MODAL_ERROR_TITLE'),
          message: $filter('translate')('SAY_HI__MODAL_ERROR_DESCRIPTION'),
          buttonColor: 'red',
        });
      });

    }

    function record(stream) {
      gumVideo = document.querySelector('video'); //todo refactor this
      gumVideo.srcObject = stream;
      recordedBlobs = [];
      let options = {mimeType: 'video/webm;codecs=vp9'};
      if (!MediaRecorder.isTypeSupported(options.mimeType)) {
        options = {mimeType: 'video/webm;codecs=vp8'};
        if (!MediaRecorder.isTypeSupported(options.mimeType)) {
          options = {mimeType: 'video/webm'};
          if (!MediaRecorder.isTypeSupported(options.mimeType)) {
            options = {mimeType: ''};
          }
        }
      }
      mediaRecorder = new MediaRecorder(stream, options);

      mediaRecorder.ondataavailable = handleDataAvailable;
      mediaRecorder.start(10); // collect 10ms of data
    }

    function stopRecording() {
      recording = false;
      mediaRecorder.stop();
      gumVideo.srcObject.getTracks().forEach(track => track.stop());
      let recordedVideo = new Blob(recordedBlobs, {type: 'video/webm'});
      recordedVideoUrl = URL.createObjectURL(recordedVideo);
    }

    function uploadManually() {
      return upload(document.getElementById('mVideo').files[0]);
    }

    let hasUploadedVideo = SayHiResource.hasUploadedVideo;

    return ({
      startRecording: startRecording,
      stopRecording: stopRecording,
      upload: upload,
      uploadManually: uploadManually,
      recordedVideoUrl: getRecordedVideoUrl,
      restart: restart,
      recording: getRecording,
      hasUploadedVideo: hasUploadedVideo,
    });
  }]);

angular.module('searchMeployees')

.controller('SearchMeployeesController', ['$scope', 'SearchMeployees', '$location', 'LanguageService', 'GeoResource', 'MyStaff', '$translate', 'AlertBanner', 'Category', '$window', '$filter',
        function($scope, SearchMeployees, $location, LanguageService, GeoResource, MyStaff, $translate, AlertBanner, Category, $window, $filter ) {

    $scope.form = {};

    $scope.noResults = SearchMeployees.getResultsState;

    $scope.meployees = SearchMeployees.getMeployees;

    $scope.filters = SearchMeployees.getFilters;

    $scope.resetFilters = () => {
        SearchMeployees.clearFilters();
        $scope.form.region = SearchMeployees.getRegionBy();
        $scope.form.categories = '';
        $scope.form.language = ''
    };

    $scope.orderBy = SearchMeployees.getOrderBy;

    $scope.regionBy = SearchMeployees.getRegionBy;

    $scope.findMeployees = SearchMeployees.findMeployees;

    $scope.addFilter = SearchMeployees.addFilter;

    $scope.setOrder = SearchMeployees.setOrder;

    $scope.setRegion = SearchMeployees.setRegion;

    $scope.setLang = SearchMeployees.setLang;

    $scope.setShowExistingStaff = SearchMeployees.setShowExistingStaff;

    $scope.removeFilter = SearchMeployees.removeFilter;

    $scope.showExistingStaff = SearchMeployees.showExistingStaff;

    $scope.regions = GeoResource.query();

    $scope.addCategoryFilter = SearchMeployees.addCategoryFilter;

    $scope.inStaffUsers = {};

    SearchMeployees.loadDefaultRegion().then(region => {
        $scope.form.region = region;
    });

    $scope.goToUserProfile = function (id) {
         $scope.saveOffset();
         $location.path('/profile/' + id)
    };

    $scope.addFilterAndInitSearch = (filter) => {
         SearchMeployees.newSearching();
         SearchMeployees.addFilter(filter);
    };

    $scope.searchAutocompleteField = 'name_' + LanguageService.getCurrentLanguage();

    $scope.allCategories = Category.getAll();

    $scope.searchMeployee = function (searchStr) {
        if (!searchStr) { return }
        SearchMeployees.addFilter(searchStr.originalObject['name_'+LanguageService.getCurrentLanguage()]);
        $scope.form.filter = '';
    };

    $scope.pages = {
        current : SearchMeployees.getCurrentPage,
        disableInfiniteScroll: SearchMeployees.infiniteScrollDisabled
    };


    MyStaff.getStaffMeployeeIds().$promise.then(result => {
        result.meployees.forEach(id => {
            $scope.inStaffUsers[id] = true;
        })
    });

    $scope.switchStaff = function (meployee) {
        if (!$scope.inStaffUsers[meployee.id]) {
            MyStaff.addToStaff(meployee.id).then(() => {
                AlertBanner.publish({
                    type: 'success',
                    message: $filter('translate')('PROFILE__ADD_TO_STAFF__SUCCEED', {name: meployee.first_name}),
                    timeCollapse: 2000
                });
                $scope.inStaffUsers[meployee.id] = true;
                MyStaff.actionsAfterAddToRemoveFromStaff(false);
            });
        } else {
            MyStaff.removeFromMyStaff(meployee.id).then(() => {
               $scope.inStaffUsers[meployee.id] = false;
                MyStaff.actionsAfterAddToRemoveFromStaff(false);
            });
        }
    };

    $scope.saveOffset = () => {
        SearchMeployees.initialVerticalOffset = $window.pageYOffset;
    };

    $scope.setVerticalOffset(SearchMeployees.initialVerticalOffset, () => {SearchMeployees.initialVerticalOffset = 0});

}]);

angular.module('searchMeployees')

.service('SearchMeployeesResource', ['$resource' , 'RequestTransform', function($resource, RequestTransform) {
    return  $resource('/api/user-search/', {}, {
        search: { method:'GET',
            isArray: true,
            transformResponse: RequestTransform.getPaginatedCount,
            params: {
                page_size: 8
            }
        }
    });
}]);

angular.module('searchMeployees')

.factory('SearchMeployees', ['SearchMeployeesResource', '$location', 'GeoResource',
    function (SearchMeployeesResource, $location, GeoResource) {

    var SearchMeployees = {};

    var filters = [];

    var meployees = [];

    let categories = [];

    var orderBy;

    let defaultRegion = {};

    var regionBy = {};

    let language;

    var currentPage = 0;

    var disableInfiniteScroll = false;

    var noResults = false;

    var pending = false;

    var showExistingStaff = false;

    SearchMeployees.findMeployees = function (filters, orderBy) {
        if (pending) {return}
        pending = true;
        currentPage = currentPage + 1;
        let data = {'filters': filters, 'ordering': orderBy, 'page' : currentPage, 'show_existing_staff' : showExistingStaff};
        if (regionBy && regionBy.id) {
            data['region'] = regionBy.id;
        }
        if (language) {
            data['lang'] = language;
        }
        if (categories) {
            data['category'] = categories;
        }
        return SearchMeployeesResource.search(data).$promise.then(function (response) {
            meployees = meployees.concat(response);
            pending = false;
            if (filters && response.length == 0) {
                noResults = true;
                disableInfiniteScroll = true;
            } else {
                noResults = false
            }
        }, function () {
            disableInfiniteScroll = true;
            pending = false;
        });
    };

    SearchMeployees.getMeployees = function () {
        return meployees;
    };

    SearchMeployees.getFilters = function () {
        return filters;
    };

    SearchMeployees.getResultsState = function () {
        return noResults;
    };

    SearchMeployees.getCurrentPage = function () {
        return currentPage;
    };

    SearchMeployees.infiniteScrollDisabled = function () {
        return disableInfiniteScroll;
    };

    SearchMeployees.addCategoryFilter = function (category) {
        categories[0] = category;
        SearchMeployees.newSearching();
        SearchMeployees.findMeployees(filters, orderBy)
    };

    SearchMeployees.loadDefaultRegion = () => {
        return GeoResource.getCurrentUserRegion().$promise.then((region) => {
            defaultRegion = region;
            regionBy = region;
            return region
        });
    };


    SearchMeployees.setRegion = function (region) {
        regionBy = region;
        SearchMeployees.newSearching();
        SearchMeployees.findMeployees(filters, orderBy);
    };

    SearchMeployees.setLang = lang => {
        language = lang;
        SearchMeployees.newSearching();
        SearchMeployees.findMeployees(filters, orderBy);
    };

    SearchMeployees.setOrder = function (order) {
        orderBy = order;
        SearchMeployees.newSearching();
        SearchMeployees.findMeployees(filters, order);
    };

    SearchMeployees.setShowExistingStaff = showExisting => {
        showExistingStaff = showExisting;
        SearchMeployees.newSearching();
        SearchMeployees.findMeployees(filters, orderBy, showExistingStaff);
    };

    SearchMeployees.getOrderBy = function () {
        return orderBy;
    };

    SearchMeployees.getRegionBy = () => {
        return regionBy;
    };

    SearchMeployees.clearFilters = function () {
        filters = [];
        language = undefined;
        regionBy = defaultRegion;
        categories = [];
        SearchMeployees.newSearching();
        SearchMeployees.findMeployees(filters, orderBy);
    };

    SearchMeployees.addFilter = function (filter) {
        if (filter && filters.indexOf(filter) == -1 ) {
            filters.push(filter);
            SearchMeployees.newSearching();
            SearchMeployees.findMeployees(filters, orderBy)
        }
    };

    SearchMeployees.removeFilter = function (filter) {
        var index = filters.indexOf(filter);
        filters.splice(index, 1);
        SearchMeployees.newSearching();
        SearchMeployees.findMeployees(filters, orderBy);
        if (filters.length == 0) {
            noResults = false;
        }
    };

    SearchMeployees.newSearching = function () {
        disableInfiniteScroll = false;
        currentPage = 0;
        meployees = [];
    };

    SearchMeployees.initialVerticalOffset = 0;

    return SearchMeployees;

}]);

angular.module('searchPloys')

.controller('SearchPloysMapController', ['$scope', 'SearchPloys', 'User',
        function($scope, SearchPloys, User) {


        $scope.ploys = SearchPloys.getPloys;

        $scope.map = SearchPloys.Map.setMap(12, _.get(_.find(SearchPloys.getFilters(), 'myLat'), 'myLat'), _.get(_.find(SearchPloys.getFilters(), 'myLon'), 'myLon'));

        $scope.options = SearchPloys.Map.options;

        $scope.control = {};

        $scope.$on('refresh-search-ploys-map', function(event, args) {
            $scope.control.refresh({latitude: _.get(_.find(SearchPloys.getFilters(), 'myLat'), 'myLat'), longitude: _.get(_.find(SearchPloys.getFilters(), 'myLon'), 'myLon')});
        });

        $scope.mapControl = {};
        var clickHandler = function(){
            angular.forEach($scope.mapControl.getGWindows(), function(gWindow){
                gWindow.close()
            });
        };

        var createMarker = function(i, bounds, idKey, ploy) {
                if (idKey == null) {
                    idKey = "id";
                }

                var ret = {
                    latitude: ploy.lat,
                    longitude: ploy.lon,
                    ploy: ploy,
                    icon: {
                     url : ploy.category.icon,
                     scaledSize: {
                        width: 50,
                        height: 50
                     }
                    }
                };
                ret[idKey] = ploy.id;
                ret.onClick = clickHandler;
                return ret;
        };

        $scope.ploysMarkers = [];
            // Get the bounds from the map once it's loaded

        $scope.$watch(function() {
            return $scope.map.bounds || $scope.ploys();
            }, function() {
                // Only need to regenerate once

                var i = 0;
                if ($scope.ploys()) {
                    var markers = [];
                    while ($scope.ploys()[i]) {
                        markers.push(createMarker(i, $scope.map.bounds, null, $scope.ploys()[i]));
                        i++;
                    }
                    $scope.ploysMarkers = markers;
                }
        }, true);
            
        $scope.markersOptions = {
             optimized : false,
             animation: 'DROP'
        };

}]);

angular.module('searchPloys')

    .controller('SearchPloysController', ['$scope', 'SearchPloys', 'Category', 'Ploy', '$filter', 'Geolocation', 'AlertBanner', '$rootScope',
        'Constants', 'GeoResource', 'User', '$location', 'Modal', 'MyCalendar', '$timeout', '$uibModal',
        function ($scope, SearchPloys, Category, Ploy, $filter, Geolocation, AlertBanner, $rootScope, Constants, GeoResource, User, $location,
                  Modal, MyCalendar, $timeout, $uibModal) {

            $scope.form = SearchPloys.getFilters;

            $scope.form.categories = SearchPloys.getCategories;

            $scope.allCategories = Category.getAll();

            $scope.ploys = SearchPloys.getPloys;

            $scope.findPloys = SearchPloys.findPloys;

            $scope.noResults = SearchPloys.getResultsState;

            $scope.filters = SearchPloys.getFilters;

            $scope.categories = SearchPloys.getCategories;

            $scope.orderBy = SearchPloys.getOrderBy();

            $scope.addFilter = SearchPloys.addFilter;

            $scope.addCategoryFilter = SearchPloys.addCategoryFilter;

            $scope.setOrder = SearchPloys.setOrder;

            $scope.removeFilter = SearchPloys.removeFilter;

            if (User.isAuthenticated()) {
                $scope.regions = GeoResource.query();
            }

            $scope.hours = Constants.hours;

            $scope.round = (number) => {
                return $filter('number')(number, 2);
            };

            $scope.mainSearch = function () {
                SearchPloys.mainSearch(SearchPloys.getFilters(), SearchPloys.getCategories(), SearchPloys.getOrderBy(), $scope.pages.current());
                $rootScope.$broadcast('refresh-search-ploys-map');
                if ($scope.mobileBreakpoint()) {
                    $scope.filtersCollapsed = true;
                    $scope.invitationCollapsed = true;
                }
            };

            $scope.listResultTabs = SearchPloys.listResultsTabs;

            $scope.pages = {
                current: SearchPloys.getCurrentPage,
                disableInfiniteScroll: SearchPloys.infiniteScrollDisabled
            };

            $scope.filtersCollapsed = $scope.mobileBreakpoint();
            $scope.invitationCollapsed = $scope.mobileBreakpoint();

            $scope.resetFilters = function () {
                $scope.form = {};
                SearchPloys.resetFilters();
            };

            $scope.onPlaceChanged = function (place) { // Fired when user choose city from google autocomplete
                if (Ploy.isPlaceWithinRestrictions(place)) {
                    angular.extend($scope.form, Ploy.parseAddressComponents(place.address_components));
                    SearchPloys.setLocationFilter(
                        String(place.geometry.location.lat()).slice(0, 8),
                        String(place.geometry.location.lng()).slice(0, 8)
                    );
                    console.log($scope.filters())
                } else {
                    $scope.form.address = '';
                    AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')('LIMITED_TO_COPENHAGEN'),
                        timeCollapse: 4000
                    });
                }
            };


            $scope.getCurrentPosition = function () {  // Fired when user click on geolocation
                Geolocation.getCurrentPosition().then(function (position) {
                    Geolocation.getAddressFromLatLon(position.coords.latitude, position.coords.longitude, function (data) {
                        if (data.success == true) {
                            $scope.form.address = data.formatted_address;
                            SearchPloys.setLocationFilter(position.coords.latitude, position.coords.longitude);
                            console.log($scope.filters());
                            AlertBanner.publish({
                                type: 'info',
                                message: $filter('translate')('LOCATION_SET') + data.formatted_address,
                                timeCollapse: 4000
                            });
                        }
                    });
                })
            };

            $scope.goToPloyDetail = (ploy) => {
                $location.path('/ploy-detail/' + ploy.id);
            };

            let checkCalendarEvents = () => {
                if (!User.isAuthenticated() || User.get().user_type !== Constants.userTypes.MEPLOYEE) {
                    return;
                }
                let date_to = moment().endOf('month').format('YYYY-MM-DD');
                MyCalendar.getAvailableDays(date_to).$promise.then((availableDays) => {
                    if (!availableDays.length) {
                        return Modal.confirm({
                            title: $filter('translate')('CALENDAR_REMINDER_MODAL__TITLE'),
                            message: $filter('translate')('CALENDAR_REMINDER_MODAL__CONTENT'),
                            firstButtonLabel: $filter('translate')('CALENDAR_REMINDER_MODAL__FIRST_BUTTON'),
                            secondButtonLabel: $filter('translate')('CALENDAR_REMINDER_MODAL__SECOND_BUTTON'),
                            secondButtonColor: 'green',
                            secondButtonFunction: () => {
                                $location.path('/my-calendar')
                            }
                        });
                    }
                });
                if (User.get().user_typeform_data && User.get().user_typeform_data.nationality !== 1 && !User.get().profile.origin_country) {
                    $uibModal.open({
                        templateUrl: '/src/modals/html/modal-set-origin-country.html',
                        windowClass: 'modal-vertical-centered',
                        size: 'sm',
                        controller: 'ModalSetOriginCountryController',
                    });
                }
            };

            $timeout(checkCalendarEvents, 2000);

            $scope.inviteForm = {};
            $scope.inviteUser = () => {
                User.createUserInvitation({'email': $scope.inviteForm.to}).$promise.then(() => {
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('SEARCH_PLOY__USER_INVITATION__SUCCESS'),
                        timeCollapse: 4000
                    });
                    $scope.inviteForm.to = '';
                }, error => {
                    console.log(error);
                    AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')('SEARCH_PLOY__USER_INVITATION__ERROR'),
                        timeCollapse: 4000
                    });
                });
            };

            $scope.openInvitationLinkModal = () => {
                return $uibModal.open({
                    templateUrl: 'src/modals/html/modal-invitation-link.html',
                    windowClass: 'modal-vertical-centered',
                    controller: 'ModalInvitationLinkController',
                    resolve: {
                        user: function () {
                            return $scope.user;
                        }
                    }
                })
            };

        }]);

angular.module('searchPloys')

.factory('GeoResource', ['$resource' , 'RequestTransform', function($resource) {
    return  $resource('/api/region/', {id:'@id'},{
        query: { method:'GET', isArray: true ,cache: true },
        'getCurrentUserRegion': {
            method: 'GET',
            url: '/api/region/get_current_user_region/',
        },
        'getCountriesList': {
            method: 'GET',
            url: '/api/country/get_available_countries/',
        },
    });
}]);

angular.module('searchPloys')

.factory('SearchPloysResource', ['$resource' , 'RequestTransform', function($resource, RequestTransform) {
    return  $resource('/api/ploy-search/:id/', {id:'@id'},{
        query: { method:'GET', isArray: false },
        searchFilters: {
            method:'GET',
            url: '/api/ploy-search/search_ploys/',
            isArray: true,
            params: {page_size: 8},
            transformResponse: RequestTransform.getPaginatedCount    }
    });
}]);

angular.module('searchMeployees')

.factory('Map', ['$location', 'Constants', function ($location, Constants) {
    
    var Map = {};
    
    Map.options = function() {
        return {
            scrollwheel: false,
            zoomControl: false,
            scaleControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            draggable: false,
            autocomplete: true
        };
    };
    
    
    Map.map = function(zoom, lat, lon) {
        if(!zoom) {
            zoom = 12;
        }
        return {
            center: {
                latitude: lat || Constants.cities.Copenhagen.lat, longitude: lon || Constants.cities.Copenhagen.lon
            },
            zoom: zoom,
            center_marker: {},
            bounds: {}
        };
    };

    return Map;
}]);

angular.module('searchPloys')

.factory('SearchPloys', ['SearchPloysResource', 'Constants', function (SearchPloysResource, Constants) {

    var SearchPloys = {};

    var filters = {};

    var categories = [];

    var ploys = [];

    var orderBy = '-created';

    var currentPage = 0;

    var disableInfiniteScroll = false;

    var noResults = false;

    var pending = false;

    SearchPloys.findPloys = function (filters, categories, orderBy) {
        if (pending) {return}
        pending = true;
        currentPage = currentPage + 1;
        return SearchPloysResource.searchFilters({
            'ploys': filters,
            'categories': categories,
            'ordering': orderBy,
            'page' : currentPage
        }).$promise.then(function (response) {
            ploys = ploys.concat(response);
            pending = false;
            if (filters && response.length == 0) {
                noResults = true;
                disableInfiniteScroll = true;
            } else {
                noResults = false
            }
        }, function () {
            disableInfiniteScroll = true;
            pending = false;
        });
    };

    SearchPloys.getPloys = function () {
        return ploys;
    };

    SearchPloys.getFilters = function () {
        return filters;
    };

    SearchPloys.getCategories = function () {
        return categories;
    };

    SearchPloys.getResultsState = function () {
        return noResults;
    };

    SearchPloys.getCurrentPage = function () {
      return currentPage;
    };

    SearchPloys.infiniteScrollDisabled = function () {
      return disableInfiniteScroll;
    };


    SearchPloys.setOrder = function (order) {
      orderBy = order;
      SearchPloys.newSearching();
      SearchPloys.findPloys(filters, categories, order, currentPage);
    };

    SearchPloys.getOrderBy = function () {
      return orderBy;
    };

    SearchPloys.setLocationFilter = function (lat, lon) {
        if ( !_.get(_.find(filters, 'myLat'), 'myLat') && !_.get(_.find(filters, 'myLon'), 'myLon') ) {
            filters.push({ 'myLat' : lat, 'myLon' : lon });
        } else {
            _.find(filters, 'myLat').myLat = lat
            _.find(filters, 'myLat').myLon = lon
        }
    };

    SearchPloys.addFilter = (key, value) => {
        filters[key] = value;
    };

    SearchPloys.addCategoryFilter = function (category) {
        // if (category && categories.indexOf(category) == -1 ) {
            categories[0] = category;
        // }
    };

    SearchPloys.newSearching = function () {
        disableInfiniteScroll = false;
        currentPage = 0;
        ploys = [];
    };

    SearchPloys.mainSearch = function (filters, categories, orderBy, currentPage) {
        SearchPloys.newSearching();
        SearchPloys.findPloys(filters, categories, orderBy, currentPage);
    };

    SearchPloys.resetFilters = function () {
      filters = {};
      categories = [];
      SearchPloys.mainSearch();
    };

    SearchPloys.listResultsTabs = {
        active: 'list',
        activate: function (type) {
            SearchPloys.listResultsTabs.active = type
        }
    };
    
    SearchPloys.Map = {};
    
    SearchPloys.Map.options = {
        scrollwheel: true,
        zoomControl: true,
        scaleControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        draggable: true,
        autocomplete: true
    };
    
    
    SearchPloys.Map.setMap = function(zoom, lat, lon) {
        if(!zoom) {
            zoom = 12;
        }
        return {
            center: {
                latitude: lat || Constants.cities.Copenhagen.lat, longitude: lon || Constants.cities.Copenhagen.lon
            },
            zoom: zoom,
            center_marker: {},
            bounds: {}
        };
    };
    
    
    
    
    return SearchPloys;

}]);

angular.module('signUpMeployeeAddress')

.controller('SignUpMeployeeAddressController', ['$scope', 'Auth', 'User', '$location', '$window', function($scope, Auth, User, $location, $window) {
    User.get().$promise.then(function(user) {
        $scope.form = angular.copy(user);
        $scope.form.address = null
    });
    $scope.saveUser = function (form) {
        User.save(form).then(function() {
            $location.path('/');
        });
    }

}]);

angular.module('signUpMeployeeTaxes')

.controller('SignUpMeployeeTaxesController', ['$scope', 'Auth', 'User', '$location', function($scope, Auth, User, $location) {
    User.get().$promise.then(function(user) {
        $scope.form = angular.copy(user);
        $scope.form.tax_agreement = true;
    });
    $scope.saveTaxAgreement = function () {
        User.save($scope.form).then(function() {
            $location.path('/');
        });
    }

}]);
angular.module('signUpMeployee')

.controller('SignUpDetailsController', ['$scope', 'User', '$location', 'SignUpMeployeeService', 'Category',
    'Constants', 'Geolocation', 'AlertBanner', '$filter', '$translate', 'GeoResource', 'Device',
    function($scope, User, $location, SignUpMeployeeService, Category, Constants, Geolocation, AlertBanner, $filter,
    $translate, GeoResource, Device) {

    $scope.form = {
        chosenCategories: []  // must be a nested scope - http://jimhoskins.com/2012/12/14/nested-scopes-in-angularjs.html
    };

    $scope.goToChooseCategory = () => {  // used on page - when to work
        SignUpMeployeeService.updateUserTypeformData({'when_would_like_work': $scope.when_would_like_work}).$promise.then(() => {
            $location.path('/sign-up/employee/choose-categories');
        }, error => console.log(error));
    };

    $scope.goToCalendar = () => {  // used on page - choose categories
        User.silentUpdateUserProperty('category', $scope.form.chosenCategories).then(() => {
            $location.path('/sign-up/employee/calendar');
        }, error => console.log(error));
    };

    $scope.goToPostalCode = () => {  // used on page - calendar
        $location.path('/sign-up/employee/postal-code');
    };

    $scope.goToSummary = (form) => {  // used on page - postal code
        SignUpMeployeeService.updateUserTypeformData(form).$promise.then(() => {
            User.saveSilent(form).then(() => {
                $location.path('/sign-up/employee/summary');
            });
        });
    };

    $scope.goToHome = (form) => {  // used on page - postal code
        SignUpMeployeeService.updateUserTypeformData(form).$promise.then(() => {
            User.saveSilent(form).then(() => {
                $location.path('/');
            });
        });
    };

    $scope.goToEmailVerification = () => {  // used on page - summary
        if ($scope.mobileBreakpoint()) {
           return $location.path('/download-app');
        }
        $location.path('/confirm-email');
    };

    $scope.goToProApplication = () => {  // used on page - summary
        $location.path('/application');
    };

    $scope.signupMeployeeSteps = [
        {
            name: 'SIGNUP_MEPLOYEE_STEPS__STEP_1'
        },
        {
            name: 'SIGNUP_MEPLOYEE_STEPS__STEP_2'
        },
        {
            name: 'SIGNUP_MEPLOYEE_STEPS__STEP_3'
        },
        {
            name: 'SIGNUP_MEPLOYEE_STEPS__STEP_4'
        },
    ];

    $scope.showSignupReviewAlert = true;

    $scope.when_would_like_work = [];

    $scope.changeWhenStatus = (value) => {
        if ($scope.when_would_like_work.includes(value)) {
            $scope.when_would_like_work = $scope.when_would_like_work.filter(e => e !== value);
        } else {
            $scope.when_would_like_work.push(value);
        }
    };

    $scope.whenToWorkOptions = [
        {
            value: '1',
            name: 'SIGNUP_MEPLOYEE_WHEN_TO_WORK__OPTION__DAYTIME',
            slug: 'daytime'
        },
        {
            value: '2',
            name: 'SIGNUP_MEPLOYEE_WHEN_TO_WORK__OPTION__EVENING',
            slug: 'evening'
        },
        {
            value: '3',
            name: 'SIGNUP_MEPLOYEE_WHEN_TO_WORK__OPTION__NIGHT',
            slug: 'night'
        },
        {
            value: '4',
            name: 'SIGNUP_MEPLOYEE_WHEN_TO_WORK__OPTION__WEEKDAYS',
            slug: 'weekdays'
        },
        {
            value: '5',
            name: 'SIGNUP_MEPLOYEE_WHEN_TO_WORK__OPTION__WEEKENDS',
            slug: 'weekends'
        }
    ];


    $scope.saveSilent = (userForm) => {
        userForm.birthday.setMilliseconds(0);  // backend raise validation error is milliseconds not 000
        User.isCprNumberUnique({'cpr_number': userForm.cpr_number}).$promise.then((response) => {
            if (response.unique) {
                // Case is only for already logged in users
                // First is save to typeform, because user can change email in userForm, and then will be auto-logged-out
                SignUpMeployeeService.updateUserTypeformData({'nationality': $scope.form.user_typeform_data.nationality}).$promise.then(() => {
                    User.saveSilent(userForm).then(() => {
                        $location.path('/sign-up/employee/when-to-work');
                    }, error => console.log(error));
                });
            } else {
                AlertBanner.publish({
                    type: 'error',
                    message: $filter('translate')('AUTH__USER_WITH_THIS_CPR_NUMBER_ALREADY_EXISTS'),
                    timeCollapse: 4000
                });
            }
        }, error => console.log(error));
    };

    $scope.setNationality = (value) => {
        $scope.form.user_typeform_data.nationality = value;
    };

    $scope.uploadAvatar = User.upload_avatar_64;

    $scope.patterns = Constants.patterns;
    $scope.status = {};

    $scope.nationalityOptions = Constants.nationalityOptions;

    User.get().$promise.then((user) => {
        $scope.form = angular.copy(user);
        delete $scope.form.profile.origin_country;
        let adult = new moment().subtract(18, 'years').toDate();
        $scope.form.birthday = $scope.form.birthday ? $scope.form.birthday : adult;
        $scope.form.legal_form = $scope.form.legal_form ? $scope.form.legal_form : 'private';
        // $scope.form.nationality = $scope.form.nationality ? $scope.form.nationality : 1;
        $scope.form.origin_country = $scope.form.origin_country ? $scope.form.origin_country : '';
        $scope.form.postal_code = parseInt(user.postal_code);
        if (user.user_typeform_data) {
            $scope.when_would_like_work = user.user_typeform_data.when_would_like_work;
            $scope.form.user_typeform_data.nationality = user.user_typeform_data.nationality;

            // get data for 'How did you hear about meploy'
            $scope.form.how_did_u_hear_about_meploy = user.user_typeform_data.how_did_u_hear_about_meploy;
            $scope.form.how_did_u_hear_about_meploy_trade_union = user.user_typeform_data.how_did_u_hear_about_meploy_trade_union;
            $scope.form.how_did_u_hear_about_meploy_friend = user.user_typeform_data.how_did_u_hear_about_meploy_friend;
            $scope.form.how_did_u_hear_about_meploy_job_center = user.user_typeform_data.how_did_u_hear_about_meploy_job_center;
            $scope.form.how_did_u_hear_about_meploy_job_fair = user.user_typeform_data.how_did_u_hear_about_meploy_job_fair;
        }
        $scope.form.chosenCategories = user.category;
        $scope.checkPostalCodeName();
    });

    $scope.postalCodeName = '';

    $scope.checkPostalCodeName = () => {
        if ($scope.form.postal_code && String($scope.form.postal_code).length == 4) {
            getNameOfPostalCode($scope.form.postal_code);
        }
    };

    let getNameOfPostalCode = (code) => {
        Geolocation.getNameOfPostalCode({ postal_code: code }).$promise.then((postalCode) => {
            $scope.postalCodeName = postalCode.name;
        }, error => console.log(error));
    };

    $scope.setBirthDayBasedOnCprNumber = () => {
        $scope.form.birthday = User.setBirthDayBasedOnCprNumber($scope.form.cpr_number, $scope.form.birthday);
    };

    GeoResource.getCountriesList().$promise.then(countries => {
        $scope.countries = countries;
    });

    $scope.howDidYouHearAboutMeployOptions = [
        {
            value: 1,
            name: 'SIGNUP_MEPLOYEE__HOW_YOU_HEAR__GOOGLE_SEARCH',
        },
        {
            value: 2,
            name: 'SIGNUP_MEPLOYEE__HOW_YOU_HEAR__FACEBOOK_AD',
        },
        {
            value: 11,
            name: 'SIGNUP_MEPLOYEE__FACEBOOK_POST_IN_GROUP',
        },
        {
            value: 12,
            name: 'SIGNUP_MEPLOYEE__INSTAGRAM',
        },
        {
            value: 3,
            name: 'SIGNUP_MEPLOYEE__HOW_YOU_HEAR__PRESS_ARTICLE',
        },
        {
            value: 10,
            name: 'SIGNUP_MEPLOYEE__MEPLOY_CALLED_ME',
        },
        {
            value: 13,
            name: 'SIGNUP_MEPLOYEE__WORKPLACE_REFERENCE',
        },
        {
            value: 4,
            name: 'SIGNUP_MEPLOYEE__HOW_YOU_HEAR__TRADE_UNION',
        },
        {
            value: 8,
            name: 'SIGNUP_MEPLOYEE__HOW_YOU_HEAR__MY_JOBCENTER',
        },
        {
            value: 14,
            name: 'SIGNUP_MEPLOYEE__JOBNET',
        },
        {
            value: 9,
            name: 'SIGNUP_MEPLOYEE__HOW_YOU_HEAR__JOB_FAIR',
        },
        {
            value: 5,
            name: 'SIGNUP_MEPLOYEE__HOW_YOU_HEAR__SCHOOL_EVENT',
        },
        {
            value: 6,
            name: 'SIGNUP_MEPLOYEE__HOW_YOU_HEAR__FRIEND_WHO_IS_ON_MEPLOY',
        },
        {
            value: 7,
            name: 'SIGNUP_MEPLOYEE__HOW_YOU_HEAR__A_FRIEND',
        },
        {
            value: 15,
            name: 'SIGNUP_MEPLOYEE__OTHER',
        },
    ];

}]);

angular.module('signUpMeployee')

    .controller('SignUpController', ['$scope', 'Auth', 'User', '$routeParams', 'Constants', '$analytics', '$location', 'GeoResource',
        function ($scope, Auth, User, $routeParams, Constants, $analytics, $location, GeoResource) {
            $scope.signUp = Auth.signup;
            $scope.countries = {}; // init list of all countries used for origin_country field
            let adult = new moment().subtract(18, 'years').toDate();
            $scope.form = {
                legal_form: 'private',
                birthday: adult,
            };
            $analytics.eventTrack('Lead', {category: 'Registration'});
            $scope.status = {};
            $scope.oauthLogin = Auth.oauthLogin;
            $scope.patterns = Constants.patterns;

            $scope.goToSignUpEmail = () => {
                $location.path('/sign-up/employee/email');
            };

            $scope.setNationality = (value) => {
                $scope.form.user_typeform_data.nationality = value;
            };

            $scope.nationalityOptions = Constants.nationalityOptions;

            $scope.setBirthDayBasedOnCprNumber = () => {
                $scope.form.birthday = User.setBirthDayBasedOnCprNumber($scope.form.cpr_number, $scope.form.birthday);
            };

            GeoResource.getCountriesList().$promise.then(countries => {
                $scope.countries = countries;
            })

        }]);


angular
    .module('signUpMeployee')
    .directive('signUpEmailForm', [
        function() {
            return {
                restrict: 'E',
                scope: {
                    form: '=',
                    patterns: '=',
                    status: '=',
                    hidePasswordField: '=',
                    nationality: '=',
                    nationalityOptions: '=',
                    countryOptions: '=',
                    setNationality: '=',
                    setBirthDayBasedOnCprNumber: '=',
                },
                templateUrl: '/src/sign-up-meployee/html/includes/sign-up-meployee-email-form.html',
                replace: true
            };
        }
    ]);

angular.module('signUpMeployee')

.factory('SignUpMeployeeResource', ['$resource', function($resource) {
    return $resource('/api/user-typeform-data/', {}, {
        userTypeformData: {
            method: 'POST',
            url: '/api/user-typeform-data/update_data/',
        }
    })
}]);

angular.module('signUpMeployee')

.factory('SignUpMeployeeService', ['SignUpMeployeeResource', function(SignUpMeployeeResource) {

    let SignUpMeployeeService = {};

    SignUpMeployeeService.updateUserTypeformData = SignUpMeployeeResource.userTypeformData;

    return SignUpMeployeeService;

}]);

angular.module('signUpMeployer')

.controller('MeployerOnboardingBar', ['$scope', 'Modal', '$filter', 'User', 'ContactForm', 'AlertBanner', '$location', 'MeployerOnboardingBar', 'Company',
    function($scope, Modal, $filter, User, ContactForm, AlertBanner, $location, MeployerOnboardingBar, Company) {

    let requestHelpMessage = {};
    $scope.isCollapsed = false;

    $scope.firstStepCompleted = MeployerOnboardingBar.firstStepCompleted;
    $scope.secondStepCompleted = MeployerOnboardingBar.secondStepCompleted;
    $scope.thirdStepCompleted = MeployerOnboardingBar.thirdStepCompleted;
    $scope.allStepsCompleted = MeployerOnboardingBar.allStepsCompleted;

    $scope.switchCollapse = () => {
        $scope.isCollapsed = !$scope.isCollapsed;
    };

    $scope.goToSalarySettings = () => {
        $location.path('/salary-rules/base-salary');
    };

    $scope.goToCompanySettings = () => {
        $location.path('/my-company/invoice-settings');
    };

    $scope.goToSalaryFactor = () => {
        $location.path('/salary-factor/calculate');
    };

    $scope.goToCollectiveAgreements= () => {
        $location.path('/collective-agreements');
    };

    $scope.showOnboardingBar = () => {
        return !$location.path().includes('sign-up');
    };

    $scope.setOnboardingAsCompleted = () => {
        Company.setOnboardingAsCompleted().$promise.then(company => {
            AlertBanner.publish({
                type: 'success',
                message: $filter('translate')('Happy ploying!') + '!',
                timeCollapse: 4000
            });
            User.get().company.onboarding_completed = company.onboarding_completed
        });
    };


    User.get().$promise.then(user => {
        requestHelpMessage = {
            name: user.first_name + ' ' + user.last_name,
            email: user.email,
            subject: 'Onboarding help request',
            message: '-- Automatic message -- \n User ' + '(ID: ' + user.id + ') requested a call using help button in meployer onboarding bar.'
        };
    });

    $scope.showHelpModal = () => {
        return Modal.confirm({
            title : $filter('translate')('MEPLOYER_ONBOARDING_BAR__HELP_MODAL__TITLE'),
            message: $filter('translate')('MEPLOYER_ONBOARDING_BAR__HELP_MODAL__DESCRIPTION'),
            firstButtonLabel : $filter('translate')('MEPLOYER_ONBOARDING_BAR__HELP_MODAL__FIRST_BUTTON'),
            secondButtonLabel : $filter('translate')('MEPLOYER_ONBOARDING_BAR__HELP_MODAL__SECOND_BUTTON'),
            secondButtonColor : 'green',
            secondButtonFunction: () => {
                console.log(requestHelpMessage)
                ContactForm.save(requestHelpMessage).$promise.then(() => {
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('MEPLOYER_ONBOARDING_BAR__HELP_MODAL__HELP_REQUESTED_INFO'),
                        timeCollapse: 4000
                    });
                });
            }
        });
    }

}]);

angular.module('signUpMeployer')

.controller('SignUpMeployerDetailsController', ['$scope', 'Company', 'AlertBanner', '$filter', '$location', 'User', 'Geolocation', 'ProfileSettings',
    function($scope, Company, AlertBanner, $filter, $location, User, Geolocation, ProfileSettings) {

        $scope.form = {};
        $scope.previewCompanyAddress = '';


        $scope.signupMeployerSteps = [
        {
            name: 'SIGNUP_MEPLOYER_STEPS__STEP_1'
        },
        {
            name: 'SIGNUP_MEPLOYER_STEPS__STEP_2'
        },
    ];

        Company.getCompany().$promise.then(company => {
            $scope.company = company;
            $scope.collectiveAgreement = company.collective_agreement
        });

        $scope.goToPostalCode = () => {
            if (!$scope.company.postal_code) {
                    return $location.path('/sign-up/employer/company-address')
            }
            return $location.path('/my-ploys')
        };

        $scope.unknownCollectiveAgreement = () => {
          return $scope.collectiveAgreement === null;
        };

        $scope.setCompanyCollectiveAgreement = isCollectiveAgreement => {
            Company.updateCompanyCollectiveAgreement(isCollectiveAgreement).then(() => {
                $scope.collectiveAgreement = isCollectiveAgreement;
            })
        };

        $scope.checkPostalCodeName = () => {
            if ($scope.form.postal_code && $scope.form.postal_code.length === 4) {
                getNameOfPostalCode($scope.form.postal_code);
            }
        };

        let getNameOfPostalCode = (code) => {
            Geolocation.getNameOfPostalCode({postal_code: code}).$promise.then((postalCode) => {
                $scope.previewCompanyAddress = postalCode.name;
            }, error => console.log(error));
        };

        $scope.saveCompany = form => {
            Company.updateCompany(form).$promise.then(succ => {
                $location.path('/my-ploys');
                AlertBanner.publish({
                    type: 'success',
                    message: $filter('translate')('SAVED') + '!',
                    timeCollapse: 2000
                });
            }, err => {
                if (err.data.postal_code) {
                    AlertBanner.publish({
                        type: 'error',
                        message: $filter('translate')('INVALID_POSTAL_CODE') + '!',
                        timeCollapse: 4000
                    })
                }
            });
        };

}]);

angular.module('signUpMeployer')

.controller('SignUpMeployerController', ['$scope', 'Auth', 'User', '$routeParams', 'Constants', function($scope, Auth, User, $routeParams, Constants) {
    $scope.signUp = Auth.signup;
    $scope.companyForm = {
        legal_form : Constants.legalForms.COMPANY,
        user_type : Constants.userTypes.MEPLOYER
    };
    $scope.individualForm = {
        legal_form : Constants.legalForms.PRIVATE,
        user_type : Constants.userTypes.MEPLOYER
    };
    $scope.oauthLogin = Auth.oauthLogin;
    $scope.patterns = Constants.patterns;
    $scope.legalForm = {
        isCompany: true,
        switch: function () { this.isCompany = !this.isCompany }
    };
}]);
angular.module('signUpMeployer')

.service('MeployerOnboardingBar', ['SalaryRulesResource', 'Company', 'SalaryFactor', 'User', 'CollectiveAgreement',
    function(SalaryRulesResource, Company, SalaryFactor, User, CollectiveAgreement) {

    let MeployerOnboardingBar = {};

    let hasSalarySettings = false;
    let hasCompanyInvoiceSettings = false;
    let hasSalaryFactorSettings = false;
    let hasEstablishedCollectiveAgreements = false;
    let companyIsCollectiveAgreement = false;

    Company.getCompany().$promise.then(company => {
            companyIsCollectiveAgreement  = company.collective_agreement
    })

    MeployerOnboardingBar.loadSalarySettings = () => {
        SalaryRulesResource.hasSalarySettings().$promise.then(data => {
            hasSalarySettings = data.has_salary_settings;
        });
    };
    MeployerOnboardingBar.loadSalarySettings();

    MeployerOnboardingBar.loadCompanyInvoiceSettings = () => {
        Company.hasInvoiceSettings().$promise.then(data => {
            hasCompanyInvoiceSettings = data.has_invoice_settings;
        })
    };
    MeployerOnboardingBar.loadCompanyInvoiceSettings();

    MeployerOnboardingBar.loadSalaryFactorSettings = () => {
        SalaryFactor.hasSalaryFactor().$promise.then(data => {
            hasSalaryFactorSettings = data.has_salary_factor;
        })
    };
    MeployerOnboardingBar.loadSalaryFactorSettings();

    MeployerOnboardingBar.loadCollectiveAgreements = () => {
        CollectiveAgreement.hasCollectiveAgreements().$promise.then(data => {
            hasEstablishedCollectiveAgreements = data.has_established_agreements;
        })
    };
    MeployerOnboardingBar.loadCollectiveAgreements();

    MeployerOnboardingBar.firstStepCompleted = () => hasSalarySettings;
    MeployerOnboardingBar.secondStepCompleted = () => {
        if (companyIsCollectiveAgreement) {
            return hasEstablishedCollectiveAgreements
        }
        return hasSalaryFactorSettings;
    };
    MeployerOnboardingBar.thirdStepCompleted = () => hasCompanyInvoiceSettings;

    MeployerOnboardingBar.allStepsCompleted = () => {
        return MeployerOnboardingBar.firstStepCompleted() &&
               MeployerOnboardingBar.secondStepCompleted() &&
               MeployerOnboardingBar.thirdStepCompleted()
    };

    return MeployerOnboardingBar;

}]);

angular.module('signUpNewMeployee')

.controller('SignUpNewBirthdayController', ['$scope', 'SignUpNewMeployeeService', '$location',
    function($scope, SignUpNewMeployeeService, $location) {

    $scope.form = SignUpNewMeployeeService.getForm();
    if (!$scope.form.first_name) {
        $location.path('/sign-up/new-employee');
    }

    $scope.goToSignUpEmailPhone = () => {
        SignUpNewMeployeeService.updateForm($scope.form);
        $location.path('/sign-up/new-employee/email-phone');
    };

    $scope.datepickerOptions = {
        maxDate: new Date().setFullYear(new Date().getFullYear() - 18)
    };

}]);

angular.module('signUpNewMeployee')

.controller('SignUpNewEmailPhoneController', ['$scope', 'SignUpNewMeployeeService', '$location', 'AlertBanner', '$filter',
    function($scope, SignUpNewMeployeeService, $location, AlertBanner, $filter) {

    $scope.form = SignUpNewMeployeeService.getForm();
    if (!$scope.form.first_name) {
        $location.path('/sign-up/new-employee');
    }

    $scope.goToSignUpPassword = () => {
        SignUpNewMeployeeService.validateContactData($scope.form.email, $scope.form.phone).$promise.then((response) => {
            if (response.email_exist) {
                AlertBanner.publish({
                    type: 'error',
                    message: $filter('translate')('THIS_EMAIL_IS_ALREADY_REGISTERED'),
                    timeCollapse: 4000
                });
                return;
            }
            if (response.phone_exist) {
                AlertBanner.publish({
                    type: 'error',
                    message: $filter('translate')('THIS_PHONE_IS_ALREADY_REGISTERED'),
                    timeCollapse: 4000
                });
                return;
            }
            SignUpNewMeployeeService.updateForm($scope.form);
            $location.path('/sign-up/new-employee/password');
        });
    };

}]);

angular.module('signUpNewMeployee')

.controller('SignUpNewNameController', ['$scope', 'SignUpNewMeployeeService', '$location',
    function($scope, SignUpNewMeployeeService, $location) {

    $scope.form = SignUpNewMeployeeService.getForm();

    $scope.goToSignUpPostalCode = () => {
        SignUpNewMeployeeService.updateForm($scope.form);
        $location.path('/sign-up/new-employee/postal-code');
    };

}]);

angular.module('signUpNewMeployee')

.controller('SignUpNewPasswordController', ['$scope', 'SignUpNewMeployeeService', '$location', 'Auth',
    function($scope, SignUpNewMeployeeService, $location, Auth) {

    $scope.form = SignUpNewMeployeeService.getForm();
    if (!$scope.form.first_name) {
        $location.path('/sign-up/new-employee');
    }

    $scope.passwordsNotEqual = () => {
        if ($scope.form.password && $scope.form.password_repeat) {
            return $scope.form.password !== $scope.form.password_repeat;
        }
        return false;
    }

    $scope.doRegister = () => {
        Auth.signup($scope.form);
    };

}]);

angular.module('signUpNewMeployee')

.controller('SignUpNewPhoneVerifyController', ['$scope', 'Modal', '$filter', 'User', 'AlertBanner', '$rootScope', '$location',
    function($scope, Modal, $filter, User, AlertBanner, $rootScope, $location) {

    $scope.phone = {};

    $scope.checkCode = () => {
        if( $scope.phone.code.length === 4 ) {
            User.verifyPhone($scope.phone.code).$promise.then(() => {
                $scope.phone.code = '';
                Modal.alert({
                    title: $filter('translate')('SMS_VERIFICATION_BAR__MODAL_SUCCESS_TITLE'),
                    message: $filter('translate')('SMS_VERIFICATION_BAR__MODAL_SUCCESS_MESSAGE'),
                });
                $rootScope.$broadcast('user-verified-phone');
                $location.path('/');
            }, (error) => {
                $scope.phone.code = '';
                Modal.alert({
                    title: $filter('translate')('SMS_VERIFICATION_BAR__MODAL_FAIL_TITLE'),
                    message: $filter('translate')('SMS_VERIFICATION_BAR__MODAL_FAIL_MESSAGE'),
                });
            });
        }
    };

    $scope.resendSmsCode = () => {
        User.resendSmsCode();
        AlertBanner.publish({
            type: 'info',
            message: $filter('translate')('CONFIRMATION_CODE_HAS_BEEN_SENT_TO') + ' ' + $scope.user().phone,
            timeCollapse: 4000
        });
    }

}]);

angular.module('signUpNewMeployee')

.controller('SignUpNewPostalCodeController', ['$scope', 'SignUpNewMeployeeService', '$location', 'Geolocation',
    function($scope, SignUpNewMeployeeService, $location, Geolocation) {

    $scope.form = SignUpNewMeployeeService.getForm();
    if (!$scope.form.first_name) {
        $location.path('/sign-up/new-employee');
    }
    $scope.postalCodeName = '';
    $scope.nonExistingPostalCode = false;

    $scope.goToSignUpBirthday = () => {
        SignUpNewMeployeeService.updateForm($scope.form);
        $location.path('/sign-up/new-employee/birthday');
    };

    $scope.postalCodeChange = () => {
        if ($scope.form.postal_code_code && $scope.form.postal_code_code.toString().length === 4) {
            Geolocation.getNameOfPostalCode({ postal_code: $scope.form.postal_code_code }).$promise.then((postalCode) => {
                $scope.nonExistingPostalCode = false;
                $scope.postalCodeName = postalCode.name;
                $scope.form.postal_code = postalCode.id;
            }, error => {
                $scope.nonExistingPostalCode = true;
                console.log(error);
            });
        } else {
            $scope.postalCodeName = '';
            $scope.nonExistingPostalCode = false;
        }
    }
    $scope.postalCodeChange();

}]);

angular.module('signUpNewMeployee')

.controller('SignUpNewController', ['$scope', '$location', function($scope, $location) {

    $scope.goToSignUpName = () => {
        $location.path('/sign-up/new-employee/name');
    };

}]);

angular.module('signUpNewMeployee')

.factory('SignUpNewMeployeeService', ['UserResource', function(UserResource) {

    let SignUpNewMeployeeService = {};

    this.form = {};

    SignUpNewMeployeeService.updateForm = (form) => {
        this.form = form;
    }

    SignUpNewMeployeeService.getForm = () => {
        return this.form;
    }

    SignUpNewMeployeeService.validateContactData = (email, phone) => {
        return UserResource.validateContactData({'email': email, 'phone': phone});
    }

    return SignUpNewMeployeeService;

}]);

angular.module('smsVerificationBar')

.controller('SmsVerificationBarController', ['$scope', '$rootScope', 'User', 'Modal', '$translate', '$location', 'Constants', '$filter',
    function($scope, $rootScope, User, Modal, $translate, $location, Constants, $filter) {
        $scope.phone = {
            code: null
        };

        $scope.checkCode = () => {
            if( $scope.phone.code.length == 4 ) {
                User.verifyPhone($scope.phone.code).$promise.then(() => {
                    $scope.phone.code = '';
                    Modal.alert({
                        title: $filter('translate')('SMS_VERIFICATION_BAR__MODAL_SUCCESS_TITLE'),
                        message: $filter('translate')('SMS_VERIFICATION_BAR__MODAL_SUCCESS_MESSAGE'),
                    });
                    $rootScope.$broadcast('user-verified-phone');
                }, (error) => {
                    $scope.phone.code = '';
                    Modal.alert({
                        title: $filter('translate')('SMS_VERIFICATION_BAR__MODAL_FAIL_TITLE'),
                        message: $filter('translate')('SMS_VERIFICATION_BAR__MODAL_FAIL_MESSAGE'),
                    });
                });
            }
        };

        $scope.userTypes = Constants.userTypes;

        $scope.goToVerifications = () => {
            $location.path('/verifications');
        };

        $scope.userIsOnVerificationPage = () => {
            return $location.path().includes('application');
        };

        $scope.showVerificationBar = () => {
            return !$location.path().includes('sign-up');
        }

}]);

angular.module('stat')

.factory('StatResource', ['$resource', function ($resource) {
    return function (event) {
        return $resource('/api/stat/', {}, {
            record: {method: 'GET', url: '/api/stat/record/', params: {'event': event || 'ping'}},
            recordUserAction: {
                method: 'POST',
                url: '/api/stat/record/',
            },
            employeeStats: {
                method: 'GET',
                url: '/api/stat/employee-stats/'
            },
            getCompanyStats: {
                method: 'GET',
                url: '/api/stat/company-year-stats/',
                isArray: true
            },
            getCompanyStatsAvailableYears: {
                method: 'GET',
                url: '/api/stat/company-year-stats/available-years/',
                isArray: true
            },
            recordPloyView: {
                method: 'POST',
                url: '/api/stat/ploy-stat/record_ploy_visit/',
                isArray: true
            },
        })
    }
}]);

angular.module('stat')

.service('Stat', ['StatResource', function (StatResource) {
    this.record = () => {
        return StatResource('ping').record();
    };
    this.recordUserAction = (event, data) => {
        return StatResource().recordUserAction({'event': event, 'data': data});
    };
    this.employeeStats = () => {
        return StatResource(null).employeeStats();
    };
    this.getCompanyStats = year => {
        return StatResource(null).getCompanyStats({'year': year});
    };
    this.getCompanyStatsAvailableYears = () => {
      return StatResource(null).getCompanyStatsAvailableYears();
    };
    this.recordPloyView = ployId => {
      return StatResource().recordPloyView({'ploy_id': ployId});
    };
}]);

angular.module('supplement')

.factory('SupplementResource', ['$resource', ($resource) => {
    return $resource('/api/supplement/:id/', {id: '@id'}, {
        save: { method: 'POST' },
        remove: { method: 'DELETE' },
        'getSupplementsForPloy': {
            method: 'GET',
            url: '/api/supplement/get_supplements_for_ploy/',
            isArray: true,
        },
    })
}]);

angular.module('timecards')

.controller('RedeemTimeCardController', ['$scope', 'User', 'TimeCard', 'AlertBanner', '$filter',
    function($scope, User, TimeCard, AlertBanner, $filter) {
    $scope.redeemTimeCard = function(data) {
        TimeCard.use(data).$promise.then(function() {
                User.refresh().then(function (){
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('CODE_ACTIVATED_NOW_YOU_HAVE') + User.get().hours_discount + $filter('translate')('HOURS_LEFT_THANKS'),
                        timeCollapse: 8000
                    });
                    $scope.$close();
                })

        }, function () {
                AlertBanner.publish({
                    type: 'error',
                    message: $filter('translate')('THIS_CODE_DOESNT_EXIST'),
                    timeCollapse: 4000
                });
        });
    }
}]);
angular.module('timecards')

.controller('TimeCardController', ['$scope', '$uibModal', 'User', 'Modal', '$filter', function($scope, $uibModal, User, Modal, $filter) {
    $scope.openTimeCardModal = function() {
        if (!User.get().id) {
            Modal.alert({
                title: 'Psst..',
                message: $filter('translate')('YOU_NEED_TO_LOGIN_FIRST')
            })
        } else {
            $uibModal.open({
                templateUrl: 'src/timecards/html/modal-reedem.html',
                controller: 'RedeemTimeCardController',
                windowClass: 'modal-vertical-centered'
            })
        }
    };
}]);

angular.module('timecards')

.service('TimeCard', ['$resource', function($resource) {
    var DiscountResource = $resource('/api/discountcode/:code/', {code:'@code'}, {update:{'method':'PATCH'}});

    this.use = DiscountResource.update;

}]);

angular.module('ui-kit')

.controller('uiKitController', ['$scope', '$uibModal', 'User', 'Modal', 'AlertBanner', 'LightBox',
    function($scope, $uibModal, User, Modal, AlertBanner, LightBox) {

    $scope.openLightBox = LightBox.open;

    $scope.userPlaceholder = {
        "id": 469,
        "first_name": "John",
        "middle_name": "",
        "last_name": "Smith",
        "email": "xxx",
        "email_verify": true,
        "avatar_url": "https://unsplash.it/200/300",
        "language": "en",
        "country": "DK",
        "address": "Sss, 2000 Frederiksberg København",
        "tax_agreement": true,
        "postal_code": "2000",
        "city": "København",
        "deleted": false,
        "street": "Sss",
        "phone": "",
        "phone_verify": true,
        "about": " Mauris vehicula massa non orci volutpat cursus. Aenean sed purus enim. In in nibh nisl. Sed ut blandit nibh, eget vulputate nisi. Mauris vitae nisi eget ante venenatis lacinia. Morbi sit amet sagittis nunc. Nulla mattis tortor non erat imperdiet malesuada. Integer consequat nibh mattis volutpat tempor.",
        "occupation": "student-su",
        "birthday": "1981-12-27",
        "email_message": true,
        "email_request": true,
        "email_receive": true,
        "email_change": true,
        "message": false,
        "request": false,
        "receive": true,
        "change": true,
        "general": true,
        "review": true,
        "share": false,
        "search": true,
        "reviews_received_count": 1,
        "average_data": {
            "overall__avg": 3.0
        },
        "can_receive_payment": true,
        "has_facebook": true,
        "profile": {
            "facebook_friends_count": 0,
            "average_response_time": 0,
            "hours_paid": 0,
            "hours_rewarded": 0,
            "people_paid": 0
        },
        "works": [],
        "languages": [{"id": 1013, "name": "Polish"}],
        "skills": [],
        "schools": [],
        "ploys_completed": 0,
        "ploys_posted": 12,
        "ploys_posted_completed": 7,
        "engagements_count": 0,
        "user_type": "meployer",
        "lat": null,
        "long": null,
        "hours_discount": 5,
        "legal_form": "company",
        "cpr_number": "99879",
        "user_projects": [{
            "id": 98,
            "user": 469,
            "project_image": "https://meployprod.s3.amazonaws.com/user-projects/2017/02/af5c2117-fe9_YKc3x8c.jpg",
            "project_caption": null,
            "project_image_url": "https://meployprod.s3.amazonaws.com/cache/95/49/954958a69621d3cb5c899252247a1789.jpg"
        }, {
            "id": 99,
            "user": 469,
            "project_image": "https://meployprod.s3.amazonaws.com/user-projects/2017/02/94cb50a6-0a1_qRLZYYb.jpg",
            "project_caption": "dgdsggdf",
            "project_image_url": "https://meployprod.s3.amazonaws.com/cache/dc/9c/dc9cd8cfbbf5595995b656f6300f409d.jpg"
        }],
        "category": [{
            "id": 3,
            "name": "Moving",
            "name_en": "Moving",
            "name_da": "Flyttehjælp",
            "slug": "moving",
            "icon": "https://meployprod.s3.amazonaws.com/category-icons/2016/05/moving.png"
        }, {
            "id": 6,
            "name": "Barista",
            "name_en": "Barista",
            "name_da": "Barista",
            "slug": "barista",
            "icon": "https://meployprod.s3.amazonaws.com/category-icons/2016/06/Barista.svg"
        }, {
            "id": 8,
            "name": "DJ",
            "name_en": "DJ",
            "name_da": "DJ",
            "slug": "dj",
            "icon": "https://meployprod.s3.amazonaws.com/category-icons/2016/06/DJ.svg"
        }]
    };

    // Scope for user-calendar needs
    $scope.currentMonth = moment();
    $scope.currentMonth_plus_1 = moment().add(1, 'MONTH');
    $scope.currentMonth_plus_2 = moment().add(2, 'MONTH');
    $scope.calendarMonth = $scope.currentMonth;
    $scope.daysAllowed=[];
    $scope.selectedDates = [];
    $scope.maxSelectedDates = 7;
    $scope.ploysTogether = [];
    $scope.getMonthName = function (month)
    {
        return _.capitalize(month.format('MMMM'));
    };


    $scope.openAlertModal = function () {
        Modal.alert({
            title: 'Alert modal',
            message: 'This is alert modal with one button. Open modal.js service to see the documentation'
        })
    };

    $scope.openConfirmModal = function () {
        Modal.confirm({
            title: 'Confirm modal',
            message: 'Confirm modal with two buttons. Open modal.js service to see the documentation',
            firstButtonLabel : 'Close',
            secondButtonLabel: 'Go!',
            secondButtonColor: 'green'
        })
    };

    $scope.openCustomModal = function () {
        $uibModal.open({
            templateUrl: 'src/modals/html/modals/defined/modal-custom.html',
            windowClass: 'modal-vertical-centered'
        })
    };

    $scope.openBaseSalaryRuleModal = function () {
        $uibModal.open({
            templateUrl: 'src/modals/html/modals/defined/modal-salary-rule.html',
            windowClass: 'modal-vertical-centered'
        })
    };

    $scope.alertSuccess = function () {
        AlertBanner.publish({
            type: 'success',
            message: 'Alert success! Data saved',
            timeCollapse: 4000
        });
    };

    $scope.alertError = function () {
        AlertBanner.publish({
            type: 'error',
            message: 'ERROR. Something went wrong',
            timeCollapse: 4000
        });
    };

    $scope.alertInfo = function () {
        AlertBanner.publish({
            type: 'info',
            message: 'INFO alert. ',
            timeCollapse: 4000
        });
    };

    $scope.dragndropList = {
         selected: null,
        targetNameFiltering: '',
        listResultsLimit: 10,
         lists: {"source": [
             {name: "John Smith"},
             {name: "Dan Berry"},
             {name: "Connor Baker"},
             {name: "Brandon Ball"},
             {name: "Eric Bond"},
             {name: "Gavin Burgess"},
             {name: "Gordon Buckland"},
             {name: "Jason Greene"},
             {name: "Joseph Henderson"},
             {name: "Paul Graham"},
             {name: "Sebastian Burgess"},
             {name: "Victor Burgess"},
             ], "target": []},
        expandListResults: () => {$scope.dragndropList.listResultsLimit = undefined;}
     };

    $scope.colorPickerOptions = {
        size: 50,
        roundCorners: true,
        total: 6,
        customColors: [
            '#C41A20',
            '#3C6BD0',
            '#28B224',
            '#EB9A2E',
            '#30c7cb',
            '#f8f8f8',
        ]
    };

    $scope.startDay = moment();
    $scope.endDay = moment().add(5, 'days')

    $scope.tags = [
        {
            'id': 123,
            'name': 'simple',
        },
        {
            'id': 124,
            'name': 'CAPITAL TAG',
        },
        {
            'id': 125,
            'name': 'test',
        },
        {
            'id': 126,
            'name': 'Testing Word',
        },
    ];

    $scope.ploy = {
        address: "Ved Norgesporten 2100, 2100 København, Denmark",
        amount_employee: 491.1667,
        amount_employer: 663.075045,
        area: "København Ø",
        category: {id: 3, name: "Empty container", name_en: "Empty container", name_da: "Containertømning"},
        country: null,
        created: "2019-04-30T11:39:36.306989+02:00",
        created_by: {id: 1, first_name: "Maciej", last_name: "Kostuch"},
        description: "super opis",
        end_day: "2019-06-26T00:00:00+02:00",
        hours: 3.5,
        id: 508,
        is_live_ploy: false,
        is_private: true,
        lat: 55.6777,
        locality: null,
        lon: 12.5709,
        one_day_job: false,
        paid_pause_time: true,
        postal_code: "2100",
        price_employee: 140.3333,
        price_hour: null,
        region: "Københavns Kommune, Frederiksberg og omegn",
        route: "Ved Norgesporten",
        start_day: "2019-06-24T00:00:00+02:00",
        start_time: "2019-04-30T11:39:00+02:00",
        status: "PUBLISHED",
        street_number: "2100",
        weekdays: 7,
        when: "2019-06-24T09:39:00Z",
        work_requirement: [
            {id: 145, ploy: 508, ploy_template: null, name: "I confirm I will take safety shoes"},
            {id: 146, ploy: 508, ploy_template: null, name: "I confirm I will be sober"},
        ],
        working_days_number: 3
    }

        $scope.engagementShiftsTableData =  [
                {
                    ploy: {
                        id: 91,
                        category: {
                            id: 4,
                            name: 'Assistance',
                            name_en: 'Assistance',
                            name_da: 'Anden assistance',
                            slug: 'assistance',
                            icon: 'https://meploytmp.s3.amazonaws.com/category-icons/2019/08/assistance.png',
                            order: null,
                            based_on_verification: false
                        },
                        created: '2019-10-08T17:11:31.147601+02:00',
                        created_by: {
                            id: 28,
                            first_name: 'Hans',
                            last_name: 'Blauf',
                            avatar_url: 'https://meploytmp.s3.amazonaws.com/cache/29/11/291108f6333b78ecaaec2856ff3a6267.jpg',
                            country: 'DK',
                            company: {
                                id: 13,
                                name: 'Storck',
                                logo: 'https://meploytmp.s3.amazonaws.com/company_logos/2019/10/csm_teaser-storck-we-create-joy_80c08742c1_Li6FrYu.png',
                                color: '#ff9800',
                                about: 'adddd',
                                website: null,
                                logo_url: 'https://meploytmp.s3.amazonaws.com/cache/35/95/3595e2d425e85fc04689c180e5fdeca2.jpg',
                                date_joined: '2019-09-09T11:15:22Z',
                                ploys_posted: 4,
                                community_fee: 0,
                                full_name: 'Storck GmBH',
                                enterprise: null,
                                paid_pause_time: false,
                                company_stats: null,
                                collective_agreement: true,
                                onboarding_completed: true,
                                staffing_permission: true,
                                address_annotation: 'second floor of the building'
                            },
                            date_joined: '2019-09-09T13:15:22+02:00',
                            full_name: 'Hans Blauf',
                            legal_form: 'company',
                            profile: {
                                verified: null
                            },
                            professional_title: 'CFO'
                        },
                        start_day: '2019-10-08T00:00:00+02:00',
                        end_day: '2019-10-08T00:00:00+02:00',
                        start_time: '2019-10-08T17:11:00+02:00',
                        hours: 8,
                        is_live_ploy: false,
                        description: 'test22222333',
                        address: 'Asnæs Centret, 4550 Asnæs, Denmark',
                        amount_employer: 1296,
                        amount_employee: 960,
                        price_employee: 120,
                        one_day_job: true,
                        work_requirement: [],
                        working_days_number: 1,
                        should_work_time: '28800.0',
                        is_company_trusted: false,
                        company_id: 13,
                        is_ploy_by_worker: false
                    },
                    employee: {
                        id: 30,
                        first_name: 'Henry',
                        last_name: 'Magick',
                        avatar_url: 'https://meploytmp.s3.amazonaws.com/cache/93/3c/933c30c6886601c9a662897125edab52.jpg',
                        country: 'DK',
                        company: null,
                        date_joined: '2019-10-01T17:03:45+02:00',
                        full_name: 'Henry Magick',
                        legal_form: 'private',
                        profile: {
                            verified: null
                        },
                        professional_title: null
                    },
                    engShifts: [
                        {
                            id: 378,
                            ploy: {
                                id: 91,
                                category: {
                                    id: 4,
                                    name: 'Assistance',
                                    name_en: 'Assistance',
                                    name_da: 'Anden assistance',
                                    slug: 'assistance',
                                    icon: 'https://meploytmp.s3.amazonaws.com/category-icons/2019/08/assistance.png',
                                    order: null,
                                    based_on_verification: false
                                },
                                created: '2019-10-08T15:11:31.147Z',
                                created_by: {
                                    id: 28,
                                    first_name: 'Hans',
                                    last_name: 'Blauf',
                                    avatar_url: 'https://meploytmp.s3.amazonaws.com/cache/29/11/291108f….jpg',
                                    country: 'DK',
                                    company: {
                                        id: 13,
                                        name: 'Storck',
                                        logo: 'https://meploytmp.s3.amazonaws.com/company_logos/2019/10/csm_teaser-storck-we-create-joy_80c08742c1_Li6FrYu.png',
                                        color: '#ff9800',
                                        about: 'adddd',
                                        website: null,
                                        logo_url: 'https://meploytmp.s3.amazonaws.com/cache/35/95/3595e2d….jpg',
                                        date_joined: '2019-09-09T11:15:22.000Z',
                                        ploys_posted: 4,
                                        community_fee: 0,
                                        full_name: 'Storck GmBH',
                                        enterprise: null,
                                        paid_pause_time: false,
                                        company_stats: null,
                                        collective_agreement: true,
                                        onboarding_completed: true,
                                        staffing_permission: true,
                                        address_annotation: 'second floor of the building'
                                    },
                                    date_joined: '2019-09-09T11:15:22.000Z',
                                    full_name: 'Hans Blauf',
                                    legal_form: 'company',
                                    profile: {
                                        verified: null
                                    },
                                    professional_title: 'CFO'
                                },
                                start_day: '2019-10-07T22:00:00.000Z',
                                end_day: '2019-10-07T22:00:00.000Z',
                                start_time: '2019-10-08T15:11:00.000Z',
                                hours: 8,
                                is_live_ploy: false,
                                description: 'test22222333',
                                address: 'Asnæs Centret, 4550 Asnæs, Denmark',
                                amount_employer: 1296,
                                amount_employee: 960,
                                price_employee: 120,
                                one_day_job: true,
                                work_requirement: [],
                                working_days_number: 1,
                                should_work_time: '28800.0',
                                is_company_trusted: false,
                                company_id: 13,
                                is_ploy_by_worker: false
                            },
                            review_exists: false,
                            review_overall: null,
                            employee: {
                                id: 30,
                                first_name: 'Henry',
                                last_name: 'Magick',
                                avatar_url: 'https://meploytmp.s3.amazonaws.com/cache/93/3c/933c30c….jpg',
                                country: 'DK',
                                company: null,
                                date_joined: '2019-10-01T15:03:45.000Z',
                                full_name: 'Henry Magick',
                                legal_form: 'private',
                                profile: {
                                    verified: null
                                },
                                professional_title: null
                            },
                            created: '2019-10-08T15:15:28.128Z',
                            state: 'ENGAGEMENT_COMPLETED',
                            pause_time: '00:00:00',
                            checkin_time: '2019-10-08T15:30:00.000Z',
                            checkout_time: '2019-10-08T23:30:00.000Z',
                            approved: false,
                            checkin_time_different: true,
                            overtime_work: false,
                            checked_in: true,
                            checked_out_worklog: null,
                            checkin_different: {
                                id: 2,
                                engagement: 378,
                                checkin_time: '2019-10-08T15:30:00.000Z',
                                checkout_time: null,
                                pause_time: null,
                                created: '2019-10-08T15:26:14.937Z',
                                comment: null,
                                requested_by: 'ada',
                                log_type: 'check-in-modified'
                            },
                            work_time: 28800000
                        },
                        {
                            id: 378,
                            ploy: {
                                id: 91,
                                category: {
                                    id: 4,
                                    name: 'Assistance',
                                    name_en: 'Assistance',
                                    name_da: 'Anden assistance',
                                    slug: 'assistance',
                                    icon: 'https://meploytmp.s3.amazonaws.com/category-icons/2019/08/assistance.png',
                                    order: null,
                                    based_on_verification: false
                                },
                                created: '2019-10-08T15:11:31.147Z',
                                created_by: {
                                    id: 28,
                                    first_name: 'Hans',
                                    last_name: 'Blauf',
                                    avatar_url: 'https://meploytmp.s3.amazonaws.com/cache/29/11/291108f….jpg',
                                    country: 'DK',
                                    company: {
                                        id: 13,
                                        name: 'Storck',
                                        logo: 'https://meploytmp.s3.amazonaws.com/company_logos/2019/10/csm_teaser-storck-we-create-joy_80c08742c1_Li6FrYu.png',
                                        color: '#ff9800',
                                        about: 'adddd',
                                        website: null,
                                        logo_url: 'https://meploytmp.s3.amazonaws.com/cache/35/95/3595e2d….jpg',
                                        date_joined: '2019-09-09T11:15:22.000Z',
                                        ploys_posted: 4,
                                        community_fee: 0,
                                        full_name: 'Storck GmBH',
                                        enterprise: null,
                                        paid_pause_time: false,
                                        company_stats: null,
                                        collective_agreement: true,
                                        onboarding_completed: true,
                                        staffing_permission: true,
                                        address_annotation: 'second floor of the building'
                                    },
                                    date_joined: '2019-09-09T11:15:22.000Z',
                                    full_name: 'Hans Blauf',
                                    legal_form: 'company',
                                    profile: {
                                        verified: null
                                    },
                                    professional_title: 'CFO'
                                },
                                start_day: '2019-10-07T22:00:00.000Z',
                                end_day: '2019-10-07T22:00:00.000Z',
                                start_time: '2019-10-08T15:11:00.000Z',
                                hours: 8,
                                is_live_ploy: false,
                                description: 'test22222333',
                                address: 'Asnæs Centret, 4550 Asnæs, Denmark',
                                amount_employer: 1296,
                                amount_employee: 960,
                                price_employee: 120,
                                one_day_job: true,
                                work_requirement: [],
                                working_days_number: 1,
                                should_work_time: '28800.0',
                                is_company_trusted: false,
                                company_id: 13,
                                is_ploy_by_worker: false
                            },
                            review_exists: false,
                            review_overall: null,
                            employee: {
                                id: 30,
                                first_name: 'Henry',
                                last_name: 'Magick',
                                avatar_url: 'https://meploytmp.s3.amazonaws.com/cache/93/3c/933c30c….jpg',
                                country: 'DK',
                                company: null,
                                date_joined: '2019-10-01T15:03:45.000Z',
                                full_name: 'Henry Magick',
                                legal_form: 'private',
                                profile: {
                                    verified: null
                                },
                                professional_title: null
                            },
                            created: '2019-10-08T15:15:28.128Z',
                            state: 'ENGAGEMENT_COMPLETED',
                            pause_time: '00:00:00',
                            checkin_time: '2019-10-08T15:30:00.000Z',
                            checkout_time: '2019-10-08T23:30:00.000Z',
                            approved: false,
                            checkin_time_different: true,
                            overtime_work: false,
                            checked_in: true,
                            checked_out_worklog: null,
                            checkin_different: {
                                id: 2,
                                engagement: 378,
                                checkin_time: '2019-10-08T15:30:00.000Z',
                                checkout_time: null,
                                pause_time: null,
                                created: '2019-10-08T15:26:14.937Z',
                                comment: null,
                                requested_by: 'ada',
                                log_type: 'check-in-modified'
                            },
                            work_time: 28800000
                        }
                    ]
                },
                {
                    ploy: {
                        id: 107,
                        category: {
                            id: 3,
                            name: 'Moving & lifting',
                            name_en: 'Moving & lifting',
                            name_da: 'Flyttehjælp og løft',
                            slug: 'moving-lifting',
                            icon: 'https://meploytmp.s3.amazonaws.com/category-icons/2019/08/moving.png',
                            order: null,
                            based_on_verification: false
                        },
                        created: '2019-10-25T11:48:51.487303+02:00',
                        created_by: {
                            id: 28,
                            first_name: 'Hans',
                            last_name: 'Blauf',
                            avatar_url: 'https://meploytmp.s3.amazonaws.com/cache/29/11/291108f6333b78ecaaec2856ff3a6267.jpg',
                            country: 'DK',
                            company: {
                                id: 13,
                                name: 'Storck',
                                logo: 'https://meploytmp.s3.amazonaws.com/company_logos/2019/10/csm_teaser-storck-we-create-joy_80c08742c1_Li6FrYu.png',
                                color: '#ff9800',
                                about: 'adddd',
                                website: null,
                                logo_url: 'https://meploytmp.s3.amazonaws.com/cache/35/95/3595e2d425e85fc04689c180e5fdeca2.jpg',
                                date_joined: '2019-09-09T11:15:22Z',
                                ploys_posted: 4,
                                community_fee: 0,
                                full_name: 'Storck GmBH',
                                enterprise: null,
                                paid_pause_time: false,
                                company_stats: null,
                                collective_agreement: true,
                                onboarding_completed: true,
                                staffing_permission: true,
                                address_annotation: 'second floor of the building'
                            },
                            date_joined: '2019-09-09T13:15:22+02:00',
                            full_name: 'Hans Blauf',
                            legal_form: 'company',
                            profile: {
                                verified: null
                            },
                            professional_title: 'CFO'
                        },
                        start_day: '2019-10-25T00:00:00+02:00',
                        end_day: '2019-10-25T00:00:00+02:00',
                        start_time: '2019-10-25T11:20:00+02:00',
                        hours: 3,
                        is_live_ploy: false,
                        description: 'aa',
                        address: 'Frederiksberg Allé, 1820 Frederiksberg, Denmark',
                        amount_employer: 486,
                        amount_employee: 360,
                        price_employee: 120,
                        one_day_job: true,
                        work_requirement: [],
                        working_days_number: 1,
                        should_work_time: '10800.0',
                        is_company_trusted: false,
                        company_id: 13,
                        is_ploy_by_worker: false
                    },
                    employee: {
                        id: 29,
                        first_name: 'Steven',
                        last_name: 'McQuerty',
                        avatar_url: 'https://meploytmp.s3.amazonaws.com/cache/95/dd/95dd5103d44f6e72cbbb93f00e9dff00.jpg',
                        country: 'DK',
                        company: null,
                        date_joined: '2019-09-23T11:15:19+02:00',
                        full_name: 'Steven McQuerty',
                        legal_form: 'private',
                        profile: {
                            verified: null
                        },
                        professional_title: null
                    }
                },
            ];
            $scope.isListItemCollapsed = ployShift => false;

}]);

angular.module('ui-kit')
.controller('UiKitCarouselController',  ['$scope', function($scope) {
    $scope.myInterval = 3000;
    $scope.noWrapSlides = false;
    $scope.active = 0;
    $scope.slides = [];
    let proj_id = 0

    for (let i = 0; i < 10; i++) {
        console.log('loop')
        $scope.slides.push({
            image: 'https://unsplash.it/500/300',
            text: 'test caption',
            id: proj_id++
        });
    }
}]);


angular.module('user-menu')

.controller('CompanySwitcherController', ['$scope', 'User', '$location',
    function ($scope, User, $location) {

        if (User.isAuthenticated()) {
            User.get().$promise.then(user => {
                $scope.currUser = user;
            });
        }

        $scope.redirectToCompanySettings = hasAnyCompanies => {
            hasAnyCompanies ? $location.path('/my-company') : null
        };

        $scope.switchCompany = companyId => {
            User.switchCompany(companyId);
        };

    }]);

angular.module('user-menu')

    .controller('UserMenuController', ['$scope', 'Auth', 'Ploy', '$cookies', 'Constants', '$window', 'LanguageService', 'IpipService',
        function ($scope, Auth, Ploy, $cookies, Constants, $window, LanguageService, IpipService) {
            let ipipResultExists = false;
            let ipipChoicesExists = false;
            $scope.logout = Auth.logout;
            $scope.languages = Constants.languages;
            $scope.setLanguage = LanguageService.setLanguage;
            $scope.userTypes = Constants.userTypes;
            $scope.form = {};
            $scope.form.language = $cookies.language || $scope.languages[0].value;
            $scope.getFormattedDate = date => moment(date).format("DD/MM/YYYY HH:mm");

            IpipService.hasResult().then(hasResult => {
                ipipResultExists = hasResult;
                IpipService.hasChoices().then(hasChoices => {
                    ipipChoicesExists = hasChoices;
                })
            })

            $scope.getIpipLink = () => {
                if (ipipResultExists) {
                    return '/ipip/result'
                }
                if (ipipChoicesExists) {
                    return '/ipip/test'
                }
                return '/ipip'
            }
        }]);

angular.module('user-menu')

.directive('companySwitcher', function() {
  return {
    templateUrl: 'src/user-menu/html/company-switcher.html',
    restrict: 'E',
    transclude: true
  };

});

angular.module('user-menu')

    .directive('userMenu', function () {
        return {
            templateUrl: 'src/user-menu/html/user-menu.html',
            restrict: 'E',
            transclude: true,
            controller: function ($scope) {
                $scope.getAvatarTooltip = (user) => {
                    if (user && user.profile) {
                        return user.profile.pause ? 'HEADER_LOGGED_IN__PAUSE_DURATION_LABEL' : '';
                    }
                }
            },
        };

    });

angular.module('user')

.controller('SuspendedBarController', ['$scope',
    function($scope) {

    $scope.isCollapsed = true;

    $scope.switchCollapse = () => {
        $scope.isCollapsed = !$scope.isCollapsed;
    };

    $scope.suspensionReasons = [
        {
            'name': 'SUSPENSION_REASON__ABSENCE',
            'value': 'absence',
        },
        {
            'name': 'SUSPENSION_REASON__BREAKING_COMMUNITY_RULES',
            'value': 'breaking-community-rules',
        },
        {
            'name': 'SUSPENSION_REASON__FALSE_CHECKIN_CHECKOUT_TIME',
            'value': 'false-checkin-checkout-time',
        }
    ];

    $scope.displaySuspensionReason = value => {
        return $scope.suspensionReasons.find(reasonObj => {
            return reasonObj.value === value;
        }).name
    };


}]);

angular.module('user')
    .directive('categoryPicker', function () {
        return {
            scope: {
                ngModel: '=',
            },
            restrict: 'AE',
            templateUrl: '/src/user/directives/html/category-picker.directive.html',
            controller: ["$scope", "Category", "$element", function ($scope, Category, $element) {
                Category.getAll().$promise.then(categories => {
                    $scope.allCategories = categories;
                    $scope.allCategories = $scope.allCategories.map(c => {
                        if ($scope.ngModel.some(cat => cat.id === c.id)) {
                            c.selected = true;
                        }
                    })
                    $scope.allCategoriesByGroup = _.groupBy(categories, 'category_group.id');
                });

                $scope.changeCategoryStatus = (category) => {
                    if ($scope.ngModel.some(e => e.id === category.id)) {
                        $scope.ngModel = $scope.ngModel.filter(e => e.id !== category.id);
                    } else {
                        $scope.ngModel.push(category);
                    }
                };

                $scope.blinkCategories = () => {
                    return !$scope.ngModel.some(c => c.id)
                }

            }],
        };
    });

angular.module('user')
    .directive('myCalendar', function() {
        return {
            restrict: 'AE',
            templateUrl: '/src/user/directives/html/my-calendar.html',
            controller: 'MyCalendarController'
        };
    });

angular.module('user')

    .factory('CompanyDocumentResource', ['$resource', function ($resource) {
        return $resource('/api/company-document/:id/', {id: '@id'}, {
            get: {
                method: 'GET',
                isArray: true
            },
            updateDocument: {
                method: 'PATCH',
                url: '/api/company-document/update_document/',
            },
            removeDocument: {
                method: 'DELETE',
            },
            getActiveDocuments: {
                url: '/api/company-document/active_documents/',
                isArray: true
            },
            getUnacceptedDocuments: {
                url: '/api/company-document/unaccepted_documents/',
                isArray: true
            },
            createAcceptations: {
                method: 'POST',
                url: '/api/company-document/create_acceptations/',
            },
            queryDocumentsAcceptations: {
                method: 'GET',
                url: '/api/company-document/list_acceptations/',
                // isArray: true
            },
        });
    }]);

angular.module('user')

.factory('CompanyResource', ['$resource', function($resource) {
  return  $resource('/api/company/:id/', {id:'@id'},{
          update: { method:'PATCH'},
          getMembers: {
            method: 'POST',
            url: '/api/company/list_members/',
            isArray: true
          },
          get: {
            method: 'GET',
            url: '/api/company/my_company/',
            isArray: false
          },
          hasInvoiceSettings: {
            method: 'GET',
            url: '/api/company/has_invoice_settings/',
            isArray: false
          },
          getProfile: {
            method: 'GET',
            url: '/api/company/company_profile/',
            isArray: false
          },
          getDocuments: {
            method: 'GET',
            url: '/api/company-document/get_documents/',
            isArray: true
          },
          updateDocument: {
            method: 'PATCH',
            url: '/api/company-document/update_document/',
          },
          removeDocument: {
            method: 'DELETE',
            url: '/api/company-document/',
          },
          updateMyCompany: {
            method: 'PATCH',
            url: '/api/company/update_my_company/',
          },
          getOpenPloys: {
            method: 'GET',
            url: '/api/company/open_ploys/',
            isArray: true
          },
          setOnboardingAsCompleted  : {
            method: 'POST',
            url: '/api/company/set_onboarding_completed/',
          },
          getCompanyMembersAutocomplete: {
            method: 'GET',
            url: '/api/company/get_company_members_autocomplete/',
            isArray: true,
          },
          isUsingDashboard: {
            method: 'GET',
            url: '/api/company/is_using_dashboard/',
          },
      });
  }]);

angular.module('user')

.factory('PensionCompanyResource', ['$resource', function($resource) {
  return  $resource('/api/pension-company/:id/', {id:'@id'}, {});
}]);

angular.module('user')

    .factory('PensionResource', ['$resource', function ($resource) {
        return $resource('/api/pension/:id/', {id: '@id'}, {
            update: { method:'PATCH'},
            getMyPension: {
                method: 'GET',
                url: '/api/pension/get_my_pension/'
            },
        });
    }]);

angular.module('user')

    .factory('UserResource', ['$resource', function ($resource) {
        return $resource('/api/user/:id/', {id: '@id'}, {
            update: {method: 'PATCH'},
            changePassword: {
                method: 'POST',
                url: '/api/password/change/'
            },
            getCurrent: {
                method: 'GET',
                url: '/api/user/current/'
            },
            verifyEmail: {
                method: 'POST',
                url: '/api/user/verify_email/'
            },
            sendVerificationEmail: {
                method: 'POST',
                url: '/api/user/send_verification_email/'
            },
            verifyPhone: {
                method: 'POST',
                url: '/api/user/verify_phone/'
            },
            changeAccountSettings: {
                method: 'PATCH',
                url: '/api/account-settings/:id/'
            },
            confirmEmail: {
                method: 'POST',
                url: '/api/user/confirm_email/'
            },
            sendResetLink: {
                method: 'POST',
                url: '/api/user/send_reset_link/'
            },
            resendSmsCode: {
                method: 'POST',
                url: '/api/user/resend_phone_code/'
            },
            generateNewPassword: {
                method: 'POST',
                url: '/api/user/generate_new_password/'
            },
            downloadActivity: {
                method: 'POST',
                url: '/api/user/download_activity/'
            },
            downloadShifts: {
                method: 'POST',
                url: '/api/user/download_shifts/'
            },
            getActivity: {
                method: 'POST',
                url: '/api/user/get_activity/'
            },
            getActivityPart: {
                method: 'POST',
                url: '/api/user/get_activity_part/'
            },
            setLanguage: {
                method: 'POST',
                url: '/api/user/set_language/'
            },
            profileCompletePercentage: {
                method: 'GET',
                url: '/api/user/profile_complete_percentage/'
            },
            updateOriginCountry: {
                method: 'POST',
                url: '/api/user/update_origin_country/'
            },
            getProfile: {
                method: 'GET',
                url: '/api/user/:id/profile/'
            },
            getInvitationSender: {
                method: 'GET',
                url: '/api/user/:id/invitation_sender/'
            },
            hasAnyStaff: {
                method: 'GET',
                url: '/api/user/has_any_staff/'
            },
            hasAnyStaffGroups: {
                method: 'GET',
                url: '/api/user/has_any_staff_groups/'
            },
            hasAnyPloyTemplates: {
                method: 'GET',
                url: '/api/user/has_any_ploy_templates/'
            },
            hasEmailVerified: {
                method: 'GET',
                url: '/api/user/has_email_verified/'
            },
            getTargetData: {
                method: 'GET',
                url: '/api/user/:id/target_data/'
            },
            getTypeformData: {
                method: 'GET',
                url: '/api/user/typeform_data/'
            },
            getJoinedNumber: {
                method: 'GET',
                url: '/api/user/joined/'
            },
            getHolidayPercent: {
                url: '/api/country/get_holiday_percent/',
                method: 'GET',
            },
            getFeeHour: {
                url: '/api/country/get_fee_hour/',
                method: 'GET',
            },
            hasLoggedInLast90Days: {
                url: '/api/user/has_logged_in_last_90_days/',
                method: 'GET',
            },
            switchCompany: {
                url: '/api/user/choose_company/',
                method: 'PATCH',
            },
            isCprNumberUnique: {
                url: '/api/user/is_cpr_number_unique/',
                method: 'POST',
            },
            getDocumentsForEmployers: {
                url: '/api/user/:id/get_documents_for_employers/',
                method: 'GET',
            },
            createUserInvitation: {
                url: '/api/user-invitation/',
                method: 'POST',
            },
            createUserInvitationByUrl: {
                url: '/api/user-invitation/invite_by_url/',
                method: 'POST',
            },
            validateContactData: {
                url: '/api/user/validate_contact_data/',
                method: 'POST',
            },
            getCurrentProProfile: {
                url: '/api/user/current_pro_profile/',
                method: 'GET',
            },
            getProfileProgress: {
                url: '/api/user/profile_progress/',
                method: 'GET',
            },
            getCvProgress: {
                url: '/api/user/cv_progress/',
                method: 'GET',
            },
            getSignature: {
                url: '/api/user/:id/signature/',
                method: 'GET',
            },
            getCvPdf: {
                url: '/api/cv-pdf/',
                method: 'GET',
            },
        });
    }]);

angular.module('user')

    .factory('Auth', ['$auth', '$window', 'User', 'PloyFormStorage', '$routeParams', 'LanguageService',
        '$location', 'AlertBanner', '$filter', 'Modal', 'SignUpMeployeeService', '$analytics', 'Constants', '$cookies',
        function ($auth, $window, User, PloyFormStorage, $routeParams, LanguageService,
                  $location, AlertBanner, $filter, Modal, SignUpMeployeeService, $analytics, Constants, $cookies) {
            var auth = {};

            auth.redirectPath = '';
            let userTypes = Constants.userTypes;

            let checkIfInvitedBy = () => {
                if ($cookies.get('invited_by')) {
                    const IdOfUserWhoInvited = Number($cookies.get('invited_by'));
                    User.createUserInvitationByUrl({'created_by': IdOfUserWhoInvited});
                }
            };

            auth.login = function (form, first_login) {
                return $auth.login(form).then(function (response) {
                    if (response.data.user.user_type === Constants.userTypes.MEPLOYER && response.data.user.client_version !== 1) {
                        window.location = DEBUG ? Constants.dashboardEnvUrls.DEV : Constants.dashboardEnvUrls.PROD;
                    }
                    User.set(response.data.user).then(() => {
                        if (first_login) {
                            checkIfInvitedBy();
                            return $location.path('/');
                        }
                        if (!PloyFormStorage.hasPloyForm()) {
                            if (response.data.user.user_type == 'meployee' && response.data.user.email_verify == false) {
                                return $location.path('/');
                            }
                            $location.path(auth.getStartUrl());
                        }
                        User.hasLoggedInLast90Days().$promise.then(response => {
                            if (User.get().user_type === Constants.userTypes.MEPLOYER) return;
                            let profileCompletionAlert = () => Modal.alert({
                                title: $filter('translate')('LOGIN_AFTER_90_DAYS_ALERT__TITLE'),
                                message: $filter('translate')('LOGIN_AFTER_90_DAYS_ALERT__MESSAGE'),
                                buttonColor: 'green',
                            });
                            return response.has_logged_in ? null : profileCompletionAlert();
                        });
                    });
                })
            };

            auth.oauthLogin = function (provider, extra) {
                extra = extra || {};
                extra.language = LanguageService.getCurrentLanguage();
                $auth.authenticate(provider, extra).then(
                    function (response) {
                        if ($routeParams.token) {  // save used code if exists in url
                            response.data.email = response.data.name;
                        }
                        if (!PloyFormStorage.hasPloyForm()) {
                            $location.path(auth.getStartUrl());
                        }

                    }, function (error) {
                        if (error.data == 'Already connected to another account') {
                            return Modal.alert({
                                title: $filter('translate')('OAUTH__ACCOUNT_ALREADY_CONNECTED_ERROR__TITLE'),
                                message: $filter('translate')('OAUTH__ACCOUNT_ALREADY_CONNECTED_ERROR__CONTENT')
                            })
                        }
                        if (error.data == 'SIGNUP_NO_EMAIL_GIVEN') {
                            return Modal.alert({
                                title: $filter('translate')('OAUTH__SIGNUP_NO_EMAIL_GIVEN__TITLE'),
                                message: $filter('translate')('OAUTH__SIGNUP_NO_EMAIL_GIVEN__CONTENT')
                            })
                        }
                        Modal.alert({
                            title: $filter('translate')('OAUTH__ERROR__TITLE'),
                            message: $filter('translate')('OAUTH__ERROR__CONTENT')
                        })
                    }
                )
            };

            auth.signup = function (form, form_name) {
                form.language = LanguageService.getCurrentLanguage();
                form.birthday = moment(form.birthday).format("YYYY-MM-DD");
                $auth.signup(form).then(function (response) {
                    auth.login({
                        'email': response.data.user.email,
                        'password': form.password,
                        'nationality': form.nationality,
                        'origin_country': form.origin_country
                    }, true).then(() => {

                        if (response.data.user.user_type != userTypes.MEPLOYEE) {
                            var _hsq = window._hsq = window._hsq || [];
                            _hsq.push(["identify", {
                                email: response.data.user.email,
                                firstName: response.data.user.first_name,
                                lastName: response.data.user.last_name,
                                phone: response.data.user.phone
                            }]);
                            _hsq.push(['trackPageView']);
                        }
                        $analytics.eventTrack('Reg' + response.data.user.user_type + 'form submited', {category: 'Registration'});
                    });
                }, function (error) {
                    if (error.data.email) {
                        Modal.confirm({
                            title: 'Ups...',
                            message: $filter('translate')('THIS_EMAIL_IS_ALREADY_REGISTERED'),
                            firstButtonLabel: $filter('translate')('NO_THANKS'),
                            secondButtonLabel: 'OK',
                            secondButtonColor: 'green',
                            firstButtonFunction: function () {
                            },
                            secondButtonFunction: function () {
                                $location.path('/log-in').search({email: form.email})
                            }
                        });
                    } else {
                        let errorMessage = (error.data[0]) ? error.data[0] : 'SOMETHING_WENT_WRONG_PLEASE_CONTACT_WITH_SUPPORT';
                        AlertBanner.publish({
                            type: 'error',
                            message: $filter('translate')(errorMessage),
                            timeCollapse: 4000
                        });
                    }
                })
            };

            auth.isAuthenticated = function () {
                return $auth.isAuthenticated()
            };

            let getRedirectLocation = () => {
                if ($window.location.origin === 'https://cloud.meploy.me') {
                    return 'https://meploy.me';
                }
                return '/log-in';
            };

            auth.logout = function () {
                $auth.removeToken();
                if (window.HubSpotConversations) {
                    window.HubSpotConversations.widget.close();
                }
                Raven.setUserContext({});
                $window.location.href = getRedirectLocation();
            };

            auth.setRedirect = function (url) {
                if (auth.isAuthenticated()) {
                    $location.path(url);
                } else {
                    auth.redirectPath = url;
                    $location.path('/log-in');
                }
            };

            auth.getStartUrl = function () {
                let tmp_path = auth.redirectPath;
                auth.redirectPath = undefined;
                return tmp_path || '/'
            };

            return auth
        }]);

angular.module('user')
.factory('CompanyDocument', ['CompanyDocumentResource', function (CompanyDocumentResource) {

    let CompanyDocumentService = {};

    let cachedMyCompanyDocuments = {};

    let addFilenameToDocument = document => {
        return document.file.replace(/^.*[\\\/]/, ''); // add filename to document obj
    };

    CompanyDocumentService.loadMyCompanyDocuments = () => {
        CompanyDocumentResource.get().$promise.then(documents => {
            cachedMyCompanyDocuments = documents.map(document => {
                document.filename = addFilenameToDocument(document);
                return document;
            });
        });
    };
    CompanyDocumentService.loadMyCompanyDocuments();

    CompanyDocumentService.loadActiveDocuments = companyId => {
        return Promise.resolve(CompanyDocumentResource.getActiveDocuments({'company_id': companyId}).$promise.then(documents => {
            return documents.map(document => {
                document.filename = addFilenameToDocument(document);
                return document;
            });
        }));
    };

    CompanyDocumentService.loadUnacceptedDocuments = companyId => {
        return Promise.resolve(CompanyDocumentResource.getUnacceptedDocuments({'company_id': companyId}).$promise.then(documents => {
            return documents.map(document => {
                document.filename = addFilenameToDocument(document);
                return document;
            });
        }));
    };

    CompanyDocumentService.createAcceptationsForMissingDocuments = company => {
        return CompanyDocumentResource.createAcceptations({'company_id': company});
    };

    CompanyDocumentService.queryDocumentsAcceptations = CompanyDocumentResource.queryDocumentsAcceptations;

    CompanyDocumentService.updateCompanyDocument = document => {
        return CompanyDocumentResource.updateDocument(document);
    };

    CompanyDocumentService.archiveCompanyDocument = document => {
        document.archived = true;
        return CompanyDocumentResource.updateDocument(document);
    };

    CompanyDocumentService.removeCompanyDocument = documentId => {
        return CompanyDocumentResource.removeDocument({'id': documentId});
    };

    CompanyDocumentService.getMyCompanyDocuments = () => cachedMyCompanyDocuments;

    return CompanyDocumentService

}]);

angular.module('user')


    .factory('Company', ['CompanyResource', 'User', 'Upload', 'AlertBanner', '$filter', function (CompanyResource, User, Upload, AlertBanner, $filter) {

        let CompanyService = {};
        let userCompanyID;

        User.get().$promise.then(user => {
            if (user.company) {
                userCompanyID = user.company.id;
            }
        });

        CompanyService.updateCompanyProperty = (propertyObj) => CompanyResource.update({id: userCompanyID}, propertyObj);

        CompanyService.updateCompanyCollectiveAgreement = (isCollectiveAgreement) => {
            return CompanyService.updateCompanyProperty({'collective_agreement': isCollectiveAgreement}).$promise.then(() => {
                User.get().company.collective_agreement = isCollectiveAgreement
            });
        };

        CompanyService.saveSalaryFactor = CompanyResource.saveSalaryFactor;

        CompanyService.getMembers = () => CompanyResource.getMembers();

        CompanyService.getCompany = () => CompanyResource.get();

        CompanyService.getSalaryFactorLogs = CompanyResource.getSalaryFactorLogs;

        CompanyService.hasInvoiceSettings = CompanyResource.hasInvoiceSettings;

        CompanyService.isUsingDashboard = CompanyResource.isUsingDashboard;

        CompanyService.setOnboardingAsCompleted = CompanyResource.setOnboardingAsCompleted;

        CompanyService.getCompanyProfile = (id) => CompanyResource.getProfile({'id': id});

        CompanyService.getOpenPloys = id => {
            return CompanyResource.getOpenPloys({'id': id});
        };

        CompanyService.updateCompany = (companyObj) => CompanyResource.updateMyCompany(companyObj);

        CompanyService.uploadLogo = files => {
            const file = files[0];
            Upload.upload({
                url: '/api/company/upload_logo/',
                data: {
                    logo: file,
                },
            }).then(response => {
                User.currentUser.company.logo_url = response.data.logo_url;
                AlertBanner.publish({
                    type: 'success',
                    message: $filter('translate')('SAVED') + '!',
                    timeCollapse: 4000
                });
            }, err => {
                AlertBanner.publish({
                    type: 'error',
                    message: 'Invalid image format',
                    timeCollapse: 4000
                });
            });
        };

        return CompanyService

    }]);

angular.module('user')
.factory('Pension', ['PensionCompanyResource', 'PensionResource', function (PensionCompanyResource, PensionResource) {

    let PensionService = {};

    PensionService.getAllPensionCompanies = PensionCompanyResource.query;
    PensionService.savePension = PensionResource.save;
    PensionService.updatePension = PensionResource.update;
    PensionService.getMyPension = PensionResource.getMyPension;

    return PensionService

}]);

angular.module('satellizer')
.decorator('SatellizerStorage', function($delegate, $cookies) {
  function getDomain(){
    return window.location.hostname.split('.').slice(-2).join('.')
  }

  return {
    get: function (key) {
      return $cookies.get(key);
    },
    set: function (key, value) {
      console.log('it sets');
      $cookies.put(key, value, {path: '/', domain: getDomain()});
    },
    remove: function (key) {
      $cookies.remove(key, {path: '/', domain: getDomain()});
    }
  };
});

angular.module('user')


    .factory('User', ['UserResource', 'Constants', '$auth', '$location', 'Upload', 'LanguageService', '$q', '$uibModal',
        'PloyFormStorage', 'AlertBanner', '$filter', 'HandleServerErrors', 'Modal', '$window', '$timeout', '$rootScope',
        function (UserResource, Constants, $auth, $location, Upload, LanguageService, $q, $uibModal,
                  PloyFormStorage, AlertBanner, $filter, HandleServerErrors, Modal, $window, $timeout, $rootScope) {
            var UserService = {};

            UserService.currentUser = {};

            UserService.set = function (user) {
                return Promise.resolve(() => {
                     UserService.currentUser = user;
                });
            };

            UserService.get = function () {

                if (UserService.currentUser.$resolved) {
                    return UserService.currentUser;
                }
                if (!$auth.isAuthenticated()) {
                    LanguageService.getCurrentLanguage();
                    return {}
                }

                if (UserService.currentUser.$resolved !== false) {
                    UserService.currentUser = UserResource.getCurrent({}, function (user) {
                        LanguageService.setLanguage(user.language);
                        Raven.setUserContext({
                            email: user.email,
                            id: user.id
                        });
                        PloyFormStorage.handleFormsAfterLogin();
                    });
                }
                return UserService.currentUser;
            };

            UserService.refresh = function () {
                var deffered = $q.defer();
                UserService.currentUser = UserResource.getCurrent({}, function (user) {
                    LanguageService.setLanguage(user.language);
                    deffered.resolve(UserService.currentUser);
                });
                return deffered.promise;
            };

            UserService.setField = function (key, value) {
                UserService.currentUser[key] = value
            };

            UserService.isAuthenticated = $auth.isAuthenticated;

            UserService.get();

            UserService.changePassword = UserResource.changePassword;

            UserService.changeAccountSettings = UserResource.changeAccountSettings;

            UserService.updateUserProperty = function (key, value) {
                var user = angular.copy(UserService.get());
                user[key] = value;
                return UserService.save(user);
            };

            UserService.updateOriginCountry = (country) => {
                return UserResource.updateOriginCountry({'origin_country': country});
            };

            UserService.silentUpdateUserProperty = (key, value) => {
                let user = angular.copy(UserService.get());
                let form = {id: user.id};
                form[key] = value;
                return UserService.saveSilent(form);
            };

            UserService.verifyEmail = function (email) {
                return UserResource.verifyEmail({'email': email});
            };

            UserService.resendSmsCode = function () {
                return UserResource.resendSmsCode();
            };

            UserService.sendVerificationEmail = function (email) {
                return UserResource.sendVerificationEmail({'email': email});
            };

            UserService.verifyPhone = function (phone) {
                return UserResource.verifyPhone({'phone_verify_code': phone});
            };

            UserService.confirmEmail = function (token) {
                return UserResource.confirmEmail({'token': token});
            };

            UserService.hasEmailVerified = () => {
                return UserResource.hasEmailVerified();
            };

            UserService.sendResetLink = function (email) {
                return UserResource.sendResetLink({'email': email});
            };

            UserService.generateNewPassword = function (token, password, confirm_password) {
                return UserResource.generateNewPassword({
                    'token': token,
                    'password': password,
                    'confirm_password': confirm_password
                });
            };

            UserService.downloadActivity = function () {
                return UserResource.downloadActivity();
            };

            UserService.getActivity = function (occupation, user) {
                return UserResource.getActivity({'occupation': occupation, 'user': user});
            };

            UserService.getActivityPart = function (occupation, user, data_type, period) {
                return UserResource.getActivityPart({
                    'occupation': occupation, 'user': user, 'data_type': data_type,
                    'period': period
                });
            };

            UserService.save = function (user) {
                UserService.currentUser = UserResource.update(user, function () {
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('SAVED') + '!',
                        timeCollapse: 4000
                    });
                    $rootScope.$broadcast('profile-updated');
                }, HandleServerErrors.handleFormError);

                return UserService.currentUser.$promise
            };

            UserService.saveSilent = (user) => {
                UserService.currentUser = UserResource.update(user, () => {
                }, HandleServerErrors.handleFormError);
                return UserService.currentUser.$promise;
            };

            UserService.setLanguage = function (user, language) {
                return UserResource.setLanguage({'user': user, 'language': language})
            };

            UserService.getProfile = function (user) {
                return UserResource.getProfile({'id': user});
            };

             UserService.getInvitationSender = (id) => {
                return UserResource.getInvitationSender({'id': id});
            };

            UserService.hasAnyStaff = function () {
                return UserResource.hasAnyStaff();
            };

            UserService.hasAnyStaffGroups = function () {
                return UserResource.hasAnyStaffGroups();
            };

            UserService.hasAnyPloyTemplates = () => {
                return UserResource.hasAnyPloyTemplates();
            };

            UserService.hasDefaultAvatar = () => {
                return UserService.get().$promise.then(user => {
                    return user.avatar_url === Constants.defaultAvatarUrl;
                })
            };

            UserService.delete = function () {
                UserService.currentUser.deleted = true;
                UserService.currentUser.$update().then(function () {
                    $auth.removeToken();
                    $location.path('/');
                });
            };

            UserService.getCurrentPaymentType = () => {
                let deffered = $q.defer();
                UserService.get().$promise.then((user) => {
                    let type = Constants.paymentTypesDetails.find(type => {
                        return type.value == user.profile.payment_type
                    });
                    if (type) {
                        deffered.resolve(type);
                    } else {
                        deffered.reject('type-not-found');
                    }
                });
                return deffered.promise;
            };

            UserService.hasLoggedInLast90Days = () => {
                return UserResource.hasLoggedInLast90Days();
            };

            UserService.upload_avatar = picture => {
                Upload.upload({
                    url: '/api/user/upload_avatar/',
                    data: {
                        avatar: picture
                    },
                }).then(response => {
                    UserService.currentUser.avatar_url = response.data.avatar_url;
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('SAVED') + '!',
                        timeCollapse: 4000
                    });
                });
            }

            UserService.upload_avatar_64 = dataURI => {
                Upload.upload({
                    url: '/api/user/upload_avatar_64/',
                    data: {
                        avatar: dataURI
                    },
                }).then(response => {
                    UserService.currentUser.avatar_url = response.data.avatar_url;
                    AlertBanner.publish({
                        type: 'success',
                        message: $filter('translate')('SAVED') + '!',
                        timeCollapse: 4000
                    });
                    $rootScope.$broadcast('profile-updated');
                });
            };

            UserService.upload_project = function (files) {
                if (files && files.length) {
                    const file = files[0];
                    Upload.upload({
                        url: '/api/user-project/upload_user_project/',
                        data: {
                            project_image: file,
                        },
                    }).then(response => {
                        UserService.refresh()
                    }, err => {
                        console.log('error status: ' + err);
                    });
                }
            };


            UserService.getHourDiscountChoices = function (max_hours) {
                var hoursDiscount = UserService.currentUser.hours_discount;
                if (!hoursDiscount) {
                    return []
                }
                if (max_hours) {
                    hoursDiscount = Math.min(hoursDiscount, max_hours)
                }
                return _.range(1, hoursDiscount + 1)
            };

            UserService.getJoinedNumber = UserResource.getJoinedNumber;

            UserService.getTargetData = UserResource.getTargetData;

            UserService.getTypeformData = UserResource.getTypeformData;

            let twoDigitYearToFourDigits = (year) => {  // will work fine to all with birth year no longer than 100 year ago
                year = parseInt(String(new Date().getFullYear()).substring(0, 2) + year);
                while (year > new Date().getFullYear()) {
                    year = year - 100;
                    $timeout
                }
                return year;
            };

            UserService.setBirthDayBasedOnCprNumber = (cpr_number, currentBirthday) => {
                if (!cpr_number || cpr_number.length != 10) {
                    return currentBirthday;
                }

                let day = cpr_number.substr(0, 2);
                let month = cpr_number.substr(2, 2);
                let year = cpr_number.substr(4, 2);
                year = twoDigitYearToFourDigits(year);
                let birthdayToSet = new moment(year + "-" + month + "-" + day).toDate();
                if (!isNaN(birthdayToSet.getTime())) {  // validate if date is correct
                    return birthdayToSet;
                }
                return currentBirthday;
            };

            UserService.getHolidayPercent = () => {
                Modal
                return UserResource.getHolidayPercent();
            };

            UserService.getFeeHour = () => {
                return UserResource.getFeeHour();
            };

            UserService.isOutsideOfEU = () => {
                return UserService.currentUser.user_typeform_data && UserService.currentUser.user_typeform_data.nationality
                    && UserService.currentUser.user_typeform_data.nationality == 4;
            };

            UserService.switchCompany = companyId => {
                return Modal.confirm({
                    title: $filter('translate')('ARE_YOU_SURE'),
                    message: $filter('translate')('COMPANY_SWITCHER__WARNING_TEXT'),
                    firstButtonLabel: $filter('translate')('NO'),
                    secondButtonLabel: $filter('translate')('YES'),
                    secondButtonColor: 'green',
                    secondButtonFunction: function () {
                        return UserResource.switchCompany({'choosen_company': companyId}).$promise.then(() => {
                            $timeout($window.location.reload(), 200)

                        });
                    }
                });
            };

            UserService.setPauseDue = (due) => {
                const user = {
                    id: UserService.get().id,
                    profile: {pause_due: due}
                };
                return Promise.resolve(UserService.saveSilent(user));
            };

            UserService.unpauseProfile = () => {
                const user = {
                    id: UserService.get().id,
                    profile: {pause_due: null, pause: false}
                };
                return Promise.resolve(UserService.saveSilent(user));
            };

            UserService.askForProfilePause = eng => {
                return $uibModal.open({
                    templateUrl: 'src/modals/html/modal-pause-profile.html',
                    controller: 'ModalProfilePauseController',
                    windowClass: 'modal-custom modal-vertical-centered',
                    backdrop: 'static'
                });
            };

            UserService.isCprNumberUnique = UserResource.isCprNumberUnique;

            UserService.getDocumentsForEmployers = UserResource.getDocumentsForEmployers;

            let initialChat = () => {

                if (window.HubSpotConversations && window.HubSpotConversations.widget) {
                    window.HubSpotConversations.widget.refresh();
                    window.HubSpotConversations.widget.load();
                } else {

                    var ref = window.document.getElementsByTagName('script')[0];

                    // Create a new script element
                    var script = window.document.createElement('script');

                    // Set the script element `src`
                    script.src = 'https://js.hs-scripts.com/4851648.js';

                    // Inject the script into the DOM
                    ref.parentNode.insertBefore(script, ref);

                    window.hsConversationsOnReady = [initialChat];
                }

                // intercom initial

                // var APP_ID = Constants.intercom_APP_ID;
                // window.intercomSettings = {
                //     app_id: Constants.intercom_APP_ID,
                // };
                // (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + APP_ID;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
                // Get the first script element on the page


            };

            UserService.checkUserAndInitializeChat = () => {
                UserService.get().$promise.then(user => {
                    if (user.user_type === Constants.userTypes.MEPLOYER) {  // intercom is initialized only for employers
                        initialChat();
                        var _hsq = window._hsq = window._hsq || [];
                        _hsq.push(["identify", {
                            email: user.email,
                            firstName: user.first_name,
                            lastName: user.last_name,
                            phone: user.phone
                        }]);
                        _hsq.push(['trackPageView']);

                        // window.Intercom('boot', {
                        //     app_id: Constants.intercom_APP_ID,
                        //     email: user.email,
                        //     first_name: user.first_name,
                        //     last_request_at: parseInt((new Date()).getTime() / 1000),
                        // });
                    }
                });
            };

            UserService.createUserInvitation = UserResource.createUserInvitation;
            UserService.createUserInvitationByUrl = UserResource.createUserInvitationByUrl;

            UserService.switchClient = (clientID) => {
                let user = {'id': UserService.get().id};
                user['client_version'] = clientID;
                return UserService.saveSilent(user);
            };

            UserService.getCurrentProProfile = UserResource.getCurrentProProfile;
            UserService.getProfileProgress = UserResource.getProfileProgress;
            UserService.getCvProgress = UserResource.getCvProgress;

            UserService.getSignature = UserResource.getSignature;

            UserService.getCvPdf = (signature) => {
                window.open('/api/cv-pdf/?signature=' + signature, '_blank');
            };

            return UserService

        }]);

angular.module('workRequirement')

.factory('WorkRequirementResource', ['$resource', ($resource) => {
    return $resource('/api/work-requirement/:id/', {id: '@id'}, {
        save: { method: 'POST' },
    })
}]);

angular.module('workerSalary')
.controller('WorkerSalaryController', ['$scope', 'WorkerSalaryService', 'User', 'AlertBanner', '$filter', 'EngagementResource',
    function($scope, WorkerSalaryService, User, AlertBanner, $filter, EngagementResource) {

    $scope.getWorkerSalary = WorkerSalaryService.getWorkerSalary;
    $scope.getSalaryPeriodSums = WorkerSalaryService.getSalaryPeriodSums;
    $scope.getSalaryPeriodHoursWorkedSum = WorkerSalaryService.getSalaryPeriodHoursWorkedSum;
    $scope.getSalaryShiftsCount = WorkerSalaryService.getSalaryShiftsCount;


    let downloadFn = (salaryPeriod) => {
            EngagementResource.downloadWorkerSalaryShifts({'salaryPeriodId': salaryPeriod.id}).$promise.then(() => {
            AlertBanner.publish({
                type: 'info',
                message: $filter('translate')('WORKER_SALARY_SHIFTS__DOWNLOAD__SUCCESS') + ' ' + User.get().email,
                timeCollapse: 8000
            });
        });
    };

    $scope.downloadWorkerSalary = _.debounce(downloadFn, 5000, {leading: true, trailing: false});

    $scope.collapseListItem = WorkerSalaryService.loadWorkerSalaryShifts;

    $scope.roundFloor = (value) => {
        return Math.floor(value);
    }

}]);

angular.module('workerSalary')
.service('WorkerSalaryService', ['EngagementResource', function(EngagementResource) {

    let WorkerSalaryService = {};

    let workerSalary = {};

    let salaryPeriodSums = [];

    let salaryPeriodHoursWorkedSum = [];

    let salaryPeriodShiftsCount = [];

    EngagementResource.workerSalary().$promise.then(result => {
        workerSalary = result;

        workerSalary.forEach(value => {
            salaryPeriodSums[value.salary_period.id] = salaryPeriodSums[value.salary_period.id] ? salaryPeriodSums[value.salary_period.id] : 0;
            salaryPeriodSums[value.salary_period.id] = salaryPeriodSums[value.salary_period.id] + value.salary_sum;

            salaryPeriodHoursWorkedSum[value.salary_period.id] = salaryPeriodHoursWorkedSum[value.salary_period.id] ? salaryPeriodHoursWorkedSum[value.salary_period.id] : 0;
            salaryPeriodHoursWorkedSum[value.salary_period.id] = salaryPeriodHoursWorkedSum[value.salary_period.id] + value.work_time_sum_seconds;

            salaryPeriodShiftsCount[value.salary_period.id] = salaryPeriodShiftsCount[value.salary_period.id] ? salaryPeriodShiftsCount[value.salary_period.id] : 0;
            salaryPeriodShiftsCount[value.salary_period.id] = salaryPeriodShiftsCount[value.salary_period.id] + value.shifts_count;
        });
    });

    WorkerSalaryService.getWorkerSalary = () => workerSalary;
    WorkerSalaryService.getSalaryPeriodSums = () => salaryPeriodSums;
    WorkerSalaryService.getSalaryPeriodHoursWorkedSum = () => salaryPeriodHoursWorkedSum;
    WorkerSalaryService.getSalaryShiftsCount = () => salaryPeriodShiftsCount;

    WorkerSalaryService.loadWorkerSalaryShifts = (salaryPeriod, company) => {
        let index = workerSalary.findIndex(elem =>
                elem.salary_period.id === salaryPeriod.id && elem.company.id === company.id);
        if (workerSalary[index].engShifts && workerSalary[index].engShifts.length) {  // hiding results for salary period/company pair
            workerSalary[index].engShifts = [];
            return;
        }
        workerSalary[index].isLoading = true;
        EngagementResource.workerSalaryShifts({
            'salaryPeriodId': salaryPeriod.id,
            'companyId': company.id
        }).$promise.then(shifts => {
            workerSalary[index].engShifts = shifts;
            workerSalary[index].isLoading = false;
        });
    };

    return WorkerSalaryService;

}]);

angular.module('edit-profile')

.controller('EditProfileAddressController', ['$scope', '$location', 'User',
    function($scope, $location, User) {

    User.get().$promise.then((user) => {
        $scope.form = {
            id: user.id,
            street: user.street,
            postal_code: user.postal_code,
            city: user.city,
        };
    });

    $scope.saveProfile = () => {
        User.save($scope.form).then(() => {
            $location.path('/edit-profile');
        })
    };

}])

angular.module('edit-profile')

.controller('EditProfileAgeController', ['$scope', '$location', 'User',
    function($scope, $location, User) {

    User.get().$promise.then((user) => {
        $scope.form = {
            id: user.id,
            birthday: user.birthday,
        };
    });

    $scope.saveProfile = () => {
        User.save($scope.form).then(() => {
            $location.path('/edit-profile');
        })
    };

    $scope.datepickerOptions = {
        maxDate: new Date().setFullYear(new Date().getFullYear() - 18)
    };

}]);

angular.module('edit-profile')

.controller('EditProfileBankController', ['$scope', '$location', 'User',
    function($scope, $location, User) {

    $scope.form = {
        profile: {}
    }

    User.get().$promise.then((user) => {
        $scope.form['id'] = user.id;
        if (user.profile) {
            $scope.form['profile']['danish_bank_registration_no'] = user.profile.danish_bank_registration_no;
            $scope.form['profile']['danish_bank_account_no'] = user.profile.danish_bank_account_no;
        }
    });

    $scope.saveProfile = () => {
        User.save($scope.form).then(() => {
            $location.path('/edit-profile');
        })
    };

}])

angular.module('edit-profile')

.controller('EditProfileBioController', ['$scope', '$location', 'User',
    function($scope, $location, User) {

    $scope.minNumberOfDescription = 60;

    User.get().$promise.then((user) => {
        $scope.form = {
            id: user.id,
            about: user.about,
        };
    });

    $scope.saveProfile = () => {
        User.save($scope.form).then(() => {
            $location.path('/edit-profile');
        })
    };

}]);

angular.module('edit-profile')

.controller('EditProfileCategoryController', ['$scope', '$location', 'User',
    function($scope, $location, User) {

    $scope.form = {
        category: []
    };

    User.get().$promise.then((user) => {
        $scope.form = {
            id: user.id,
            category: user.category,
        };
    });

    $scope.saveProfile = () => {
        User.save($scope.form).then(() => {
            $location.path('/edit-profile');
        })
    };

}]);

angular.module('edit-profile')

.controller('EditProfileCprController', ['$scope', '$location', 'User',
    function($scope, $location, User) {

    User.get().$promise.then((user) => {
        $scope.form = {
            id: user.id,
            cpr_number: user.cpr_number,
        };
    });

    $scope.saveProfile = () => {
        User.save($scope.form).then(() => {
            $location.path('/edit-profile');
        })
    };

}])

angular.module('edit-profile')

.controller('EditProfileCriminalRecordController', ['$scope', '$location', 'KycService', 'KycConstants', 'User',
    function($scope, $location, KycService, KycConstants, User) {

    $scope.saveProfile = () => {
        $location.path('/edit-profile');
    };

    $scope.getCriminalRecord = KycService.getCriminalRecord;
    $scope.constants = KycConstants;

    let loadUser = () => {
        User.getCurrentProProfile().$promise.then(function (user) {
            $scope.currentProProfile = angular.copy(user);
        });
    };
    loadUser();

}]);

angular.module('edit-profile')

.controller('EditProfileEmailController', ['$scope', '$location', 'User', 'Verification',
    function($scope, $location, User, Verification) {

    User.get().$promise.then((user) => {
        $scope.form = {
            id: user.id,
            email: user.email,
        };
    });

    $scope.saveProfile = () => {
        User.save($scope.form).then(() => {
            $location.path('/edit-profile');
        })
    };

    $scope.sendVerificationEmail = Verification.sendVerificationEmail;

}]);

angular.module('edit-profile')

.controller('EditProfileIdController', ['$scope', '$location', 'KycService', 'KycConstants', 'User',
    function($scope, $location, KycService, KycConstants, User) {

    $scope.saveProfile = () => {
        $location.path('/edit-profile');
    };

    $scope.getID = KycService.getID;
    $scope.constants = KycConstants;

    let loadUser = () => {
        User.getCurrentProProfile().$promise.then(function (user) {
            $scope.currentProProfile = angular.copy(user);
        });
    };
    loadUser();

}])

angular.module('edit-profile')

.controller('EditProfileNameController', ['$scope', '$location', 'User',
    function($scope, $location, User) {

    User.get().$promise.then((user) => {
        $scope.form = {
            id: user.id,
            first_name: user.first_name,
            last_name: user.last_name,
        };
    });

    $scope.saveProfile = () => {
        User.save($scope.form).then(() => {
            $location.path('/edit-profile');
        })
    };

}]);

angular.module('edit-profile')

.controller('EditProfileNationalityController', ['$scope', '$location', 'User', 'Constants', 'GeoResource', 'SignUpMeployeeService', '$rootScope', 'KycService', 'KycConstants',
    function($scope, $location, User, Constants, GeoResource, SignUpMeployeeService, $rootScope, KycService, KycConstants) {

    $scope.nationalityOptions = Constants.nationalityOptions;
    GeoResource.getCountriesList().$promise.then(countries => {
        $scope.countryOptions = countries;
    });

    User.get().$promise.then((user) => {
        $scope.form = {
            id: user.id,
        };
        if (user.user_typeform_data) {
            $scope.form['user_typeform_data'] = user.user_typeform_data;
        }
        if (user.profile) {
            $scope.form['profile'] = user.profile;
        }
    });

    $scope.saveProfile = () => {
        SignUpMeployeeService.updateUserTypeformData({'nationality': $scope.form.user_typeform_data.nationality}).$promise.then(() => {
            User.updateOriginCountry($scope.form.profile.origin_country).$promise.then(() => {
                User.refresh().then(() => {
                    $rootScope.$broadcast('profile-updated');
                    $location.path('/edit-profile');
                });
            })
        })
    };

    $scope.setNationality = (value) => {
        $scope.form.user_typeform_data.nationality = value;
    };

    $scope.isOutsideOfEU = User.isOutsideOfEU;

    $scope.getWorkPermit = KycService.getWorkPermit;
    $scope.constants = KycConstants;

    let loadUser = () => {
        User.getCurrentProProfile().$promise.then(function (user) {
            $scope.currentProProfile = angular.copy(user);
        });
    };
    loadUser();

}]);

angular.module('edit-profile')

.controller('EditProfileOccupationController', ['$scope', '$location', 'User', 'Constants',
    function($scope, $location, User, Constants) {

    $scope.occupations = Constants.occupations;

    User.get().$promise.then((user) => {
        $scope.form = {
            id: user.id,
            occupation: user.occupation,
        };
    });

    $scope.saveProfile = () => {
        User.save($scope.form).then(() => {
            $location.path('/edit-profile');
        })
    };

}]);

angular.module('edit-profile')

.controller('EditProfilePensionController', ['$scope', '$location', 'Pension', '$rootScope',
    function($scope, $location, Pension, $rootScope) {

    $scope.pensionTimeIntervals = [
        {
            name: 'PAYOUT_SETTINGS__PENSION_TIME_INTERVAL__LESS_THAN_MONTH',
            value: 'less_than_month'
        },
        {
            name: 'PAYOUT_SETTINGS__PENSION_TIME_INTERVAL__MORE_THAN_MONTH',
            value: 'more_than_month'
        },
        {
            name: 'PAYOUT_SETTINGS__PENSION_TIME_INTERVAL__MORE_THAN_3_MONTHS',
            value: 'more_than_3_months'
        },
        {
            name: 'PAYOUT_SETTINGS__PENSION_TIME_INTERVAL__MORE_THAN_6_MONTHS',
            value: 'more_than_6_months'
        },
        {
            name: 'PAYOUT_SETTINGS__PENSION_TIME_INTERVAL__MORE_THAN_1_YEAR',
            value: 'more_than_1_year'
        },
        {
            name: 'PAYOUT_SETTINGS__PENSION_TIME_INTERVAL__MORE_THAN_2_YEARS',
            value: 'more_than_2_years'
        },
    ];

    Pension.getAllPensionCompanies().$promise.then(companies => {
        $scope.autocompleteData = companies
    });

    Pension.getMyPension().$promise.then(pension => {
        $scope.pension = angular.copy(pension);
    });

    $scope.saveProfile = () => {
        if (!$scope.pension.id) {
            if (!$scope.pension.company) {
                $location.path('/edit-profile');
                return
            }
            return Pension.savePension($scope.pension).$promise.then(() => {
                $rootScope.$broadcast('profile-updated');
                $location.path('/edit-profile');
            })
        }
        return Pension.updatePension($scope.pension).$promise.then(() => {
            $rootScope.$broadcast('profile-updated');
            $location.path('/edit-profile');
        });
    };

}]);

angular.module('edit-profile')

.controller('EditProfilePhoneController', ['$scope', '$location', 'User',
    function($scope, $location, User) {

    User.get().$promise.then((user) => {
        $scope.form = {
            id: user.id,
            phone: user.phone,
        };
    });

    $scope.saveProfile = () => {
        User.save($scope.form).then(() => {
            $location.path('/edit-profile');
        })
    };

}]);

angular.module('edit-profile')

.controller('EditProfilePhotoController', ['$scope', '$location', 'User', 'Upload', '$uibModal',
    function($scope, $location, User, Upload, $uibModal) {

    $scope.saveProfile = () => {
        $location.path('/edit-profile');
    };

    $scope.picFile = '';
    $scope.upload = (picFile) => {
        Upload.base64DataUrl(picFile).then(base64image => {
            $uibModal.open({
                templateUrl: 'src/modals/html/modal-crop-image.html',
                controller: 'ModalCropImageController',
                windowClass: 'modal-alert modal-vertical-centered',
                backdrop: 'static',
                resolve: {
                    image: () => base64image
                }
            }).result.then(base64data => {
                User.upload_avatar_64(base64data);
            })
        });
        $scope.picFile = '';
    };

}]);

angular.module('edit-profile')

.controller('EditProfileProfessionalTitleController', ['$scope', '$location', 'User',
    function($scope, $location, User) {

    User.get().$promise.then((user) => {
        $scope.form = {
            id: user.id,
            professional_title: user.professional_title,
        };
    });

    $scope.saveProfile = () => {
        User.save($scope.form).then(() => {
            $location.path('/edit-profile');
        })
    };

}]);

